(function() {
  'use strict';

  angular
    .module('zoek', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngDialog',
      'mdColorPicker',
      'permission',
      'permission.ui',
      'ui.router',
      'angular-ladda',
      'myApp.myConfig',
      'ziptastic',
      'angularMoment',
      'chart.js',
      'angular-jwt',
      'ui.mask',
      'ngTwitter',
      'ngMaterial',
      'md.data.table',
      'ngLodash',
      'ui.timepicker',
      'ngtweet',
      'ezfb',
      'ngFileSaver',
      'angular-storage'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('zoekPackages', {
      templateUrl: 'app/components/zoek_packages/zoek_packages.html',
      controller: ZoekPackagesController,
      bindings: {
        selectedPackageId: '<',
        onClick: '&'
      }
    });

  /** @ngInject */
  function ZoekPackagesController(API) {
    var vm = this;

    vm.$onInit = function() {
      vm.loading = API.getPackages()
        .then(function(packages) {
          vm.packages = packages.data;
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.handleOnClick = function(e) {
      vm.onClick({
        $event: {
          package: e.package
        }
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('zoekPackage', {
      templateUrl: 'app/components/zoek_package/zoek_package.html',
      controller: ZoekPackageController,
      bindings: {
        package: '<',
        isActive: '<',
        onClick: '&'
      }
    });

  /** @ngInject */
  function ZoekPackageController() {
    var vm = this;

    vm.$onChanges = function(changes) {
      if (changes.package) {
        vm.package = angular.copy(changes.package.currentValue);
      }
    };

    vm.handleClick = function(e) {
      vm.onClick({
        $event: {
          package: vm.package
        }
      })
    };

    vm.getClass = function() {
      if (vm.isActive) {
        return 'c-package--active';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('xferList', {
      bindings: {
        leads: '<',
        title: '@',
        query: '<',
        onSelect: '&',
        onFilter: '&',
        onExport: '&'
      },
      templateUrl: 'app/components/xfer-list/xfer-list.html',
      controller: XferListController
    });

  /** @ngInject */
  function XferListController() {
    var vm = this;

    vm.$onInit = function() {
      if (vm.query.created_from) {
        vm.query.created_from = new Date(vm.query.created_from);
      }

      if (vm.query.created_to) {
        vm.query.created_to = new Date(vm.query.created_to);
      }
    };

    vm.$onChanges = function(changes) {
      if (changes.leads) {
        vm.leads = angular.copy(changes.leads.currentValue);
      }
    };

    vm.handleSelect = function(lead) {
      vm.onSelect({
        $event: lead
      });
    };

    vm.onReorder = function(order) {
      vm.query.order = order;
      vm.handleFilter();
    };

    vm.onPaginate = function(page, limit) {
      vm.query.page = page;
      vm.query.limit = limit;
      vm.handleFilter();
    };

    vm.handleFilter = function() {
      vm.onFilter({
        $event: Object.assign({}, vm.query, {
          created_from: vm.query.created_from ? vm.query.created_from.toISOString().toString() : null,
          created_to: vm.query.created_to ? vm.query.created_to.toISOString().toString() : null,
        })
      });
    };

    vm.handleExport = function() {
      vm.onExport({
        $event: vm.query
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ViewLeadModal', ViewLeadModal);

  /** @ngInject */
  function ViewLeadModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/view_lead_modal/view_lead_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ViewClientModal', ViewClientModal);

  /** @ngInject */
  function ViewClientModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/view_client_modal/view_client_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('UpdateEmailModal', UpdateEmailModal);

  /** @ngInject */
  function UpdateEmailModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/update_email_modal/update_email_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.email = angular.copy(vm.user.email);

          vm.updateEmail = function() {
            vm.user.email = vm.email;
            $mdDialog.hide();
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('steps', {
      templateUrl: 'app/components/steps/steps.html',
      controller: StepsController,
      bindings: {
        current: '<',
        progress: '<'
      }
    });

  /** @ngInject */
  function StepsController($state) {
    var vm = this;

    vm.onClickItem = onClickItem;

    function onClickItem(index, state) {
      if (index <= vm.progress) {
        $state.go(state);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('stepItem', {
      templateUrl: 'app/components/step_item/step_item.html',
      bindings: {
        isCurrent: '<',
        isCompleted: '<',
        number: '@',
        text: '@'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('staffList', {
      bindings: {
        staff: '<',
        query: '<',
        onSelect: '&',
        onFilter: '&',
        onExportLoginActivity: '&',
      },
      templateUrl: 'app/components/staff_list/staff_list.html',
      controller: StaffListController
    });

  /** @ngInject */
  function StaffListController() {
    var vm = this;

    vm.$onChanges = function(changes) {
      if (changes.staff) {
        vm.staff = angular.copy(changes.staff.currentValue);
      }
    };

    vm.handleSelect = function(staff) {
      vm.onSelect({
        $event: staff
      });
    };

    vm.onReorder = function(order) {
      vm.query.order = order;
      vm.handleFilter();
    };

    vm.onPaginate = function(page, limit) {
      vm.query.page = page;
      vm.query.limit = limit;
      vm.handleFilter();
    };

    vm.handleFilter = function() {
      vm.onFilter({
        $event: vm.query
      });
    };

    vm.handleLoginActivityExport = function() {
      vm.onExportLoginActivity({
        $event: {},
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('sidebar', {
      templateUrl: 'app/components/sidebar/sidebar.html'
    });
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectStatus', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_status/select_status.html',
      controller: SelectStatusController
    });

  /** @ngInject */
  function SelectStatusController(statuses) {
    var vm = this;

    vm.$onInit = function() {
      vm.statuses = statuses;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectState', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_state/select_state.html',
      controller: SelectStateController
    });

  /** @ngInject */
  function SelectStateController(states) {
    var vm = this;

    vm.$onInit = function() {
      vm.states = states;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectSalesRep', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_sales_rep/select_sales_rep.html',
      controller: SelectSalesRepController
    });

  /** @ngInject */
  function SelectSalesRepController(API) {
    var vm = this;

    vm.$onInit = function() {
      vm.loading = API.getFilterBySalesReps()
        .then(function(salesReps) {
          vm.salesReps = salesReps.data;
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectRole', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_role/select_role.html',
      controller: SelectRoleController
    });

  /** @ngInject */
  function SelectRoleController(roles) {
    var vm = this;

    vm.$onInit = function() {
      vm.roles = roles;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectProvisioner', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_provisioner/select_provisioner.html',
      controller: SelectProvisionerController
    });

  /** @ngInject */
  function SelectProvisionerController(API) {
    var vm = this;

    vm.$onInit = function() {
      vm.loading = API.getFilterByProvisioners()
        .then(function(provisioners) {
          vm.provisioners = provisioners.data;
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectProposal', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_proposal/select_proposal.html',
      controller: SelectProposalController
    });

  /** @ngInject */
  function SelectProposalController(proposals) {
    var vm = this;

    vm.$onInit = function() {
      vm.proposals = proposals;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectPackage', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<',
        onChange: '&'
      },
      templateUrl: 'app/components/select_package/select_package.html',
      controller: SelectPackageController
    });

  /** @ngInject */
  function SelectPackageController(API) {
    var vm = this;

    vm.$onInit = function() {
      vm.loading = API.getPackages()
        .then(function(packages) {
          vm.packages = packages.data;
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.handleChange = function() {
      angular.forEach(vm.packages, function(pkg) {
        if (pkg.id === vm.ngModel) {
          vm.onChange({
            $event: pkg
          });
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectMarketingMethods', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_marketing_methods/select_marketing_methods.html',
      controller: SelectMarketingMethodsController
    });

  /** @ngInject */
  function SelectMarketingMethodsController(marketingMethods) {
    var vm = this;

    vm.$onInit = function() {
      vm.marketingMethods = marketingMethods;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectLeadType', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_lead_type/select_lead_type.html',
      controller: SelectLeadTypeController
    });

  /** @ngInject */
  function SelectLeadTypeController(leadTypes) {
    var vm = this;

    vm.$onInit = function() {
      vm.leadTypes = leadTypes;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectIndustry', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_industry/select_industry.html',
      controller: SelectIndustryController
    });

  /** @ngInject */
  function SelectIndustryController(industries) {
    var vm = this;

    vm.$onInit = function() {
      vm.industries = industries;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectDisposition', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_disposition/select_disposition.html',
      controller: SelectDispositionController
    });

  /** @ngInject */
  function SelectDispositionController(dispositions) {
    var vm = this;

    vm.$onInit = function() {
      vm.dispositions = dispositions;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectCountry', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_country/select_country.html',
      controller: SelectCountryController
    });

  /** @ngInject */
  function SelectCountryController(countries) {
    var vm = this;

    vm.$onInit = function() {
      vm.countries = countries;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('selectBusinessType', {
      bindings: {
        name: '@',
        label: '@',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/select_business_type/select_business_type.html',
      controller: SelectBusinessTypeController
    });

  /** @ngInject */
  function SelectBusinessTypeController(businessTypes) {
    var vm = this;

    vm.$onInit = function() {
      vm.businessTypes = businessTypes;
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('zoek')
    .controller('SaveModalController', SaveModalController);

  /** @ngInject */
  function SaveModalController (ProposalService, moment, lead, toastr, $mdDialog) {
    var vm = this;

    vm.lead = lead;

    vm.now = moment();

    vm.sendProposal = sendProposal;

    vm.setDisposition = setDisposition;

    vm.setCallback = setCallback;

    vm.exit = exit;

    ProposalService.fetchAll()
      .then(function (res) {
        vm.proposals = res.proposals;
      });

    ////////////////////

    function sendProposal () {
      vm.loading = true;

      ProposalService.send({
        lead_id: vm.lead.id,
        proposal_id: vm.proposal.id,
      })
        .then(function () {
          toastr.success('Sent proposal');
          $mdDialog.hide('proposal');
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function setDisposition () {
      vm.loading = lead.updateDisposition(vm.disposition)
        .then(function () {
          $mdDialog.hide('disposition');
          toastr.success('Successfully set disposition');
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function setCallback (callback) {
      var date = moment(callback.date);

      vm.loading = lead.createCallback({
        date: date.format('MM/DD/YY'),
        time: callback.time.format('hh:mm a'),
      })
        .then(function () {
          $mdDialog.hide('callback');
          toastr.success('Successfully setup callback');
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function exit () {
      $mdDialog.hide('exit');
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('saePipelineList', {
      bindings: {
        clients: '<',
        title: '@',
        query: '<',
        onSelect: '&',
        onFilter: '&',
        onExport: '&'
      },
      templateUrl: 'app/components/sae_pipeline_list/sae_pipeline_list.html',
      controller: SAEPipelineListController
    });

  /** @ngInject */
  function SAEPipelineListController() {
    var vm = this;

    vm.$onInit = function() {
      if (vm.query.created_from) {
        vm.query.created_from = new Date(vm.query.created_from);
      }

      if (vm.query.created_to) {
        vm.query.created_to = new Date(vm.query.created_to);
      }
    };

    vm.$onChanges = function(changes) {
      if (changes.clients) {
        vm.clients = angular.copy(changes.clients.currentValue);
      }
    };

    vm.handleSelect = function(client) {
      vm.onSelect({
        $event: client
      });
    };

    vm.onReorder = function(order) {
      vm.query.order = order;
      vm.handleFilter();
    };

    vm.onPaginate = function(page, limit) {
      vm.query.page = page;
      vm.query.limit = limit;
      vm.handleFilter();
    };

    vm.handleFilter = function() {
      vm.onFilter({
        $event: Object.assign({}, vm.query, {
          created_from: vm.query.created_from ? vm.query.created_from.toISOString().toString() : null,
          created_to: vm.query.created_to ? vm.query.created_to.toISOString().toString() : null,
        })
      });
    };

    vm.handleExport = function() {
      vm.onExport({
        $event: vm.query
      });
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .controller('RefundModalController', RefundModalController);

  /** @ngInject */
  function RefundModalController(client, toastr, $mdDialog, API) {
    var vm = this;

    vm.confirm = confirm;

    vm.cancel = cancel;

    /////////////////

    function confirm() {
      vm.loading = API.createTicket({
        client_no: client.client_no,
        ticket: 'refund_subscription',
        reason: vm.reason,
        amount: vm.amount
      })
        .then(function() {
          toastr.success('A ticket has been submitted to refund subscription');
          $mdDialog.hide();
        })
        .finally(function() {
          vm.loading = false;
        });
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('qualifierSteps', {
      templateUrl: 'app/components/qualifier_steps/qualifier_steps.html',
      controller: QualifierStepsController,
      bindings: {
        current: '<',
        progress: '<'
      }
    });

  /** @ngInject */
  function QualifierStepsController($state) {
    var vm = this;

    vm.$onInit = function() {
      if (!vm.progress) {
        vm.progress = 0;
      }
    };

    vm.isComplete = function(number) {
      return vm.progress >= number;
    };

    vm.isCurrent = function(number) {
      return number == vm.progress + 1;
    };

    vm.isActive = function(number) {
      return vm.current == number;
    };

    vm.getClass = function(number) {
      var classes = '';

      if (vm.isComplete(number)) {
        classes += ' steps__item--complete';
      }

      if (vm.isCurrent(number)) {
        classes += ' steps__item--current';
      }

      if (vm.isActive(number)) {
        classes += ' steps__item--active';
      }

      return classes;
    };

    vm.handleClick = function(number) {
      if (vm.isComplete(number) || vm.isCurrent(number)) {
        switch (number) {
          case 1:
            $state.go('root.qualifiers.lead.package');
            break;
          case 2:
            $state.go('root.qualifiers.lead.package-details');
            break;
          case 3:
            $state.go('root.qualifiers.lead.payment');
            break;
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .service('ProposalModal', ProposalModal);

  /** @ngInject */
  function ProposalModal($mdDialog) {
    return function(data) {
      return $mdDialog.show({
        templateUrl: 'app/components/proposal_modal/proposal_modal.html',
        locals: data,
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function(ProposalService, $mdDialog, toastr) {
          var vm = this;

          ProposalService.fetchAll()
            .then(function(res) {
              vm.proposals = res;
            });

          vm.sendProposal = function() {
            vm.loading = true;

            ProposalService.send({
              lead_id: vm.lead.id,
              proposal_id: vm.proposal._id
            })
              .then(function() {
                toastr.success('Sent proposal');
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.hide();
          };
        }
      });
    };
  }
})();

/**
 * Created by kevinem on 10/13/15.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('progressbar', {
      templateUrl: 'app/components/progressbar/progressbar.html',
      controllerAs: 'progressbar',
      bindings: {
        steps: '=',
        current: '='
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .factory('PrepayDisclosureModal', PrepayDisclosureModal);

  /** @ngInject */
  function PrepayDisclosureModal($mdDialog, $document) {
    return function (paymentInfo, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/prepay_disclosure_modal/prepay_disclosure_modal.html',
        parent: angular.element($document.body),
        locals: {
          user: user,
          paymentInfo: paymentInfo
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function ($mdDialog) {
          var vm = this;

          vm.confirm = function () {
            vm.loading = vm.user.convert(vm.paymentInfo.billing, vm.paymentInfo.card, vm.paymentInfo.check, 1)
              .then(function (client) {
                $mdDialog.hide(client);
              })
              .finally(function () {
                vm.loading = false;
              });
          };

          vm.cancel = function () {
            $mdDialog.cancel(user);
          };
        }
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('PaymentSuccessfulModal', PaymentSuccessfulModal);

  /** @ngInject */
  function PaymentSuccessfulModal($mdDialog, $document) {
    return function(user) {
      return $mdDialog.show({
        templateUrl: 'app/components/payment_successful_modal/payment_successful_modal.html',
        parent: angular.element($document.body),
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function(moment, $mdDialog) {
          var vm = this;

          vm.nextDate = moment().add(30, 'days').format('MMM DD, YYYY');

          vm.confirm = function() {
            $mdDialog.hide(user);
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('paymentMethods', {
      bindings: {
        label: '@',
        ngModel: '='
      },
      templateUrl: 'app/components/payment_methods/payment_methods.html',
      controller: PaymentMethodsController
    });

  /** @ngInject */
  function PaymentMethodsController(paymentMethods) {
    var vm = this;

    vm.$onInit = function() {
      vm.paymentMethods = paymentMethods;

      if (!vm.ngModel) {
        vm.ngModel = [];
      }
    };

    vm.exists = function(item, list) {
      if (list) {
        return list.indexOf(item) > -1;
      }
    };

    vm.toggle = function(item, list) {
      if (list) {
        var idx = list.indexOf(item);

        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('paymentDetails', {
      bindings: {
        loading: '<',
        billing: '<',
        card: '<',
        onSubmit: '&',
        onGoBack: '&'
      },
      templateUrl: 'app/components/payment_details/payment_details.html',
      controller: PaymentDetailsController
    });

  /** @ngInject */
  function PaymentDetailsController() {
    var vm = this;

    vm.$onChanges = function(changes) {
      vm.billling = angular.copy(changes.billing.currentValue);
      vm.card = angular.copy(changes.card.currentValue);
    };

    vm.submit = function() {
      vm.onSubmit({
        $event: {
          billing: vm.billing,
          card: {
            name: vm.card.name,
            number: vm.card.number,
            exp_date: vm.card.exp_date,
            exp_month: vm.card.exp_date.substr(0, 2),
            exp_year: '20' + vm.card.exp_date.substr(2, 2),
            cvc: vm.card.cvc
          }
        }
      });
    };

    vm.goBack = function() {
      vm.onGoBack({
        $event: {
          billing: vm.billing,
          card: vm.card
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('parkingAvailable', {
      bindings: {
        label: '@',
        ngModel: '='
      },
      templateUrl: 'app/components/parking_available/parking_available.html',
      controller: ParkingAvailableController
    });

  /** @ngInject */
  function ParkingAvailableController(parkingAvailable) {
    var vm = this;

    vm.$onInit = function() {
      vm.parkingAvailable = parkingAvailable;

      if (!vm.ngModel) {
        vm.ngModel = [];
      }
    };

    vm.exists = function(item, list) {
      if (list) {
        return list.indexOf(item) > -1;
      }
    };

    vm.toggle = function(item, list) {
      if (list) {
        var idx = list.indexOf(item);

        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('PackageRecommendModal', PackageRecommendModal);

  /** @ngInject */
  function PackageRecommendModal($mdDialog, $document) {
    return function(e, recommendedPackage) {
      return $mdDialog.show({
        templateUrl: 'app/components/package_recommend_modal/package_recommend_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        locals: {
          recommendedPackage: recommendedPackage
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function(recommendedPackage, $mdDialog, packageIncludes) {
          var vm = this;

          vm.package_includes = packageIncludes;

          vm.recommendedPackage = recommendedPackage;

          vm.confirm = function() {
            $mdDialog.hide(vm.recommendedPackage);
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('packageDetails', {
      bindings: {
        client: '<',
        loading: '<',
        onSubmit: '&',
        onGoBack: '&'
      },
      templateUrl: 'app/components/package_details/package_details.html',
      controller: PackageDetailsController
    });

  /** @ngInject */
  function PackageDetailsController() {
    var vm = this;

    vm.$onChanges = function(changes) {
      if (changes.client) {
        vm.client = angular.copy(changes.client.currentValue);
      }
    };

    vm.handleSubmit = function() {
      vm.onSubmit({
        $event: {
          client: vm.client
        }
      });
    };

    vm.handleGoBack = function() {
      vm.onGoBack();
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CustomizePackage', CustomizePackage);

  /** @ngInject */
  function CustomizePackage($mdDialog, $document) {
    return function(e) {
      return $mdDialog.show({
        templateUrl: 'app/components/package_customize_modal/package_customize_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        locals: {
          lead: e.lead,
          pkg: e.pkg,
          addOns: e.addOns,
          handle: e.handle
        },
        clickOutsideToClose: true,
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, Subscription) {
          var vm = this;

          activate();

          function activate() {
            vm.subscription = Subscription.newInstance(angular.copy(vm.lead.subscription));
            vm.subscription.setPackage(vm.pkg);
          }

          vm.cancel = function() {
            $mdDialog.cancel();
          };

          vm.submitSubscription = function() {
            if (vm.handle) {
              vm.handle(vm.subscription, $mdDialog);
            } else {
              vm.loading = vm.lead.setSubscription(vm.subscription)
                .saveSubscription()
                .then(function() {
                  $mdDialog.hide();
                })
                .finally(function() {
                  vm.loading = false;
                });
            }
          };

          vm.toggle = function(addOn) {
            if (vm.subscription.hasAddOn(addOn)) {
              vm.subscription.removeAddOn(addOn);
            } else {
              vm.subscription.addAddOn(addOn);
            }
          };
        }
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('openerSteps', {
      templateUrl: 'app/components/opener_steps/opener_steps.html',
      controller: OpenerStepsController,
      bindings: {
        current: '<',
        progress: '<'
      }
    });

  /** @ngInject */
  function OpenerStepsController($state) {
    var vm = this;

    vm.$onInit = function() {
      if (!vm.progress) {
        vm.progress = 0;
      }
    };

    vm.isComplete = function(number) {
      return vm.progress >= number;
    };

    vm.isCurrent = function(number) {
      return number == vm.progress + 1;
    };

    vm.isActive = function(number) {
      return vm.current == number;
    };

    vm.getClass = function(number) {
      var classes = '';

      if (vm.isComplete(number)) {
        classes += ' steps__item--complete';
      }

      if (vm.isCurrent(number)) {
        classes += ' steps__item--current';
      }

      if (vm.isActive(number)) {
        classes += ' steps__item--active';
      }

      return classes;
    };

    vm.handleClick = function(number) {
      if (vm.isComplete(number) || vm.isCurrent(number)) {
        switch (number) {
          case 1:
            $state.go('root.opener.contacts');
            break;
          case 2:
            $state.go('root.opener.questionnaires');
            break;
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('NotesModal', NotesModal);

  /** @ngInject */
  function NotesModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/notes_modal/notes_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        resolve: {
          notes: function() {
            return user.getNotes();
          }
        },
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = user.addNote({note: vm.note})
              .then(function(note) {
                vm.notes.data.push(note);
                resetForm();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };

          function resetForm() {
            vm.notesForm.$setPristine();
            vm.notesForm.$setUntouched();
            vm.note = '';
          }
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('notesList', {
      bindings: {
        notes: '<',
        onAddNote: '&'
      },
      templateUrl: 'app/components/notes_list/notes_list.html',
      controller: NotesListController
    });

  /** @ngInject */
  function NotesListController() {
    var vm = this;

    vm.addNote = function(note) {
      vm.loading = true;

      vm.onAddNote({$event: {note: note}})
        .then(function() {
          vm.notesForm.$setPristine();
          vm.notesForm.$setUntouched();
          vm.note = '';
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('mobileAppQuestionnaire', {
      bindings: {
        questionnaire: '<',
        loading: '<',
        onSubmit: '&',
        onGoBack: '&'
      },
      templateUrl: 'app/components/mobile_app_questionnaire/mobile_app_questionnaire.html',
      controller: MobileAppQuestionnaireController
    });

  /** @ngInject */
  function MobileAppQuestionnaireController() {
    var vm = this;

    vm.$onChanges = function(changes) {
      if (changes.questionnaire) {
        vm.questionnaire = angular.copy(changes.questionnaire.currentValue);
      }
    };

    vm.handleSubmit = function() {
      vm.onSubmit({
        $event: {
          questionnaire: vm.questionnaire
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('LoginModal', LoginModal);

  /** @ngInject */
  function LoginModal($mdDialog, $document) {
    return function(e) {
      return $mdDialog.show({
        templateUrl: 'app/components/login_modal/login_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, API) {
          var vm = this;

          vm.login = function() {
            vm.loading = API.loginOverride(vm.credentials)
              .then(function() {
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }
})();
/**
 * Created by kevinem on 12/30/15.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('login', {
      templateUrl: 'app/components/login/login.html',
      controller: LoginComponentController,
      bindings: {
        onSubmit: '&',
        hideForgotPassword: '='
      }
    });

  /** ngInject */
  function LoginComponentController() {
    var vm = this;

    vm.login = login;

    ////////////////

    function login() {
      vm.loading = vm.onSubmit({credentials: vm.credentials})
        .finally(function() {
          vm.loading = false;
        });
    }
  }
})();
/**
 * Created by kevinem on 3/25/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .controller('LogModalController', LogModalController);

  /** @ngInject */
  function LogModalController(log, $log) {
    var vm = this;

    vm.log = log;

    activate();

    /////////////////

    function activate() {
      $log.debug('LogModalController.activate.log', log);
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ListingSyncDisclosureModal', ListingSyncDisclosureModal);

  /** @ngInject */
  function ListingSyncDisclosureModal($mdDialog, $document) {
    return function(paymentInfo, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/listing_sync_disclosure_modal/listing_sync_disclosure_modal.html',
        parent: angular.element($document.body),
        locals: {
          user: user,
          paymentInfo: paymentInfo
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.convert(vm.paymentInfo.billing, vm.paymentInfo.card)
              .then(function(client) {
                $mdDialog.hide(client);
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('leadsList', {
      bindings: {
        leads: '<',
        title: '@',
        query: '<',
        onSelect: '&',
        onFilter: '&',
        onExport: '&'
      },
      templateUrl: 'app/components/leads_list/leads_list.html',
      controller: LeadsListController
    });

  /** @ngInject */
  function LeadsListController() {
    var vm = this;

    vm.$onInit = function() {
      if (vm.query.created_from) {
        vm.query.created_from = new Date(vm.query.created_from);
      }

      if (vm.query.created_to) {
        vm.query.created_to = new Date(vm.query.created_to);
      }
    };

    vm.$onChanges = function(changes) {
      if (changes.leads) {
        vm.leads = angular.copy(changes.leads.currentValue);
      }
    };

    vm.handleSelect = function(lead) {
      vm.onSelect({
        $event: lead
      });
    };

    vm.onReorder = function(order) {
      vm.query.order = order;
      vm.handleFilter();
    };

    vm.onPaginate = function(page, limit) {
      vm.query.page = page;
      vm.query.limit = limit;
      vm.handleFilter();
    };

    vm.handleFilter = function() {
      vm.onFilter({
        $event: Object.assign({}, vm.query, {
          created_from: vm.query.created_from ? vm.query.created_from.toISOString().toString() : null,
          created_to: vm.query.created_to ? vm.query.created_to.toISOString().toString() : null,
        })
      });
    };

    vm.handleExport = function() {
      vm.onExport({
        $event: vm.query
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('leadsCreatedPerDay', {
      templateUrl: 'app/components/leads_created_per_day/leads_created_per_day.html',
      controller: LeadsCreatedPerDayController,
      bindings: {
        agent: '<'
      }
    });

  /** @ngInject */
  function LeadsCreatedPerDayController(lodash, moment) {
    var vm = this;

    vm.$onInit = function() {
      vm.data = [];
      vm.labels = [];
      vm.series = ['Leads Created Per Day'];

      vm.query = {
        created_to: moment().toDate(),
        created_from: moment().subtract(1, 'month').toDate()
      };
    };

    vm.$onChanges = function(changes) {
      if (changes.agent) {
        vm.agent = angular.copy(changes.agent.currentValue);
      }
    };

    vm.$postLink = function() {
      vm.getData(vm.query);
    };

    vm.getData = function(query) {
      vm.loading = vm.agent.getLeadsCreatedPerDay(query)
        .then(function(response) {
          vm.data = [lodash.map(response, 'count')];
          vm.labels = lodash.map(response, 'date');
        })
        .finally(function() {
          vm.loading = false;
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('languagesSpoken', {
      bindings: {
        label: '@',
        ngModel: '='
      },
      templateUrl: 'app/components/languages_spoken/languages_spoken.html',
      controller: LanguagesSpokenController
    });

  /** @ngInject */
  function LanguagesSpokenController(languages) {
    var vm = this;

    vm.$onInit = function() {
      vm.languages = languages;

      if (!vm.ngModel) {
        vm.ngModel = [];
      }
    };

    vm.exists = function(item, list) {
      if (list) {
        return list.indexOf(item) > -1;
      }
    };

    vm.toggle = function(item, list) {
      if (list) {
        var idx = list.indexOf(item);

        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('inputKeywords', {
      bindings: {
        number: '<',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/input_keywords/input_keywords.html'
    });
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('inputCities', {
      bindings: {
        number: '<',
        ngMessages: '<',
        ngModel: '=',
        ngRequired: '<'
      },
      templateUrl: 'app/components/input_cities/input_cities.html'
    });
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('HotButtonsModal', HotButtonsModal);

  /** @ngInject */
  function HotButtonsModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/hot_buttons_modal/hot_buttons_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, hotButtons, toastr) {
          var vm = this;

          vm.user_hot_buttons = user.getHotButtons();

          vm.hot_buttons = hotButtons;

          vm.save = function() {
            vm.loading = user.update()
              .then(function() {
                toastr.success('Successfully updated hot buttons');
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.exists = function(item, list) {
            return list.indexOf(item) > -1;
          };

          vm.toggle = function(item, list) {
            var idx = list.indexOf(item);

            if (idx > -1) {
              list.splice(idx, 1);
            } else {
              list.push(item);
            }
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ExportModal', ExportModal);

  /** @ngInject */
  function ExportModal($mdDialog, $document) {
    return function(exportFunc) {
      return $mdDialog.show({
        templateUrl: 'app/components/export_modal/export_modal.html',
        parent: angular.element($document.body),
        bindToController: true,
        controllerAs: '$ctrl',
        controller: ExportModalController,
        locals: {
          exportFunc: exportFunc
        }
      });
    }
  }

  /** @ngInject */
  function ExportModalController($mdDialog, $window) {
    var vm = this;

    vm.progress = {
      completed: 0,
      total: 0
    };

    vm.exportFunc()
      .then(function(url) {
          $window.open(url, '_blank');
        },
        null,
        function(progress) {
          vm.progress = progress;
        });

    vm.cancel = function() {
      $mdDialog.hide();
    };
  }
})();


(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('EditSubscriptionModal', EditSubscriptionModal);

  /** @ngInject */
  function EditSubscriptionModal($mdDialog, $document) {
    return function(e, client) {
      return $mdDialog.show({
        templateUrl: 'app/components/edit_subscription_modal/edit_subscription_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          client: client
        },
        resolve: {
          packages: function(API) {
            return API.getPackages();
          },
          addOns: function(API) {
            return API.getAddOns();
          }
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: EditSubscriptionModalController
      });
    };
  }

  /** @ngInject */
  function EditSubscriptionModalController($state, $mdDialog, packages, addOns, toastr, API, LoginModal, EditSubscriptionModal) {
    var vm = this;

    vm.packages = packages;

    vm.addOns = addOns;

    vm.subscription = angular.copy(vm.client.subscription);

    vm.package = getSubscriptionPackage();

    vm.plans = vm.package.plans;

    vm.subscriptionHasAddOn = subscriptionHasAddOn;

    vm.canAddAddOn = canAddAddOn;

    updateSubscriptionTotal(calculateSubscriptionTotal());

    vm.updateSubscription = function() {
      vm.loading = API.updateClientSubscription(vm.client.id, vm.subscription)
        .then(function() {
          toastr.success('Successfully updated subscription');
          $state.reload();
          $mdDialog.hide();
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.toggle = function(addOnId) {
      if (!subscriptionHasAddOn(addOnId)) {
        addSubscriptionAddOn(addOnId);
      } else {
        removeSubscriptionAddOn(addOnId)
      }

      updateSubscriptionTotal(calculateSubscriptionTotal());
    };

    vm.onChangePackage = function() {
      var selectedPackage = getSubscriptionPackage();

      if (selectedPackage) {
        vm.subscription.package_id = selectedPackage.id;
        vm.plans = selectedPackage.plans;
        vm.subscription.plan_id = vm.plans[0].id;
      }

      updateSubscriptionTotal(calculateSubscriptionTotal());
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.handleSelectPackageType = function() {
      var plan = getSubscriptionPlan();

      if (plan && plan.is_save) {
        LoginModal()
          .then(function() {
            EditSubscriptionModal(null, Object.assign({}, vm.client, {
              subscription: {
                package_id: vm.subscription.package_id,
                add_on_ids: vm.subscription.add_on_ids,
                plan_id: plan.id
              }
            }), $mdDialog);
          })
          .catch(function() {
            EditSubscriptionModal(null, Object.assign({}, vm.client, {subscription: vm.subscription}), $mdDialog);
          });
      } else {
        updateSubscriptionTotal(calculateSubscriptionTotal());
      }
    };

    function canAddAddOn(addOnId) {
      return !((isHalfOffSetupFee(addOnId) && subscriptionHasVoidSetupFee())
      || (isVoidSetupFee(addOnId) && subscriptionHasHalfOffSetupFee())
      || (isFreeCallTracking(addOnId) && subscriptionHasCallTracking())
      || (isCallTracking(addOnId) && subscriptionHasFreeCallTracking()));
    }

    function isFreeCallTracking(addOnId) {
      return addOnId === '5632b653bffebc78178b456a';
    }

    function isCallTracking(addOnId) {
      return addOnId === '5632b642bffebc73178b456a';
    }

    function isVoidSetupFee(addOnId) {
      return addOnId === '5632b5a0bffebc78178b4568';
    }

    function isHalfOffSetupFee(addOnId) {
      return addOnId === '5632b5c2bffebc72178b4568';
    }

    function subscriptionHasVoidSetupFee() {
      return subscriptionHasAddOn('5632b5a0bffebc78178b4568');
    }

    function subscriptionHasHalfOffSetupFee() {
      return vm.subscription.add_on_ids.includes('5632b5c2bffebc72178b4568');
    }

    function subscriptionHasCallTracking() {
      return vm.subscription.add_on_ids.includes('5632b642bffebc73178b456a');
    }

    function subscriptionHasFreeCallTracking() {
      return vm.subscription.add_on_ids.includes('5632b653bffebc78178b456a');
    }

    function subscriptionHasAddOn(addOnId) {
      return vm.subscription.add_on_ids.includes(addOnId)
    }

    function addSubscriptionAddOn(addOnId) {
      vm.subscription.add_on_ids.push(addOnId);
    }

    function removeSubscriptionAddOn(addOnId) {
      vm.subscription.add_on_ids = vm.subscription.add_on_ids.filter(function(id) {
        return id !== addOnId;
      });
    }

    function updateSubscriptionTotal(total) {
      vm.subscription.monthly_fee = total.monthly_fee;
      vm.subscription.deposit_fee = total.deposit_fee;
      vm.subscription.setup_fee = total.setup_fee;
    }

    function calculateSubscriptionTotal() {
      return calculateTotal([getSubscriptionPlan(), getSubscriptionAddOnTotal()]);
    }

    function getSubscriptionPackage() {
      return vm.packages.data.find(function(pkg) {
        return pkg.id === vm.subscription.package_id;
      });
    }

    function getSubscriptionPlan() {
      return getSubscriptionPackage().plans.find(function(plan) {
        return plan.id === vm.subscription.plan_id;
      });
    }

    function getSubscriptionAddOnTotal() {
      var addOns = getSubscriptionAddOns();
      return calculateTotal(addOns);
    }

    function getSubscriptionAddOns() {
      return vm.addOns.data.filter(function(addOn) {
        return vm.subscription.add_on_ids.includes(addOn.id);
      });
    }

    function calculateTotal(array) {
      console.log(array);

      var initial = {
        monthly_fee: 0,
        deposit_fee: 0,
        setup_fee: 0
      };

      return array.reduce(function(accumulator, currentValue) {
        return {
          monthly_fee: accumulator.monthly_fee + currentValue.monthly_fee,
          deposit_fee: accumulator.deposit_fee + currentValue.deposit_fee,
          setup_fee: accumulator.setup_fee + currentValue.setup_fee
        };
      }, initial);
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('editStaffRep', {
      templateUrl: 'app/components/edit_staff_rep/edit_staff_rep.html',
      controller: EditStaffRepController,
      bindings: {
        'title': "@",
        'reps': '<',
        'editing': '<',
        'rep': '<',
        'onChange': '&'
      }
    });

  /** @ngInject */
  function EditStaffRepController(LoginModal) {
    var vm = this;

    vm.$onInit = function() {
      vm.editing = false;
    };

    vm.$onChanges = function(changes) {
      if (changes.rep) {
        vm.rep = angular.copy(changes.rep.currentValue);
      }

      if (changes.reps) {
        vm.resp = angular.copy(changes.reps.currentValue);
      }
    };

    vm.overrideToAllowChangeRep = function(e) {
      LoginModal(e)
        .then(function() {
          vm.editing = true;
        });
    };

    vm.changeRep = function(rep) {
      vm.onChange({
        $event: {
          rep: rep
        }
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('DispositionModal', DispositionModal);

  /** @ngInject */
  function DispositionModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/disposition_modal/disposition_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr, dispositions) {
          var vm = this;

          vm.disposition = angular.copy(vm.user.disposition);

          vm.dispositions = dispositions;

          vm.confirm = function() {
            vm.loading = vm.user.updateDisposition(vm.disposition)
              .then(function(lead) {
                $mdDialog.hide(lead);
                toastr.success('Successfully set disposition');
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appCrm', {
      templateUrl: 'app/components/crm/crm.html',
      controller: CRMController
    });

  /** @ngInject */
  function CRMController(API) {
    var vm = this;

    vm.$onInit = function() {
      API.getFlashSaleStatus()
        .then(function(res) {
          vm.flashSaleStatus = res.status;
        });
    };

    vm.toggleFlashSaleStatus = function() {
      vm.updatingFlashStatus = true;
      API.updateFlashSaleStatus({
        status: vm.flashSaleStatus ? 'inactive' : 'active'
      })
        .then(function(res) {
          vm.flashSaleStatus = res.status;
        })
        .finally(function() {
          vm.updatingFlashStatus = false;
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CreditCardModal', CreditCardModal);

  /** @ngInject */
  function CreditCardModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/credit_card_modal/credit_card_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.updateCreditCard()
              .then(function() {
                toastr.success("Successfully Updated Credit Card");
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('creditCardComp', {
      templateUrl: 'app/components/credit_card/credit_card.html',
      bindings: {
        card: '<'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CloserAgreementModal', CloserAgreementModal);

  /** @ngInject */
  function CloserAgreementModal($mdDialog, $document) {
    return function(paymentInfo, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/closer_agreement_modal/closer_agreement_modal.html',
        parent: angular.element($document.body),
        locals: {
          user: user,
          paymentInfo: paymentInfo
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.convert(vm.paymentInfo.billing, vm.paymentInfo.card)
              .then(function(client) {
                $mdDialog.hide(client);
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('clientsList', {
      bindings: {
        clients: '<',
        title: '@',
        query: '<',
        onSelect: '&',
        onFilter: '&',
        onExport: '&'
      },
      templateUrl: 'app/components/clients_list/clients_list.html',
      controller: ClientsListController
    });

  /** @ngInject */
  function ClientsListController() {
    var vm = this;

    vm.$onInit = function() {
      if (vm.query.created_from) {
        vm.query.created_from = new Date(vm.query.created_from);
      }

      if (vm.query.created_to) {
        vm.query.created_to = new Date(vm.query.created_to);
      }
    };

    vm.$onChanges = function(changes) {
      if (changes.clients) {
        vm.clients = angular.copy(changes.clients.currentValue);
      }
    };

    vm.handleSelect = function(client) {
      vm.onSelect({
        $event: client
      });
    };

    vm.onReorder = function(order) {
      vm.query.order = order;
      vm.handleFilter();
    };

    vm.onPaginate = function(page, limit) {
      vm.query.page = page;
      vm.query.limit = limit;
      vm.handleFilter();
    };

    vm.handleFilter = function() {
      vm.onFilter({
        $event: Object.assign({}, vm.query, {
          created_from: vm.query.created_from ? vm.query.created_from.toISOString().toString() : null,
          created_to: vm.query.created_to ? vm.query.created_to.toISOString().toString() : null,
        })
      });
    };

    vm.handleExport = function() {
      vm.onExport({
        $event: vm.query
      });
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CheckModal', CheckModal);

  /** @ngInject */
  function CheckModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/check_modal/check_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.updateChecking()
              .then(function() {
                toastr.success("Successfully Updated Checking Information");
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ChangeStatusModal', ChangeStatusModal);

  /** @ngInject */
  function ChangeStatusModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/change_status_modal/change_status_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr) {
          var vm = this;

          vm.status = angular.copy(vm.user.status);

          vm.reason = angular.copy(vm.user.reason);

          vm.confirm = function() {
            vm.loading = vm.user.updateStatus({
              status: vm.status,
              reason: vm.reason
            })
              .then(function() {
                toastr.success('Successfully updated status');
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };

          vm.onStatusChange = function() {
            if (vm.status !== 'cancelled' || vm.status !== 'failed_compliance') {
              vm.reason = null;
            }
          }
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ChangePasswordModal', ChangePasswordModal);

  /** @ngInject */
  function ChangePasswordModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/change_password_modal/change_password_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.changePassword({
              password: vm.password,
              password_confirmation: vm.password_confirmation
            })
              .then(function() {
                toastr.success('Successfully changed password');
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CancelModal', CancelModal);

  /** @ngInject */
  function CancelModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/cancel_modal/cancel_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.updateStatus({
              status: 'cancelled',
              reason: vm.reason
            })
              .then(function(response) {
                toastr.success('Successfully cancelled');
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('businessHours', {
      templateUrl: 'app/components/business_hours/business_hours.html',
      controller: BusinessHoursController,
      bindings: {
        hours: '='
      }
    });

  /** @ngInject */
  function BusinessHoursController(ApplyHoursModal) {
    var vm = this;

    vm.$onInit = function() {
      if (vm.hours) {
        for (var i = 0; i < vm.hours.length; i++) {
          if (vm.hours[i]) {
            vm.hours[i] = {
              closed: vm.hours[i].closed,
              is_24_hours: vm.hours[i].is_24_hours,
              by_appointment: vm.hours[i].by_appointment,
              opens: new Date(vm.hours[i].opens),
              closes: new Date(vm.hours[i].closes)
            };
          }
        }
      } else {
        vm.hours = [];
      }
    };

    vm.applyAllHours = function(e, hours) {
      ApplyHoursModal(e, vm.hours, hours);
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('BillingModal', BillingModal);

  /** @ngInject */
  function BillingModal($mdDialog, $document) {
    return function(e, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/billing_address_modal/billing_address_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          user: user
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog, toastr) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.updateBilling()
              .then(function() {
                toastr.success("Successfully Updated Billing Address");
                $mdDialog.hide();
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ApplyHoursModal', ApplyHoursModal);

  /** @ngInject */
  function ApplyHoursModal($mdDialog, $document) {
    return function(e, business_hours, hours_to_apply) {
      return $mdDialog.show({
        templateUrl: 'app/components/apply_hours_modal/apply_hours_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          business_hours: business_hours,
          hours_to_apply: hours_to_apply
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.hours = [false, false, false, false, false, false, false];

          vm.apply = function() {
            for (var i = 0; i < vm.hours.length; i++) {
              if (vm.hours[i]) {
                vm.business_hours[i] = angular.copy(vm.hours_to_apply);
              }
            }

            $mdDialog.hide();
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('AppALaCarteDisclosureModal', AppALaCarteDisclosureModal);

  /** @ngInject */
  function AppALaCarteDisclosureModal($mdDialog, $document, moment) {
    return function(paymentInfo, user) {
      return $mdDialog.show({
        templateUrl: 'app/components/app_a_la_carte_disclosure_modal/app_a_la_carte_disclosure_modal.html',
        parent: angular.element($document.body),
        locals: {
          user: user,
          paymentInfo: paymentInfo,
          moment: moment
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function($mdDialog) {
          var vm = this;

          vm.confirm = function() {
            vm.loading = vm.user.convert(vm.paymentInfo.billing, vm.paymentInfo.card)
              .then(function(client) {
                $mdDialog.hide(client);
              })
              .finally(function() {
                vm.loading = false;
              });
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .factory('AddNewStaffModal', AddNewStaffModal);

  /** @ngInject */
  function AddNewStaffModal($mdDialog, $document, Staff) {
    return function (e) {
      return $mdDialog.show({
        templateUrl: 'app/components/add_new_staff_modal/add_new_staff_modal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          staff: Staff.newInstance()
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function ($mdDialog, roles, toastr, staff, teams) {
          var vm = this;

          vm.staff = staff;

          vm.roles = roles;

          vm.teams = teams;

          vm.confirm = function () {
            vm.loading = staff.create()
              .then(function (staff) {
                toastr.success('Added new staff member');
                $mdDialog.hide(staff);
              })
              .finally(function () {
                vm.loading = false;
              });
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };
        }
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appXfer', {
      templateUrl: 'app/xfer/xfer.html',
      controller: XferController,
      bindings: {
        leads: '<'
      }
    });

  /** @ngInject */
  function XferController($state, $stateParams, API) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function(lead) {
      lead.claim().then(handleClaimedLead);
    };

    vm.handleFilter = function(query) {
      $state.go('root.xfer', query, {reload: true});
    };

    vm.handleExport = function(query) {
      API.requestExportToken()
        .then(function(res) {
          API.exportLeads(Object.assign({lead_type: 'Xfer'}, query), res.token);
        });
    };

    function handleClaimedLead(lead) {
      switch (lead.progress) {
        case 2:
          $state.go('root.qualifiers.lead.package', {lead_id: lead.id});
          break;
        case 3:
          $state.go('root.qualifiers.lead.package-details', {lead_id: lead.id});
          break;
        case 4:
          $state.go('root.qualifiers.lead.payment', {lead_id: lead.id});
          break;
        default:
          $state.go('root.qualifiers.lead.questionnaires', {lead_id: lead.id});
          break;
      }
    }
  }
})();




(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appWebLeads', {
      templateUrl: 'app/web-leads/web-leads.html',
      controller: WebLeadsController,
      bindings: {
        leads: '<'
      }
    });

  /** @ngInject */
  function WebLeadsController($state, $stateParams, ExportModal, ExportService) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function(lead) {
      lead.claim().then(handleClaimedLead);
    };

    vm.handleFilter = function(query) {
      $state.go('root.web-leads', query, {reload: true});
    };

    vm.handleExport = function(query) {
      ExportModal(function() {
        return ExportService.exportWebLeads(query);
      });
    };

    function handleClaimedLead(lead) {
      switch (lead.progress) {
        case 2:
          $state.go('root.qualifiers.lead.package', {lead_id: lead.id});
          break;
        case 3:
          $state.go('root.qualifiers.lead.package-details', {lead_id: lead.id});
          break;
        case 4:
          $state.go('root.qualifiers.lead.payment', {lead_id: lead.id});
          break;
        default:
          $state.go('root.qualifiers.lead.questionnaires', {lead_id: lead.id});
          break;
      }
    }
  }
})();
/**
 * Created by kevinem on 2/2/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('User', UserService);

  /** @ngInject */
  function UserService(moment, ZoekRole) {

    function User() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'role') {
          this[prop] = ZoekRole.newInstance(args[0][prop]);
        } else {
          this[prop] = args[0][prop];
        }
      }
    }

    User.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new User(data[i]));
        }

        return array;
      } else {
        return new User(data);
      }
    };

    User.prototype.getCreated = function() {
      return moment(this.created);
    };

    User.prototype.getUpdated = function() {
      return moment(this.updated);
    };

    return User;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Subscription', SubscriptionService);

  /** @ngInject */
  function SubscriptionService(Package, AddOn, CreditCard, Address, lodash, moment) {

    function Subscription() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'add_ons') {
          this[prop] = {
            data: AddOn.newInstance(args[0][prop].data)
          };
        } else if (prop === 'package') {
          this[prop] = Package.newInstance(args[0][prop]);
        } else if (prop === 'card') {
          this[prop] = CreditCard.newInstance(args[0][prop]);
        } else if (prop === 'billing') {
          this[prop] = Address.newInstance(args[0][prop]);
        } else {
          this[prop] = args[0][prop];
        }
      }

      if (!this.add_on_ids) {
        this.add_on_ids = [];
      }
    }

    Subscription.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Subscription(data[i]));
        }

        return array;
      } else {
        return new Subscription(data);
      }
    };

    Subscription.prototype.getCreditCard = function() {
      return this.card;
    };

    Subscription.prototype.getBilling = function() {
      return this.billing;
    };

    Subscription.prototype.setBilling = function(billing) {
      this.billing = billing;
      return this;
    };

    Subscription.prototype.getPackage = function() {
      return this.package;
    };

    Subscription.prototype.setPackage = function(pkg) {
      this.package = pkg;
      this.package_id = pkg.id;

      if (!this.plan_id || !this.getPlan()) {
        this.plan_id = this.getPackage().plans[0].id
      }

      this.updateTotal();

      return this;
    };

    Subscription.prototype.getAddOns = function() {
      if (!this.add_ons) {
        this.add_ons = {
          data: []
        }
      }

      return this.add_ons.data;
    };

    Subscription.prototype.hasAddOn = function(addOn) {
      return lodash.indexOf(this.add_on_ids, addOn.id) !== -1;
    };

    Subscription.prototype.canAddAddOn = function(addOn) {
      // if addon is half off and void setup fee is in add_on_ids
      if (addOn.id === '5632b5c2bffebc72178b4568' && (lodash.indexOf(this.add_on_ids, '5632b5a0bffebc78178b4568') !== -1 || lodash.indexOf(this.add_on_ids, '5b3a8d0c84caca459092fae9') !== -1)) {
        return true;
      }
      // if addon is void setup fee is half half off is in add_on_ids
      else if (addOn.id === '5632b5a0bffebc78178b4568' && (lodash.indexOf(this.add_on_ids, '5632b5c2bffebc72178b4568') !== -1 || lodash.indexOf(this.add_on_ids, '5b3a8d0c84caca459092fae9') !== -1)) {
        return true;
      }
      // if addon is $100 setup fee and half off & void is in add_on_ids
      else if(addOn.id === '5b3a8d0c84caca459092fae9' && (lodash.indexOf(this.add_on_ids, '5632b5c2bffebc72178b4568') !== -1 || lodash.indexOf(this.add_on_ids, '5632b5a0bffebc78178b4568') !== -1)) {
        return true;
      }
      // if addon is free call tracking and 9.99 call tracking is in add_on_ids
      else if (addOn.id === '5632b653bffebc78178b456a' && lodash.indexOf(this.add_on_ids, '5632b642bffebc73178b456a') !== -1) {
        return true;
      }
      // if addon is 9.99 call tracking is no in add_on_ids and free call tracking is in add_on_ids
      else if (addOn.id === '5632b642bffebc73178b456a' && lodash.indexOf(this.add_on_ids, '5632b653bffebc78178b456a') !== -1) {
        return true;
      } else {
        return false;
      }
    };

    Subscription.prototype.removeAddOn = function(addOn) {
      lodash.remove(this.getAddOns(), function(n) {
        return n.id === addOn.id;
      });

      lodash.pull(this.add_on_ids, addOn.id);

      this.updateTotal();

      return this;
    };

    Subscription.prototype.addAddOn = function(addOn) {
      if (!this.canAddAddOn(addOn)) {
        this.getAddOns().push(addOn);
        this.add_on_ids.push(addOn.id);
        this.updateTotal();
      }

      return this;
    };

    Subscription.prototype.updateTotal = function() {
      var plan = this.getPlan();

      if (plan) {
        this.monthly_fee = plan.monthly_fee || 0;
        this.deposit_fee = plan.deposit_fee || 0;
        this.setup_fee = plan.setup_fee || 0;
      }

      var subscription = this;

      lodash.forEach(this.getAddOns(), function(addOn) {
        subscription.monthly_fee += addOn.monthly_fee;
        subscription.deposit_fee += addOn.deposit_fee;
        subscription.setup_fee += addOn.setup_fee;
      });

      console.log(subscription);

      return this;
    };

    Subscription.prototype.getPlan = function() {
      var subscription = this;

      return lodash.find(this.getPackage().plans, function(plan) {
        return plan.id === subscription.plan_id;
      });
    };

    Subscription.prototype.getBilling = function() {
      return this.billing;
    };

    Subscription.prototype.getCard = function() {
      return this.card;
    };

    Subscription.prototype.getTotal = function() {
      return this.monthly_fee + this.setup_fee;
    };

    Subscription.prototype.getBillDate = function() {
      return moment().format('Do');
    };

    Subscription.prototype.getBillEndDate = function() {
      return moment().add(this.getPlan().payment_term, 'months').format('MM/DD/YYYY');
    };

    return Subscription;
  }
})();

/**
 * Created by kevinem on 4/12/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Staff', StaffService);

  /** @ngInject */
  function StaffService(API, User, ZoekRole) {

    function Staff() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'role') {
          this[prop] = ZoekRole.newInstance(args[0][prop]);
        } else {
          this[prop] = args[0][prop];
        }
      }
    }

    Staff.prototype = Object.create(User.prototype);

    Staff.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Staff(data[i]));
        }

        return array;
      } else {
        return new Staff(data);
      }
    };

    Staff.all = function(params) {
      return API.getAgents({
        params: params
      })
        .then(function(data) {
          var response = {
            meta: data.meta,
            data: []
          };

          for (var i = 0; i < data.data.length; i++) {
            response.data.push(Staff.newInstance(data.data[i]));
          }

          return response;
        });
    };

    Staff.getSalesReps = function() {
      return API.getAgents({
        params: {
          role_id: '56a2e7efbffebc52128b4569',
          pagination: 0,
          order: '-first_name'
        },
        cache: true
      })
        .then(function(data) {
          var response = {
            meta: data.meta,
            data: []
          };

          for (var i = 0; i < data.data.length; i++) {
            response.data.push(Staff.newInstance(data.data[i]));
          }

          return response;
        });
    };

    Staff.get = function(id, params) {
      return API.getAgent(id, params)
        .then(function(response) {
          return Staff.newInstance(response);
        });
    };

    Staff.prototype.update = function() {
      return API.updateEmployee(this.id, this)
        .then(function(response) {
          return Staff.newInstance(response);
        });
    };

    Staff.prototype.remove = function() {
      return API.removeAgent(this.id);
    };

    Staff.prototype.create = function() {
      return API.createAgent(this)
        .then(function(response) {
          return Staff.newInstance(response);
        });
    };

    Staff.prototype.changePassword = function(password) {
      return API.changeAgentPassword(this.id, password)
        .then(function(response) {
          return Staff.newInstance(response);
        });
    };

    Staff.prototype.getLeadsCreatedPerDay = function(params) {
      return API.getLeadsCreatedPerDayOfAgent(this.id, params);
    };

    return Staff;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('ZoekRole', RoleService);

  /** @ngInject */
  function RoleService() {

    function Role() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    Role.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Role(data[i]));
        }

        return array;
      } else {
        return new Role(data);
      }
    };

    Role.prototype.isAdmin = function() {
      return this.name === 'Admin';
    };

    Role.prototype.isManagement = function() {
      return this.name === 'Management';
    };

    Role.prototype.isOpener = function() {
      return this.name === 'Opener';
    };

    Role.prototype.isCloser = function() {
      return this.name === 'Closer';
    };

    Role.prototype.isProvisioner = function() {
      return this.name === 'Provisioner';
    };

    Role.prototype.isCustomerService = function() {
      return this.name === 'Customer Service';
    };

    Role.prototype.isBilling = function() {
      return this.name === 'Billing';
    };

    Role.prototype.isSEO = function() {
      return this.name === 'SEO';
    };

    Role.prototype.isClient = function() {
      return this.name === 'Client';
    };

    Role.prototype.isLead = function() {
      return this.name === 'Lead';
    };

    Role.prototype.isSRAccountExec = function() {
      return this.name === 'Sr Account Exec';
    };

    return Role;
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .service('ProposalService', ProposalService);

  /** @ngInject */
  function ProposalService(API) {
    var service = this;

    service.fetchAll = function() {
      return API.fetchAllProposals();
    };

    service.send = function(data) {
      return API.sendProposal({
        lead_id: data.lead_id,
        proposal_id: data.proposal_id
      });
    };

    return service;
  }

})();


/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Plan', PlanService);

  /** @ngInject */
  function PlanService() {

    function Plan() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    Plan.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Plan(data[i]));
        }

        return array;
      } else {
        return new Plan(data);
      }
    };

    return Plan;
  }
})();
/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Package', PackageService);

  /** @ngInject */
  function PackageService(Plan) {

    function Package() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'plans') {
          this[prop] = Plan.newInstance(args[0][prop]);
        } else {
          this[prop] = args[0][prop];
        }
      }
    }

    Package.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Package(data[i]));
        }

        return array;
      } else {
        return new Package(data);
      }
    };

    return Package;
  }
})();
/**
 * Created by kevinem on 5/20/16.
 */

(function () {
  'use strict';

  angular
    .module('zoek')
    .factory('OverviewConfig', OverviewConfigService);

  /** @ngInject */
  function OverviewConfigService() {

    function OverviewConfig() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    OverviewConfig.newInstance = function (data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new OverviewConfig(data[i]));
        }

        return array;
      } else {
        return new OverviewConfig(data);
      }
    };

    return OverviewConfig;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Note', NoteService);

  /** @ngInject */
  function NoteService() {

    function Note() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    Note.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Note(data[i]));
        }

        return array;
      } else {
        return new Note(data);
      }
    };

    return Note;
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .service('Navigation', NavigationService);

  /** @ngInject */
  function NavigationService() {
    var service = this;

    service.transitioning = false;

    return service;
  }

})();


/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Log', LogService);

  /** @ngInject */
  function LogService(API, User, moment) {

    function Log() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'auth') {  //TODO could be a non-staff user or staff user
          this[prop] = User.newInstance(args[0][prop]);
        } else {
          this[prop] = args[0][prop];
        }
      }
    }

    Log.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Log(data[i]));
        }

        return array;
      } else {
        return new Log(data);
      }
    };

    Log.all = function(params) {
      return API.getLogs(params)
        .then(function(logs) {
          var response = {
            meta: logs.meta,
            data: []
          };

          for (var i = 0; i < logs.data.length; i++) {
            response.data.push(Log.newInstance(logs.data[i]));
          }

          return response;
        });
    };

    Log.prototype.getCreated = function() {
      return moment(this.created);
    };

    Log.prototype.getUpdated = function() {
      return moment(this.updated);
    };

    return Log;
  }

})();

/**
 * Created by kevinem on 4/1/16.
 */


(function () {
  'use strict';

  angular
    .module('zoek')
    .factory('Lead', LeadService);

  /** @ngInject */
  function LeadService(API, ZoekRole, Staff, Subscription, Address, Note, Package, Client, CreditCard, Checking) {

    function Lead() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'role') {
          this[prop] = ZoekRole.newInstance(args[0][prop]);
        } else if (prop === 'opener' || prop === 'closer' || prop === 'pinner') {
          this[prop] = Staff.newInstance(args[0][prop]);
        } else if (prop === 'subscription') {
          this[prop] = Subscription.newInstance(args[0][prop]);
        } else if (prop === 'address') {
          this[prop] = Address.newInstance(args[0][prop]);
        } else {
          this[prop] = args[0][prop];
        }
      }
    }

    Lead.newInstance = function (data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Lead(data[i]));
        }

        return array;
      } else {
        return new Lead(data);
      }
    };

    Lead.all = function (params) {
      return API.getLeads(params)
        .then(function (data) {
          var response = {
            meta: data.meta,
            data: []
          };

          for (var i = 0; i < data.data.length; i++) {
            response.data.push(Lead.newInstance(data.data[i]));
          }

          return response;
        });
    };

    Lead.get = function (id, params) {
      return API.getLead(id, params)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.create = function () {
      if (this.getSubscription() && this.getSubscription().getCard()) {
        this.getSubscription().getCard().exp_month = this.getSubscription().getCard().exp_date.substr(0, 2);
        this.getSubscription().getCard().exp_year = '20' + this.getSubscription().getCard().exp_date.substr(2, 2);
      }

      return API.createLead(this)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.update = function (params) {
      return API.updateLead(this.id, this, params)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.getNotes = function (params) {
      return API.getLeadNotes(this.id, params)
        .then(function (response) {
          return Note.newInstance(response);
        });
    };

    Lead.prototype.addNote = function (data) {
      return API.addLeadNote(this.id, data)
        .then(function (response) {
          return Note.newInstance(response);
        });
    };

    Lead.prototype.updateDisposition = function (disposition) {
      return API.updateDisposition(this.id, { disposition: disposition })
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.updateAddress = function (address) {
      return API.updateLeadAddress(this.id, address)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.updateQuestionnaires = function (data) {
      return API.updateLeadQuestionnaires(this.id, data)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.updateMobileAppQuestionnaire = function (data) {
      return API.updateLeadMobileAppQuestionnaire(this.id, data)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.updateProgress = function (progress) {
      return API.updateLead(this.id, { progress: progress })
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    Lead.prototype.getHotButtons = function () {
      return this.hot_buttons;
    };

    Lead.prototype.getSubscription = function () {
      return this.subscription;
    };

    Lead.prototype.hasSubscription = function () {
      return !!this.subscription;
    };

    Lead.prototype.setSubscription = function (subscription) {
      this.subscription = subscription;
      return this;
    };

    Lead.prototype.saveSubscription = function () {
      return API.saveLeadSubscription(this.id, this.getSubscription())
        .then(function (response) {
          return Subscription.newInstance(response);
        });
    };

    Lead.prototype.updateChecking = function (checking) {
      return API.updateLeadChecking(this.id, checking)
        .then(function (response) {
          return Checking.newInstance(response);
        });
    };

    Lead.prototype.updateCreditCard = function (card) {
      card.exp_month = card.exp_date.substr(0, 2);
      card.exp_year = '20' + card.exp_date.substr(2, 2);

      return API.updateLeadSubscriptionCreditCard(this.id, card)
        .then(function (response) {
          return CreditCard.newInstance(response);
        });
    };

    Lead.prototype.updateBilling = function (billing) {
      var lead = this;

      return API.updateLeadSubscriptionBilling(this.id, billing)
        .then(function (response) {
          var address = Address.newInstance(response);
          lead.subscription.billing = address;
          return address;
        });
    };

    Lead.prototype.getRecommendedPackage = function () {
      return API.getRecommendedPackage(this.id)
        .then(function (response) {
          return Package.newInstance(response);
        });
    };

    Lead.prototype.convert = function (billing, creditCard, check, isPrepay) {
      return API.convertLead(this.id, {
        is_prepay: isPrepay,
        billing: billing,
        check: check,
        credit_card: !!creditCard ? {
          name: creditCard.name,
          number: creditCard.number,
          exp_date: creditCard.exp_date,
          cvc: creditCard.cvc,
          exp_month: creditCard.exp_date.substr(0, 2),
          exp_year: '20' + creditCard.exp_date.substr(2, 2)
        } : undefined,
      })
        .then(function (response) {
          return Client.newInstance(response);
        });
    };

    Lead.prototype.sendProposal = function (package_id, plan_id) {
      return API.sendProposal({
        lead_id: this.id,
        package_id: package_id,
        plan_id: plan_id
      });
    };

    Lead.prototype.createCallback = function (callback) {
      return API.createCallBack({
        user_id: this.id,
        date: callback.date,
        time: callback.time
      });
    };

    Lead.prototype.changeSalesRep = function (staff_id) {
      return API.changeLeadSalesRep(this.id, staff_id);
    };

    Lead.prototype.deleteLead = function () {
      return API.deleteLead(this.id);
    };

    Lead.prototype.claim = function (data) {
      return API.claimLead(this.id, data)
        .then(function (response) {
          return Lead.newInstance(response);
        });
    };

    return Lead;
  }

})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .service('ExportService', ExportService);

  /** @ngInject */
  function ExportService(myConfig, $window, $httpParamSerializer, store) {
    var service = this;

    service.exportLeads = function (query) {
      var token = store.get('token');
      var url = myConfig.apiV2Base + '/exports/leads?access_token=' + token.access_token + '&' + $httpParamSerializer(query);
      $window.open(url, '_blank');
    };

    service.exportWebLeads = function (query) {

    };

    service.exportClients = function (query) {
      var token = store.get('token');
      var url = myConfig.apiV2Base + '/exports/clients?access_token=' + token.access_token + '&' + $httpParamSerializer(query);
      $window.open(url, '_blank');
    };

    service.exportSAEPipeline = function (query) {

    };

    service.exportLoginActivity = function() {
      var token = store.get('token');
      var url = myConfig.apiV2Base + '/logs/logins?access_token=' + token.access_token;
      $window.open(url, '_blank');
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('errorInterceptor', ErrorInterceptorService);

  /** @ngInject */
  function ErrorInterceptorService($q, $log, toastr) {
    return {
      responseError: function(rejection) {
        $log.error('ErrorInterceptorService', rejection);

        if (rejection.status === 422 && rejection.data.errors) {
          var properties = Object.keys(rejection.data.errors);

          properties.forEach(function(property) {
            if (rejection.data.errors[property] instanceof Array) {
              rejection.data.errors[property].forEach(function(err) {
                toastr.error(err, 'Validation Error');
              });
            }
          });

          toastr.error(rejection.data.message, 'Validation Error');
        } else {
          toastr.error(rejection.data.message, rejection.statusText);
        }

        return $q.reject(rejection);
      }
    };
  }

})();


(function() {
  'use strict';

  angular
    .module('zoek')
    .service('CRM', CRMService);

  /** @ngInject */
  function CRMService(API, $log) {
    var service = this;

    service.is_flash_sale = false;

    service.getState = function() {
      API.getFlashSaleStatus()
        .then(function(res) {
          $log.debug('CRMService.getCRM.getFlashSaleStatus.then', res);
          service.is_flash_sale = res.status;
        })
        .catch(function(err) {
          $log.error('CRMService.getCRM.getFlashSaleStatus.catch', err)
        });
    };

    return service;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CreditCard', CreditCardService);

  /** @ngInject */
  function CreditCardService() {

    function CreditCard() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    CreditCard.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new CreditCard(data[i]));
        }

        return array;
      } else {
        return new CreditCard(data);
      }
    };

    return CreditCard;
  }

})();
/**
 * Created by kevinem on 5/1/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Client', ClientService);

  /** @ngInject */
  function ClientService(moment, API, User, Subscription, Staff, ZoekRole, Address, Checking, CreditCard, CAP, Note, lodash) {

    function Client() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        if (prop === 'role') {
          this[prop] = ZoekRole.newInstance(args[0][prop]);
        } else if (prop === 'opener' || prop === 'closer' || prop === 'pinner') {
          this[prop] = Staff.newInstance(args[0][prop]);
        } else if (prop === 'cap') {
          this[prop] = CAP.newInstance(args[0][prop]);
        } else if (prop === 'subscription') {
          this[prop] = Subscription.newInstance(args[0][prop]);
        } else if (prop === 'address') {
          this[prop] = Address.newInstance(args[0][prop]);
        } else if (prop === 'business_hours') {
          var hours = args[0][prop];
          for(var index in hours) {
            var hour = hours[index];
            if(hour !== null) {
              hour['opens'] = moment(hour['opens']).utc().format('YYYY-MM-DD LT');
              hour['closes'] = moment(hour['closes']).utc().format('YYYY-MM-DD LT');
            }
          }
          console.log(hours);
          this[prop] = hours;
        } else {
          this[prop] = args[0][prop];
        }
      }
    }

    Client.prototype = Object.create(User.prototype);

    Client.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Client(data[i]));
        }

        return array;
      } else {
        return new Client(data);
      }
    };

    Client.all = function(params) {
      return API.getClients(params)
        .then(function(data) {
          var response = {
            meta: data.meta,
            data: []
          };

          for (var i = 0; i < data.data.length; i++) {
            response.data.push(Client.newInstance(data.data[i]));
          }

          return response;
        });
    };

    Client.getProvisioningClients = function(params) {
      return API.getProvisioningClients(params)
        .then(function(data) {
          var response = {
            meta: data.meta,
            data: []
          };

          for (var i = 0; i < data.data.length; i++) {
            response.data.push(Client.newInstance(data.data[i]));
          }

          return response;
        });
    };

    Client.get = function(id, params) {
      return API.getClient(id, params)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.getOverviewConfig = function(id, params) {
      return API.getClientOverviewConfig(id, params);
    };

    Client.prototype.updateOverviewConfig = function(data) {
      return API.updateClientOverviewConfig(this.id, data);
    };

    Client.getSAEPipeline = function(params) {
      return API.getSAEPipeline(params)
        .then(function(data) {
          var response = {
            meta: data.meta,
            data: []
          };

          for (var i = 0; i < data.data.length; i++) {
            response.data.push(Client.newInstance(data.data[i]));
          }

          return response;
        });
    };

    Client.prototype.update = function() {
      return API.updateClient(this.id, this)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.progressTo = function(number) {
      if (this.progress < number) {
        this.progress = number;
      }

      return this;
    };

    /* Hot Button */

    Client.prototype.getHotButtons = function() {
      return this.hot_buttons;
    };

    /* Subscription */

    Client.prototype.getSubscription = function() {
      return this.subscription;
    };

    Client.prototype.getPlan = function() {
      var client = this;

      return lodash.find(client.getSubscription().getPackage().plans, function(plan) {
        return plan.id === client.getSubscription().plan_id;
      });
    };

    Client.prototype.setSubscription = function(subscription) {
      this.subscription = subscription;
      return this;
    };

    Client.prototype.updateSubscription = function() {
      return API.updateClientSubscription(this.id, this.getSubscription())
        .then(function(response) {
          return Subscription.newInstance(response);
        });
    };

    /* Billing */

    Client.prototype.getBilling = function() {
      var billing = this.getSubscription().billing;
      if(!billing) {
        this.getSubscription().billing = {};
        return billing;
      }
      return billing;
    };

    Client.prototype.setBilling = function(data) {
      this.getSubscription().billing = data;
      return this;
    };

    Client.prototype.updateBilling = function() {
      var client = this;

      return API.updateBilling(client.id, client.getBilling())
        .then(function(data) {
          return client.setBilling(Address.newInstance(data));
        });
    };

    /* Credit Card */

    Client.prototype.getCreditCard = function() {
      var card = this.getSubscription().card;
      if(!card) {
        this.getSubscription().card = {};
        return card;
      }
      return card;
    };

    Client.prototype.setCreditCard = function(data) {
      this.getSubscription().card = data;
      return this;
    };

    Client.prototype.updateCreditCard = function() {
      var client = this;

      return API.updateCreditCard(client.id, client.getCreditCard())
        .then(function(data) {
          return client.setCreditCard(CreditCard.newInstance(data));
        });
    };

    /* Checking */

    Client.prototype.getChecking = function() {
      var checking = this.getSubscription().check;
      if(!checking) {
        this.getSubscription().check = {};
        return checking;
      }
      return checking;
    };

    Client.prototype.setChecking = function(data) {
      this.getSubscription().check = data;
      return this;
    };

    Client.prototype.updateChecking = function() {
      var client = this;
      return API.updateChecking(client.id, client.getChecking())
        .then(function(data) {
          return client.setChecking(Checking.newInstance(data));
        });
    };

    /* CAP */

    Client.prototype.getCAP = function() {
      return this.cap;
    };

    Client.prototype.setCAP = function(data) {
      this.cap = data;

      return this;
    };

    Client.prototype.updateCAP = function() {
      var client = this;

      return API.updateCAP(this.id, this.getCAP())
        .then(function(response) {
          return client.setCAP(CAP.newInstance(response));
        });
    };

    /* Claim */

    Client.prototype.claim = function() {
      return API.claimClient(this.id)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.updateStatus = function(data) {
      return API.updateClientStatus(this.id, data)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.getNotes = function(params) {
      return API.getClientNotes(this.id, params)
        .then(function(response) {
          return Note.newInstance(response);
        });
    };

    Client.prototype.updateMobileAppQuestionnaire = function(data) {
      return API.updateClientMobileAppQuestionnaire(this.id, data)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.addNote = function(data) {
      return API.addClientNote(this.id, data)
        .then(function(response) {
          return Note.newInstance(response);
        });
    };

    Client.prototype.changePassword = function(password) {
      return API.changeClientPassword(this.id, password)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.changeSalesRep = function(staff_id) {
      return API.changeClientSalesRep(this.id, staff_id)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.changeProvisioner = function(staff_id) {
      return API.changeClientProvisioner(this.id, staff_id)
        .then(function(response) {
          return Client.newInstance(response);
        });
    };

    Client.prototype.exportCAP = function() {
      return API.exportClientCAP(this.id);
    };

    Client.prototype.viewReport = function() {
      return API.viewClientReport(this.id);
    };

    Client.prototype.getOrders = function() {
      return API.getClientOrders(this.id);
    };

    return Client;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Checking', CheckingService);

  /** @ngInject */
  function CheckingService() {

    function Checking() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    Checking.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Checking(data[i]));
        }

        return array;
      } else {
        return new Checking(data);
      }
    };

    return Checking;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('CAP', CAPService);

  /** @ngInject */
  function CAPService() {

    function CAP() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    CAP.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new CAP(data[i]));
        }

        return array;
      } else {
        return new CAP(data);
      }
    };

    return CAP;
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .service('Authentication', AuthenticationService);

  /** @ngInject */
  function AuthenticationService(API, store, $state, $rootScope, jwtHelper, myConfig) {
    var service = this;

    service.isAuthenticated = false;

    service.login = function(credentials) {
      return API.login({
        grant_type: 'password',
        client_id: myConfig.clientId,
        client_secret: myConfig.clientSecret,
        username: credentials.email,
        password: credentials.password
      })
        .then(function(response) {
          store.set('token', response);
          service.isAuthenticated = true;
          return API.getUser();
        })
        .then(function(profile) {
          store.set('profile', profile);
          service.profile = profile;

          if (profile.role.name === 'Admin'
            || profile.role.name === 'Management') {
            $state.go('root.agents');
          } else if (profile.role.name === 'Opener'
            || profile.role.name === 'Closer') {
            $state.go('root.add');
          } else if (profile.role.name === 'Provisioner'
            || profile.role.name === 'Customer Service'
            || profile.role.name === 'Billing'
            || profile.role.name === 'SEO') {
            $state.go('root.provisioning.clients');
          } else if (profile.role.name === 'Sr Account Exec') {
            $state.go('root.clients', {client_id: profile.id});
          }
        });
    };

    service.logout = function() {
      store.remove('token');
      service.isAuthenticated = false;
      $state.go('root-login.login');
    };

    service.checkAuthOnRefresh = function() {
      $rootScope.$on('$locationChangeStart', function() {

        var token = store.get('token');
        if (token && token.access_token) {
          if (!jwtHelper.isTokenExpired(token.access_token)) {
            service.isAuthenticated = true;
            var profile = store.get('profile');
            if (!profile) {
              API.getUser()
                .then(function(profile) {
                  store.set('profile', profile);
                  service.profile = profile;
                });
            } else {
              service.profile = profile;
            }
          } else {
            service.isAuthenticated = false;
            $rootScope.$broadcast('tokenHasExpired', token);
          }
        }
      });
    };

    service.redirectWhenUnauthenticated = function() {
      $rootScope.$on('unauthenticated', function() {
        $state.go('root-login.login');
        service.isAuthenticated = false;
      });
    };

    return service;
  }

})();
(function () {
  'use strict';

  angular
    .module('zoek')
    .service('API', APIService);

  /** @ngInject */
  function APIService(myConfig, $http, $log, $httpParamSerializer) {
    var service = this;

    service.getFlashSaleStatus = function () {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/crm/flash-sale',
      })
        .then(function (response) {
          $log.debug('APIService.getFlashSaleStatus.then', response);
          return response.data;
        });
    };

    service.updateFlashSaleStatus = function (data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/crm/flash-sale',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateFlashSaleStatus.then', response);
          return response.data;
        });
    };

    /* Authentication */

    service.login = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase.replace('/api', '') + '/oauth/token',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.login.then', response);
          return response.data;
        });
    };

    service.getUser = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/user',
        params: params,
        cache: true,
      })
        .then(function (response) {
          $log.debug('APIService.getUser.then', response);
          return response.data;
        });
    };

    /* Add Ons */

    service.getAddOns = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiV2Base + '/addons',
        cache: true,
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getAddOns.then', response);
          return response.data;
        });
    };

    /* Packages */

    service.getPackages = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiV2Base + '/packages',
        cache: true,
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getPackages.then', response);
          return response.data;
        });
    };

    /* Tickets */

    service.createTicket = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/tickets',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.createTicket.then', response);
          return response.data;
        });
    };

    /* Agents */

    service.createAgent = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/agents',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.createAgent.then', response);
          return response.data;
        });
    };

    service.getAgents = function (config) {
      return $http.get(myConfig.apiBase + '/agents', config)
        .then(function (response) {
          $log.debug('APIService.getAgents.then', response);
          return response.data;
        });
    };

    service.getAgent = function (id, params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/agents/' + id,
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getAgent.then', response);
          return response.data;
        });
    };

    service.updateEmployee = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/agents/' + id,
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateEmployee.then', response);
          return response.data;
        });
    };

    service.removeAgent = function (id) {
      return $http({
        method: 'DELETE',
        url: myConfig.apiBase + '/agents/' + id,
      })
        .then(function (response) {
          $log.debug('APIService.removeAgent.then', response);
          return response.data;
        });
    };

    service.changeAgentPassword = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/agents/' + id + '/password',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.changeAgentPassword.then', response);
          return response.data;
        });
    };

    service.getLeadsCreatedPerDayOfAgent = function (id, params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/agents/' + id + '/leads-created-per-day',
        params: params,
        cache: true,
      })
        .then(function (response) {
          $log.debug('APIService.getLeadsCreatedPerDayOfAgent.then', response);
          return response.data;
        });
    };

    /* Leads */

    service.createLead = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/leads',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.createLead.then', response);
          return response.data;
        });
    };

    service.convertLead = function (id, data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/leads/' + id + '/convert',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.convertLead.then', response);
          return response.data;
        });
    };

    service.getLeads = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/leads',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getLeads.then', response);
          return response.data;
        });
    };

    service.deleteLead = function (id) {
      return $http({
        method: 'DELETE',
        url: myConfig.apiBase + '/leads/' + id,
      });
    };

    service.getRecommendedPackage = function (id) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/leads/' + id + '/recommended-package',
      })
        .then(function (response) {
          $log.debug('APIService.getRecommendedPackage.then', response);
          return response.data;
        });
    };

    service.getLead = function (id, params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/leads/' + id,
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getLead.then', response);
          return response.data;
        });
    };

    service.updateLead = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id,
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.update.then', response);
          return response.data;
        });
    };

    service.updateLeadAddress = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/address',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateLeadAddress.then', response);
          return response.data;
        });
    };

    service.updateLeadQuestionnaires = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/questionnaires',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateLeadQuestionnaires.then', response);
          return response.data;
        });
    };

    service.updateLeadMobileAppQuestionnaire = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/mobile-app-questionnaire',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateLeadMobileAppQuestionnaire.then', response);
          return response.data;
        });
    };

    service.saveLeadSubscription = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/subscription',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.saveLeadSubscription.then', response);
          return response.data;
        });
    };

    service.updateLeadSubscriptionCreditCard = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/subscription/card',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateLeadSubscriptionCreditCard.then', response);
          return response.data;
        });
    };

    service.updateLeadSubscriptionBilling = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/subscription/billing',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateLeadSubscriptionBilling.then', response);
          return response.data;
        });
    };

    service.updateDisposition = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/disposition',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateDisposition.then', response);
          return response.data;
        });
    };

    service.createCallBack = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/callbacks',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.createCallBack.then', response);
          return response.data;
        });
    };

    service.claimLead = function (id, data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/leads/' + id + '/claim',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.claimLead.then', response);
          return response.data;
        });
    };

    /* Clients */

    service.getClientBusinessHours = function (id) {
      return $http({
        method: 'GET',
        url: myConfig.apiV2Base + '/clients/' + id + '/business/hours',
      })
        .then(function (response) {
          $log.debug('APIService.getClientBusinessHours.then', response);
          return response.data;
        });
    };

    service.updateClientBusinessHours = function (id, business_hours) {
      return $http({
        method: 'PUT',
        url: myConfig.apiV2Base + '/clients/' + id + '/business/hours',
        data: {
          business_hours: business_hours,
        },
      })
        .then(function (response) {
          $log.debug('APIService.updateClientBusinessHours.then', response);
          return response.data;
        });
    };

    service.claimClient = function (id) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/clients/' + id + '/claim',
      })
        .then(function (response) {
          $log.debug('APIService.claimClient.then', response);
          return response.data;
        });
    };

    service.getProvisioningClients = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/provisioning',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getProvisioningClients.then', response);
          return response.data;
        });
    };

    service.getClient = function (id, params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/' + id,
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getClient.then', response);
          return response.data;
        });
    };

    service.updateClient = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id,
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateClient.then', response);
          return response.data;
        });
    };

    service.getClients = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getClients.then', response);
          return response.data;
        });
    };

    /* Logs */

    service.getLogs = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/logs',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getLogs.then', response);
          return response.data;
        });
    };

    /* Billing */

    service.updateBilling = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/subscription/billing',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateBilling.then', response);
          return response.data;
        });
    };

    /* Overview Config */

    service.getClientOverviewConfig = function (id, data) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/' + id + '/config',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.getClientOverviewConfig.then', response);
          return response.data;
        });
    };

    service.updateClientOverviewConfig = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/config',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateClientOverviewConfig.then', response);
          return response.data;
        });
    };

    /* Credit Card */

    service.updateCreditCard = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/subscription/card',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateCard.then', response);
          return response.data;
        });
    };

    /* Checking */

    service.updateLeadChecking = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiV2Base + '/leads/' + id + '/subscription/check',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateLeadChecking.then', response);
          return response.data;
        });
    };

    service.updateChecking = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiV2Base + '/clients/' + id + '/subscription/check',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateChecking.then', response);
          return response.data;
        });
    };

    /* CAP */

    service.updateCAP = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/cap',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateCAP.then', response);
          return response.data;
        });
    };

    /* Mobile App Questionnaire */

    service.updateClientMobileAppQuestionnaire = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/mobile-app-questionnaire',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateClientMobileAppQuestionnaire.then', response);
          return response.data;
        });
    };

    /* Client Subscription */

    service.updateClientSubscription = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/subscription',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateClientSubscription.then', response);
          return response.data;
        });
    };

    /* Notes */

    service.getClientNotes = function (id, params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/' + id + '/notes',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getClientNotes.then', response);
          return response.data;
        });
    };

    service.getLeadNotes = function (id, params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/leads/' + id + '/notes',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getLeadNotes.then', response);
          return response.data;
        });
    };

    service.addLeadNote = function (id, data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/leads/' + id + '/notes',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.addLeadNote.then', response);
          return response.data;
        });
    };

    service.addClientNote = function (id, data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/clients/' + id + '/notes',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.addClientNote.then', response);
          return response.data;
        });
    };

    service.requestResetPassword = function (email) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/reset-password',
        params: {
          email: email,
        },
      })
        .then(function (response) {
          $log.debug('APIService.requestResetPassword.then', response);
          return response.data;
        });
    };

    service.resetPassword = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/reset-password',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.resetPassword.then', response);
          return response.data;
        });
    };

    service.loginOverride = function (data) {
      return $http({
        method: 'POST',
        url: myConfig.apiBase + '/override',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.loginOverride.then', response);
          return response.data;
        });
    };

    service.updateClientStatus = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/status',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.updateClientStatus.then', response);
          return response.data;
        });
    };

    service.changeLeadSalesRep = function (id, staff_id) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/leads/' + id + '/sales',
        data: {
          staff_id: staff_id,
        },
      })
        .then(function (response) {
          $log.debug('APIService.changeLeadSalesRep.then', response);
          return response.data;
        });
    };

    service.changeClientSalesRep = function (id, staff_id) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/sales',
        data: {
          staff_id: staff_id,
        },
      })
        .then(function (response) {
          $log.debug('APIService.changeClientSalesRep.then', response);
          return response.data;
        });
    };

    service.changeClientProvisioner = function (id, staff_id) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/provisioner',
        data: {
          staff_id: staff_id,
        },
      })
        .then(function (response) {
          $log.debug('APIService.changeClientProvisioner.then', response);
          return response.data;
        });
    };

    service.changeClientPassword = function (id, data) {
      return $http({
        method: 'PUT',
        url: myConfig.apiBase + '/clients/' + id + '/password',
        data: data,
      })
        .then(function (response) {
          $log.debug('APIService.changeClientPassword.then', response);
          return response.data;
        });
    };

    service.exportClientCAP = function (id) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/' + id + '/cap/export',
      });
    };

    service.viewClientReport = function (id) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/' + id + '/rankings',
      })
        .then(function (response) {
          $log.debug('APIService.viewClientReport.then', response);
          return response.data;
        });
    };

    service.getClientOrders = function (id) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/' + id + '/orders',
        cache: true,
      })
        .then(function (response) {
          $log.debug('APIService.getClientOrders.then', response);
          return response.data;
        });
    };

    service.getSAEPipeline = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/sae-pipeline',
        params: params,
      })
        .then(function (response) {
          $log.debug('APIService.getSAEPipeline.then', response);
          return response.data;
        });
    };

    /* Filters */

    service.getFilterBySalesReps = function () {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/filters/sales-reps',
        cache: true,
      })
        .then(function (response) {
          $log.debug('APIService.getFilterBySalesReps.then', response);
          return response.data;
        });
    };

    service.getFilterByProvisioners = function () {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/filters/provisioners',
        cache: true,
      })
        .then(function (response) {
          $log.debug('APIService.getFilterByProvisioners.then', response);
          return response.data;
        });
    };

    /* Ranking Report */

    service.getRankingReportUrl = function (id) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/ranking-reports/' + id,
        cache: true,
      })
        .then(function (response) {
          $log.debug('APIService.getRankingReportUrl.then', response);
          return response.data;
        });
    };

    /* Export */

    service.exportLeads = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/leads/export?' + $httpParamSerializer(params),
      });
    };

    service.exportClients = function (params) {
      return $http({
        method: 'GET',
        url: myConfig.apiBase + '/clients/export?' + $httpParamSerializer(params),
      });
    };

    /* Proposals */

    service.sendProposal = function (data) {
      return $http.post(myConfig.apiV2Base + '/proposals', data)
        .then(function (response) {
          $log.debug('APIService.sendProposal.then', response);
          return response.data;
        });
    };

    service.fetchAllProposals = function () {
      return $http.get(myConfig.apiV2Base + '/proposals', {cache: true})
        .then(function (response) {
          $log.debug('APIService.fetchAllProposals.then', response);
          return response.data;
        });
    };

    /* Custom Price */

    service.updateCustomPrice = function (id, custom_price) {
      return $http.put(myConfig.apiV2Base + '/clients/' + id + '/subscription/custom_price', {custom_price: custom_price})
        .then(function (response) {
          $log.debug('APIService.updateCustomPrice.then', response);
          return response.data;
        });
    };

    service.getClientSubscription = function (id) {
      return $http.get(myConfig.apiV2Base + '/clients/' + id + '/subscription')
        .then(function (response) {
          $log.debug('APIService.getClientSubscription.then', response);
          return response.data;
        });
    };

    return service;
  }
})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('Address', AddressService);

  /** @ngInject */
  function AddressService() {

    function Address() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    Address.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new Address(data[i]));
        }

        return array;
      } else {
        return new Address(data);
      }
    };

    return Address;
  }

})();

/**
 * Created by kevinem on 5/20/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .factory('AddOn', AddOnService);

  /** @ngInject */
  function AddOnService() {

    function AddOn() {
      var args = Array.prototype.slice.call(arguments);

      for (var prop in args[0]) {
        this[prop] = args[0][prop];
      }
    }

    AddOn.newInstance = function(data) {
      if (Array.isArray(data)) {
        var array = [];

        for (var i = 0; i < data.length; i++) {
          array.push(new AddOn(data[i]));
        }

        return array;
      } else {
        return new AddOn(data);
      }
    };

    return AddOn;
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appUnauthorized', {
      templateUrl: 'app/unauthorized/unauthorized.html'
    });
})();



(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appSAEPipeline', {
      templateUrl: 'app/sae-pipeline/sae-pipeline.html',
      controller: SAEPipelineController,
      bindings: {
        clients: '<'
      }
    });

  /** @ngInject */
  function SAEPipelineController($state, $stateParams, ExportModal, ExportService) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function(client) {
      $state.go('root.client.overview', {client_id: client.id});
    };

    vm.handleFilter = function(query) {
      $state.go('root.sae-pipeline', query, {reload: true});
    };

    vm.handleExport = function(query) {
      ExportModal(function() {
        return ExportService.exportSAEPipeline(query);
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appRootLogin', {
      templateUrl: 'app/root-login/root-login.html'
    });
})();



(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appRoot', {
      templateUrl: 'app/root/root.html',
      controller: RootController
    });

  /** @ngInject */
  function RootController(Authentication, Navigation, CRM) {
    var vm = this;

    vm.$onInit = function() {
      vm.navigation = Navigation;
      CRM.getState();
    };

    vm.logout = function() {
      Authentication.logout();
    };
  }
})();


(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appResetPassword', {
      templateUrl: 'app/reset-password/reset-password.html',
      controller: ResetPasswordController,
      bindings: {
        token: '<'
      }
    });

  /** @ngInject */
  function ResetPasswordController($state, toastr, API) {
    var vm = this;

    vm.resetPassword = function() {
      vm.loading = API.resetPassword({
        token: vm.token,
        password: vm.newPassword,
        password_confirmation: vm.confirmPassword
      })
        .then(function() {
          toastr.success('Password has been reset');
          $state.go('root_login.login');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appQuickAdd', {
      templateUrl: 'app/quick-add/quick-add.html',
      controller: Controller,
      bindings: {
        addOns: '<'
      }
    });

  /** @ngInject */
  function Controller(Lead, $state, states, $document, $mdDialog, API, toastr, CustomizePackage,
                      ListingSyncDisclosureModal, CloserAgreementModal, PaymentSuccessfulModal,
                      AppALaCarteDisclosureModal, NotesModal, HotButtonsModal, ProposalModal) {
    var vm = this;

    vm.$onInit = function () {
      vm.states = states;
      vm.marketingMethods = [
        'Social Media',
        'Mobile App',
        'Review Monitoring',
        'Search Engine Optimization',
        'Video',
        'PPC'
      ];

      vm.lead = Lead.newInstance({
        marketing: [],
        hot_buttons: [],
      });
    };

    vm.save = function () {
      vm.loading = createOrUpdateLead()
        .then(function (lead) {
          if (vm.lead.id) {
            vm.lead = Lead.newInstance(lead);
            return toastr.success('Lead has been updated');
          }

          vm.lead = Lead.newInstance(lead);
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Lead Successful Added')
              .textContent('Here is your lead number: ' + lead.lead_no)
              .ok('Okay')
          );
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.saveAndConvert = function () {
      if (!vm.lead.first_name) {
        return toastr.error('First name is required to convert');
      }

      if (!vm.lead.last_name) {
        return toastr.error('Last name is required to convert');
      }

      if (!vm.lead.email) {
        return toastr.error('Email is required to convert');
      }

      if (!vm.lead.phone) {
        return toastr.error('Phone is required to convert');
      }

      if (!vm.lead.subscription) {
        return toastr.error('Subscription is required to convert');
      }

      if (!vm.billing || !vm.billing.line1 || !vm.billing.city || !vm.billing.state || !vm.billing.postal || !vm.billing.country) {
        return toastr.error('Billing is required to convert');
      }

      if (!vm.card || !vm.card.name || !vm.card.number || !vm.card.exp_date || !vm.card.cvc) {
        return toastr.error('Credit Card is required to convert');
      }

      vm.loading = createOrUpdateLead()
        .then(function (lead) {
          vm.lead = Lead.newInstance(lead);
          return showDisclosure({ billing: vm.billing, card: vm.card }, vm.lead);
        })
        .then(function (client) {
          return PaymentSuccessfulModal(client);
        })
        .then(function (client) {
          $state.go('root.client.overview', { client_id: client.id });
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.handleOnClickPackage = function (e) {
      CustomizePackage({
        lead: vm.lead,
        pkg: e.package,
        addOns: vm.addOns,
        handle: function (subscription, $mdDialog) {
          vm.lead.setSubscription(subscription);
          $mdDialog.hide();
        }
      });
    };

    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    function createOrUpdateLead() {
      return vm.lead.id ? vm.lead.update().then(function() {
        return vm.lead.updateAddress(vm.lead.address);
      }) : API.createLead(vm.lead);
    }

    function showDisclosure(paymentInfo, lead) {
      if (vm.lead.subscription.package_id === '57ae658b2f16c4f89c44245e') {
        return ListingSyncDisclosureModal(paymentInfo, lead);
      } else if (vm.lead.subscription.package_id === '57ae0bb02f16c4f89c44244e') {
        return AppALaCarteDisclosureModal(paymentInfo, lead);
      } else {
        return CloserAgreementModal(paymentInfo, lead);
      }
    }

    vm.openNotesModal = function(e) {
      NotesModal(e, vm.lead);
    };

    vm.openHotButtonModal = function(e) {
      HotButtonsModal(e, vm.lead);
    };

    vm.openProposalModal = function() {
      ProposalModal({
        lead: vm.lead
      });
    };

    vm.openDispositionModal = function(e) {
      DispositionModal(e, vm.lead);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appQualifiersPayment', {
      templateUrl: 'app/qualifiers-payment/qualifiers-payment.html',
      controller: QualifiersPaymentController,
      bindings: {
        lead: '<'
      }
    });

  /** @ngInject */
  function QualifiersPaymentController($state, CreditCard, store, ListingSyncDisclosureModal,
                                       CloserAgreementModal, PaymentSuccessfulModal, AppALaCarteDisclosureModal) {
    var vm = this;

    vm.$onInit = function () {
      var session = store.get('zoek.qualifiers.payment');

      vm.billing = session && session.billing ? session.billing : vm.lead.subscription.billing;

      vm.card = session && session.card ? session.card : vm.lead.subscription.card;

      //Autofill credit card name
      if (angular.isUndefined(vm.card)) {
        vm.card = CreditCard.newInstance({name: vm.lead.name});
      }
    };

    vm.submit = function (paymentInfo) {
      vm.loading = showDisclosure(paymentInfo, vm.lead)
        .then(function (client) {
          return PaymentSuccessfulModal(client);
        })
        .then(function () {
          return $mdDialog.show(
            $mdDialog.confirm()
              .textContent('Ok, thank you so much and congratulations (OWNER NAME), your payment was\n' +
                'accepted for $xxx.xx.\n' +
                '\n' +
                'Before I transfer you over to meet your PMC can you please take a second to check your email to make sure that you received your receipt for today\'s investment and welcome email? I just want to make sure that we aren’t going to spam or have the incorrect email for you on file.')
              .ok('YES')
              .cancel('NO')
          )
            .then(function () {
              return $mdDialog.show(
                $mdDialog.confirm()
                  .textContent('Ok great, thanks for confirming that for me. Your CID (XXXXX) is on there as well as our contact for future reference. Hold on one second while I transfer you over / thank you again for your business we will attempt to contact you on (DATE) for your PMC setup call.')
                  .ok('Okay')
              );
            })
            .catch(function () {
              return $mdDialog.show(
                $mdDialog.confirm()
                  .textContent('Ok it’s important that you find it, can you first confirm the email that we have for you? I have (SPELL OUT EMAIL). If that is correct, please take a second and check your junk mail, if it is in there please take it out of spam that way our future emails will be easier for you to find.')
                  .ok('Okay')
              );
            });
        })
        .then(function () {
          $state.go('root.qualifiers.leads');
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.goBack = function (event) {
      store.set('zoek.qualifiers.payment', event);
      $state.go('root.qualifiers.lead.package-details');
    };

    function showDisclosure(paymentInfo, lead) {
      if (vm.lead.subscription.package_id === '57ae658b2f16c4f89c44245e') {
        return ListingSyncDisclosureModal(paymentInfo, lead);
      } else if (vm.lead.subscription.package_id === '57ae0bb02f16c4f89c44244e') {
        return AppALaCarteDisclosureModal(paymentInfo, lead);
      } else {
        return CloserAgreementModal(paymentInfo, lead);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appQualifiersPackageDetails', {
      templateUrl: 'app/qualifiers-package-details/qualifiers-package-details.html',
      controller: QualifiersPackageDetailsController,
      bindings: {
        lead: '<'
      }
    });

  /** @ngInject */
  function QualifiersPackageDetailsController($state) {
    var vm = this;

    vm.$onInit = function() {
      if (!vm.lead.authorized_users) {
        vm.lead.authorized_users = vm.lead.name;
      }

      if (!vm.lead.email_for_contact) {
        vm.lead.email_for_contact = vm.lead.email;
      }

      if (!vm.lead.parking_available) {
        vm.lead.parking_available = [];
      }

      if (!vm.lead.languages_spoken) {
        vm.lead.languages_spoken = [];
      }

      if (!vm.lead.payments_accepted) {
        vm.lead.payments_accepted = [];
      }
    };

    vm.saveSubscription = function() {
      vm.loading = vm.lead.saveSubscription()
        .then(function() {
          return vm.lead.updateProgress(4);
        })
        .then(function() {
          return vm.lead.update();
        })
        .then(function() {
          $state.go('root.qualifiers.lead.payment');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appQualifiersPackage', {
      templateUrl: 'app/qualifiers-package/qualifiers-package.html',
      controller: QualifiersPackageController,
      bindings: {
        lead: '<',
        packages: '<',
        addOns: '<'
      }
    });

  /** @ngInject */
  function QualifiersPackageController(packageIncludes, $state, CustomizePackage) {
    var vm = this;

    vm.$onInit = function () {
      vm.packageIncludes = packageIncludes;

      if (vm.lead.hasSubscription()) {
        vm.handleOnClickPackage({
          package: vm.lead.getSubscription().getPackage()
        });
      }
    };

    vm.handleOnClickPackage = function (e) {
      CustomizePackage({
        lead: vm.lead,
        pkg: e.package,
        addOns: vm.addOns
      })
        .then(function () {
          return vm.lead.updateProgress(3);
        })
        .then(function () {
          $state.go('root.qualifiers.lead.package-details');
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appQualifiersLeads', {
      templateUrl: 'app/qualifiers-leads/qualifiers-leads.html',
      controller: QualifiersLeadsController,
      bindings: {
        leads: '<'
      }
    });

  /** @ngInject */
  function QualifiersLeadsController($state, $mdDialog, $stateParams, ExportModal, ExportService) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function (lead) {
      var confirm = $mdDialog.confirm()
        .title('Claim Lead')
        .textContent('Are you claiming this lead?')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        switch (lead.progress) {
          case 2:
            $state.go('root.qualifiers.lead.package-details', {lead_id: lead.id});
            break;
          case 3:
            $state.go('root.qualifiers.lead.payment', {lead_id: lead.id});
            break;
          default:
            $state.go('root.qualifiers.lead.package', {lead_id: lead.id});
            break;
        }
      });
    };

    vm.handleFilter = function (query) {
      $state.go('root.qualifiers.leads', query, {reload: true});
    };

    vm.handleExport = function (query) {
      ExportModal(function () {
        return ExportService.exportLeads(query);
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appQualifiersLead', {
      templateUrl: 'app/qualifiers-lead/qualifiers-lead.html',
      controller: QualifiersLeadController,
      bindings: {
        lead: '<'
      }
    });

  /** @ngInject */
  function QualifiersLeadController($state, $mdDialog, $document, NotesModal, HotButtonsModal, ViewLeadModal) {
    var vm = this;

    vm.openHotButtonsModal = function(e) {
      HotButtonsModal(e, vm.lead);
    };

    vm.openNotesModal = function(e) {
      NotesModal(e, vm.lead);
    };

    vm.openSaveModal = function(ev) {
      $mdDialog.show({
        templateUrl: 'app/components/save_modal/save_modal.html',
        controller: 'SaveModalController',
        controllerAs: 'saveModal',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          lead: vm.lead
        }
      })
        .then(function(response) {
          if (response === 'disposition' || response === 'exit') {
            $state.go('root.closer.leads');
          }
        });
    };

    vm.openViewLeadModal = function(e) {
      ViewLeadModal(e, vm.lead);
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appQualifiers', {
      templateUrl: 'app/qualifiers/qualifiers.html'
    });
})();


(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningMobileApp', {
      templateUrl: 'app/provisioning-mobile-app/provisioning-mobile-app.html',
      controller: ProvisioningMobileAppController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningMobileAppController($state, $mdDialog, $document) {
    var vm = this;

    vm.handleSubmit = function(e) {
      vm.loading = vm.client.updateMobileAppQuestionnaire(e.questionnaire)
        .then(function(client) {
          return client.progressTo(13).update();
        })
        .then(function(client) {
          return client.updateStatus({
            status: 'active'
          });
        })
        .then(function() {
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Client status has been set to active')
              .ok('Okay')
          );
        })
        .then(function() {
          $state.go('root.provisioning.clients');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.handleGoBack = function() {
      $state.go('root.provisioning.clients');
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningListingSync', {
      templateUrl: 'app/provisioning-listing-sync/provisioning-listing-sync.html',
      controller: ProvisioningListingSyncController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningListingSyncController($state, $mdDialog, $document) {
    var vm = this;

    vm.handleSubmit = function(e) {
      vm.loading = e.client.progressTo(13).update()
        .then(function(client) {
          return client.updateStatus({
            status: 'active'
          });
        })
        .then(function() {
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Client status has been set to active')
              .ok('Okay')
          );
        })
        .then(function() {
          $state.go('root.provisioning.clients');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.handleGoBack = function() {
      $state.go('root.provisioning.clients');
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClients', {
      templateUrl: 'app/provisioning-clients/provisioning-clients.html',
      controller: ProvisioningClientsController,
      bindings: {
        clients: '<',
        provisioners: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientsController($state, $stateParams, ExportModal, ExportService) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function(client) {
      client.claim()
        .then(function(claimedClient) {
          if (claimedClient.subscription.package_id === '57ae658b2f16c4f89c44245e') {
            $state.go('root.provisioning.listing-sync', {client_id: claimedClient.id});
          } else if (claimedClient.subscription.package_id === '57ae0bb02f16c4f89c44244e') {
            $state.go('root.provisioning.mobile-app', {client_id: claimedClient.id});
          }
          else {
            $state.go('root.provisioning.client.step' + (claimedClient.progress + 1), {client_id: claimedClient.id});
          }
        });
    };

    vm.handleFilter = function(query) {
      $state.go('root.provisioning.clients', query, {reload: true});
    };

    vm.handleExport = function(query) {
      ExportModal(function() {
        return ExportService.exportClients(query);
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep9', {
      templateUrl: 'app/provisioning-client-step9/provisioning-client-step9.html',
      controller: ProvisioningClientStep9Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep9Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(9).update()
        .then(function() {
          $state.go('root.provisioning.client.step10');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep8', {
      templateUrl: 'app/provisioning-client-step8/provisioning-client-step8.html',
      controller: ProvisioningClientStep8Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep8Controller($state, API) {
    var vm = this;

    vm.listingLive = function() {
      $state.go('root.provisioning.client.step9');
    };

    vm.callbackPostCard = function() {
      vm.loading = API.createTicket({
        client_no: vm.client.client_no,
        ticket: 'send_postcard'
      })
        .then(function() {
          vm.client.select_post_card = true;
          return vm.client.progressTo(8).update();
        })
        .then(function() {
          $state.go('root.pinner.client.step9');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep7', {
      templateUrl: 'app/provisioning-client-step7/provisioning-client-step7.html',
      controller: ProvisioningClientStep7Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep7Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(8).update()
        .then(function() {
          $state.go('root.provisioning.client.step9');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.addManagement = function() {
      vm.client.select_management = true;

      vm.loading = vm.client.progressTo(8).update()
        .then(function() {
          $state.go('root.provisioning.client.step9');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep6', {
      templateUrl: 'app/provisioning-client-step6/provisioning-client-step6.html',
      controller: ProvisioningClientStep6Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep6Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(6).update()
        .then(function() {
          $state.go('root.provisioning.client.step7');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep5', {
      templateUrl: 'app/provisioning-client-step5/provisioning-client-step5.html',
      controller: ProvisioningClientStep5Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep5Controller($state, API) {
    var vm = this;

    vm.optOut = function() {
      vm.opttingout = API.createTicket({
        client_no: vm.client.client_no,
        ticket: 'opt_out_call_tracking'
      })
        .then(function() {
          return vm.client.progressTo(5).update()
        })
        .then(function() {
          $state.go('root.provisioning.client.step6');
        })
        .finally(function() {
          vm.opttingout = false;
        });
    };

    vm.optIn = function() {
      vm.opttingin = API.createTicket({
        client_no: vm.client.client_no,
        ticket: 'opt_in_call_tracking'
      })
        .then(function() {
          return vm.client.progressTo(5).update();
        })
        .then(function() {
          $state.go('root.provisioning.client.step6');
        })
        .finally(function() {
          vm.opttingin = false;
        });
    };

    vm.next = function() {
      vm.loading = vm.client.progressTo(5).update()
        .then(function() {
          $state.go('root.provisioning.client.step6');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep4', {
      templateUrl: 'app/provisioning-client-step4/provisioning-client-step4.html',
      controller: ProvisioningClientStep4Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep4Controller($state, LoginModal) {
    var vm = this;

    vm.$onInit = function() {
      vm.number_of_cities = vm.client.getSubscription().number_of_cities;
      vm.package_name = vm.client.getSubscription().getPackage().name;
      vm.cities = vm.client.getSubscription().cities;
    };

    vm.updateCities = function() {
      vm.loading = vm.client.updateSubscription()
        .then(function() {
          return vm.client.progressTo(4).update();
        })
        .then(function() {
          $state.go('root.provisioning.client.step5');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.selectCitiesLater = function(e) {
      LoginModal(e)
        .then(function() {
          vm.loading = true;
          return vm.client.progressTo(4).update();
        })
        .then(function() {
          $state.go('root.provisioning.client.step5');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep3', {
      templateUrl: 'app/provisioning-client-step3/provisioning-client-step3.html',
      controller: ProvisioningClientStep3Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep3Controller($state, LoginModal) {
    var vm = this;

    vm.$onInit = function() {
      vm.keywords = vm.client.getSubscription().keywords;
    };

    vm.updateKeywords = function() {
      vm.loading = vm.client.updateSubscription()
        .then(function() {
          return vm.client.progressTo(3).update();
        })
        .then(function() {
          $state.go('root.provisioning.client.step4');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.selectKeywordsLater = function(e) {
      LoginModal(e)
        .then(function() {
          vm.loading = true;
          return vm.client.progressTo(3).update();
        })
        .then(function() {
          $state.go('root.provisioning.client.step4');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep2', {
      templateUrl: 'app/provisioning-client-step2/provisioning-client-step2.html',
      controller: ProvisioningClientStep2Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep2Controller($state, toastr, UpdateEmailModal) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(2).update()
        .then(function() {
          $state.go('root.provisioning.client.step3');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.openUpdateEmailModal = function(e) {
      UpdateEmailModal(e, vm.client)
        .then(function() {
          vm.loading = vm.client.progressTo(2).update({
            resend_emails: true
          });
          return vm.loading;
        })
        .then(function() {
          toastr.success('Successfully updated email');
          $state.go('root.provisioning.client.step3');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep14', {
      templateUrl: 'app/provisioning-client-step14/provisioning-client-step14.html',
      controller: ProvisioningClientStep14Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep14Controller($state, $mdDialog, $document) {
    var vm = this;

    vm.finish = function() {
      vm.loading = vm.client.progressTo(13).update()
        .then(function(client) {
          vm.client = client;

          return vm.client.updateStatus({
            status: 'active'
          });
        })
        .then(function() {
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Client status has been set to active')
              .ok('Okay')
          );
        })
        .then(function() {
          $state.go('root.provisioning.clients');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep12', {
      templateUrl: 'app/provisioning-client-step12/provisioning-client-step12.html',
      controller: ProvisioningClientStep12Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep12Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(12).update()
        .then(function() {
          $state.go('root.provisioning.client.step13');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep13', {
      templateUrl: 'app/provisioning-client-step13/provisioning-client-step13.html',
      controller: ProvisioningClientStep13Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep13Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(13).update()
        .then(function() {
          $state.go('root.provisioning.client.step14');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep11', {
      templateUrl: 'app/provisioning-client-step11/provisioning-client-step11.html',
      controller: ProvisioningClientStep11Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep11Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(11).update()
        .then(function() {
          $state.go('root.provisioning.client.step12');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep10', {
      templateUrl: 'app/provisioning-client-step10/provisioning-client-step10.html',
      controller: ProvisioningClientStep10Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep10Controller($state) {
    var vm = this;

    vm.next = function() {
      vm.loading = vm.client.progressTo(10).update()
        .then(function() {
          $state.go('root.provisioning.client.step11');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClientStep1', {
      templateUrl: 'app/provisioning-client-step1/provisioning-client-step1.html',
      controller: ProvisioningClientStep1Controller,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientStep1Controller($state, store) {
    var vm = this;

    vm.$onInit = function() {
      vm.profile = store.get('profile');
    };

    vm.next = function() {
      vm.loading = vm.client.progressTo(1).update()
        .then(function() {
          $state.go('root.provisioning.client.step2');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioningClient', {
      templateUrl: 'app/provisioning-client/provisioning-client.html',
      controller: ProvisioningClientController,
      bindings: {
        client: '<',
        packages: '<',
        addOns: '<'
      }
    });

  /** @ngInject */
  function ProvisioningClientController(NotesModal, HotButtonsModal, ViewClientModal, ChangeStatusModal,
                                        EditSubscriptionModal) {
    var vm = this;

    vm.openHotButtonsModal = function(e) {
      HotButtonsModal(e, vm.client);
    };

    vm.openNotesModal = function(e) {
      NotesModal(e, vm.client);
    };

    vm.openViewClientModal = function(e) {
      ViewClientModal(e, vm.client);
    };

    vm.openEditSubscriptionModal = function(e) {
      EditSubscriptionModal(e, vm.client);
    };

    vm.openChangeStatusModal = function(e) {
      ChangeStatusModal(e, vm.client);
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisioning', {
      templateUrl: 'app/provisioning/provisioning.html'
    });
})();



(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appProvisionerClients', {
      templateUrl: 'app/provisioner-clients/provisioner-clients.html',
      controller: ProvisionerClientsController,
      bindings: {
        clients: '<',
        pinner: '<'
      }
    });

  /** @ngInject */
  function ProvisionerClientsController(Client, $stateParams) {
    var vm = this;

    vm.$onInit = function() {
      vm.status = $stateParams.status || 'claimed';
    };

    vm.getClient = function(query) {
      vm.filtering = Client.all(angular.extend({
        order: 'client_no',
        claimed: $stateParams.pinner_id,
        status: $stateParams.status
      }, query))
        .then(function(clients) {
          vm.clients = clients
        })
        .finally(function() {
          vm.filtering = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appNotFound', {
      templateUrl: 'app/not-found/not-found.html'
    });
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appLogin', {
      templateUrl: 'app/login/login.html',
      controller: LoginController
    });

  /** @ngInject */
  function LoginController(Authentication) {
    var vm = this;

    vm.login = function(credentials) {
      return Authentication.login(credentials);
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appLeadsShow', {
      templateUrl: 'app/leads-show/leads-show.html',
      controller: LeadsShowController,
      bindings: {
        lead: '<',
        salesReps: '<',
        addOns: '<'
      }
    });

  /** @ngInject */
  function LeadsShowController(Lead, $document, $state, states, toastr, $mdDialog, ProposalModal, NotesModal,
                               HotButtonsModal, DispositionModal, CustomizePackage,
                               PrepayDisclosureModal,
                               ListingSyncDisclosureModal, CloserAgreementModal,
                               PaymentSuccessfulModal, AppALaCarteDisclosureModal) {
    var vm = this;

    vm.save = function () {
      vm.states = states;
      vm.loading = vm.lead.update()
        .then(function () {
          return vm.lead.updateAddress(vm.lead.address);
        })
        .then(function () {
          toastr.success('Lead has been updated');
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.openNotesModal = function (e) {
      NotesModal(e, vm.lead);
    };

    vm.openDispositionModal = function (e) {
      DispositionModal(e, vm.lead);
    };

    vm.openHotButtonModal = function (e) {
      HotButtonsModal(e, vm.lead);
    };

    vm.changeSalesRep = function (event) {
      vm.loading = vm.lead.changeSalesRep(event.rep.id)
        .then(function () {
          vm.lead.closer = event.rep;
          toastr.success('Successfully Changed Sales Representative');
        })
        .finally(function () {
          vm.loading = false;
          vm.editingSalesRep = false;
        });
    };

    vm.deleteLead = function (ev) {
      $mdDialog.show($mdDialog.confirm()
        .parent(angular.element($document.body))
        .title('Delete ' + vm.lead.name)
        .textContent('Are you sure?')
        .targetEvent(ev)
        .ok('Yes')
        .cancel('No'))
        .then(function () {
          vm.loading = true;

          return vm.lead.deleteLead();
        })
        .then(function () {
          $state.go('root.leads.list');
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.convertPrepay = function () {
      if (!vm.lead.first_name) {
        return toastr.error('First name is required to convert');
      }

      if (!vm.lead.last_name) {
        return toastr.error('Last name is required to convert');
      }

      if (!vm.lead.email) {
        return toastr.error('Email is required to convert');
      }

      if (!vm.lead.phone) {
        return toastr.error('Phone is required to convert');
      }

      if (!vm.lead.subscription) {
        return toastr.error('Subscription is required to convert');
      }

      if (!vm.check || !vm.check.bank || !vm.check.routing || !vm.check.account) {
        return toastr.error('Check info is required to convert');
      }

      vm.loading = vm.lead.update()
        .then(function () {
          return vm.lead.updateChecking(vm.check);
        })
        .then(function () {
          return vm.lead.updateAddress(vm.lead.address);
        })
        .then(function (lead) {
          vm.lead = Lead.newInstance(lead);
          return PrepayDisclosureModal({
            paymentInfo: {
              billing: vm.billing,
              card: vm.card,
              check: vm.check,
            },
          }, vm.lead);
        })
        .then(function (client) {
          vm.client = client;
          return $mdDialog.show(
            $mdDialog.confirm()
              .textContent('Ok, thank you so much and congratulations (OWNER NAME), your payment was\n' +
                'accepted for $xxx.xx.\n' +
                '\n' +
                'Before I transfer you over to meet your PMC can you please take a second to check your email to make sure that you received your receipt for today\'s investment and welcome email? I just want to make sure that we aren’t going to spam or have the incorrect email for you on file.')
              .ok('YES')
              .cancel('NO')
          )
            .then(function () {
              return $mdDialog.show(
                $mdDialog.confirm()
                  .textContent('Ok great, thanks for confirming that for me. Your CID ' + client.client_no + ' is on there as well as our contact for future reference. Hold on one second while I transfer you over / thank you again for your business we will attempt to contact you on (DATE) for your PMC setup call.')
                  .ok('Okay')
              );
            })
            .catch(function () {
              return $mdDialog.show(
                $mdDialog.confirm()
                  .textContent('Ok it’s important that you find it, can you first confirm the email that we have for you? I have (SPELL OUT EMAIL). If that is correct, please take a second and check your junk mail, if it is in there please take it out of spam that way our future emails will be easier for you to find.')
                  .ok('Okay')
              );
            });
        })
        .then(function () {
          $state.go('root.client.overview', {client_id: vm.client.id});
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.handleOnClickPackage = function (e) {
      CustomizePackage({
        lead: vm.lead,
        pkg: e.package,
        addOns: vm.addOns
      });
    };

    vm.openProposalModal = function () {
      ProposalModal({
        lead: vm.lead
      });
    };

    vm.saveAndConvert = function () {
      if (!vm.lead.first_name) {
        return toastr.error('First name is required to convert');
      }

      if (!vm.lead.last_name) {
        return toastr.error('Last name is required to convert');
      }

      if (!vm.lead.email) {
        return toastr.error('Email is required to convert');
      }

      if (!vm.lead.phone) {
        return toastr.error('Phone is required to convert');
      }

      if (!vm.lead.subscription) {
        return toastr.error('Subscription is required to convert');
      }

      if (!vm.billing || !vm.billing.line1 || !vm.billing.city || !vm.billing.state || !vm.billing.postal || !vm.billing.country) {
        return toastr.error('Billing is required to convert');
      }

      if (!vm.card || !vm.card.name || !vm.card.number || !vm.card.exp_date || !vm.card.cvc) {
        return toastr.error('Credit Card is required to convert');
      }

      vm.loading = vm.lead.update()
        .then(function () {
          return vm.lead.updateAddress(vm.lead.address);
        })
        .then(function (lead) {
          vm.lead = Lead.newInstance(lead);
          return showDisclosure({billing: vm.billing, card: vm.card}, vm.lead);
        })
        .then(function (client) {
          vm.client = client;
          return $mdDialog.show(
            $mdDialog.confirm()
              .textContent('Ok, thank you so much and congratulations (OWNER NAME), your payment was\n' +
                'accepted for $xxx.xx.\n' +
                '\n' +
                'Before I transfer you over to meet your PMC can you please take a second to check your email to make sure that you received your receipt for today\'s investment and welcome email? I just want to make sure that we aren’t going to spam or have the incorrect email for you on file.')
              .ok('YES')
              .cancel('NO')
          )
            .then(function () {
              return $mdDialog.show(
                $mdDialog.confirm()
                  .textContent('Ok great, thanks for confirming that for me. Your CID ' + client.client_no + ' is on there as well as our contact for future reference. Hold on one second while I transfer you over / thank you again for your business we will attempt to contact you on (DATE) for your PMC setup call.')
                  .ok('Okay')
              );
            })
            .catch(function () {
              return $mdDialog.show(
                $mdDialog.confirm()
                  .textContent('Ok it’s important that you find it, can you first confirm the email that we have for you? I have (SPELL OUT EMAIL). If that is correct, please take a second and check your junk mail, if it is in there please take it out of spam that way our future emails will be easier for you to find.')
                  .ok('Okay')
              );
            });
        })
        .then(function () {
          $state.go('root.client.overview', {client_id: vm.client.id});
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    function showDisclosure(paymentInfo, lead) {
      if (vm.lead.subscription.package_id === '57ae658b2f16c4f89c44245e') {
        return ListingSyncDisclosureModal(paymentInfo, lead);
      } else if (vm.lead.subscription.package_id === '57ae0bb02f16c4f89c44244e') {
        return AppALaCarteDisclosureModal(paymentInfo, lead);
      } else {
        return CloserAgreementModal(paymentInfo, lead);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appLeadsList', {
      templateUrl: 'app/leads-list/leads-list.html',
      controller: LeadsController,
      bindings: {
        leads: '<'
      }
    });

  /** @ngInject */
  function LeadsController($state, $stateParams, ExportModal, ExportService) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function(lead) {
      $state.go('root.leads.show', {lead_id: lead.id})
    };

    vm.handleFilter = function(query) {
      $state.go('root.leads.list', query, {reload: true});
    };

    vm.handleExport = function(query) {
      ExportModal(function() {
        return ExportService.exportLeads(query);
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appForgotPassword', {
      templateUrl: 'app/forgot-password/forgot-password.html',
      controller: ForgotPasswordController
    });

  /** @ngInject */
  function ForgotPasswordController($state, toastr, API) {
    var vm = this;

    vm.requestReset = function() {
      vm.loading = API.requestResetPassword(vm.email)
        .then(function() {
          toastr.success('An email has been sent');
          $state.go('root_login.login');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();


(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appLeads', {
      templateUrl: 'app/leads/leads.html'
    });
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('yesNo', YesNoFilter);

  /** @ngInject */
  function YesNoFilter() {
    return function(input) {
      return input === '1' ? 'yes' : 'no';
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('removeMobileAppAddOnsForMobilePackage', RemoveMobileAppAddOnsForMobilePackageFilter);

  /** @ngInject */
  function RemoveMobileAppAddOnsForMobilePackageFilter() {
    return function(addOns, package_id) {
      return addOns.filter(function(addOn) {
        return !(package_id === '57ae0bb02f16c4f89c44244e' && (addOn.id === '57842d825b6678a547acdaf5' || addOn.id === '57282dd7d4c6155ee96b9587'));
      });
    };
  }
})();
(function() {
  'use strict';

  /**
   * Remove free call tracking for mobile app and listings sync package
   */
  angular
    .module('zoek')
    .filter('removeFreeCallTrackingAddOnForSomePackages', RemoveFreeCallTrackingAddOnForSomePackagesFilter);

  /** @ngInject */
  function RemoveFreeCallTrackingAddOnForSomePackagesFilter() {
    return function(addOns, package_id) {
      return addOns.filter(function(addOn) {
        return !((package_id === '57ae0bb02f16c4f89c44244e' && addOn.id === '5632b653bffebc78178b456a')
          || (package_id === '57ae658b2f16c4f89c44245e' && addOn.id === '5632b653bffebc78178b456a'));
      });
    };
  }
})();
(function() {
  'use strict';

  /**
   * 29.99 Listings Sync only for Mobile app package
   */
  angular
    .module('zoek')
    .filter('remove2999ListingSyncAddOnForSomePackages', Remove2999ListingSyncAddOnForSomePackagesFilter);

  /** @ngInject */
  function Remove2999ListingSyncAddOnForSomePackagesFilter() {
    return function(addOns, package_id) {
      return addOns.filter(function(addOn) {
        return !(addOn.id === '57c735a57bc8490d84a29739' && package_id !== '57ae0bb02f16c4f89c44244e');
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('remove2499listingSyncPlan', Remove2499ListingSyncPlanFilter);

  /** @ngInject */
  function Remove2499ListingSyncPlanFilter() {
    return function(plans) {
      return plans.filter(function(plan) {
        return plan.id !== '57ae658b2f16c4f89c442460';
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('remove2499listingSyncAddOn', Remove2499ListingSyncAddOnFilter);

  /** @ngInject */
  function Remove2499ListingSyncAddOnFilter() {
    return function(addOns) {
      return addOns.filter(function(addOn) {
        return addOn.id !== '57bb8960cd06ea9b7fe94700';
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('removeSavePlans', RemoveSavePlansFilter);

  /** @ngInject */
  function RemoveSavePlansFilter() {
    return function(addOns) {
      return addOns.filter(function(addOn) {
        return !addOn.is_save;
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('removeMonitorAppOnly', RemoveMonitorAppOnlyFilter);

  /** @ngInject */
  function RemoveMonitorAppOnlyFilter() {
    return function(addOns, package_id) {
      return addOns.filter(function(addOn) {
        return !(package_id === '57ae0bb02f16c4f89c44244e' && addOn.id === '57e0348e8e75773eb3c78d6b');
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .filter('removeInactivePlans', RemoveInactivePlansFilter);

  /** @ngInject */
  function RemoveInactivePlansFilter () {
    return function (plans) {
      return plans.filter(function (plan) {
        return plan.status === 'active';
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('range', RangeFilter);

  /** @ngInject */
  function RangeFilter() {
    return function(input, total) {
      total = parseInt(total);

      for (var i = 0; i < total; i++) {
        input.push(i);
      }

      return input;
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('professionalMobileApp', ProfessionalMobileAppFilter);

  /** @ngInject */
  function ProfessionalMobileAppFilter() {
    return function(addOns, packageId) {
      return addOns.filter(function(addOn) {
        return !(addOn.id === '580a51836bdcda2932ea9e62' && packageId !== '5632b4c0bffebc72178b4567');
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * Free Zocial Media Add On for Enterprise and Professional
   */
  angular
    .module('zoek')
    .filter('freeZocialMedia', FreeZocialMediaAddOnFilter);

  /** @ngInject */
  function FreeZocialMediaAddOnFilter() {
    return function(addOns, packageId) {
      return addOns.filter(function(addOn) {
        return !(addOn.id === '5807df6b6bdcda5f30331256' && packageId !== '5632b528bffebc78178b4567' && packageId !== '5632b4c0bffebc72178b4567');
      });
    };
  }
})();
(function() {
  'use strict';

  /**
   * Free Mobile App Add On for Enterprise
   */
  angular
    .module('zoek')
    .filter('freeMobileApp', FreeMobileAppAddOnFilter);

  /** @ngInject */
  function FreeMobileAppAddOnFilter() {
    return function(addOns, packageId) {
      return addOns.filter(function(addOn) {
        return !(addOn.id === '5807dcf26bdcda5f30331252' && packageId !== '5632b528bffebc78178b4567');
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('flashSalePlan', FlashSalePlanFilter);

  /** @ngInject */
  function FlashSalePlanFilter(CRM, moment) {
    return function(plans, lead) {
      return plans.filter(function(plan) {
        return CRM.is_flash_sale || !plan.is_flash_sale || moment().diff(lead.created, 'days') >= 5;
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('flashSaleEditSubscription', FlashSaleEditSubscriptionFilter);

  /** @ngInject */
  function FlashSaleEditSubscriptionFilter(CRM) {
    return function(plans) {
      return plans.filter(function(plan) {
        return CRM.is_flash_sale || !plan.is_flash_sale;
      });
    };
  }
})();


(function() {
  'use strict';

  /**
   * Remove 1/2 off setup fee add on and void entire setup up add on
   */
  angular
    .module('zoek')
    .filter('removeSetupFeeAddOns', RemoveSetupFeeAddOnsFilter);

  /** @ngInject */
  function RemoveSetupFeeAddOnsFilter() {
    return function(addOns) {
      return addOns.filter(function(addOn) {
        return addOn.id !== '5632b5a0bffebc78178b4568' && addOn.id !== '5632b5c2bffebc72178b4568';
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .filter('capitalize', CapitalizeFilter);

  /** @ngInject */
  function CapitalizeFilter(lodash) {
    return function(input) {
      return input ? lodash.startCase(input) : '';
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appError', {
      templateUrl: 'app/error/error.html'
    });
})();


(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('uiSrefActiveIf', UISrefActiveIfDirective);

  /** @ngInject */
  function UISrefActiveIfDirective($transitions, $state) {
    return {
      restrict: 'A',
      scope: {
        uiSrefActiveIf: '<',
        uiSrefActiveClass: '@'
      },
      controller: function($scope, $element) {

        function update() {
          var state = $scope.uiSrefActiveIf;

          $element.removeClass($scope.uiSrefActiveClass);

          if (state instanceof Array) {
            angular.forEach(state, function(item) {
              addClassIfStateMatches(item);
            });
          } else {
            addClassIfStateMatches(state);
          }
        }

        function addClassIfStateMatches(state) {
          if ($state.includes(state) || $state.is(state)) {
            $element.addClass($scope.uiSrefActiveClass);
          }
        }

        $transitions.onSuccess({}, update);

        update();
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('postalLookup', PostalLookup);

  /** @ngInject */
  function PostalLookup(ziptastic) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        address: '='
      },
      link: function(scope, element, attr, ctrl) {
        element.bind('blur', function() {
          if (scope.address.postal) {
            ziptastic.lookup(scope.address.postal)
              .then(function(response) {
                scope.address.city = response.city;
                scope.address.state = response.state_short;
                scope.address.country = response.country;
              });
          }
        });
      }
    };
  }
})();
/**
 * Created by kevinem on 2/25/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('match', MatchDirective);

  /** @ngInject */
  function MatchDirective() {
    return {
      require: 'ngModel',
      scope: {
        match: '@'
      },
      link: function(scope, element, attr, ctrl) {
        ctrl.$validators.match = function(modelValue) {
          return scope.match === modelValue;
        };
      }
    };
  }
})();
/**
 * Created by kevinem on 12/8/15.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('httpPrefix', HttpPrefixDirective);

  /** @ngInject */
  function HttpPrefixDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, controller) {
        function ensureHttpPrefix(value) {
          // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
          if (value && !/^(https?):\/\//i.test(value) && 'http://'.indexOf(value) !== 0 && 'https://'.indexOf(value) !== 0) {
            controller.$setViewValue('http://' + value);
            controller.$render();
            return 'http://' + value;
          }
          else {
            return value;
          }
        }

        controller.$formatters.push(ensureHttpPrefix);
        controller.$parsers.splice(0, 0, ensureHttpPrefix);
      }
    };
  }
})();
/**
 * Created by kevinem on 1/11/16.
 */


(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('creditCardExp', CreditCardExpDirective);

  /** @ngInject */
  function CreditCardExpDirective($filter) {
    return {
      require: 'ngModel',
      scope: {
        creditCardExp: '='
      },
      link: function(scope, element, attr, ctrl) {
        ctrl.$validators.creditCardExp = function(modelValue) {
          if (!modelValue || angular.isUndefined(modelValue)) {
            return true;
          }

          var expDate = $filter('amParse')(modelValue, 'MMYY');

          var expired = $filter('amDifference')(expDate, null, 'days');

          return expired > 0;
        };
      }
    };
  }
})();
/**
 * Created by kevinem on 1/11/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('creditCard', CreditCardDirective);

  /** @ngInject */
  function CreditCardDirective() {
    return {
      require: '?ngModel',
      scope: {
        creditCard: '@'
      },
      link: function(scope, element, attr, ctrl) {
        if (!ctrl) {
          return;
        }

        ctrl.$validators.creditCard = function(modelValue) {
          if (modelValue) {
            var number = modelValue.replace(/[-\s]/g, '');

            var len = number.length;

            var mul = 0,
              prodArr = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]],
              sum = 0;

            while (len--) {
              sum += prodArr[mul][parseInt(number.charAt(len), 10)];
              mul ^= 1;
            }

            return sum % 10 === 0 && sum > 0;
          }

          return true;
        };
      }
    };
  }
})();
/**
 * Created by kevinem on 1/11/16.
 */

(function() {
  'use strict';

  angular
    .module('zoek')
    .directive('accessibleForm', AccessibleFormDirective);

  /** @ngInject */
  function AccessibleFormDirective() {
    return {
      restrict: 'A',
      link: function(scope, element, attr, ctrl) {

        // set up event handler on the form element
        element.on('submit', function() {

          // find the first invalid element
          var firstInvalid = element[0].querySelector('.ng-invalid');

          // if we find one, set focus
          if (firstInvalid) {
            firstInvalid.focus();
          }
        });
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClients', {
      templateUrl: 'app/clients/clients.html',
      controller: ClientsController,
      bindings: {
        clients: '<'
      }
    });

  /** @ngInject */
  function ClientsController($state, $stateParams, ExportModal, ExportService) {
    var vm = this;

    vm.$stateParams = $stateParams;

    vm.handleSelect = function(client) {
      $state.go('root.client.overview', {client_id: client.id});
    };

    vm.handleFilter = function(query) {
      $state.go('root.clients', query, {reload: true});
    };

    vm.handleExport = function(query) {
      ExportModal(function() {
        return ExportService.exportClients(query);
      });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientWebsiteNotes', {
      templateUrl: 'app/client-website-notes/client-website-notes.html',
      controller: ClientWebsiteNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientWebsiteNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_website'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientWebsite', {
      templateUrl: 'app/client-website/client-website.html',
      controller: ClientWebsiteController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ClientWebsiteController(toastr, API) {
    var vm = this;

    vm.createWebsiteTicket = function() {
      vm.loading = API.createTicket({
        ticket: 'request_discovery_call',
        client_no: vm.client.client_no
      })
        .then(function() {
          toastr.success('A ticket has been made for discovery call');
        })
        .finally(function() {
          vm.loading = false;
        })
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientSocialMediaNotes', {
      templateUrl: 'app/client-social-media-notes/client-social-media-notes.html',
      controller: ClientSocialMediaNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientSocialMediaNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_social_media'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientSocialMedia', {
      templateUrl: 'app/client-social-media/client-social-media.html',
      controller: ClientSocialMediaController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ClientSocialMediaController(toastr) {
    var vm = this;

    vm.updateSocialMedia = function() {
      vm.loading = vm.client.update()
        .then(function() {
          toastr.success("Successfully updated client's social media");
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appClientOverviewSubscription', {
      templateUrl: 'app/client-overview-subscription/client-overview-subscription.html',
      controller: Controller,
      bindings: {
        client: '<',
        subscription: '<',
      }
    });

  /** @ngInject */
  function Controller(API, toastr) {
    var vm = this;

    vm.state = {
      editing: false,
    };

    vm.edit = function () {
      vm.state.editing = true;
    };

    vm.cancel = function () {
      vm.state.editing = false;
    };

    vm.update = function () {
      API.updateCustomPrice(vm.client.id, vm.subscription.custom_price)
        .then(function (subscription) {
          vm.subscription = subscription;
          vm.state.editing = false;
          toastr.success('Successfully updated subscription');
        })
        .catch(function () {
          toastr.error('There was an error updating the subscription');
        });
    };

    vm.hasCustomPrice = function() {
      return vm.subscription.custom_price !== ''
        && vm.subscription.custom_price !== undefined
        && vm.subscription.custom_price !== null
        && vm.subscription.custom_price !== vm.client.getSubscription().getPlan().monthly_fee;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientOverviewNotes', {
      templateUrl: 'app/client-overview-notes/client-overview-notes.html',
      controller: ClientOverviewNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientOverviewNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_overview'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientOverview', {
      templateUrl: 'app/client-overview/client-overview.html',
      controller: ClientOverviewController,
      bindings: {
        client: '<',
        businessHours: '<',
        overviewConfig: '<',
        provisioners: '<',
        salesReps: '<'
      }
    });

  /** @ngInject */
  function ClientOverviewController($document, $log, $mdDialog, API, toastr, moment, CancelModal, ChangePasswordModal) {
    var vm = this;

    vm.$onInit = function() {
      $log.debug('ClientsOverviewController.activate.client', vm.client);

      //Calculating because {{clientsOverview.client.converted_at | amDifference : null : 'days'}} generates a negative number
      vm.shelfLife = moment().diff(moment(vm.client.converted_at), 'days');

      // Getting latest notes to use as last modified date
      API.getClientNotes(vm.client.id, {limit: 1})
        .then(function(res) {
          vm.last_modified = res.data[0].created_at;
        });
    };

    vm.update = function() {
      vm.loading = API.updateClientBusinessHours(vm.client.id, vm.businessHours)
        .then(function() {
          return vm.client.updateCAP();
        })
        .then(function() {
          return vm.client.updateOverviewConfig(vm.overviewConfig);
        })
        .then(function() {
          return vm.client.updateSubscription();
        })
        .then(function() {
          return vm.client.update();
        })
        .then(function() {
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Successfully Updated Overview Information')
              .ok('Okay')
          );
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.openChangePasswordModal = function(e) {
      ChangePasswordModal(e, vm.client);
    };

    vm.cancel = function(e) {
      CancelModal(e, vm.client);
    };

    vm.refund = function(ev) {
      return $mdDialog.show({
        templateUrl: 'app/components/refund_modal/refund_modal.html',
        parent: angular.element($document.body),
        controller: 'RefundModalController',
        controllerAs: 'refundModal',
        clickOutsideToClose: true,
        targetEvent: ev,
        openFrom: ev.toElement,
        closeTo: ev.toElement,
        locals: {
          client: vm.client
        }
      });
    };

    vm.changeSalesRep = function(event) {
      vm.loading = vm.client.changeSalesRep(event.rep.id)
        .then(function() {
          vm.client.closer = event.rep;
          toastr.success('Successfully Changed Sales Representative');
        })
        .finally(function() {
          vm.loading = false;
          vm.editingSalesRep = false;
        });
    };

    vm.changeProvisioner = function(event) {
      vm.loading = vm.client.changeProvisioner(event.rep.id)
        .then(function() {
          vm.client.pinner = event.rep;
          toastr.success('Successfully Changed Provisioner');
        })
        .finally(function() {
          vm.loading = false;
          vm.editingProvisioner = false;
        });
    };

    vm.overrideToAllowChangeSalesRep = function(e) {
      LoginModal(e)
        .then(function() {
          vm.changingSalesRep = true;
        });
    };

    vm.overrideToAllowChangeProvisioner = function(e) {
      LoginModal(e)
        .then(function() {
          vm.changingProvisioner = true;
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientContentNotes', {
      templateUrl: 'app/client-content-notes/client-content-notes.html',
      controller: ClientContentNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientContentNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_content'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientContent', {
      templateUrl: 'app/client-content/client-content.html',
      controller: ClientContentController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ClientContentController(toastr) {
    var vm = this;

    vm.updateContent = function() {
      vm.loading = vm.client.update()
        .then(function() {
          toastr.success('Successfully Updated Content Information');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientCAPNotes', {
      templateUrl: 'app/client-cap-notes/client-cap-notes.html',
      controller: ClientCAPNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientCAPNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_cap'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientCAP', {
      templateUrl: 'app/client-cap/client-cap.html',
      controller: ClientCAPController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ClientCAPController($mdDialog, $document, FileSaver) {
    var vm = this;

    vm.$onInit = function() {
      if (vm.client.getSubscription().getPackage().name === 'Professional Package') {
        vm.number_of_articles = 9;
      } else if (vm.client.getSubscription().getPackage().name === 'Enterprise Package') {
        vm.number_of_articles = 19;
      } else {
        vm.number_of_articles = 4;
      }
    };

    vm.updateCAP = function() {
      vm.loading = vm.client.updateCAP()
        .then(function() {
          return vm.client.update();
        })
        .then(function() {
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Successfully Updated C.A.P.')
              .ok('Okay')
          );
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.exportData = function() {
      vm.exporting = vm.client.exportCAP()
        .then(function(response) {
          var data = new Blob([JSON.stringify(response.data)], {type: 'application/json'});
          FileSaver.saveAs(data, 'website.json');
        })
        .finally(function() {
          vm.exporting = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientBusinessDirectoriesNotes', {
      templateUrl: 'app/client-business-directories-notes/client-business-directories-notes.html',
      controller: ClientBusinessDirectoriesNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientBusinessDirectoriesNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_business'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientBusinessDirectories', {
      templateUrl: 'app/client-business-directories/client-business-directories.html',
      controller: ClientBusinessDirectoriesController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ClientBusinessDirectoriesController($mdDialog, $document) {
    var vm = this;

    vm.updateBusiness = function() {
      vm.loading = vm.client.update()
        .then(function() {
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Successfully Updated Business Information')
              .ok('Okay')
          );
        })
        .finally(function() {
          vm.loading = false;
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientBillingNotes', {
      templateUrl: 'app/client-billing-notes/client-billing-notes.html',
      controller: ClientBillingNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientBillingNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_account_success'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientBilling', {
      templateUrl: 'app/client-billing/client-billing.html',
      controller: ClientBillingController,
      bindings: {
        client: '<',
        orders: '<'
      }
    });

  /** @ngInject */
  function ClientBillingController(CheckModal, BillingModal, CreditCardModal, $http, $stateParams, myConfig) {
    var vm = this;

    vm.$onInit = function() {
      $http({
        method: 'GET',
        url: myConfig.apiV2Base + '/clients/' + $stateParams.client_id + '/subscription/check',
      })
        .then(function (response) {
          vm.check = response.data;
        });
    };

    vm.openBillingModal = function(e) {
      BillingModal(e, vm.client);
    };

    vm.openCreditCardModal = function(e) {
      CreditCardModal(e, vm.client);
    };

    vm.openCheckModal = function(e) {
      CheckModal(e, vm.client);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientAccountSuccessNotes', {
      templateUrl: 'app/client-account-success-notes/client-account-success-notes.html',
      controller: ClientAccountSuccessNotesController,
      bindings: {
        client: '<',
        notes: '<'
      }
    });

  /** @ngInject */
  function ClientAccountSuccessNotesController() {
    var vm = this;

    vm.addNote = function(event) {
      return vm.client.addNote({
        note: event.note,
        type: 'client_account_success'
      })
        .then(function(note) {
          vm.notes.data.unshift(note);
        });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClientAccountSuccess', {
      templateUrl: 'app/client-account-success/client-account-success.html',
      controller: ClientAccountSuccessController,
      bindings: {
        client: '<'
      }
    });

  /** @ngInject */
  function ClientAccountSuccessController(toastr, API, $window) {
    var vm = this;

    vm.update = function() {
      vm.loading = vm.client.updateSubscription()
        .then(function() {
          return vm.client.update();
        })
        .then(function() {
          toastr.success('Successfully updated');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.viewReport = function() {
      if (vm.client.places_scout_id) {
        vm.loadingRankingReport = API.getRankingReportUrl(vm.client.places_scout_id)
          .then(function(res) {
            $window.open(res.url);
          })
          .finally(function() {
            vm.loadingRankingReport = false;
          });
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appClient', {
      templateUrl: 'app/client/client.html',
      controller: ClientController,
      bindings: {
        client: '<',
        packages: '<',
        addOns: '<'
      }
    });

  /** @ngInject */
  function ClientController(NotesModal, HotButtonsModal, ChangeStatusModal, EditSubscriptionModal) {
    var vm = this;

    vm.openNotesModal = function(e) {
      NotesModal(e, vm.client);
    };

    vm.openHotButtonsModal = function(e) {
      HotButtonsModal(e, vm.client);
    };

    vm.openEditSubscriptionModal = function(e) {
      EditSubscriptionModal(e, vm.client);
    };

    vm.openChangeStatusModal = function(e) {
      ChangeStatusModal(e, vm.client);
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appAgents', {
      templateUrl: 'app/agents/agents.html',
      controller: AgentsController,
      bindings: {
        agents: '<'
      }
    });

  /** @ngInject */
  function AgentsController($state, $stateParams, AddNewStaffModal, Authentication, ExportService) {
    var vm = this;

    vm.$onInit = function() {
      vm.$stateParams = $stateParams;
      vm.profile = Authentication.profile;
    };

    vm.handleSelect = function(agent) {
      $state.go('root.agent', {agent_id: agent.id})
    };

    vm.handleFilter = function(query) {
      $state.go('root.agents', query, {reload: true});
    };

    vm.openAddNewStaffModal = function(e) {
      AddNewStaffModal(e)
        .then(function(staff) {
          handleSelect({
            staff: staff
          });
        });
    };

    vm.handleExportLoginActivity = function() {
      ExportService.exportLoginActivity();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appAgent', {
      templateUrl: 'app/agent/agent.html',
      controller: AgentController,
      bindings: {
        agent: '<'
      }
    });

  /** @ngInject */
  function AgentController(teams, $mdDialog, toastr, $state, ChangePasswordModal) {
    var vm = this;

    vm.teams = teams;

    vm.update = function() {
      vm.loading = vm.agent.update()
        .then(function(agent) {
          vm.agent = agent;
          toastr.success('Updated agent');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.removeAgent = function(ev) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .targetEvent(ev)
        .ok('Remove agent?')
        .cancel('Cancel');

      $mdDialog.show(confirm)
        .then(function() {
          vm.loading = true;
          return vm.agent.remove();
        })
        .then(function() {
          toastr.success('Agent has been removed');
          $state.go('root.agents');
        })
        .finally(function() {
          vm.loading = false;
        });
    };

    vm.openChangePasswordModal = function(e) {
      ChangePasswordModal(e, vm.agent);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .component('appActivity', {
      templateUrl: 'app/activity/activity.html',
      controller: ActivityController,
      bindings: {
        logs: '<'
      }
    });

  /** @ngInject */
  function ActivityController($stateParams) {
    var vm = this;

    vm.onReorder = function(order) {
      getLogs(angular.extend({}, $stateParams.query, {order: order}));
    };

    vm.onPaginate = function(page, limit) {
      getLogs(angular.extend({}, $stateParams.query, {
        page: page,
        limit: limit
      }));
    };

    vm.getLogs = function(query) {
      vm.promise = logs.getLogs(query);
    };

    function openLogModal(ev, log) {
//            $mdDialog.show({
//                templateUrl: 'app/components/log_modal/log_modal.html',
//                controller: 'LogModalController',
//                controllerAs: 'logModal',
//                parent: angular.element($document.body),
//                targetEvent: ev,
//                clickOutsideToClose: true,
//                resolve: {
//                    log: function() {
//                        return log;
//                    }
//                }
//            });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('zoek')
    .component('appAdd', {
      templateUrl: 'app/add/add.html',
      controller: AddController
    });

  /** @ngInject */
  function AddController($document, $mdDialog, $state, API) {
    var vm = this;

    vm.$onInit = function () {
      vm.marketingMethods = [
        'Social Media',
        'Mobile App',
        'Review Monitoring',
        'Search Engine Optimization',
        'Video',
        'PPC'
      ];

      vm.lead = {
        marketing: []
      };
    };

    vm.handleAdd = function () {
      vm.loading = API.createLead(vm.lead)
        .then(function (lead) {
          vm.lead = lead;
          return $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element($document.body))
              .title('Lead Successful Added')
              .textContent('Here is your lead number: ' + lead.lead_no)
              .ok('Okay')
          );
        })
        .then(function () {
          $state.go('root.qualifiers.lead.package', {lead_id: vm.lead.id}, {reload: true});
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .value('uiTimepickerConfig', {
      step: 5,
      asMoment: true
    });

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .run(runBlock);

  /** @ngInject */
  function runBlock(PermPermissionStore, Authentication, $transitions, $location, $window, Navigation) {

    Authentication.checkAuthOnRefresh();

    Authentication.redirectWhenUnauthenticated();

    $transitions.onStart({}, function() {
      Navigation.transitioning = true;
    });

    $transitions.onFinish({}, function() {
      Navigation.transitioning = false;
    });

    $transitions.onStart({to: 'root-login.**'}, function(transition) {
      var $state = transition.router.stateService;

      if (Authentication.isAuthenticated) {
        return $state.target('root.add');
      }
    });

    $transitions.onStart({to: 'root.**'}, function(transition) {
      var $state = transition.router.stateService;

      if (!Authentication.isAuthenticated) {
        return $state.target('root-login.login');
      }
    });

    PermPermissionStore.definePermission('deleteLead', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewAdd', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Provisioner'
      || Authentication.profile.role.name === 'Opener'
      || Authentication.profile.role.name === 'Closer'
      || Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewQuickAdd', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
        && Authentication.profile.role
        && (Authentication.profile.role.name === 'Provisioner'
          || Authentication.profile.role.name === 'Opener'
          || Authentication.profile.role.name === 'Closer'
          || Authentication.profile.role.name === 'Management'
          || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewQualifiers', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Opener'
      || Authentication.profile.role.name === 'Closer'
      || Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewProvisioning', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Provisioner'
      || Authentication.profile.role.name === 'Customer Service'
      || Authentication.profile.role.name === 'SEO'
      || Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewLeads', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Opener'
      || Authentication.profile.role.name === 'Closer'
      || Authentication.profile.role.name === 'Provisioner'
      || Authentication.profile.role.name === 'Customer Service'
      || Authentication.profile.role.name === 'Billing'
      || Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewClients', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Opener'
      || Authentication.profile.role.name === 'Closer'
      || Authentication.profile.role.name === 'Provisioner'
      || Authentication.profile.role.name === 'Customer Service'
      || Authentication.profile.role.name === 'Billing'
      || Authentication.profile.role.name === 'SEO'
      || Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewTickets', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Closer'
      || Authentication.profile.role.name === 'Provisioner'
      || Authentication.profile.role.name === 'Customer Service'
      || Authentication.profile.role.name === 'Billing'
      || Authentication.profile.role.name === 'SEO'
      || Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewStaff', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && (Authentication.profile.role.name === 'Management'
      || Authentication.profile.role.name === 'Admin'));
    });

    PermPermissionStore.definePermission('viewActivity', /*@ngInject*/ function(permissionName, transitionProperties) {
      return (Authentication.profile
      && Authentication.profile.role
      && Authentication.profile.role.name === 'Admin');
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('zoek')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $stateProvider) {

    $stateProvider
      .state({
        abstract: true,
        name: 'root-login',
        component: 'appRootLogin'
      })
      .state({
        name: 'root-login.login',
        url: '/login',
        component: 'appLogin'
      })
      .state({
        name: 'root-login.forgot-password',
        url: '/forgot-password',
        component: 'appForgotPassword'
      })
      .state({
        name: 'root-login.reset-password',
        url: '/reset-password?token',
        component: 'appResetPassword',
        resolve: {
          token: function ($stateParams) {
            return $stateParams.token;
          }
        }
      });

    $stateProvider
      .state({
        name: 'unauthorized',
        url: '/unauthorized',
        component: 'appUnauthorized'
      })
      .state({
        name: 'error',
        url: '/error',
        component: 'appError'
      })
      .state({
        name: 'not-found',
        url: '/not-found',
        component: 'appNotFound'
      });

    $stateProvider
      .state({
        abstract: true,
        name: 'root',
        component: 'appRoot',
        resolve: {
          packages: function (API) {
            return API.getPackages();
          },
          addOns: function (API) {
            return API.getAddOns();
          }
        }
      })
      .state({
        name: 'root.add',
        url: '/add',
        component: 'appAdd'
      })
      .state({
        name: 'root.quick-add',
        url: '/quick-add',
        component: 'appQuickAdd'
      });

    $stateProvider
      .state({
        abstract: true,
        name: 'root.leads',
        component: 'appLeads'
      })
      .state({
        name: 'root.leads.list',
        url: '/leads?lead_no&first_name&last_name&email&phone&business&address&created_from&created_to&progress&closer_id&lead_type&business_type&disposition&package_id&limit&page&order',
        component: 'appLeadsList',
        resolve: {
          leads: function (Lead, $stateParams) {
            var params = Object.assign({}, $stateParams);
            if (!params.order) {
              params.order = 'lead_no';
            }
            return Lead.all(params);
          }
        }
      })
      .state({
        name: 'root.leads.show',
        url: '/leads/{lead_id}',
        component: 'appLeadsShow',
        resolve: {
          lead: function (Staff, Lead, $stateParams) {
            return Lead.get($stateParams.lead_id);
          },
          salesReps: function (Staff) {
            return Staff.all({
              role_id: '56a2e7efbffebc52128b4569',
              pagination: 0,
              order: '-first_name'
            });
          }
        }
      });

    $stateProvider
      .state({
        name: 'root.web-leads',
        url: '/web-leads?lead_no&first_name&last_name&email&phone&business&address&created_from&created_to&progress&pinner_id&closer_id&status&lead_type&business_type&limit&page&order',
        component: 'appWebLeads',
        resolve: {
          leads: function (Lead, $stateParams, moment, Authentication) {
            var params = Object.assign({}, $stateParams);
            params.lead_type = 'Web';

            if (Authentication.profile.role.name !== 'Admin' && Authentication.profile.role.name !== 'Management') {
              params.created_to = moment().subtract(2, 'days').toISOString();
            }

            if (!params.order) {
              params.order = 'lead_no';
            }
            return Lead.all(params);
          }
        }
      });

    $stateProvider
      .state({
        abstract: true,
        name: 'root.qualifiers',
        component: 'appQualifiers'
      })
      .state({
        name: 'root.qualifiers.leads',
        url: '/qualifiers?lead_no&first_name&last_name&email&phone&business&address&created_from&created_to&progress&closer_id&lead_type&business_type&disposition&limit&page&order',
        component: 'appQualifiersLeads',
        resolve: {
          leads: function (Lead, $stateParams) {
            var params = Object.assign({}, $stateParams);
            if (!params.order) {
              params.order = 'lead_no';
            }
            return Lead.all(params);
          }
        }
      })
      .state({
        abstract: true,
        name: 'root.qualifiers.lead',
        url: '/qualifiers/{lead_id}',
        component: 'appQualifiersLead',
        resolve: {
          lead: function (Lead, $stateParams) {
            return Lead.get($stateParams.lead_id);
          }
        },
        onExit: function (store) {
          store.remove('zoek.qualifiers.payment');
        }
      })
      .state({
        name: 'root.qualifiers.lead.package',
        url: '/package',
        component: 'appQualifiersPackage'
      })
      .state({
        name: 'root.qualifiers.lead.package-details',
        url: '/package-details',
        resolve: {
          lead: function (Lead, $stateParams) {
            return Lead.get($stateParams.lead_id);
          }
        },
        component: 'appQualifiersPackageDetails'
      })
      .state({
        name: 'root.qualifiers.lead.payment',
        url: '/payment',
        resolve: {
          lead: function (Lead, $stateParams) {
            return Lead.get($stateParams.lead_id);
          }
        },
        component: 'appQualifiersPayment'
      });

    $stateProvider
      .state({
        name: 'root.provisioner.clients',
        url: '/provisioner/{pinner_id}/clients?status',
        component: 'appProvisionerClients',
        resolve: {
          clients: function (Client, $stateParams) {
            return Client.all({
              claimed: $stateParams.pinner_id,
              status: $stateParams.status
            });
          },
          pinner: function (API, $stateParams) {
            return API.getAgent($stateParams.pinner_id);
          }
        }
      });

    $stateProvider
      .state({
        abstract: true,
        name: 'root.provisioning',
        url: '/provisioning',
        component: 'appProvisioning'
      })
      .state({
        name: 'root.provisioning.clients',
        url: '/clients?client_no&first_name&last_name&email&phone&business&address&created_from&created_to&progress&pinner_id&closer_id&status&lead_type&business_type&limit&page&order',
        component: 'appProvisioningClients',
        resolve: {
          clients: function (Client, $stateParams) {
            var params = Object.assign({}, $stateParams);
            if (!params.order) {
              params.order = 'client_no';
            }
            return Client.getProvisioningClients(params);
          },
          provisioners: function (API) {
            return API.getAgents({
              params: {
                role_id: '56a2e7e5bffebc57128b4567'
              },
              cache: true
            });
          }
        }
      })
      .state({
        name: 'root.provisioning.client',
        url: '/{client_id}',
        component: 'appProvisioningClient',
        resolve: {
          client: function (Client, $stateParams) {
            return Client.get($stateParams.client_id);
          }
        }
      })
      .state({
        name: 'root.provisioning.client.step1',
        url: '/step1',
        component: 'appProvisioningClientStep1'
      })
      .state({
        name: 'root.provisioning.client.step2',
        url: '/step2',
        component: 'appProvisioningClientStep2'
      })
      .state({
        name: 'root.provisioning.client.step3',
        url: '/step3',
        component: 'appProvisioningClientStep3'
      })
      .state({
        name: 'root.provisioning.client.step4',
        url: '/step4',
        component: 'appProvisioningClientStep4'
      })
      .state({
        name: 'root.provisioning.client.step5',
        url: '/step5',
        component: 'appProvisioningClientStep5'
      })
      .state({
        name: 'root.provisioning.client.step6',
        url: '/step6',
        component: 'appProvisioningClientStep6'
      })
      .state({
        name: 'root.provisioning.client.step7',
        url: '/step7',
        component: 'appProvisioningClientStep7'
      })
      .state({
        name: 'root.provisioning.client.step8',
        url: '/step8',
        component: 'appProvisioningClientStep8'
      })
      .state({
        name: 'root.provisioning.client.step9',
        url: '/step9',
        component: 'appProvisioningClientStep9'
      })
      .state({
        name: 'root.provisioning.client.step10',
        url: '/step10',
        component: 'appProvisioningClientStep10'
      })
      .state({
        name: 'root.provisioning.client.step11',
        url: '/step11',
        component: 'appProvisioningClientStep11'
      })
      .state({
        name: 'root.provisioning.client.step12',
        url: '/step12',
        component: 'appProvisioningClientStep12'
      })
      .state({
        name: 'root.provisioning.client.step13',
        url: '/step13',
        component: 'appProvisioningClientStep13'
      })
      .state({
        name: 'root.provisioning.client.step14',
        url: '/step14',
        component: 'appProvisioningClientStep14'
      })
      .state({
        name: 'root.provisioning.listing-sync',
        url: '/{client_id}/listing-sync',
        component: 'appProvisioningListingSync',
        resolve: {
          client: function (Client, $stateParams) {
            return Client.get($stateParams.client_id);
          }
        }
      })
      .state({
        name: 'root.provisioning.mobile-app',
        url: '/{client_id}/mobile-app',
        component: 'appProvisioningMobileApp',
        resolve: {
          client: function (Client, $stateParams) {
            return Client.get($stateParams.client_id);
          }
        }
      });

    $stateProvider
      .state({
        name: 'root.agents',
        url: '/agents?staff_no&first_name&last_name&email&role_id&status&limit&page&order',
        component: 'appAgents',
        resolve: {
          agents: function (Staff, $stateParams) {
            var params = Object.assign({}, $stateParams);
            if (!params.order) {
              params.order = 'staff_no';
            }
            if (!params.status) {
              params.status = 'active';
            }
            return Staff.all(params);
          }
        }
      })
      .state({
        name: 'root.agent',
        url: '/agents/{agent_id}',
        component: 'appAgent',
        resolve: {
          agent: function (Staff, $stateParams) {
            return Staff.get($stateParams.agent_id);
          }
        }
      });

    $stateProvider
      .state({
        name: 'root.activity',
        url: '/activity',
        component: 'appActivity',
        resolve: {
          logs: function (Log, $stateParams) {
            return Log.all({
              order: 'created_at',
              limit: 50
            });
          }
        }
      });

    $stateProvider
      .state({
        name: 'root.sae-pipeline',
        url: '/sae-pipeline?client_no&first_name&last_name&email&phone&business&address&created_from&created_to&progress&pinner_id&closer_id&status&lead_type&business_type&limit&page&order',
        component: 'appSAEPipeline',
        resolve: {
          clients: function (Client, $stateParams) {
            var params = Object.assign({}, $stateParams);
            if (!params.order) {
              params.order = 'client_no';
            }
            return Client.getSAEPipeline(params);
          }
        }
      });

    $stateProvider
      .state({
        name: 'root.xfer',
        url: '/xfer?lead_no&first_name&last_name&email&phone&limit&page&order',
        component: 'appXfer',
        resolve: {
          leads: function (Lead, $stateParams) {
            var params = Object.assign({}, $stateParams);
            params.lead_type = 'Xfer';
            if (!params.order) {
              params.order = 'lead_no';
            }
            return Lead.all(params);
          }
        }
      });

    $stateProvider
      .state({
        name: 'root.clients',
        url: '/clients?client_no&first_name&last_name&email&phone&business&address&created_from&created_to&progress&pinner_id&closer_id&status&lead_type&business_type&package_id&limit&page&order',
        component: 'appClients',
        resolve: {
          clients: function (Client, $stateParams) {
            var params = Object.assign({}, $stateParams);
            if (!params.order) {
              params.order = 'client_no';
            }
            return Client.all(params);
          }
        }
      })
      .state({
        abstract: true,
        name: 'root.client',
        url: '/clients/{client_id}',
        component: 'appClient',
        resolve: {
          client: function (Client, $stateParams) {
            return Client.get($stateParams.client_id);
          },
          businessHours: function(API, $stateParams) {
            return API.getClientBusinessHours($stateParams.client_id);
          },
          overviewConfig: function(Client, $stateParams) {
            return Client.getOverviewConfig($stateParams.client_id);
          },
          salesReps: function (Staff) {
            return Staff.all({
              role_id: '56a2e7efbffebc52128b4569',
              pagination: 0,
              order: '-first_name'
            });
          },
          provisioners: function (Staff) {
            return Staff.all({
              role_id: '56a2e7e5bffebc57128b4567',
              pagination: 0,
              order: '-first_name'
            });
          }
        }
      })
      .state({
        name: 'root.client.overview',
        url: '/overview',
        views: {
          main: {
            component: 'appClientOverview'
          },
          right0: {
            component: 'appClientOverviewSubscription'
          },
          notes: {
            component: 'appClientOverviewNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_overview'});
          },
          subscription: function (API, $stateParams) {
            return API.getClientSubscription($stateParams.client_id);
          },
        }
      })
      .state({
        name: 'root.client.account-success',
        url: '/account-success',
        views: {
          main: {
            component: 'appClientAccountSuccess'
          },
          notes: {
            component: 'appClientAccountSuccessNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_account_success'});
          }
        }
      })
      .state({
        name: 'root.client.content',
        url: '/content',
        views: {
          main: {
            component: 'appClientContent'
          },
          notes: {
            component: 'appClientContentNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_content'});
          }
        }
      })
      .state({
        name: 'root.client.business-directories',
        url: '/business-directories',
        views: {
          main: {
            component: 'appClientBusinessDirectories'
          },
          notes: {
            component: 'appClientBusinessDirectoriesNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_business'});
          }
        }
      })
      .state({
        name: 'root.client.cap',
        url: '/cap',
        views: {
          main: {
            component: 'appClientCAP'
          },
          notes: {
            component: 'appClientCAPNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_cap'});
          }
        }
      })
      .state({
        name: 'root.client.social-media',
        url: '/social-media',
        views: {
          main: {
            component: 'appClientSocialMedia'
          },
          notes: {
            component: 'appClientSocialMediaNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_social_media'});
          }
        }
      })
      .state({
        name: 'root.client.website',
        url: '/website',
        views: {
          main: {
            component: 'appClientWebsite'
          },
          notes: {
            component: 'appClientWebsiteNotes'
          }
        }
      })
      .state({
        name: 'root.client.billing',
        url: '/billing',
        views: {
          main: {
            component: 'appClientBilling'
          },
          notes: {
            component: 'appClientBillingNotes'
          }
        },
        resolve: {
          notes: function (client) {
            return client.getNotes({type: 'client_billing'});
          },
          orders: function (client) {
            return client.getOrders();
          }
        }
      });

    $urlRouterProvider.otherwise('/login');
  }
})
();

/* global toastr:false */
(function () {
  'use strict';

  angular
    .module('zoek')
    .constant('teams', [
      'Highrollers',
      'ABC',
      'Heavy Hitters',
      'Dead Presidents',
      'OneLunaGlobal',
    ])
    .constant('toastr', toastr)
    .constant('packageIncludes', [
      "Front Page Placement",
      "10 Business Specific Keywords",
      "Custom Written Content",
      "Customer Acquisition Page",
      "Yahoo & Bing Business Listings",
      "35+ Online Business Profile Listings",
      "Mobile Search Optimized",
      "MyZoek Marketing Dashboard",
      "Expert Consultation"
    ])
    .constant('statuses', [
      'provisioning',
      'active',
      'cancelled',
      'failed_compliance',
      'non_compliance',
      'failed_payments',
      'collections',
      'winback',
      'chargeback',
      'freeze'
    ])
    .constant('leadTypes', [
      'VB',
      'APP',
      'ER',
      'FB',
      'Referral',
      'Website',
      'Other',
      'Web',
      'Xfer',
      'VMCB'
    ])
    .constant('businessTypes', [
      'B2B',
      'B2C',
      'B2G'
    ])
    .constant('proposals', [
      {
        name: 'Business Package Plan A - 12 Months',
        package_id: '5632b485bffebc73178b4568',
        plan_id: '5723e06e5b66e474bb121b5f'
      },
      {
        name: 'Business Package Plan B - 12 Months',
        package_id: '5632b485bffebc73178b4568',
        plan_id: '5723e0835b66e474bb121b60'
      },
      {
        name: 'Business Package Plan C - 3 Months',
        package_id: '5632b485bffebc73178b4568',
        plan_id: '5723e0835b66e474bb121b61'
      },
      {
        name: 'Professional Package Plan A - 12 Months',
        package_id: '5632b4c0bffebc72178b4567',
        plan_id: '5723e09a5b66e474bb121b64'
      },
      {
        name: 'Professional Package Plan B - 12 Months',
        package_id: '5632b4c0bffebc72178b4567',
        plan_id: '5723e09a5b66e474bb121b65'
      },
      {
        name: 'Professional Package Plan C - 3 Months',
        package_id: '5632b4c0bffebc72178b4567',
        plan_id: '5723e09a5b66e474bb121b66'
      },
      {
        name: 'Enterprise Package Plan A - 12 Months',
        package_id: '5632b528bffebc78178b4567',
        plan_id: '5723e0905b66e474bb121b62'
      },
      {
        name: 'Enterprise Package Plan C - 3 Months',
        package_id: '5632b528bffebc78178b4567',
        plan_id: '5723e0905b66e474bb121b63'
      },
      {
        name: 'Mobile App Plan B',
        package_id: '57ae0bb02f16c4f89c44244e',
        plan_id: '57ae0bb02f16c4f89c442450'
      },
      {
        name: 'Listings Sync Plan A - $39.99',
        package_id: '57ae658b2f16c4f89c44245e',
        plan_id: '57ae658b2f16c4f89c44245f'
      },
      {
        name: 'Listings Sync Plan C - $29.99',
        package_id: '57ae658b2f16c4f89c44245e',
        plan_id: '57c8af45e03b7e5d6549f584'
      }
    ])
    .constant('industries', [
      "Accountant",
      "Advertising Agency",
      "Air Conditioning Contractor",
      "American Restaurant",
      "Amusement Center",
      "Amusement Park",
      "Animal Hospital",
      "Apartment Building",
      "Apartment Complex",
      "Appliance Store",
      "Architect",
      "Art Gallery",
      "Art Museum",
      "Ashram",
      "Asian Restaurant",
      "ATM",
      "Auto Body Shop",
      "Auto Parts Store",
      "Auto Repair Shop",
      "Baby Store",
      "Bahá'í House of Worship",
      "Bakery",
      "Bank",
      "Baptist Church",
      "Bar & Grill",
      "Bar",
      "Barbecue Restaurant",
      "Barber Shop",
      "Beach Resort",
      "Beauty Salon",
      "Beauty Supply Store",
      "Bed & Breakfast",
      "Bicycle Store",
      "Book Store",
      "Boutique",
      "Bowling Alley",
      "Breakfast Restaurant",
      "Bridal Shop",
      "Buddhist Temple",
      "Budget Hotel",
      "Buffet Restaurant",
      "Building Materials Store",
      "Business Management Consultant",
      "Butcher Shop",
      "Cabinet Maker",
      "Cable Company",
      "Cafe",
      "Campground",
      "Car Dealer",
      "Car Rental Agency",
      "Car Repair and Maintenance",
      "Car Wash",
      "Caterer",
      "Catholic Church",
      "Cell Phone Store",
      "Cemetery",
      "Chicken Restaurant",
      "Chicken Wings Restaurant",
      "Children's Clothing Store",
      "Chinese Restaurant",
      "Chiropractor",
      "Church",
      "City Government Office",
      "City or Town Hall",
      "Cleaning Service",
      "Clothing Store",
      "Coffee Shop",
      "Coffee Store",
      "College",
      "Commercial Printer",
      "Community Center",
      "Community College",
      "Computer Consultant",
      "Computer Repair Service",
      "Computer Store",
      "Condominium Complex",
      "Construction Company",
      "Consultant",
      "Contractor",
      "Convenience Store",
      "Convent",
      "Cosmetics Store",
      "County Government Office",
      "Courier Service",
      "Craft Store",
      "Credit Union",
      "Dance School",
      "Day Care Center",
      "Deli",
      "Dental Clinic",
      "Dentist",
      "Department of Motor Vehicles",
      "Department Store",
      "Dermatologist",
      "Dessert Shop",
      "Diner",
      "Discount Store",
      "Discount Supermarket",
      "Doctor",
      "Donut Shop",
      "Driving School",
      "Drug Store",
      "Dry Cleaner",
      "Electric Utility Company",
      "Electrical Supply Store",
      "Electrician",
      "Electronics Store",
      "Elementary School",
      "Employment Agency",
      "Engineer",
      "Engineering Consultant",
      "Event Planner",
      "Event Venue",
      "Extended Stay Hotel",
      "Eye Care Center",
      "Fabric Store",
      "Family Practice Physician",
      "Family Restaurant",
      "Fashion Accessories Store",
      "Fast Food Restaurant",
      "Financial Consultant",
      "Financial Planner",
      "Fire Station",
      "Florist",
      "Freight Forwarding Service",
      "French Restaurant",
      "Funeral Home",
      "Furniture Store",
      "Gas Station",
      "General Contractor",
      "General Practitioner",
      "General Store",
      "Gift Shop",
      "Golf Club",
      "Golf Course",
      "Government Office",
      "Grocery Store",
      "Guest House",
      "Gurudwara",
      "Gym",
      "Hair Salon",
      "Hamburger Restaurant",
      "Hardware Store",
      "Health Club",
      "Health Food Store",
      "High School",
      "Hindu Temple",
      "Home Builder",
      "Home Goods Store",
      "Home Health Care Service",
      "Home Improvement Store",
      "Hospital",
      "Hostel",
      "Hotel",
      "House Cleaning Service",
      "Ice Cream Shop",
      "Indian Restaurant",
      "Industrial Area",
      "Insurance Agency",
      "Interior Designer",
      "Internet Marketing Service",
      "Internet Service Provider",
      "Internist",
      "Italian Restaurant",
      "Jain Temple",
      "Japanese Restaurant",
      "Jeweler",
      "Jewelry Store",
      "Kindergarten",
      "Korean Restaurant",
      "Landscaper",
      "Laundry Service",
      "Lawyer",
      "Legal Services",
      "Library",
      "Lingerie Store",
      "Liquor Store",
      "Live Music Venue",
      "Loan Agency",
      "Local Government Office",
      "Lottery Retailer",
      "Luxury Hotel",
      "Market",
      "Marketing Agency",
      "Massage Therapist",
      "Meal Takeaway",
      "Medical Center",
      "Medical Clinic",
      "Medical Laboratory",
      "Men's Clothing Store",
      "Mexican Restaurant",
      "Middle School",
      "Mission",
      "Monastery",
      "Money Transfer Service",
      "Mosque",
      "Motel",
      "Motorcycle Dealer",
      "Movie Rental Kiosk",
      "Movie Theater",
      "Museum",
      "Nail Salon",
      "National Park",
      "Newspaper Publisher",
      "Night Club",
      "Notary Public",
      "Nursing Agency",
      "Obstetrician-Gynecologist",
      "Office Supply Store",
      "Optician",
      "Optometrist",
      "Outdoor Sports Store",
      "Outlet Mall",
      "Pagoda",
      "Paint Store",
      "Painter",
      "Park",
      "Parking Garage",
      "Parking Lot",
      "Pawn Shop",
      "Pediatrician",
      "Performing Arts Theater",
      "Pest Control Service",
      "Pet Store",
      "Pet Supply Store",
      "Pharmacy",
      "Photographer",
      "Physical Therapist",
      "Pilgrimage Place",
      "Pizza Delivery",
      "Pizza Restaurant",
      "Place of Worship",
      "Plumber",
      "Police Department",
      "Police Station",
      "Post Office",
      "Preschool",
      "Primary School",
      "Print Shop",
      "Private School",
      "Property Management Company",
      "Psychologist",
      "Pub",
      "Public Library",
      "Public School",
      "Public Swimming Pool",
      "Public University",
      "Publisher",
      "Ramen Restaurant",
      "Real Estate Agency",
      "Real Estate Agents",
      "Real Estate Developer",
      "Religious Destination",
      "Resort",
      "Restaurant",
      "Roofing Contractor",
      "RV Park",
      "Sandwich Shop",
      "Savings Bank",
      "School",
      "Seafood Restaurant",
      "Shinto Shrine",
      "Shipping and Mailing Service",
      "Shipping Company",
      "Shoe Store",
      "Shopping Mall",
      "Software Company",
      "Spa",
      "Sporting Goods Store",
      "Sports Bar",
      "Sportswear Store",
      "Stadium",
      "Stationery Store",
      "Steak House",
      "Store",
      "Supermarket",
      "Sushi Restaurant",
      "Synagogue",
      "Tailor",
      "Tattoo Shop",
      "Tax Consultant",
      "Tax Preparation Service",
      "Taxi Service",
      "Tea House",
      "Telecommunications Service Provider",
      "Thai Restaurant",
      "Theme Park",
      "Thrift Store",
      "Tire Shop",
      "Tobacco Shop",
      "Tourist Attraction",
      "Tourist Information Center",
      "Toy Store",
      "Transportation Service",
      "Travel Agency",
      "Truck Rental Agency",
      "Trucking Company",
      "Tutoring Service",
      "University",
      "Used Car Dealer",
      "Veterinarian",
      "Video Game Store",
      "Warehouse club",
      "Water Park",
      "Website Designer",
      "Wine Store",
      "Winery",
      "Women's Clothing Store",
      "Zoo"
    ])
    .constant('roles', [
      {
        id: '56a2e7dfbffebc52128b4568',
        name: 'admin'
      },
      {
        id: '56a2e7e5bffebc57128b4567',
        name: 'provisioner'
      },
      {
        id: '56a2e7eabffebc5b128b4568',
        name: 'opener'
      },
      {
        id: '56a2e7efbffebc52128b4569',
        name: 'closer'
      },
      {
        id: '5702a00a5b66113f42065922',
        name: 'customer service'
      },
      {
        id: '5702a01d5b66113f42065925',
        name: 'billing'
      },
      {
        id: '5702a02d5b66113f42065926',
        name: 'seo'
      },
      {
        id: '5702a0385b66113f42065927',
        name: 'management'
      },
      {
        id: '57bf6dbd7358791e03abde0d',
        name: 'sr. account exec'
      },
      {
        id: '57f2b67794bb3248ac80b592',
        name: 'cap'
      },
      {
        id: '58470f6bc278ebe6d882ab4a',
        name: 'outsource'
      }
    ])
    .constant('hotButtons', [
      "Company",
      "Emails",
      "Fix incorrect info",
      "Google Local",
      "Guarantee",
      "Image SEO",
      "Increase Traffic",
      "Keywords",
      "More Customers",
      "Organic",
      "Power Listings",
      "PPC",
      "Premium Site",
      "Price",
      "Promotional Material",
      "Sales Person",
      "Unlimited Clicks",
      "Video SEO",
      "Website",
      "Yahoo & Bing"
    ])
    .constant('marketingMethods', [
      "AdWords",
      "Affiliate",
      "Banner Ads",
      "Billboards",
      "Email",
      "None",
      "Other",
      "Print",
      "Radio",
      "SEO",
      "Social Media",
      "Telemarketing",
      "TV",
      "Word of Mouth"
    ])
    .constant('paymentMethods', [
      "american express",
      "cash",
      "check",
      "discover",
      "mastercard",
      "paypal",
      "visa"
    ])
    .constant('dispositions', [
      "Already with SEO",
      "Business Closed",
      "CB Setup",
      "DNC",
      "No Money",
      "Partner",
      "Partner Objection",
      "Seasonal"
    ])
    .constant('leadTypes', [
      "Inbound (VB)",
      "Outbound",
      "Referral",
      "Transfer (From Opener)",
      "Update Call"
    ])
    .constant('languages', [
      "Cantonese",
      "Dutch",
      "English",
      "French",
      "German",
      "Hebrew",
      "Italian",
      "Mandarin",
      "Other",
      "Portuguese",
      "Spanish",
      "Vietnamese"
    ])
    .constant('parkingAvailable', [
      "Covered",
      "Free",
      "Handicap",
      "None",
      "Street",
      "Valet"
    ])
    .constant('countries', [
//            {
//                "name": "Afghanistan",
//                "alpha-2": "AF",
//                "alpha-3": "AFG",
//                "country-code": "004",
//                "iso_3166-2": "ISO 3166-2:AF",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Åland Islands",
//                "alpha-2": "AX",
//                "alpha-3": "ALA",
//                "country-code": "248",
//                "iso_3166-2": "ISO 3166-2:AX",
//                "sub-region-code": "154",
//                "region-code": "150",
//                "sub-region": "Northern Europe",
//                "region": "Europe"
//            },
//            {
//                "name": "Albania",
//                "alpha-2": "AL",
//                "alpha-3": "ALB",
//                "country-code": "008",
//                "iso_3166-2": "ISO 3166-2:AL",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Algeria",
//                "alpha-2": "DZ",
//                "alpha-3": "DZA",
//                "country-code": "012",
//                "iso_3166-2": "ISO 3166-2:DZ",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "American Samoa",
//                "alpha-2": "AS",
//                "alpha-3": "ASM",
//                "country-code": "016",
//                "iso_3166-2": "ISO 3166-2:AS",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Andorra",
//                "alpha-2": "AD",
//                "alpha-3": "AND",
//                "country-code": "020",
//                "iso_3166-2": "ISO 3166-2:AD",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Angola",
//                "alpha-2": "AO",
//                "alpha-3": "AGO",
//                "country-code": "024",
//                "iso_3166-2": "ISO 3166-2:AO",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Anguilla",
//                "alpha-2": "AI",
//                "alpha-3": "AIA",
//                "country-code": "660",
//                "iso_3166-2": "ISO 3166-2:AI",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Antarctica",
//                "alpha-2": "AQ",
//                "alpha-3": "ATA",
//                "country-code": "010",
//                "iso_3166-2": "ISO 3166-2:AQ",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Antigua and Barbuda",
//                "alpha-2": "AG",
//                "alpha-3": "ATG",
//                "country-code": "028",
//                "iso_3166-2": "ISO 3166-2:AG",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Argentina",
//                "alpha-2": "AR",
//                "alpha-3": "ARG",
//                "country-code": "032",
//                "iso_3166-2": "ISO 3166-2:AR",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Armenia",
//                "alpha-2": "AM",
//                "alpha-3": "ARM",
//                "country-code": "051",
//                "iso_3166-2": "ISO 3166-2:AM",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Aruba",
//                "alpha-2": "AW",
//                "alpha-3": "ABW",
//                "country-code": "533",
//                "iso_3166-2": "ISO 3166-2:AW",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Australia",
//                "alpha-2": "AU",
//                "alpha-3": "AUS",
//                "country-code": "036",
//                "iso_3166-2": "ISO 3166-2:AU",
//                "region": "Oceania",
//                "sub-region": "Australia and New Zealand",
//                "region-code": "009",
//                "sub-region-code": "053"
//            },
//            {
//                "name": "Austria",
//                "alpha-2": "AT",
//                "alpha-3": "AUT",
//                "country-code": "040",
//                "iso_3166-2": "ISO 3166-2:AT",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Azerbaijan",
//                "alpha-2": "AZ",
//                "alpha-3": "AZE",
//                "country-code": "031",
//                "iso_3166-2": "ISO 3166-2:AZ",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Bahamas",
//                "alpha-2": "BS",
//                "alpha-3": "BHS",
//                "country-code": "044",
//                "iso_3166-2": "ISO 3166-2:BS",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Bahrain",
//                "alpha-2": "BH",
//                "alpha-3": "BHR",
//                "country-code": "048",
//                "iso_3166-2": "ISO 3166-2:BH",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Bangladesh",
//                "alpha-2": "BD",
//                "alpha-3": "BGD",
//                "country-code": "050",
//                "iso_3166-2": "ISO 3166-2:BD",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Barbados",
//                "alpha-2": "BB",
//                "alpha-3": "BRB",
//                "country-code": "052",
//                "iso_3166-2": "ISO 3166-2:BB",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Belarus",
//                "alpha-2": "BY",
//                "alpha-3": "BLR",
//                "country-code": "112",
//                "iso_3166-2": "ISO 3166-2:BY",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Belgium",
//                "alpha-2": "BE",
//                "alpha-3": "BEL",
//                "country-code": "056",
//                "iso_3166-2": "ISO 3166-2:BE",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Belize",
//                "alpha-2": "BZ",
//                "alpha-3": "BLZ",
//                "country-code": "084",
//                "iso_3166-2": "ISO 3166-2:BZ",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Benin",
//                "alpha-2": "BJ",
//                "alpha-3": "BEN",
//                "country-code": "204",
//                "iso_3166-2": "ISO 3166-2:BJ",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Bermuda",
//                "alpha-2": "BM",
//                "alpha-3": "BMU",
//                "country-code": "060",
//                "iso_3166-2": "ISO 3166-2:BM",
//                "region": "Americas",
//                "sub-region": "Northern America",
//                "region-code": "019",
//                "sub-region-code": "021"
//            },
//            {
//                "name": "Bhutan",
//                "alpha-2": "BT",
//                "alpha-3": "BTN",
//                "country-code": "064",
//                "iso_3166-2": "ISO 3166-2:BT",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Bolivia (Plurinational State of)",
//                "alpha-2": "BO",
//                "alpha-3": "BOL",
//                "country-code": "068",
//                "iso_3166-2": "ISO 3166-2:BO",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Bonaire, Sint Eustatius and Saba",
//                "alpha-2": "BQ",
//                "alpha-3": "BES",
//                "country-code": "535",
//                "iso_3166-2": "ISO 3166-2:BQ",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Bosnia and Herzegovina",
//                "alpha-2": "BA",
//                "alpha-3": "BIH",
//                "country-code": "070",
//                "iso_3166-2": "ISO 3166-2:BA",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Botswana",
//                "alpha-2": "BW",
//                "alpha-3": "BWA",
//                "country-code": "072",
//                "iso_3166-2": "ISO 3166-2:BW",
//                "region": "Africa",
//                "sub-region": "Southern Africa",
//                "region-code": "002",
//                "sub-region-code": "018"
//            },
//            {
//                "name": "Bouvet Island",
//                "alpha-2": "BV",
//                "alpha-3": "BVT",
//                "country-code": "074",
//                "iso_3166-2": "ISO 3166-2:BV",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Brazil",
//                "alpha-2": "BR",
//                "alpha-3": "BRA",
//                "country-code": "076",
//                "iso_3166-2": "ISO 3166-2:BR",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "British Indian Ocean Territory",
//                "alpha-2": "IO",
//                "alpha-3": "IOT",
//                "country-code": "086",
//                "iso_3166-2": "ISO 3166-2:IO",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Brunei Darussalam",
//                "alpha-2": "BN",
//                "alpha-3": "BRN",
//                "country-code": "096",
//                "iso_3166-2": "ISO 3166-2:BN",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Bulgaria",
//                "alpha-2": "BG",
//                "alpha-3": "BGR",
//                "country-code": "100",
//                "iso_3166-2": "ISO 3166-2:BG",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Burkina Faso",
//                "alpha-2": "BF",
//                "alpha-3": "BFA",
//                "country-code": "854",
//                "iso_3166-2": "ISO 3166-2:BF",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Burundi",
//                "alpha-2": "BI",
//                "alpha-3": "BDI",
//                "country-code": "108",
//                "iso_3166-2": "ISO 3166-2:BI",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Cambodia",
//                "alpha-2": "KH",
//                "alpha-3": "KHM",
//                "country-code": "116",
//                "iso_3166-2": "ISO 3166-2:KH",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Cameroon",
//                "alpha-2": "CM",
//                "alpha-3": "CMR",
//                "country-code": "120",
//                "iso_3166-2": "ISO 3166-2:CM",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
      {
        "name": "Canada",
        "alpha-2": "CA",
        "alpha-3": "CAN",
        "country-code": "124",
        "iso_3166-2": "ISO 3166-2:CA",
        "region": "Americas",
        "sub-region": "Northern America",
        "region-code": "019",
        "sub-region-code": "021"
      },
//            {
//                "name": "Cabo Verde",
//                "alpha-2": "CV",
//                "alpha-3": "CPV",
//                "country-code": "132",
//                "iso_3166-2": "ISO 3166-2:CV",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Cayman Islands",
//                "alpha-2": "KY",
//                "alpha-3": "CYM",
//                "country-code": "136",
//                "iso_3166-2": "ISO 3166-2:KY",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Central African Republic",
//                "alpha-2": "CF",
//                "alpha-3": "CAF",
//                "country-code": "140",
//                "iso_3166-2": "ISO 3166-2:CF",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Chad",
//                "alpha-2": "TD",
//                "alpha-3": "TCD",
//                "country-code": "148",
//                "iso_3166-2": "ISO 3166-2:TD",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Chile",
//                "alpha-2": "CL",
//                "alpha-3": "CHL",
//                "country-code": "152",
//                "iso_3166-2": "ISO 3166-2:CL",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "China",
//                "alpha-2": "CN",
//                "alpha-3": "CHN",
//                "country-code": "156",
//                "iso_3166-2": "ISO 3166-2:CN",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Christmas Island",
//                "alpha-2": "CX",
//                "alpha-3": "CXR",
//                "country-code": "162",
//                "iso_3166-2": "ISO 3166-2:CX",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Cocos (Keeling) Islands",
//                "alpha-2": "CC",
//                "alpha-3": "CCK",
//                "country-code": "166",
//                "iso_3166-2": "ISO 3166-2:CC",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Colombia",
//                "alpha-2": "CO",
//                "alpha-3": "COL",
//                "country-code": "170",
//                "iso_3166-2": "ISO 3166-2:CO",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Comoros",
//                "alpha-2": "KM",
//                "alpha-3": "COM",
//                "country-code": "174",
//                "iso_3166-2": "ISO 3166-2:KM",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Congo",
//                "alpha-2": "CG",
//                "alpha-3": "COG",
//                "country-code": "178",
//                "iso_3166-2": "ISO 3166-2:CG",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Congo (Democratic Republic of the)",
//                "alpha-2": "CD",
//                "alpha-3": "COD",
//                "country-code": "180",
//                "iso_3166-2": "ISO 3166-2:CD",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Cook Islands",
//                "alpha-2": "CK",
//                "alpha-3": "COK",
//                "country-code": "184",
//                "iso_3166-2": "ISO 3166-2:CK",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Costa Rica",
//                "alpha-2": "CR",
//                "alpha-3": "CRI",
//                "country-code": "188",
//                "iso_3166-2": "ISO 3166-2:CR",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Côte d'Ivoire",
//                "alpha-2": "CI",
//                "alpha-3": "CIV",
//                "country-code": "384",
//                "iso_3166-2": "ISO 3166-2:CI",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Croatia",
//                "alpha-2": "HR",
//                "alpha-3": "HRV",
//                "country-code": "191",
//                "iso_3166-2": "ISO 3166-2:HR",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Cuba",
//                "alpha-2": "CU",
//                "alpha-3": "CUB",
//                "country-code": "192",
//                "iso_3166-2": "ISO 3166-2:CU",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Curaçao",
//                "alpha-2": "CW",
//                "alpha-3": "CUW",
//                "country-code": "531",
//                "iso_3166-2": "ISO 3166-2:CW",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Cyprus",
//                "alpha-2": "CY",
//                "alpha-3": "CYP",
//                "country-code": "196",
//                "iso_3166-2": "ISO 3166-2:CY",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Czech Republic",
//                "alpha-2": "CZ",
//                "alpha-3": "CZE",
//                "country-code": "203",
//                "iso_3166-2": "ISO 3166-2:CZ",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Denmark",
//                "alpha-2": "DK",
//                "alpha-3": "DNK",
//                "country-code": "208",
//                "iso_3166-2": "ISO 3166-2:DK",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Djibouti",
//                "alpha-2": "DJ",
//                "alpha-3": "DJI",
//                "country-code": "262",
//                "iso_3166-2": "ISO 3166-2:DJ",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Dominica",
//                "alpha-2": "DM",
//                "alpha-3": "DMA",
//                "country-code": "212",
//                "iso_3166-2": "ISO 3166-2:DM",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Dominican Republic",
//                "alpha-2": "DO",
//                "alpha-3": "DOM",
//                "country-code": "214",
//                "iso_3166-2": "ISO 3166-2:DO",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Ecuador",
//                "alpha-2": "EC",
//                "alpha-3": "ECU",
//                "country-code": "218",
//                "iso_3166-2": "ISO 3166-2:EC",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Egypt",
//                "alpha-2": "EG",
//                "alpha-3": "EGY",
//                "country-code": "818",
//                "iso_3166-2": "ISO 3166-2:EG",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "El Salvador",
//                "alpha-2": "SV",
//                "alpha-3": "SLV",
//                "country-code": "222",
//                "iso_3166-2": "ISO 3166-2:SV",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Equatorial Guinea",
//                "alpha-2": "GQ",
//                "alpha-3": "GNQ",
//                "country-code": "226",
//                "iso_3166-2": "ISO 3166-2:GQ",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Eritrea",
//                "alpha-2": "ER",
//                "alpha-3": "ERI",
//                "country-code": "232",
//                "iso_3166-2": "ISO 3166-2:ER",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Estonia",
//                "alpha-2": "EE",
//                "alpha-3": "EST",
//                "country-code": "233",
//                "iso_3166-2": "ISO 3166-2:EE",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Ethiopia",
//                "alpha-2": "ET",
//                "alpha-3": "ETH",
//                "country-code": "231",
//                "iso_3166-2": "ISO 3166-2:ET",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Falkland Islands (Malvinas)",
//                "alpha-2": "FK",
//                "alpha-3": "FLK",
//                "country-code": "238",
//                "iso_3166-2": "ISO 3166-2:FK",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Faroe Islands",
//                "alpha-2": "FO",
//                "alpha-3": "FRO",
//                "country-code": "234",
//                "iso_3166-2": "ISO 3166-2:FO",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Fiji",
//                "alpha-2": "FJ",
//                "alpha-3": "FJI",
//                "country-code": "242",
//                "iso_3166-2": "ISO 3166-2:FJ",
//                "region": "Oceania",
//                "sub-region": "Melanesia",
//                "region-code": "009",
//                "sub-region-code": "054"
//            },
//            {
//                "name": "Finland",
//                "alpha-2": "FI",
//                "alpha-3": "FIN",
//                "country-code": "246",
//                "iso_3166-2": "ISO 3166-2:FI",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "France",
//                "alpha-2": "FR",
//                "alpha-3": "FRA",
//                "country-code": "250",
//                "iso_3166-2": "ISO 3166-2:FR",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "French Guiana",
//                "alpha-2": "GF",
//                "alpha-3": "GUF",
//                "country-code": "254",
//                "iso_3166-2": "ISO 3166-2:GF",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "French Polynesia",
//                "alpha-2": "PF",
//                "alpha-3": "PYF",
//                "country-code": "258",
//                "iso_3166-2": "ISO 3166-2:PF",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "French Southern Territories",
//                "alpha-2": "TF",
//                "alpha-3": "ATF",
//                "country-code": "260",
//                "iso_3166-2": "ISO 3166-2:TF",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Gabon",
//                "alpha-2": "GA",
//                "alpha-3": "GAB",
//                "country-code": "266",
//                "iso_3166-2": "ISO 3166-2:GA",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Gambia",
//                "alpha-2": "GM",
//                "alpha-3": "GMB",
//                "country-code": "270",
//                "iso_3166-2": "ISO 3166-2:GM",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Georgia",
//                "alpha-2": "GE",
//                "alpha-3": "GEO",
//                "country-code": "268",
//                "iso_3166-2": "ISO 3166-2:GE",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Germany",
//                "alpha-2": "DE",
//                "alpha-3": "DEU",
//                "country-code": "276",
//                "iso_3166-2": "ISO 3166-2:DE",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Ghana",
//                "alpha-2": "GH",
//                "alpha-3": "GHA",
//                "country-code": "288",
//                "iso_3166-2": "ISO 3166-2:GH",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Gibraltar",
//                "alpha-2": "GI",
//                "alpha-3": "GIB",
//                "country-code": "292",
//                "iso_3166-2": "ISO 3166-2:GI",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Greece",
//                "alpha-2": "GR",
//                "alpha-3": "GRC",
//                "country-code": "300",
//                "iso_3166-2": "ISO 3166-2:GR",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Greenland",
//                "alpha-2": "GL",
//                "alpha-3": "GRL",
//                "country-code": "304",
//                "iso_3166-2": "ISO 3166-2:GL",
//                "region": "Americas",
//                "sub-region": "Northern America",
//                "region-code": "019",
//                "sub-region-code": "021"
//            },
//            {
//                "name": "Grenada",
//                "alpha-2": "GD",
//                "alpha-3": "GRD",
//                "country-code": "308",
//                "iso_3166-2": "ISO 3166-2:GD",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Guadeloupe",
//                "alpha-2": "GP",
//                "alpha-3": "GLP",
//                "country-code": "312",
//                "iso_3166-2": "ISO 3166-2:GP",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Guam",
//                "alpha-2": "GU",
//                "alpha-3": "GUM",
//                "country-code": "316",
//                "iso_3166-2": "ISO 3166-2:GU",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Guatemala",
//                "alpha-2": "GT",
//                "alpha-3": "GTM",
//                "country-code": "320",
//                "iso_3166-2": "ISO 3166-2:GT",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Guernsey",
//                "alpha-2": "GG",
//                "alpha-3": "GGY",
//                "country-code": "831",
//                "iso_3166-2": "ISO 3166-2:GG",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Guinea",
//                "alpha-2": "GN",
//                "alpha-3": "GIN",
//                "country-code": "324",
//                "iso_3166-2": "ISO 3166-2:GN",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Guinea-Bissau",
//                "alpha-2": "GW",
//                "alpha-3": "GNB",
//                "country-code": "624",
//                "iso_3166-2": "ISO 3166-2:GW",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Guyana",
//                "alpha-2": "GY",
//                "alpha-3": "GUY",
//                "country-code": "328",
//                "iso_3166-2": "ISO 3166-2:GY",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Haiti",
//                "alpha-2": "HT",
//                "alpha-3": "HTI",
//                "country-code": "332",
//                "iso_3166-2": "ISO 3166-2:HT",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Heard Island and McDonald Islands",
//                "alpha-2": "HM",
//                "alpha-3": "HMD",
//                "country-code": "334",
//                "iso_3166-2": "ISO 3166-2:HM",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Holy See",
//                "alpha-2": "VA",
//                "alpha-3": "VAT",
//                "country-code": "336",
//                "iso_3166-2": "ISO 3166-2:VA",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Honduras",
//                "alpha-2": "HN",
//                "alpha-3": "HND",
//                "country-code": "340",
//                "iso_3166-2": "ISO 3166-2:HN",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Hong Kong",
//                "alpha-2": "HK",
//                "alpha-3": "HKG",
//                "country-code": "344",
//                "iso_3166-2": "ISO 3166-2:HK",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Hungary",
//                "alpha-2": "HU",
//                "alpha-3": "HUN",
//                "country-code": "348",
//                "iso_3166-2": "ISO 3166-2:HU",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Iceland",
//                "alpha-2": "IS",
//                "alpha-3": "ISL",
//                "country-code": "352",
//                "iso_3166-2": "ISO 3166-2:IS",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "India",
//                "alpha-2": "IN",
//                "alpha-3": "IND",
//                "country-code": "356",
//                "iso_3166-2": "ISO 3166-2:IN",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Indonesia",
//                "alpha-2": "ID",
//                "alpha-3": "IDN",
//                "country-code": "360",
//                "iso_3166-2": "ISO 3166-2:ID",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Iran (Islamic Republic of)",
//                "alpha-2": "IR",
//                "alpha-3": "IRN",
//                "country-code": "364",
//                "iso_3166-2": "ISO 3166-2:IR",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Iraq",
//                "alpha-2": "IQ",
//                "alpha-3": "IRQ",
//                "country-code": "368",
//                "iso_3166-2": "ISO 3166-2:IQ",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Ireland",
//                "alpha-2": "IE",
//                "alpha-3": "IRL",
//                "country-code": "372",
//                "iso_3166-2": "ISO 3166-2:IE",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Isle of Man",
//                "alpha-2": "IM",
//                "alpha-3": "IMN",
//                "country-code": "833",
//                "iso_3166-2": "ISO 3166-2:IM",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Israel",
//                "alpha-2": "IL",
//                "alpha-3": "ISR",
//                "country-code": "376",
//                "iso_3166-2": "ISO 3166-2:IL",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Italy",
//                "alpha-2": "IT",
//                "alpha-3": "ITA",
//                "country-code": "380",
//                "iso_3166-2": "ISO 3166-2:IT",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Jamaica",
//                "alpha-2": "JM",
//                "alpha-3": "JAM",
//                "country-code": "388",
//                "iso_3166-2": "ISO 3166-2:JM",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Japan",
//                "alpha-2": "JP",
//                "alpha-3": "JPN",
//                "country-code": "392",
//                "iso_3166-2": "ISO 3166-2:JP",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Jersey",
//                "alpha-2": "JE",
//                "alpha-3": "JEY",
//                "country-code": "832",
//                "iso_3166-2": "ISO 3166-2:JE",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Jordan",
//                "alpha-2": "JO",
//                "alpha-3": "JOR",
//                "country-code": "400",
//                "iso_3166-2": "ISO 3166-2:JO",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Kazakhstan",
//                "alpha-2": "KZ",
//                "alpha-3": "KAZ",
//                "country-code": "398",
//                "iso_3166-2": "ISO 3166-2:KZ",
//                "region": "Asia",
//                "sub-region": "Central Asia",
//                "region-code": "142",
//                "sub-region-code": "143"
//            },
//            {
//                "name": "Kenya",
//                "alpha-2": "KE",
//                "alpha-3": "KEN",
//                "country-code": "404",
//                "iso_3166-2": "ISO 3166-2:KE",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Kiribati",
//                "alpha-2": "KI",
//                "alpha-3": "KIR",
//                "country-code": "296",
//                "iso_3166-2": "ISO 3166-2:KI",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Korea (Democratic People's Republic of)",
//                "alpha-2": "KP",
//                "alpha-3": "PRK",
//                "country-code": "408",
//                "iso_3166-2": "ISO 3166-2:KP",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Korea (Republic of)",
//                "alpha-2": "KR",
//                "alpha-3": "KOR",
//                "country-code": "410",
//                "iso_3166-2": "ISO 3166-2:KR",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Kuwait",
//                "alpha-2": "KW",
//                "alpha-3": "KWT",
//                "country-code": "414",
//                "iso_3166-2": "ISO 3166-2:KW",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Kyrgyzstan",
//                "alpha-2": "KG",
//                "alpha-3": "KGZ",
//                "country-code": "417",
//                "iso_3166-2": "ISO 3166-2:KG",
//                "region": "Asia",
//                "sub-region": "Central Asia",
//                "region-code": "142",
//                "sub-region-code": "143"
//            },
//            {
//                "name": "Lao People's Democratic Republic",
//                "alpha-2": "LA",
//                "alpha-3": "LAO",
//                "country-code": "418",
//                "iso_3166-2": "ISO 3166-2:LA",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Latvia",
//                "alpha-2": "LV",
//                "alpha-3": "LVA",
//                "country-code": "428",
//                "iso_3166-2": "ISO 3166-2:LV",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Lebanon",
//                "alpha-2": "LB",
//                "alpha-3": "LBN",
//                "country-code": "422",
//                "iso_3166-2": "ISO 3166-2:LB",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Lesotho",
//                "alpha-2": "LS",
//                "alpha-3": "LSO",
//                "country-code": "426",
//                "iso_3166-2": "ISO 3166-2:LS",
//                "region": "Africa",
//                "sub-region": "Southern Africa",
//                "region-code": "002",
//                "sub-region-code": "018"
//            },
//            {
//                "name": "Liberia",
//                "alpha-2": "LR",
//                "alpha-3": "LBR",
//                "country-code": "430",
//                "iso_3166-2": "ISO 3166-2:LR",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Libya",
//                "alpha-2": "LY",
//                "alpha-3": "LBY",
//                "country-code": "434",
//                "iso_3166-2": "ISO 3166-2:LY",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "Liechtenstein",
//                "alpha-2": "LI",
//                "alpha-3": "LIE",
//                "country-code": "438",
//                "iso_3166-2": "ISO 3166-2:LI",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Lithuania",
//                "alpha-2": "LT",
//                "alpha-3": "LTU",
//                "country-code": "440",
//                "iso_3166-2": "ISO 3166-2:LT",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Luxembourg",
//                "alpha-2": "LU",
//                "alpha-3": "LUX",
//                "country-code": "442",
//                "iso_3166-2": "ISO 3166-2:LU",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Macao",
//                "alpha-2": "MO",
//                "alpha-3": "MAC",
//                "country-code": "446",
//                "iso_3166-2": "ISO 3166-2:MO",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Macedonia (the former Yugoslav Republic of)",
//                "alpha-2": "MK",
//                "alpha-3": "MKD",
//                "country-code": "807",
//                "iso_3166-2": "ISO 3166-2:MK",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Madagascar",
//                "alpha-2": "MG",
//                "alpha-3": "MDG",
//                "country-code": "450",
//                "iso_3166-2": "ISO 3166-2:MG",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Malawi",
//                "alpha-2": "MW",
//                "alpha-3": "MWI",
//                "country-code": "454",
//                "iso_3166-2": "ISO 3166-2:MW",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Malaysia",
//                "alpha-2": "MY",
//                "alpha-3": "MYS",
//                "country-code": "458",
//                "iso_3166-2": "ISO 3166-2:MY",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Maldives",
//                "alpha-2": "MV",
//                "alpha-3": "MDV",
//                "country-code": "462",
//                "iso_3166-2": "ISO 3166-2:MV",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Mali",
//                "alpha-2": "ML",
//                "alpha-3": "MLI",
//                "country-code": "466",
//                "iso_3166-2": "ISO 3166-2:ML",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Malta",
//                "alpha-2": "MT",
//                "alpha-3": "MLT",
//                "country-code": "470",
//                "iso_3166-2": "ISO 3166-2:MT",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Marshall Islands",
//                "alpha-2": "MH",
//                "alpha-3": "MHL",
//                "country-code": "584",
//                "iso_3166-2": "ISO 3166-2:MH",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Martinique",
//                "alpha-2": "MQ",
//                "alpha-3": "MTQ",
//                "country-code": "474",
//                "iso_3166-2": "ISO 3166-2:MQ",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Mauritania",
//                "alpha-2": "MR",
//                "alpha-3": "MRT",
//                "country-code": "478",
//                "iso_3166-2": "ISO 3166-2:MR",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Mauritius",
//                "alpha-2": "MU",
//                "alpha-3": "MUS",
//                "country-code": "480",
//                "iso_3166-2": "ISO 3166-2:MU",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Mayotte",
//                "alpha-2": "YT",
//                "alpha-3": "MYT",
//                "country-code": "175",
//                "iso_3166-2": "ISO 3166-2:YT",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Mexico",
//                "alpha-2": "MX",
//                "alpha-3": "MEX",
//                "country-code": "484",
//                "iso_3166-2": "ISO 3166-2:MX",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Micronesia (Federated States of)",
//                "alpha-2": "FM",
//                "alpha-3": "FSM",
//                "country-code": "583",
//                "iso_3166-2": "ISO 3166-2:FM",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Moldova (Republic of)",
//                "alpha-2": "MD",
//                "alpha-3": "MDA",
//                "country-code": "498",
//                "iso_3166-2": "ISO 3166-2:MD",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Monaco",
//                "alpha-2": "MC",
//                "alpha-3": "MCO",
//                "country-code": "492",
//                "iso_3166-2": "ISO 3166-2:MC",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Mongolia",
//                "alpha-2": "MN",
//                "alpha-3": "MNG",
//                "country-code": "496",
//                "iso_3166-2": "ISO 3166-2:MN",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Montenegro",
//                "alpha-2": "ME",
//                "alpha-3": "MNE",
//                "country-code": "499",
//                "iso_3166-2": "ISO 3166-2:ME",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Montserrat",
//                "alpha-2": "MS",
//                "alpha-3": "MSR",
//                "country-code": "500",
//                "iso_3166-2": "ISO 3166-2:MS",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Morocco",
//                "alpha-2": "MA",
//                "alpha-3": "MAR",
//                "country-code": "504",
//                "iso_3166-2": "ISO 3166-2:MA",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "Mozambique",
//                "alpha-2": "MZ",
//                "alpha-3": "MOZ",
//                "country-code": "508",
//                "iso_3166-2": "ISO 3166-2:MZ",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Myanmar",
//                "alpha-2": "MM",
//                "alpha-3": "MMR",
//                "country-code": "104",
//                "iso_3166-2": "ISO 3166-2:MM",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Namibia",
//                "alpha-2": "NA",
//                "alpha-3": "NAM",
//                "country-code": "516",
//                "iso_3166-2": "ISO 3166-2:NA",
//                "region": "Africa",
//                "sub-region": "Southern Africa",
//                "region-code": "002",
//                "sub-region-code": "018"
//            },
//            {
//                "name": "Nauru",
//                "alpha-2": "NR",
//                "alpha-3": "NRU",
//                "country-code": "520",
//                "iso_3166-2": "ISO 3166-2:NR",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Nepal",
//                "alpha-2": "NP",
//                "alpha-3": "NPL",
//                "country-code": "524",
//                "iso_3166-2": "ISO 3166-2:NP",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Netherlands",
//                "alpha-2": "NL",
//                "alpha-3": "NLD",
//                "country-code": "528",
//                "iso_3166-2": "ISO 3166-2:NL",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "New Caledonia",
//                "alpha-2": "NC",
//                "alpha-3": "NCL",
//                "country-code": "540",
//                "iso_3166-2": "ISO 3166-2:NC",
//                "region": "Oceania",
//                "sub-region": "Melanesia",
//                "region-code": "009",
//                "sub-region-code": "054"
//            },
//            {
//                "name": "New Zealand",
//                "alpha-2": "NZ",
//                "alpha-3": "NZL",
//                "country-code": "554",
//                "iso_3166-2": "ISO 3166-2:NZ",
//                "region": "Oceania",
//                "sub-region": "Australia and New Zealand",
//                "region-code": "009",
//                "sub-region-code": "053"
//            },
//            {
//                "name": "Nicaragua",
//                "alpha-2": "NI",
//                "alpha-3": "NIC",
//                "country-code": "558",
//                "iso_3166-2": "ISO 3166-2:NI",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Niger",
//                "alpha-2": "NE",
//                "alpha-3": "NER",
//                "country-code": "562",
//                "iso_3166-2": "ISO 3166-2:NE",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Nigeria",
//                "alpha-2": "NG",
//                "alpha-3": "NGA",
//                "country-code": "566",
//                "iso_3166-2": "ISO 3166-2:NG",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Niue",
//                "alpha-2": "NU",
//                "alpha-3": "NIU",
//                "country-code": "570",
//                "iso_3166-2": "ISO 3166-2:NU",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Norfolk Island",
//                "alpha-2": "NF",
//                "alpha-3": "NFK",
//                "country-code": "574",
//                "iso_3166-2": "ISO 3166-2:NF",
//                "region": "Oceania",
//                "sub-region": "Australia and New Zealand",
//                "region-code": "009",
//                "sub-region-code": "053"
//            },
//            {
//                "name": "Northern Mariana Islands",
//                "alpha-2": "MP",
//                "alpha-3": "MNP",
//                "country-code": "580",
//                "iso_3166-2": "ISO 3166-2:MP",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Norway",
//                "alpha-2": "NO",
//                "alpha-3": "NOR",
//                "country-code": "578",
//                "iso_3166-2": "ISO 3166-2:NO",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Oman",
//                "alpha-2": "OM",
//                "alpha-3": "OMN",
//                "country-code": "512",
//                "iso_3166-2": "ISO 3166-2:OM",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Pakistan",
//                "alpha-2": "PK",
//                "alpha-3": "PAK",
//                "country-code": "586",
//                "iso_3166-2": "ISO 3166-2:PK",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Palau",
//                "alpha-2": "PW",
//                "alpha-3": "PLW",
//                "country-code": "585",
//                "iso_3166-2": "ISO 3166-2:PW",
//                "region": "Oceania",
//                "sub-region": "Micronesia",
//                "region-code": "009",
//                "sub-region-code": "057"
//            },
//            {
//                "name": "Palestine, State of",
//                "alpha-2": "PS",
//                "alpha-3": "PSE",
//                "country-code": "275",
//                "iso_3166-2": "ISO 3166-2:PS",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Panama",
//                "alpha-2": "PA",
//                "alpha-3": "PAN",
//                "country-code": "591",
//                "iso_3166-2": "ISO 3166-2:PA",
//                "region": "Americas",
//                "sub-region": "Central America",
//                "region-code": "019",
//                "sub-region-code": "013"
//            },
//            {
//                "name": "Papua New Guinea",
//                "alpha-2": "PG",
//                "alpha-3": "PNG",
//                "country-code": "598",
//                "iso_3166-2": "ISO 3166-2:PG",
//                "region": "Oceania",
//                "sub-region": "Melanesia",
//                "region-code": "009",
//                "sub-region-code": "054"
//            },
//            {
//                "name": "Paraguay",
//                "alpha-2": "PY",
//                "alpha-3": "PRY",
//                "country-code": "600",
//                "iso_3166-2": "ISO 3166-2:PY",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Peru",
//                "alpha-2": "PE",
//                "alpha-3": "PER",
//                "country-code": "604",
//                "iso_3166-2": "ISO 3166-2:PE",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Philippines",
//                "alpha-2": "PH",
//                "alpha-3": "PHL",
//                "country-code": "608",
//                "iso_3166-2": "ISO 3166-2:PH",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Pitcairn",
//                "alpha-2": "PN",
//                "alpha-3": "PCN",
//                "country-code": "612",
//                "iso_3166-2": "ISO 3166-2:PN",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Poland",
//                "alpha-2": "PL",
//                "alpha-3": "POL",
//                "country-code": "616",
//                "iso_3166-2": "ISO 3166-2:PL",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Portugal",
//                "alpha-2": "PT",
//                "alpha-3": "PRT",
//                "country-code": "620",
//                "iso_3166-2": "ISO 3166-2:PT",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Puerto Rico",
//                "alpha-2": "PR",
//                "alpha-3": "PRI",
//                "country-code": "630",
//                "iso_3166-2": "ISO 3166-2:PR",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Qatar",
//                "alpha-2": "QA",
//                "alpha-3": "QAT",
//                "country-code": "634",
//                "iso_3166-2": "ISO 3166-2:QA",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Réunion",
//                "alpha-2": "RE",
//                "alpha-3": "REU",
//                "country-code": "638",
//                "iso_3166-2": "ISO 3166-2:RE",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Romania",
//                "alpha-2": "RO",
//                "alpha-3": "ROU",
//                "country-code": "642",
//                "iso_3166-2": "ISO 3166-2:RO",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Russian Federation",
//                "alpha-2": "RU",
//                "alpha-3": "RUS",
//                "country-code": "643",
//                "iso_3166-2": "ISO 3166-2:RU",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Rwanda",
//                "alpha-2": "RW",
//                "alpha-3": "RWA",
//                "country-code": "646",
//                "iso_3166-2": "ISO 3166-2:RW",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Saint Barthélemy",
//                "alpha-2": "BL",
//                "alpha-3": "BLM",
//                "country-code": "652",
//                "iso_3166-2": "ISO 3166-2:BL",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Saint Helena, Ascension and Tristan da Cunha",
//                "alpha-2": "SH",
//                "alpha-3": "SHN",
//                "country-code": "654",
//                "iso_3166-2": "ISO 3166-2:SH",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Saint Kitts and Nevis",
//                "alpha-2": "KN",
//                "alpha-3": "KNA",
//                "country-code": "659",
//                "iso_3166-2": "ISO 3166-2:KN",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Saint Lucia",
//                "alpha-2": "LC",
//                "alpha-3": "LCA",
//                "country-code": "662",
//                "iso_3166-2": "ISO 3166-2:LC",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Saint Martin (French part)",
//                "alpha-2": "MF",
//                "alpha-3": "MAF",
//                "country-code": "663",
//                "iso_3166-2": "ISO 3166-2:MF",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Saint Pierre and Miquelon",
//                "alpha-2": "PM",
//                "alpha-3": "SPM",
//                "country-code": "666",
//                "iso_3166-2": "ISO 3166-2:PM",
//                "region": "Americas",
//                "sub-region": "Northern America",
//                "region-code": "019",
//                "sub-region-code": "021"
//            },
//            {
//                "name": "Saint Vincent and the Grenadines",
//                "alpha-2": "VC",
//                "alpha-3": "VCT",
//                "country-code": "670",
//                "iso_3166-2": "ISO 3166-2:VC",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Samoa",
//                "alpha-2": "WS",
//                "alpha-3": "WSM",
//                "country-code": "882",
//                "iso_3166-2": "ISO 3166-2:WS",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "San Marino",
//                "alpha-2": "SM",
//                "alpha-3": "SMR",
//                "country-code": "674",
//                "iso_3166-2": "ISO 3166-2:SM",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Sao Tome and Principe",
//                "alpha-2": "ST",
//                "alpha-3": "STP",
//                "country-code": "678",
//                "iso_3166-2": "ISO 3166-2:ST",
//                "region": "Africa",
//                "sub-region": "Middle Africa",
//                "region-code": "002",
//                "sub-region-code": "017"
//            },
//            {
//                "name": "Saudi Arabia",
//                "alpha-2": "SA",
//                "alpha-3": "SAU",
//                "country-code": "682",
//                "iso_3166-2": "ISO 3166-2:SA",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Senegal",
//                "alpha-2": "SN",
//                "alpha-3": "SEN",
//                "country-code": "686",
//                "iso_3166-2": "ISO 3166-2:SN",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Serbia",
//                "alpha-2": "RS",
//                "alpha-3": "SRB",
//                "country-code": "688",
//                "iso_3166-2": "ISO 3166-2:RS",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Seychelles",
//                "alpha-2": "SC",
//                "alpha-3": "SYC",
//                "country-code": "690",
//                "iso_3166-2": "ISO 3166-2:SC",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Sierra Leone",
//                "alpha-2": "SL",
//                "alpha-3": "SLE",
//                "country-code": "694",
//                "iso_3166-2": "ISO 3166-2:SL",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Singapore",
//                "alpha-2": "SG",
//                "alpha-3": "SGP",
//                "country-code": "702",
//                "iso_3166-2": "ISO 3166-2:SG",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Sint Maarten (Dutch part)",
//                "alpha-2": "SX",
//                "alpha-3": "SXM",
//                "country-code": "534",
//                "iso_3166-2": "ISO 3166-2:SX",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Slovakia",
//                "alpha-2": "SK",
//                "alpha-3": "SVK",
//                "country-code": "703",
//                "iso_3166-2": "ISO 3166-2:SK",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "Slovenia",
//                "alpha-2": "SI",
//                "alpha-3": "SVN",
//                "country-code": "705",
//                "iso_3166-2": "ISO 3166-2:SI",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Solomon Islands",
//                "alpha-2": "SB",
//                "alpha-3": "SLB",
//                "country-code": "090",
//                "iso_3166-2": "ISO 3166-2:SB",
//                "region": "Oceania",
//                "sub-region": "Melanesia",
//                "region-code": "009",
//                "sub-region-code": "054"
//            },
//            {
//                "name": "Somalia",
//                "alpha-2": "SO",
//                "alpha-3": "SOM",
//                "country-code": "706",
//                "iso_3166-2": "ISO 3166-2:SO",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "South Africa",
//                "alpha-2": "ZA",
//                "alpha-3": "ZAF",
//                "country-code": "710",
//                "iso_3166-2": "ISO 3166-2:ZA",
//                "region": "Africa",
//                "sub-region": "Southern Africa",
//                "region-code": "002",
//                "sub-region-code": "018"
//            },
//            {
//                "name": "South Georgia and the South Sandwich Islands",
//                "alpha-2": "GS",
//                "alpha-3": "SGS",
//                "country-code": "239",
//                "iso_3166-2": "ISO 3166-2:GS",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "South Sudan",
//                "alpha-2": "SS",
//                "alpha-3": "SSD",
//                "country-code": "728",
//                "iso_3166-2": "ISO 3166-2:SS",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Spain",
//                "alpha-2": "ES",
//                "alpha-3": "ESP",
//                "country-code": "724",
//                "iso_3166-2": "ISO 3166-2:ES",
//                "region": "Europe",
//                "sub-region": "Southern Europe",
//                "region-code": "150",
//                "sub-region-code": "039"
//            },
//            {
//                "name": "Sri Lanka",
//                "alpha-2": "LK",
//                "alpha-3": "LKA",
//                "country-code": "144",
//                "iso_3166-2": "ISO 3166-2:LK",
//                "region": "Asia",
//                "sub-region": "Southern Asia",
//                "region-code": "142",
//                "sub-region-code": "034"
//            },
//            {
//                "name": "Sudan",
//                "alpha-2": "SD",
//                "alpha-3": "SDN",
//                "country-code": "729",
//                "iso_3166-2": "ISO 3166-2:SD",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "Suriname",
//                "alpha-2": "SR",
//                "alpha-3": "SUR",
//                "country-code": "740",
//                "iso_3166-2": "ISO 3166-2:SR",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Svalbard and Jan Mayen",
//                "alpha-2": "SJ",
//                "alpha-3": "SJM",
//                "country-code": "744",
//                "iso_3166-2": "ISO 3166-2:SJ",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Swaziland",
//                "alpha-2": "SZ",
//                "alpha-3": "SWZ",
//                "country-code": "748",
//                "iso_3166-2": "ISO 3166-2:SZ",
//                "region": "Africa",
//                "sub-region": "Southern Africa",
//                "region-code": "002",
//                "sub-region-code": "018"
//            },
//            {
//                "name": "Sweden",
//                "alpha-2": "SE",
//                "alpha-3": "SWE",
//                "country-code": "752",
//                "iso_3166-2": "ISO 3166-2:SE",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
//            {
//                "name": "Switzerland",
//                "alpha-2": "CH",
//                "alpha-3": "CHE",
//                "country-code": "756",
//                "iso_3166-2": "ISO 3166-2:CH",
//                "region": "Europe",
//                "sub-region": "Western Europe",
//                "region-code": "150",
//                "sub-region-code": "155"
//            },
//            {
//                "name": "Syrian Arab Republic",
//                "alpha-2": "SY",
//                "alpha-3": "SYR",
//                "country-code": "760",
//                "iso_3166-2": "ISO 3166-2:SY",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Taiwan, Province of China",
//                "alpha-2": "TW",
//                "alpha-3": "TWN",
//                "country-code": "158",
//                "iso_3166-2": "ISO 3166-2:TW",
//                "region": "Asia",
//                "sub-region": "Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "030"
//            },
//            {
//                "name": "Tajikistan",
//                "alpha-2": "TJ",
//                "alpha-3": "TJK",
//                "country-code": "762",
//                "iso_3166-2": "ISO 3166-2:TJ",
//                "region": "Asia",
//                "sub-region": "Central Asia",
//                "region-code": "142",
//                "sub-region-code": "143"
//            },
//            {
//                "name": "Tanzania, United Republic of",
//                "alpha-2": "TZ",
//                "alpha-3": "TZA",
//                "country-code": "834",
//                "iso_3166-2": "ISO 3166-2:TZ",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Thailand",
//                "alpha-2": "TH",
//                "alpha-3": "THA",
//                "country-code": "764",
//                "iso_3166-2": "ISO 3166-2:TH",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Timor-Leste",
//                "alpha-2": "TL",
//                "alpha-3": "TLS",
//                "country-code": "626",
//                "iso_3166-2": "ISO 3166-2:TL",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Togo",
//                "alpha-2": "TG",
//                "alpha-3": "TGO",
//                "country-code": "768",
//                "iso_3166-2": "ISO 3166-2:TG",
//                "region": "Africa",
//                "sub-region": "Western Africa",
//                "region-code": "002",
//                "sub-region-code": "011"
//            },
//            {
//                "name": "Tokelau",
//                "alpha-2": "TK",
//                "alpha-3": "TKL",
//                "country-code": "772",
//                "iso_3166-2": "ISO 3166-2:TK",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Tonga",
//                "alpha-2": "TO",
//                "alpha-3": "TON",
//                "country-code": "776",
//                "iso_3166-2": "ISO 3166-2:TO",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Trinidad and Tobago",
//                "alpha-2": "TT",
//                "alpha-3": "TTO",
//                "country-code": "780",
//                "iso_3166-2": "ISO 3166-2:TT",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Tunisia",
//                "alpha-2": "TN",
//                "alpha-3": "TUN",
//                "country-code": "788",
//                "iso_3166-2": "ISO 3166-2:TN",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "Turkey",
//                "alpha-2": "TR",
//                "alpha-3": "TUR",
//                "country-code": "792",
//                "iso_3166-2": "ISO 3166-2:TR",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Turkmenistan",
//                "alpha-2": "TM",
//                "alpha-3": "TKM",
//                "country-code": "795",
//                "iso_3166-2": "ISO 3166-2:TM",
//                "region": "Asia",
//                "sub-region": "Central Asia",
//                "region-code": "142",
//                "sub-region-code": "143"
//            },
//            {
//                "name": "Turks and Caicos Islands",
//                "alpha-2": "TC",
//                "alpha-3": "TCA",
//                "country-code": "796",
//                "iso_3166-2": "ISO 3166-2:TC",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Tuvalu",
//                "alpha-2": "TV",
//                "alpha-3": "TUV",
//                "country-code": "798",
//                "iso_3166-2": "ISO 3166-2:TV",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Uganda",
//                "alpha-2": "UG",
//                "alpha-3": "UGA",
//                "country-code": "800",
//                "iso_3166-2": "ISO 3166-2:UG",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Ukraine",
//                "alpha-2": "UA",
//                "alpha-3": "UKR",
//                "country-code": "804",
//                "iso_3166-2": "ISO 3166-2:UA",
//                "region": "Europe",
//                "sub-region": "Eastern Europe",
//                "region-code": "150",
//                "sub-region-code": "151"
//            },
//            {
//                "name": "United Arab Emirates",
//                "alpha-2": "AE",
//                "alpha-3": "ARE",
//                "country-code": "784",
//                "iso_3166-2": "ISO 3166-2:AE",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "United Kingdom of Great Britain and Northern Ireland",
//                "alpha-2": "GB",
//                "alpha-3": "GBR",
//                "country-code": "826",
//                "iso_3166-2": "ISO 3166-2:GB",
//                "region": "Europe",
//                "sub-region": "Northern Europe",
//                "region-code": "150",
//                "sub-region-code": "154"
//            },
      {
        "name": "United States of America",
        "alpha-2": "US",
        "alpha-3": "USA",
        "country-code": "840",
        "iso_3166-2": "ISO 3166-2:US",
        "region": "Americas",
        "sub-region": "Northern America",
        "region-code": "019",
        "sub-region-code": "021"
      },
//            {
//                "name": "United States Minor Outlying Islands",
//                "alpha-2": "UM",
//                "alpha-3": "UMI",
//                "country-code": "581",
//                "iso_3166-2": "ISO 3166-2:UM",
//                "sub-region-code": null,
//                "region-code": null,
//                "sub-region": null,
//                "region": null
//            },
//            {
//                "name": "Uruguay",
//                "alpha-2": "UY",
//                "alpha-3": "URY",
//                "country-code": "858",
//                "iso_3166-2": "ISO 3166-2:UY",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Uzbekistan",
//                "alpha-2": "UZ",
//                "alpha-3": "UZB",
//                "country-code": "860",
//                "iso_3166-2": "ISO 3166-2:UZ",
//                "region": "Asia",
//                "sub-region": "Central Asia",
//                "region-code": "142",
//                "sub-region-code": "143"
//            },
//            {
//                "name": "Vanuatu",
//                "alpha-2": "VU",
//                "alpha-3": "VUT",
//                "country-code": "548",
//                "iso_3166-2": "ISO 3166-2:VU",
//                "region": "Oceania",
//                "sub-region": "Melanesia",
//                "region-code": "009",
//                "sub-region-code": "054"
//            },
//            {
//                "name": "Venezuela (Bolivarian Republic of)",
//                "alpha-2": "VE",
//                "alpha-3": "VEN",
//                "country-code": "862",
//                "iso_3166-2": "ISO 3166-2:VE",
//                "region": "Americas",
//                "sub-region": "South America",
//                "region-code": "019",
//                "sub-region-code": "005"
//            },
//            {
//                "name": "Viet Nam",
//                "alpha-2": "VN",
//                "alpha-3": "VNM",
//                "country-code": "704",
//                "iso_3166-2": "ISO 3166-2:VN",
//                "region": "Asia",
//                "sub-region": "South-Eastern Asia",
//                "region-code": "142",
//                "sub-region-code": "035"
//            },
//            {
//                "name": "Virgin Islands (British)",
//                "alpha-2": "VG",
//                "alpha-3": "VGB",
//                "country-code": "092",
//                "iso_3166-2": "ISO 3166-2:VG",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Virgin Islands (U.S.)",
//                "alpha-2": "VI",
//                "alpha-3": "VIR",
//                "country-code": "850",
//                "iso_3166-2": "ISO 3166-2:VI",
//                "region": "Americas",
//                "sub-region": "Caribbean",
//                "region-code": "019",
//                "sub-region-code": "029"
//            },
//            {
//                "name": "Wallis and Futuna",
//                "alpha-2": "WF",
//                "alpha-3": "WLF",
//                "country-code": "876",
//                "iso_3166-2": "ISO 3166-2:WF",
//                "region": "Oceania",
//                "sub-region": "Polynesia",
//                "region-code": "009",
//                "sub-region-code": "061"
//            },
//            {
//                "name": "Western Sahara",
//                "alpha-2": "EH",
//                "alpha-3": "ESH",
//                "country-code": "732",
//                "iso_3166-2": "ISO 3166-2:EH",
//                "region": "Africa",
//                "sub-region": "Northern Africa",
//                "region-code": "002",
//                "sub-region-code": "015"
//            },
//            {
//                "name": "Yemen",
//                "alpha-2": "YE",
//                "alpha-3": "YEM",
//                "country-code": "887",
//                "iso_3166-2": "ISO 3166-2:YE",
//                "region": "Asia",
//                "sub-region": "Western Asia",
//                "region-code": "142",
//                "sub-region-code": "145"
//            },
//            {
//                "name": "Zambia",
//                "alpha-2": "ZM",
//                "alpha-3": "ZMB",
//                "country-code": "894",
//                "iso_3166-2": "ISO 3166-2:ZM",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            },
//            {
//                "name": "Zimbabwe",
//                "alpha-2": "ZW",
//                "alpha-3": "ZWE",
//                "country-code": "716",
//                "iso_3166-2": "ISO 3166-2:ZW",
//                "region": "Africa",
//                "sub-region": "Eastern Africa",
//                "region-code": "002",
//                "sub-region-code": "014"
//            }
    ])
    .constant('states', [
      {
        "name": "Alabama",
        "abbreviation": "AL"
      },
      {
        "abbreviation": "AB",
        "name": "Alberta"
      },
      {
        "name": "Alaska",
        "abbreviation": "AK"
      },
      {
        "name": "American Samoa",
        "abbreviation": "AS"
      },
      {
        "name": "Arizona",
        "abbreviation": "AZ"
      },
      {
        "name": "Arkansas",
        "abbreviation": "AR"
      },
      {
        "name": "British Columbia",
        "abbreviation": "BC"
      },
      {
        "name": "California",
        "abbreviation": "CA"
      },
      {
        "name": "Colorado",
        "abbreviation": "CO"
      },
      {
        "name": "Connecticut",
        "abbreviation": "CT"
      },
      {
        "name": "Delaware",
        "abbreviation": "DE"
      },
      {
        "name": "District Of Columbia",
        "abbreviation": "DC"
      },
      {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
      },
      {
        "name": "Florida",
        "abbreviation": "FL"
      },
      {
        "name": "Georgia",
        "abbreviation": "GA"
      },
      {
        "name": "Guam",
        "abbreviation": "GU"
      },
      {
        "name": "Hawaii",
        "abbreviation": "HI"
      },
      {
        "name": "Idaho",
        "abbreviation": "ID"
      },
      {
        "name": "Illinois",
        "abbreviation": "IL"
      },
      {
        "name": "Indiana",
        "abbreviation": "IN"
      },
      {
        "name": "Iowa",
        "abbreviation": "IA"
      },
      {
        "name": "Kansas",
        "abbreviation": "KS"
      },
      {
        "name": "Kentucky",
        "abbreviation": "KY"
      },
      {
        "name": "Louisiana",
        "abbreviation": "LA"
      },
      {
        "name": "Maine",
        "abbreviation": "ME"
      },
      {
        "name": "Manitoba",
        "abbreviation": "MB"
      },
      {
        "name": "Marshall Islands",
        "abbreviation": "MH"
      },
      {
        "name": "Maryland",
        "abbreviation": "MD"
      },
      {
        "name": "Massachusetts",
        "abbreviation": "MA"
      },
      {
        "name": "Michigan",
        "abbreviation": "MI"
      },
      {
        "name": "Minnesota",
        "abbreviation": "MN"
      },
      {
        "name": "Mississippi",
        "abbreviation": "MS"
      },
      {
        "name": "Missouri",
        "abbreviation": "MO"
      },
      {
        "name": "Montana",
        "abbreviation": "MT"
      },
      {
        "name": "Nebraska",
        "abbreviation": "NE"
      },
      {
        "name": "Nevada",
        "abbreviation": "NV"
      },
      {
        "name": "New Brunswick",
        "abbreviation": "NB"
      },
      {
        "name": "New Hampshire",
        "abbreviation": "NH"
      },
      {
        "name": "New Jersey",
        "abbreviation": "NJ"
      },
      {
        "name": "New Mexico",
        "abbreviation": "NM"
      },
      {
        "name": "New York",
        "abbreviation": "NY"
      },
      {
        "name": "Newfoundland and Labrador",
        "abbreviation": "NL"
      },
      {
        "name": "North Carolina",
        "abbreviation": "NC"
      },
      {
        "name": "North Dakota",
        "abbreviation": "ND"
      },
      {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
      },
      {
        "name": "Nova Scotia",
        "abbreviation": "NS"
      },
      {
        "name": "Northwest Territories",
        "abbreviation": "NT"
      },
      {
        "name": "Nunavut",
        "abbreviation": "NU"
      },
      {
        "name": "Ohio",
        "abbreviation": "OH"
      },
      {
        "name": "Oklahoma",
        "abbreviation": "OK"
      },
      {
        "name": "Ontario",
        "abbreviation": "ON"
      },
      {
        "name": "Oregon",
        "abbreviation": "OR"
      },
      {
        "name": "Palau",
        "abbreviation": "PW"
      },
      {
        "name": "Pennsylvania",
        "abbreviation": "PA"
      },
      {
        "name": "Prince Edward Island",
        "abbreviation": "PE"
      },
      {
        "name": "Puerto Rico",
        "abbreviation": "PR"
      },
      {
        "name": "Quebec",
        "abbreviation": "QC"
      },
      {
        "name": "Rhode Island",
        "abbreviation": "RI"
      },
      {
        "name": "Saskatchewan",
        "abbreviation": "SK"
      },
      {
        "name": "South Carolina",
        "abbreviation": "SC"
      },
      {
        "name": "South Dakota",
        "abbreviation": "SD"
      },
      {
        "name": "Tennessee",
        "abbreviation": "TN"
      },
      {
        "name": "Texas",
        "abbreviation": "TX"
      },
      {
        "name": "Utah",
        "abbreviation": "UT"
      },
      {
        "name": "Vermont",
        "abbreviation": "VT"
      },
      {
        "name": "Virgin Islands",
        "abbreviation": "VI"
      },
      {
        "name": "Virginia",
        "abbreviation": "VA"
      },
      {
        "name": "Washington",
        "abbreviation": "WA"
      },
      {
        "name": "West Virginia",
        "abbreviation": "WV"
      },
      {
        "name": "Wisconsin",
        "abbreviation": "WI"
      },
      {
        "name": "Wyoming",
        "abbreviation": "WY"
      },
      {
        "name": "Yukon",
        "abbreviation": "YT"
      }
    ]);

})();

(function() {
  'use strict';

  angular
    .module('zoek')
    .config(configuration);

  /** @ngInject */
  function configuration(ezfbProvider, $mdThemingProvider, $logProvider, $locationProvider, $httpProvider,
                         $compileProvider, myConfig, jwtOptionsProvider) {
    // Enable log
    $logProvider.debugEnabled(myConfig.debug);

    $compileProvider.debugInfoEnabled(myConfig.debug);

    ezfbProvider.setInitParams({
      appId: '1614074252214010',
      version: 'v2.5'
    });

    $locationProvider.html5Mode(true);

    jwtOptionsProvider.config({
      tokenGetter: ['store', function(store) {
        var token = store.get('token');
        return token ? token.access_token : null;
      }],
      whiteListedDomains: [
        'zoek.herokuapp.com',
        'zoek-dev.herokuapp.com',
        'localhost',
        'zoek-proposal.herokuapp.com',
        'zoek-proposal-staging.herokuapp.com',
        'api.dev.gozoek.com',
      ],
      unauthenticatedRedirectPath: '/login'
    });

    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('errorInterceptor');

    $mdThemingProvider.definePalette('primaryColor', {
      '50': 'FFFFFF',
      '100': 'E2E1F2',
      '200': 'DBBAE1',
      '300': '8E88CB',
      '400': '7A73C1',
      '500': '665EB8',
      '600': '544CAC',
      '700': '4A4296',
      '800': '3F3981',
      '900': '35306C',
      'A100': 'FFFFFF',
      'A200': 'E2E1F2',
      'A400': '7A73C1',
      'A700': '4A4296',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                          // on this palette should be dark or light
      'contrastDarkColors': [
        '50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'
      ],
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.theme('default')
      .primaryPalette('primaryColor');
  }

})();

angular.module("myApp.myConfig", [])
.constant("myConfig", {"apiBase":"https://zoek.herokuapp.com/api","debug":false,"clientId":"5832b2943d0e2f00051015b3","clientSecret":"q4ffCOYTyOwLGbuqusLqXG0L7BrVjucwyYVBI91L","apiV2Base":"https://api.dev.gozoek.com"});

angular.module("zoek").run(["$templateCache", function($templateCache) {$templateCache.put("app/error.html","");
$templateCache.put("app/activity/activity.html","<div class=\"c-root__body u-padding--right u-padding--bottom\"><div class=\"u-margin--top u-margin--left\"><md-toolbar class=\"md-table-toolbar\"><div class=\"md-toolbar-tools\"><p flex>Activity</p></div></md-toolbar><md-content layout-padding><md-table-container><table md-table md-progress=\"$ctrl.promise\"><thead md-head md-on-reorder=\"$ctrl.onReorder\"><tr md-row><th md-column md-order-by=\"event\"><span>Event</span></th><th md-column md-order-by=\"ip\"><span>IP</span></th><th md-column md-order-by=\"first_name\"><span>Name</span></th><th md-column md-order-by=\"created_at\"><span>Created</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr u-cursor--pointer\" md-row ng-click=\"$ctrl.openLogModal($event, log)\" ng-repeat=\"log in $ctrl.logs.data\"><td md-cell>{{::log.event}}</td><td md-cell>{{::log.ip}}</td><td md-cell>{{::log.auth.name}}</td><td md-cell>{{::log.created | date : \'MMM dd, yyyy h:mm a\'}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.logs.meta.pagination.per_page\" md-page=\"$ctrl.logs.meta.pagination.current_page\" md-total=\"{{::$ctrl.logs.meta.pagination.total}}\" md-on-paginate=\"$ctrl.onPaginate\" md-page-select></md-table-pagination></md-content></div></div>");
$templateCache.put("app/add/add.html","<div class=\"u-padding--right u-padding--bottom\" layout=\"column\" flex><form name=\"addForm\" ng-submit=\"addForm.$valid && $ctrl.handleAdd()\" accessible-form novalidate><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Add</p></div></md-toolbar><md-content layout-padding><div><div><p>Hello is the owner available?</p><br><md-checkbox>Confirm</md-checkbox></div><br><div><p>My name is _______ and we help businesses attract clients online using directories and major search engines.</p><br><md-checkbox>Confirm</md-checkbox></div><br><!-- Address --><div><p class=\"md-body-2\">I see your business is located at</p><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>Street</label><input name=\"address_1\" ng-model=\"$ctrl.lead.address.line1\" type=\"text\" required><div ng-messages=\"addForm.address_1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Apt, Suite, Unit, Building, Floor, etc...</label><input name=\"address_2\" ng-model=\"$ctrl.lead.address.line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>City</label><input name=\"address_city\" ng-model=\"$ctrl.lead.address.city\" type=\"text\" required><div ng-messages=\"addForm.address_city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-state name=\"address_state\" label=\"State\" ng-model=\"$ctrl.lead.address.state\" ng-messages=\"addForm.address_state.$error\" ng-required=\"true\"></select-state></div><md-input-container class=\"md-block\" flex=\"50\"><label>Postal</label><input name=\"address_postal\" ng-model=\"$ctrl.lead.address.postal\" type=\"text\" postal-lookup address=\"$ctrl.lead.address\" required><div ng-messages=\"addForm.address_postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-country name=\"address_country\" label=\"Country\" ng-model=\"$ctrl.lead.address.country\" ng-messages=\"addForm.address_country.$error\" ng-required=\"true\"></select-country></div></div></div><!-- /Address --><br><!-- Business --><div><p>I have your business name listed as</p><br><md-input-container flex=\"100\"><input name=\"business\" type=\"text\" ng-model=\"$ctrl.lead.business\" required><div ng-messages=\"addForm.business.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><!-- /Business --><br><!-- Industry --><div><p>I have your industry as (industry type)</p><br><md-input-container flex=\"100\"><select-industry name=\"industry\" ng-model=\"$ctrl.lead.industry\"></select-industry></md-input-container></div><!-- /Industry --><br><div><p>Could we start with your name?</p><div layout=\"row\"><md-input-container flex=\"50\"><label>First name</label><input name=\"first_name\" type=\"text\" ng-model=\"$ctrl.lead.first_name\" required><div ng-messages=\"addForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex=\"50\"><label>Last name</label><input name=\"first_name\" type=\"text\" ng-model=\"$ctrl.lead.last_name\" required><div ng-messages=\"addForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div><br><div><p>Great, and you are the owner correct?</p><br><md-radio-group><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group></div><br><div><p>I have your phone number listed as</p><br><md-input-container flex=\"100\"><input name=\"phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" ng-model=\"$ctrl.lead.phone\"></md-input-container></div><br><div><p>Do you currently have a website?</p><md-input-container flex=\"100\"><label>Website</label><input name=\"website\" type=\"text\" ng-model=\"$ctrl.lead.website\" http-prefix></md-input-container></div><br><div><p>Are you happy with your website?</p><br><md-radio-group ng-model=\"$ctrl.lead.happy_with_website\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group></div><br><div><p>How long have you been in business?</p><br><md-radio-group ng-model=\"$ctrl.lead.years_in_business\"><md-radio-button value=\"0-1 years\">0-1 years</md-radio-button><md-radio-button value=\"1-5 years\">1-5 years</md-radio-button><md-radio-button value=\"5-10 years\">5-10 years</md-radio-button><md-radio-button value=\"10+ years\">10+ years</md-radio-button></md-radio-group></div><br><div><p>What is your email address?</p><md-input-container flex=\"100\"><label>Email</label><input name=\"email\" type=\"email\" ng-model=\"$ctrl.lead.email\" required><div ng-messages=\"addForm.email.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><br><div><p>Can you handle an increase in business?</p><br><md-radio-group ng-model=\"$ctrl.lead.increase_in_business\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group></div><br><div><p>How much are you currently investing per month on your advertising and marketing?</p><br><md-radio-group ng-model=\"$ctrl.lead.investing_per_month\"><md-radio-button value=\"0-99\">0-99</md-radio-button><md-radio-button value=\"100-500\">100-500</md-radio-button><md-radio-button value=\"500-1000\">500-1000</md-radio-button><md-radio-button value=\"1000-5000\">1000-5000</md-radio-button><md-radio-button value=\"5000+\">5000+</md-radio-button></md-radio-group></div><br><div><p>Would you like your business to get more customers from online?</p><p>(MUST BE YES)</p><br><md-radio-group ng-model=\"$ctrl.lead.more_customers_online\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group></div><br><div><p>OK (customer name), I have a marketing consultant available now to discuss your options. Please hold for a moment while I bring them on the line. This call may be recorded for quality assurance purposes.</p><p>Transfer Question</p><br><md-checkbox>Confirm</md-checkbox></div><br><div><p>Hi (marketing specialist\'s name), I have (prospect\'s name) on the line, they are the owner of (business name) they would like new customers to find them online. Their primary phone number is (phone number). Can you take it from here? Thank you!</p><!--<p>Introduction to Marketing Specialist</p>--></div><br><div><p>Call Center ID</p><md-input-container><input name=\"call_center_id\" type=\"text\" ng-model=\"$ctrl.lead.call_center_id\" required><div ng-messages=\"addForm.call_center_id.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div><div><button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"$ctrl.loading\">Submit</button></div></md-content></div></form></div>");
$templateCache.put("app/agent/agent.html","<div class=\"u-margin--right u-margin--bottom\"><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\"><p>Staff</p><span flex></span><md-button ng-click=\"$ctrl.removeAgent($event)\">Delete</md-button></div></md-toolbar><md-progress-linear ng-show=\"$ctrl.loading\" md-mode=\"indeterminate\"></md-progress-linear><div class=\"md-subheader\" layout-padding><p>ID: {{::$ctrl.agent.staff_no}}</p><p>Create: {{::$ctrl.agent.created | date: \'mediumDate\'}}</p><p>Last Updated: {{$ctrl.agent.updated | date : \'MMM dd, yyyy h:mm a\'}}</p></div><md-content layout-padding><form name=\"employeeForm\" layout=\"column\" ng-submit=\"employeeForm.$valid && $ctrl.update()\"><md-input-container><label>Picture</label><img ng-src=\"{{$ctrl.agent.picture}}\" alt=\"\"> <input name=\"picture\" type=\"url\" ng-model=\"$ctrl.agent.picture\"></md-input-container><div layout=\"row\"><md-input-container flex><label>First Name</label><input name=\"first_name\" type=\"text\" ng-model=\"$ctrl.agent.first_name\" required><div ng-messages=\"employeeForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex><label>Last Name</label><input name=\"last_name\" type=\"text\" ng-model=\"$ctrl.agent.last_name\" required><div ng-messages=\"employeeForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><md-input-container><label>Email</label><input name=\"email\" type=\"email\" ng-model=\"$ctrl.agent.email\" required><div ng-messages=\"employeeForm.email.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"email\">Invalid email</div></div></md-input-container><md-input-container><label>Phone</label><input name=\"phone\" type=\"tel\" ng-model=\"$ctrl.agent.phone\"></md-input-container><select-role name=\"role\" label=\"Role\" ng-model=\"$ctrl.agent.role_id\" ng-messages=\"employeeForm.role.$error\" ng-required=\"true\"></select-role><md-input-container class=\"md-block\"><label>Status</label><md-select name=\"status\" ng-model=\"$ctrl.agent.status\" ng-required=\"$ctrl.ngRequired\"><md-option value=\"active\">Active</md-option><md-option value=\"inactive\">Inactive</md-option></md-select><div ng-messages=\"employeeForm.status.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Team</label><md-select ng-model=\"$ctrl.agent.team\"><md-option ng-repeat=\"team in $ctrl.teams track by $index\" ng-value=\"team\">{{::team}}</md-option></md-select></md-input-container><md-input-container><label>Position</label><input name=\"position\" type=\"tel\" ng-model=\"$ctrl.agent.position\"></md-input-container><div layout=\"row\"><button class=\"md-button md-raised\" ui-sref=\"root.agents\" type=\"button\">Go Back</button> <button class=\"md-button md-raised\" ng-click=\"$ctrl.openChangePasswordModal($event)\" type=\"button\">Change Password</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Update</button></div></form></md-content></div><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Leads Created Per Day</p></div></md-toolbar><md-content layout-padding><leads-created-per-day agent=\"$ctrl.agent\"></leads-created-per-day></md-content></div></div>");
$templateCache.put("app/agents/agents.html","<div class=\"u-margin--right u-margin--bottom\"><div class=\"u-margin--left u-margin--top\" ng-if=\"$ctrl.profile.role.name === \'Admin\'\"><app-crm></app-crm></div><div class=\"u-margin--left u-margin--top\"><staff-list staff=\"$ctrl.agents\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export-login-activity=\"$ctrl.handleExportLoginActivity($event)\"></staff-list></div></div><div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\"><md-button class=\"md-fab md-primary\" aria-label=\"Add Staff\" ng-click=\"$ctrl.openAddNewStaffModal($event)\"><md-tooltip>Add Staff</md-tooltip><md-icon md-svg-src=\"/assets/plus_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/client/client.html","<div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\"><md-button class=\"md-fab md-primary\" aria-label=\"Change Status\" ng-click=\"$ctrl.openChangeStatusModal($event)\"><md-tooltip>Change Status</md-tooltip><md-icon md-svg-src=\"/assets/close_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Edit Subscription\" ng-click=\"$ctrl.openEditSubscriptionModal($event)\"><md-tooltip>Edit Subscription</md-tooltip><md-icon md-svg-src=\"/assets/pencil_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Notes\" ng-click=\"$ctrl.openNotesModal($event)\"><md-tooltip>Notes</md-tooltip><md-icon md-svg-src=\"/assets/notes_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Hot Button\" ng-click=\"$ctrl.openHotButtonsModal($event)\"><md-tooltip>Hot Button</md-tooltip><md-icon md-svg-src=\"/assets/fire_icon.svg\"></md-icon></md-button></div><div layout-margin layout=\"column\" layout-gt-md=\"row\"><div flex=\"65\"><md-content><nav class=\"c-clients-nav\" layout=\"row\"><a class=\"c-clients-nav__item\" ui-sref=\"root.client.overview\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-globe-alt\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Overview</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.account-success\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-trophy\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Account Success</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.content\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-briefcase\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Content</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.business-directories\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-folder-alt\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Business Directories</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.cap\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-notebook\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">C.A.P.</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.social-media\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-people\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Social Media</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.website\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-screen-smartphone\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Mobile App</p></a><a class=\"c-clients-nav__item\" ui-sref=\"root.client.billing\" ui-sref-active=\"c-clients-nav__item--active\" flex><i class=\"icon-wallet\"></i><p class=\"u-hidden@mobile u-hidden@tablet\">Billing</p></a></nav></md-content><md-content layout-padding><div><h4 class=\"md-subheader\">Client ID</h4><p class=\"md-body-1\">{{$ctrl.client.client_no}}</p></div><div ui-view=\"main\"></div></md-content></div><div flex=\"35\"><div ui-view=\"right0\"></div><div ui-view=\"notes\"></div></div></div>");
$templateCache.put("app/client-account-success/client-account-success.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><form name=\"accountForm\" ng-submit=\"accountForm.$valid && $ctrl.update()\"><div layout=\"row\"><span flex></span><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"$ctrl.loading || accountForm.$invalid\">Save</md-button></div><!-- Keywords --><div><h1 class=\"md-title\">Keywords</h1><br><a class=\"md-subheader\" href=\"http://keywordtool.io\" target=\"_blank\">Keyword Tool</a><br><input-keywords number=\"$ctrl.client.getSubscription().number_of_keywords\" ng-model=\"$ctrl.client.getSubscription().keywords\"></input-keywords></div><!-- /Keywords --><!-- Cities --><div><h1 class=\"md-title\">Cities</h1><br><a class=\"md-subheader\" href=\"http://www.searchbug.com/tools/zip-radius.aspx\" target=\"_blank\">Cities Tool</a><br><input-cities number=\"$ctrl.client.getSubscription().number_of_cities\" ng-model=\"$ctrl.client.getSubscription().cities\"></input-cities></div><!-- /Cities --><!-- Places Scout --><div><h1 class=\"md-title\">Ranking Report</h1><br><md-input-container class=\"md-block\"><label>Places Scout ID</label><input name=\"places_scout_id\" type=\"text\" ng-model=\"$ctrl.client.places_scout_id\"></md-input-container><button class=\"md-button md-raised\" type=\"button\" ng-if=\"$ctrl.client.places_scout_id\" ladda=\"$ctrl.loadingRankingReport\" ng-click=\"$ctrl.viewReport()\">View Report</button></div><!-- /Places Scout --></form>");
$templateCache.put("app/client-account-success-notes/client-account-success-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-billing/client-billing.html","<div layout=\"column\" layout-gt-sm=\"row\"><div flex><div layout=\"row\"><md-subheader class=\"md-primary\">Billing Address</md-subheader><md-button ng-click=\"$ctrl.openBillingModal($event)\">Edit</md-button></div><div layout-margin><p class=\"md-body-1\">{{::$ctrl.client.getBilling().line1}} {{::$ctrl.client.getBilling().line2}}</p><p class=\"md-body-1\">{{::$ctrl.client.getBilling().city}}, {{::$ctrl.client.getBilling().state}} {{::$ctrl.client.getBilling().postal}}</p><p class=\"md-body-1\">{{::$ctrl.client.getBilling().country}}</p></div></div><div flex><div layout=\"row\"><md-subheader class=\"md-primary\">Credit Card</md-subheader><md-button ng-click=\"$ctrl.openCreditCardModal($event)\">Edit</md-button></div><div layout-margin><p class=\"md-body-1\">{{::$ctrl.client.getCreditCard().name}}</p><p class=\"md-body-1\">{{::$ctrl.client.getCreditCard().type | capitalize}} ending in {{::$ctrl.client.getCreditCard().last4digits}}</p><p class=\"md-body-1\">{{::$ctrl.client.getCreditCard().exp_month}}/{{::$ctrl.client.getCreditCard().exp_year}}</p></div></div><div flex><div layout=\"row\"><md-subheader class=\"md-primary\">Check</md-subheader><md-button ng-click=\"$ctrl.openCheckModal($event)\">Edit</md-button></div><div layout-margin><p class=\"md-body-1\">Bank: {{$ctrl.check.bank}}</p><p class=\"md-body-1\">Account number: ending in {{::$ctrl.check.accountNumberLast4}}</p><p class=\"md-body-1\">Routing: {{::$ctrl.check.routing}}</p></div></div></div><ul ng-init=\"$ctrl.showOrders = []\"><li ng-repeat=\"order in $ctrl.orders track by $index\"><div><div class=\"billing-accordion\" ng-class=\"{\n           \'billing-accordion--void\': order.is_void === \'yes\',\n           \'billing-accordion--declined\': order.decline_reason !== \'\'\n           }\" ng-click=\"$ctrl.showOrders[$index] = !$ctrl.showOrders[$index]\"><div class=\"md-toolbar-tools\" layout=\"row\"><p><span class=\"md-body-2\">Order ID: </span><span class=\"md-body-1\">{{order.order_id}}</span></p>&nbsp;<p><span class=\"md-body-2\">Date: </span><span class=\"md-body-1\">{{order.recurring_date}}</span></p><span flex></span><p><span class=\"md-body-2\">Total: </span><span class=\"md-body-1\">{{order.order_total | currency}}</span></p></div></div><div layout-padding ng-show=\"$ctrl.showOrders[$index]\"><div><p><span class=\"md-body-2\">Credit Card: </span><span class=\"md-body-1\">{{order.credit_card_number}}</span></p><p><span class=\"md-body-2\">Order Total: </span><span class=\"md-body-1\">{{order.order_total | currency}}</span></p><br><p><span class=\"md-body-2\">Is Chargeback: </span><span class=\"md-body-1\">{{order.is_chargeback | yesNo}}</span></p><p><span class=\"md-body-2\">Is Fraud: </span><span class=\"md-body-1\">{{order.is_fraud | yesNo}}</span></p><br><p><span class=\"md-body-2\">Is Recurring: </span><span class=\"md-body-1\">{{order.is_recurring | yesNo}}</span></p><p><span class=\"md-body-2\">Recurring Date: </span><span class=\"md-body-1\">{{order.recurring_date}}</span></p><br><p><span class=\"md-body-2\">On Hold: </span><span class=\"md-body-1\">{{order.on_hold | yesNo}}</span></p><p><span class=\"md-body-2\">Hold Date: </span><span class=\"md-body-1\">{{order.hold_date}}</span></p><br><p><span class=\"md-body-2\">Is Void: </span><span class=\"md-body-1\">{{order.is_void}}</span></p><p><span class=\"md-body-2\">Void Amount: </span><span class=\"md-body-1\">{{order.void_amount | currency}}</span></p><p><span class=\"md-body-2\">Void Date: </span><span class=\"md-body-1\">{{order.void_date}}</span></p><br><p><span class=\"md-body-2\">Is Refund: </span><span class=\"md-body-1\">{{order.is_refund | yesNo}}</span></p><p><span class=\"md-body-2\">Refund Amount: </span><span class=\"md-body-1\">{{order.refund_amount | currency}}</span></p><p><span class=\"md-body-2\">Refund Date: </span><span class=\"md-body-1\">{{order.refund_date}}</span></p><p><span class=\"md-body-2\">Amount Refunded To Date: </span><span class=\"md-body-1\">{{order.amount_refunded_to_date | currency}}</span></p><br><p><span class=\"md-body-2\">Decline Reason: </span><span class=\"md-body-1\">{{order.decline_reason}}</span></p><br><div><h1 class=\"md-subhead\">System Notes</h1><ul><li ng-repeat=\"systemNote in order.systemNotes\"><p class=\"md-body-1\">{{systemNote}}</p></li></ul></div></div></div></div><md-divider></md-divider></li></ul>");
$templateCache.put("app/client-billing-notes/client-billing-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-business-directories/client-business-directories.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><form name=\"businessForm\" ng-submit=\"businessForm.$valid && $ctrl.updateBusiness()\"><div layout=\"row\"><span flex></span><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"$ctrl.loading || businessForm.$invalid\">Save</md-button></div><md-checkbox ng-model=\"$ctrl.client.has_yext\" ng-false-value=\"false\" ng-true-value=\"true\" ng-disabled=\"$ctrl.client.has_synup\">YEXT</md-checkbox><md-checkbox ng-model=\"$ctrl.client.has_synup\" ng-false-value=\"false\" ng-true-value=\"true\" ng-disabled=\"$ctrl.client.has_yext\">SYNUP</md-checkbox><!-- Post Card --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">Post Card</p></div><div flex=\"70\">Date Selected in Provisioning: <span>{{$ctrl.client.post_card_selected_date | date : \'MMM dd, yyyy h:mm a\'}}</span></div></div><!-- /Post Card --><!-- Management --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">Management</p></div><div flex=\"70\">Date Management Selected in Provisioning: <span>{{$ctrl.client.management_selected_date | date : \'MMM dd, yyyy h:mm a\'}}</span></div></div><!-- /Management --><!-- PowerListings --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">Client Added To PowerListings</p></div><div flex=\"70\"><md-checkbox ng-model=\"$ctrl.client.powerlistings\" ng-false-value=\"false\" ng-true-value=\"true\"></md-checkbox></div></div><!-- /PowerListings --><!-- Google My Business --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">Google My Business</p></div><div flex=\"70\"><md-input-container class=\"md-block\"><label>Domain</label><input name=\"url\" type=\"text\" ng-model=\"$ctrl.client.google_my_business_url\" http-prefix></md-input-container></div></div><!-- /Google My Business --><!-- Google Login --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">Google My Business</p></div><div flex=\"70\"><div class=\"o-info c-clients-row__info\"><md-input-container class=\"md-block\"><label>Email</label><input name=\"email\" type=\"text\" ng-model=\"$ctrl.client.gmail_address\" autocomplete=\"off\"></md-input-container></div><div class=\"o-info c-clients-row__info\"><md-input-container class=\"md-block\"><label>Password</label><input name=\"password\" type=\"text\" ng-model=\"$ctrl.client.gmail_password\" autocomplete=\"off\"></md-input-container></div></div></div><!-- /Google Login --><!-- Yext --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">Yext</p></div><div flex=\"70\"><div class=\"o-info c-clients-row__info\"><md-input-container class=\"md-block\"><label>Yext ID</label><input name=\"yextID\" type=\"text\" ng-model=\"$ctrl.client.yext_id\"></md-input-container></div><div class=\"o-info c-clients-row__info\" ng-repeat=\"location in $ctrl.client.yext_locations\"><p class=\"o-info__title\">Business Name</p><p class=\"o-info__info u-margin--bottom\">{{location.locationName}}</p><p class=\"o-info__title\">Business Phone</p><p class=\"o-info__info u-margin--bottom\">{{location.phone}}</p><p class=\"o-info__title\">Address</p><p class=\"o-info__info u-margin--bottom\">{{location.address + \', \' + location.city + \', \' + location.state + \' \' + location.zip}}</p><p class=\"o-info__title\">Description</p><p class=\"o-info__info u-margin--bottom\">{{location.description}}</p><p class=\"o-info__title\">Hours</p><p class=\"o-info__info u-margin--bottom\">{{location.hours | hours}}</p><p class=\"o-info__title\">Payment Options</p><p class=\"o-info__info u-margin--bottom\">{{location.paymentOptions.join(\', \')}}</p><p class=\"o-info__title\">Website</p><p class=\"o-info__info u-margin--bottom\"><a href=\"{{location.websiteUrl}}\" target=\"_blank\">{{location.websiteUrl}}</a></p><p class=\"o-info__title\">Facebook</p><p class=\"o-info__info u-margin--bottom\"><a href=\"{{location.facebookPageUrl}}\" target=\"_blank\">{{location.facebookPageUrl}}</a></p><p class=\"o-info__title\">Facebook Profile Photo</p><p class=\"o-info__info u-margin--bottom\"><img ng-src=\"{{location.facebookProfilePicture.url}}\" alt=\"\"></p><p class=\"o-info__title\">Facebook Cover Photo</p><p class=\"o-info__info u-margin--bottom\"><img ng-src=\"{{location.facebookCoverPhoto.url}}\" alt=\"\"></p><p class=\"o-info__title\">Business Logo</p><p class=\"o-info__info u-margin--bottom\"><img ng-src=\"{{location.logo.url}}\" alt=\"\"></p></div></div></div><!-- /Yext --><!-- PowerListings Scan Tool --><div class=\"c-clients-row\" layout=\"row\"><div flex=\"30\"><p class=\"c-clients-row__title\">PowerListings</p></div><div flex=\"70\"><div ng-repeat=\"status in $ctrl.client.yext_powerlistings.statuses\"><div layout-padding><div layout-margin><div><h4 class=\"md-subheader\">Status</h4><p class=\"md-body-1\">{{status.status}}</p></div><div><h4 class=\"md-subheader\">Location ID</h4><p class=\"md-body-1\">{{status.locationId}}</p></div><div><h4 class=\"md-subheader\">Site ID</h4><p class=\"md-body-1\">{{status.siteId}}</p></div><div><p class=\"md-body-1\"><a href=\"{{status.screenshotUrl}}\" target=\"_blank\">Screenshot Url</a></p><p class=\"md-body-1\"><a href=\"{{status.url}}\" target=\"_blank\">Url</a></p></div></div></div></div></div></div><!-- /PowerListings Scan Tool --></form>");
$templateCache.put("app/client-business-directories-notes/client-business-directories-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-cap/client-cap.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><form name=\"capForm\" ng-submit=\"capForm.$valid && $ctrl.updateCAP()\"><div layout=\"row\"><span flex></span><md-button class=\"md-raised md-primary\" ladda=\"$ctrl.loading || $ctrl.exporting\" ng-click=\"$ctrl.exportData()\">Export</md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"$ctrl.loading || capForm.$invalid\">Save</md-button></div><div><h1 class=\"md-title\">C.A.P. Domain</h1><br><md-checkbox ng-model=\"$ctrl.client.getCAP().is_live\" ng-false-value=\"false\" ng-true-value=\"true\">Live</md-checkbox><md-checkbox ng-model=\"$ctrl.client.getCAP().client_domain_redirect_to_cap_site\" ng-false-value=\"false\" ng-true-value=\"true\">Client Domain Redirect to CAP Site</md-checkbox><md-checkbox ng-model=\"$ctrl.client.getCAP().cap_site_hosted_on_client_domain\" ng-false-value=\"false\" ng-true-value=\"true\">CAP Site Hosted on Client Domain</md-checkbox><md-checkbox ng-model=\"$ctrl.client.hide_address\" ng-false-value=\"false\" ng-true-value=\"true\">Hide Address</md-checkbox><br><div><md-input-container class=\"md-block\"><label>Domain</label><input name=\"url\" type=\"text\" ng-model=\"$ctrl.client.getCAP().url\" http-prefix></md-input-container><div md-color-picker ng-model=\"$ctrl.client.getCAP().skin_color\" label=\"Skin Color\" md-color-history=\"false\"></div><md-input-container class=\"md-block\"><label>Business</label><input name=\"business\" type=\"text\" ng-model=\"$ctrl.client.business\"></md-input-container><md-input-container class=\"md-block\"><label>Phone</label><input name=\"phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" ng-model=\"$ctrl.client.phone\"></md-input-container><div layout=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>Address Line 1</label><input name=\"address_1\" ng-model=\"$ctrl.client.address.line1\" type=\"text\" required><div ng-messages=\"capForm.address_1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Line 2</label><input name=\"address_2\" ng-model=\"$ctrl.client.address.line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>City</label><input name=\"address_city\" ng-model=\"$ctrl.client.address.city\" type=\"text\" required><div ng-messages=\"capForm.address_city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-state name=\"address_state\" label=\"State\" ng-model=\"$ctrl.client.address.state\" ng-messages=\"capForm.address_state.$error\" ng-required=\"true\"></select-state></div><md-input-container class=\"md-block\" flex=\"50\"><label>Postal</label><input name=\"address_postal\" ng-model=\"$ctrl.client.address.postal\" type=\"text\" required><div ng-messages=\"capForm.address_postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-country name=\"address_country\" label=\"Country\" ng-model=\"$ctrl.client.address.country\" ng-messages=\"openerContactsForm.address_country.$error\" ng-required=\"true\"></select-country></div></div><md-input-container class=\"md-block\"><label>Homepage Title</label><input name=\"homepage_title\" type=\"text\" ng-model=\"$ctrl.client.getCAP().homepage_title\"></md-input-container><md-input-container class=\"md-block\"><label>Homepage Content</label><textarea name=\"homepage_content\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.client.getCAP().homepage_content\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>About Us Title</label><input name=\"about_title\" type=\"text\" ng-model=\"$ctrl.client.getCAP().about_us_title\"></md-input-container><md-input-container class=\"md-block\"><label>About Us Content</label><textarea name=\"about_us_content\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.client.getCAP().about_us_content\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>Services Title</label><input name=\"services_title\" type=\"text\" ng-model=\"$ctrl.client.getCAP().services_title\"></md-input-container><md-input-container class=\"md-block\"><label>Services Tagline</label><textarea name=\"services_tagline\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.client.getCAP().services_tagline\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>Contact Title</label><input name=\"contact_title\" type=\"text\" ng-model=\"$ctrl.client.getCAP().contact_title\"></md-input-container><md-input-container class=\"md-block\"><label>Mini Contact</label><textarea name=\"mini_contact\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.client.getCAP().mini_contact\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>Facebook Link</label><input name=\"facebook_link\" type=\"text\" ng-model=\"$ctrl.client.getCAP().facebook_link\"></md-input-container><md-input-container class=\"md-block\"><label>Twitter Link</label><input name=\"twitter_link\" type=\"text\" ng-model=\"$ctrl.client.getCAP().twitter_link\"></md-input-container><md-input-container class=\"md-block\"><label>Google Plus Link</label><input name=\"google_plus_link\" type=\"text\" ng-model=\"$ctrl.client.getCAP().google_plus_link\"></md-input-container><md-input-container class=\"md-block\" ng-repeat=\"article in [] | range: $ctrl.number_of_articles track by $index\"><label>Article {{$index+1}}</label><textarea name=\"article{{$index+1}}\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.client.getCAP().articles[$index]\"></textarea></md-input-container></div></div></form>");
$templateCache.put("app/client-cap-notes/client-cap-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-content/client-content.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><form name=\"contentsForm\" ng-submit=\"contentsForm.$valid && $ctrl.updateContent()\"><div layout=\"row\"><span flex></span><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"$ctrl.loading || contentsForm.$invalid\">Save</md-button></div><!-- Description Details --><div layout=\"column\" layout-gt-xs=\"row\" layout-margin layout-wrap><md-input-container class=\"md-block\" flex=\"100\"><label>How Many Locations?</label><md-select name=\"address_type\" ng-model=\"$ctrl.client.number_of_locations\"><md-option>1</md-option><md-option>2</md-option><md-option>3</md-option><md-option>4+</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Desired URL</label><input name=\"desired_url\" ng-model=\"$ctrl.client.desired_url\" type=\"text\" http-prefix> <a href=\"https://www.godaddy.com/\" target=\"_blank\"><md-button class=\"md-primary md-button\">Check Availability</md-button></a></md-input-container><div flex=\"100\"><payment-methods name=\"payment_methods\" label=\"Payments Accepted\" ng-model=\"$ctrl.client.payments_accepted\"></payment-methods></div><md-input-container class=\"md-block\" flex=\"100\"><label>License No.</label><input name=\"license_no\" ng-model=\"$ctrl.client.license_no\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Awards and Accolades</label><input name=\"awards_and_accolades\" ng-model=\"$ctrl.client.awards_and_accolades\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Certifications</label><input name=\"certifications\" ng-model=\"$ctrl.client.certifications\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Year Established</label><input name=\"years_in_business\" ng-model=\"$ctrl.client.years_in_business\" type=\"text\" ui-mask=\"9999\" ui-mask-placeholder-char=\"space\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Number of Employees</label><input name=\"number_of_employees\" ng-model=\"$ctrl.client.number_of_employees\" type=\"text\"></md-input-container><div flex=\"100\"><languages-spoken name=\"languages_spoken\" label=\"Languages Spoken\" ng-model=\"$ctrl.client.languages_spoken\"></languages-spoken></div><div flex=\"100\"><parking-available name=\"parking_available\" label=\"Parking Available\" ng-model=\"$ctrl.client.parking_available\"></parking-available></div><div class=\"md-block\" flex=\"100\"><label>Run Special Promotions (e.g. Happy Hour, Half Off, $10 Off First Service, Referalls, etc)</label><div layout-margin><md-radio-group layout=\"row\" class=\"u-margin--top\" ng-model=\"$ctrl.client.run_special_promotions\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group><br><md-input-container class=\"md-block\" flex ng-show=\"$ctrl.client.run_special_promotions\"><label>Special Promotions (required)</label><input name=\"special_promotion\" ng-model=\"$ctrl.client.special_promotion\" type=\"text\" ng-required=\"$ctrl.client.run_special_promotions\" md-maxlength=\"40\"><div ng-messages=\"openerSubscriptionDetailForm.special_promotion.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div></div><!-- /Description Details --></form>");
$templateCache.put("app/client-content-notes/client-content-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-overview/client-overview.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><form name=\"overviewForm\" ng-submit=\"overviewForm.$valid && $ctrl.update()\" accessible-form novalidate><div layout=\"row\"><span flex></span><md-button class=\"md-raised\" ng-click=\"$ctrl.openChangePasswordModal()\">Change Password</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.refund($event)\" ng-disabled=\"$ctrl.loading\">Refund</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.cancel($event)\" ng-disabled=\"$ctrl.loading || $ctrl.client.status === \'cancelled\'\">Cancel</md-button><md-button class=\"md-raised md-primary\" type=\"submit\">Save</md-button></div><div layout=\"column\" layout-gt-sm=\"row\" layout-margin layout-wrap><div><h4 class=\"md-subheader\">Last Modified</h4><p class=\"md-body-1\">{{$ctrl.last_modified}}</p></div><div><h4 class=\"md-subheader\">Cancel Date</h4><p class=\"md-body-1\">{{$ctrl.client.cancelled_at | date : \'MMM dd, yyyy h:mm a\'}}</p></div><div><edit-staff-rep title=\"Sales Representative\" reps=\"$ctrl.salesReps.data\" rep=\"$ctrl.client.closer\" on-change=\"$ctrl.changeSalesRep($event)\" editing=\"$ctrl.editingSalesRep\"></edit-staff-rep></div><div><edit-staff-rep title=\"Provisioner\" reps=\"$ctrl.provisioners.data\" rep=\"$ctrl.client.pinner\" on-change=\"$ctrl.changeProvisioner($event)\" editing=\"$ctrl.editingProvisioner\"></edit-staff-rep></div><div><h4 class=\"md-subheader\">Account Status</h4><p class=\"md-body-1\"><span class=\"status--{{$ctrl.client.status}}\">{{$ctrl.client.status | capitalize}}</span></p><p class=\"md-body-1\" ng-show=\"$ctrl.client.status === \'cancelled\' || $ctrl.client.status === \'failed_compliance\'\">Reason: {{$ctrl.client.reason}}</p></div><div><h4 class=\"md-subheader\">Compliance Date</h4><p class=\"md-body-1\">{{$ctrl.client.status_updated_at | date : \'MMM dd, yyyy h:mm a\'}}</p></div><div><h4 class=\"md-subheader\">Shelf Life</h4><p class=\"md-body-1\">{{$ctrl.shelfLife}} days</p></div><div><h4 class=\"md-subheader\">Converted At</h4><p class=\"md-body-1\">{{$ctrl.client.converted_at | date: \'MMM dd, yyyy h:mm a\'}}</p></div><div><h4 class=\"md-subheader\">Contract Time Remaining</h4><p class=\"md-body-1\">{{$ctrl.client.getSubscription().end_date | date: \'MMM dd, yyyy h:mm a\'}}</p><p class=\"md-body-1\">{{$ctrl.client.getSubscription().end_date | amDifference : null : \'days\'}} days</p></div><div><h4 class=\"md-subheader\">Phone</h4><p class=\"md-body-1\">{{$ctrl.client.phone}}</p></div></div><div><md-checkbox ng-model=\"$ctrl.client.contract_returned\" ng-false-value=\"false\" ng-true-value=\"true\">Contract Returned</md-checkbox><md-checkbox ng-model=\"$ctrl.client.ane_opt_in\" ng-false-value=\"false\" ng-true-value=\"true\">ANE Opt-In</md-checkbox></div><br><!-- Name --><div><h1 class=\"md-title\">Name</h1><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>First Name</label><input name=\"first_name\" ng-model=\"$ctrl.client.first_name\" type=\"text\" required><div ng-messages=\"overviewForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.client.last_name\" type=\"text\" required><div ng-messages=\"overviewForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div><!-- /Name --><!-- Business --><div><h1 class=\"md-title\">Business</h1><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>Business</label><input name=\"business\" ng-model=\"$ctrl.client.business\" type=\"text\" required><div ng-messages=\"overviewForm.business.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-industry name=\"industry\" label=\"Industry\" ng-model=\"$ctrl.client.industry\" ng-messages=\"overviewForm.industry.$error\" ng-required=\"true\"></select-industry></div><md-input-container class=\"md-block\" flex=\"50\"><label>Business Phone</label><input name=\"business_phone\" ng-model=\"$ctrl.client.business_phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Business Email</label><input name=\"business_email\" ng-model=\"$ctrl.client.business_email\" type=\"email\" autocomplete=\"off\"><div ng-messages=\"overviewForm.business_email.$error\"><div ng-message=\"email\">Invalid Email</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Sub-Industry</label><input name=\"subindustry\" ng-model=\"$ctrl.client.subindustry\" type=\"text\" required><div ng-messages=\"overviewForm.subindustry.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Website</label><input name=\"website\" ng-model=\"$ctrl.client.website\" type=\"text\" http-prefix></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Gallery</label><input name=\"website\" ng-model=\"$ctrl.client.gallery_url\" type=\"text\" http-prefix></md-input-container><div flex=\"50\"><select-lead-type name=\"lead_type\" label=\"Lead Type\" ng-model=\"$ctrl.client.lead_type\"></select-lead-type></div><div flex=\"50\"><select-business-type name=\"business_type\" label=\"Business Type\" ng-model=\"$ctrl.client.business_type\"></select-business-type></div><business-hours hours=\"$ctrl.businessHours\"></business-hours></div></div><!-- /Business --><!-- Phone --><div><h1 class=\"md-title\">Phone</h1><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><div flex=\"50\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label>Phone</label><input name=\"phone\" ng-model=\"$ctrl.client.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" required><div ng-messages=\"overviewForm.phone.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.client.phone_is_mobile\" ng-true-value=\"true\" ng-false-value=\"false\">Is Mobile</md-checkbox></md-input-container></div><div flex=\"50\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label>Alt. Phone</label><input name=\"alt_phone\" ng-model=\"$ctrl.client.alt_phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"><div ng-messages=\"overviewForm.alt_phone.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.client.alt_phone_is_mobile\" ng-true-value=\"true\" ng-false-value=\"false\">Is Mobile</md-checkbox></md-input-container></div><md-input-container class=\"md-block\" flex=\"50\"><label>Business Phone</label><input name=\"business_phone\" ng-model=\"$ctrl.client.business_phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Fax</label><input name=\"alt_phone\" ng-model=\"$ctrl.client.fax\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container></div></div><!-- /Phone --><!-- Email --><div><h1 class=\"md-title\">Email</h1><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>Email</label><input name=\"email\" ng-model=\"$ctrl.client.email\" type=\"email\" required><div ng-messages=\"overviewForm.email.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Alt. Email</label><input name=\"alt_email\" ng-model=\"$ctrl.client.alt_email\" type=\"email\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Password</label><input ng-model=\"$ctrl.client.password_plain\" type=\"text\" disabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.client.do_not_send_emails\" ng-true-value=\"true\" ng-false-value=\"false\">Don\'t trigger emails</md-checkbox></md-input-container></div></div><!-- /Email --><!-- Client Acquisition Page Domain  --><div><h1 class=\"md-title\">C.A.P. Domain</h1><br><div><md-input-container class=\"md-block\"><label>Domain</label><input name=\"cap_url\" ng-model=\"$ctrl.client.cap.url\" type=\"text\" http-prefix></md-input-container></div></div><!-- /Client Acquisition Page Domain --><!-- Address --><div><h1 class=\"md-title\">Address</h1><md-input-container class=\"md-block\"><md-checkbox ng-model=\"$ctrl.client.hide_address\" ng-false-value=\"false\" ng-true-value=\"true\">Hide Address</md-checkbox></md-input-container><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>Address Line 1</label><input name=\"address_1\" ng-model=\"$ctrl.client.address.line1\" type=\"text\" required><div ng-messages=\"overviewForm.address_1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Line 2</label><input name=\"address_2\" ng-model=\"$ctrl.client.address.line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>City</label><input name=\"address_city\" ng-model=\"$ctrl.client.address.city\" type=\"text\" required><div ng-messages=\"overviewForm.address_city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-state name=\"address_state\" label=\"State\" ng-model=\"$ctrl.client.address.state\" ng-messages=\"overviewForm.address_state.$error\" ng-required=\"true\"></select-state></div><md-input-container class=\"md-block\" flex=\"50\"><label>Postal</label><input name=\"address_postal\" ng-model=\"$ctrl.client.address.postal\" type=\"text\" postal-lookup address=\"$ctrl.client.address\" required><div ng-messages=\"overviewForm.address_postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-country name=\"address_country\" label=\"Country\" ng-model=\"$ctrl.client.address.country\" ng-messages=\"openerContactsForm.address_country.$error\" ng-required=\"true\"></select-country></div></div></div><!-- /Address --><br><br><!-- Call Tracking --><div><h1 class=\"md-title\">Call Tracking</h1><br><div layout=\"row\"><md-checkbox ng-model=\"$ctrl.client.call_tracking\" ng-false-value=\"false\" ng-true-value=\"true\"></md-checkbox><md-input-container class=\"md-block\"><label>Call Tracking Number</label><input name=\"first_name\" ng-model=\"$ctrl.client.call_tracking_number\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container></div></div><!-- /Call Tracking --><!-- Keywords --><div><h1 class=\"md-title\">Keywords</h1><br><a class=\"md-subheader\" href=\"http://keywordtool.io\" target=\"_blank\">Keyword Tool</a><br><input-keywords number=\"$ctrl.client.getSubscription().number_of_keywords\" ng-model=\"$ctrl.client.getSubscription().keywords\"></input-keywords></div><!-- /Keywords --><!-- Cities --><div><h1 class=\"md-title\">Cities</h1><br><a class=\"md-subheader\" href=\"http://www.searchbug.com/tools/zip-radius.aspx\" target=\"_blank\">Cities Tool</a><br><input-cities number=\"$ctrl.client.getSubscription().number_of_cities\" ng-model=\"$ctrl.client.getSubscription().cities\"></input-cities></div><!-- /Cities --><!-- Overview Config --><div><h1 class=\"md-title\">Overview Config</h1><br><div><md-checkbox ng-model=\"$ctrl.overviewConfig.show_keywords\" ng-false-value=\"false\" ng-true-value=\"true\">Show Keywords</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_cities\" ng-false-value=\"false\" ng-true-value=\"true\">Show Cities</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_content\" ng-false-value=\"false\" ng-true-value=\"true\">Show Content</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_ranking_report\" ng-false-value=\"false\" ng-true-value=\"true\">Show Ranking Report</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_images\" ng-false-value=\"false\" ng-true-value=\"true\">Show Images</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_social_media\" ng-false-value=\"false\" ng-true-value=\"true\">Show Social Media</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_listing_sync\" ng-false-value=\"false\" ng-true-value=\"true\">Show Listing Sync</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_client_acquisition\" ng-false-value=\"false\" ng-true-value=\"true\">Show Client Acquisition</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_call_tracking\" ng-false-value=\"false\" ng-true-value=\"true\">Show Call Tracking</md-checkbox><md-checkbox ng-model=\"$ctrl.overviewConfig.show_google_my_business\" ng-false-value=\"false\" ng-true-value=\"true\">Show Google My Business</md-checkbox></div></div><!-- /Overview Config --></form>");
$templateCache.put("app/client-overview-notes/client-overview-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-overview-subscription/client-overview-subscription.html","<md-content style=\"margin-bottom: 20px\" layout-padding><div><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.edit($event)\" ng-show=\"!$ctrl.state.editing\">Edit</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.update($event)\" ng-show=\"$ctrl.state.editing\">Update</md-button><md-button class=\"md-raised\" ng-click=\"$ctrl.cancel($event)\" ng-show=\"$ctrl.state.editing\">Cancel</md-button></div><form name=\"editSubscriptionForm\" accessible-form novalidate><h1 class=\"md-title\">Subscription</h1><div><p class=\"md-subheader\">Package Type</p><p class=\"md-body-2\">{{$ctrl.client.getSubscription().package.name}} {{$ctrl.client.getSubscription().getPlan().name}}</p></div><div><p class=\"md-subheader\">Setup Cost</p><p class=\"md-body-2\">{{$ctrl.client.getSubscription().setup_fee | currency}}</p></div><div><p class=\"md-subheader\">Monthly Cost</p><p class=\"md-body-2\" ng-show=\"$ctrl.hasCustomPrice()\"><span style=\"text-decoration: line-through\">{{$ctrl.client.getSubscription().monthly_fee | currency}}</span> {{$ctrl.subscription.custom_price | currency}}</p><p class=\"md-body-2\" ng-show=\"!$ctrl.hasCustomPrice()\">{{$ctrl.client.getSubscription().monthly_fee | currency}}</p><md-input-container ng-show=\"$ctrl.state.editing\"><label>Monthly Price</label><input name=\"custom_price\" ng-model=\"$ctrl.subscription.custom_price\" type=\"number\"></md-input-container></div><div><p class=\"md-subheader\">Payment Term</p><p class=\"md-body-2\">{{$ctrl.client.getPlan().payment_term}} Months</p></div><br><h1 class=\"md-title\">Add Ons</h1><ul><li ng-repeat=\"addOn in $ctrl.client.getSubscription().add_ons.data\"><span class=\"md-body-2\">{{::addOn.name}}</span></li></ul></form></md-content>");
$templateCache.put("app/client-social-media/client-social-media.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><form name=\"socialMediaForm\" ng-submit=\"socialMediaForm.$valid && $ctrl.updateSocialMedia()\"><div layout=\"row\"><span flex></span><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"$ctrl.loading || socialMediaForm.$invalid\">Save</md-button></div><!-- Facebook --><div><h1 class=\"md-title\">Facebook</h1><br><div><div class=\"o-info c-clients-row__info\"><md-input-container class=\"md-block\"><label>Facebook Page</label><input name=\"facebook_page\" ng-model=\"$ctrl.client.facebook_page\" type=\"text\"></md-input-container></div><div class=\"fb-page\" ng-if=\"$ctrl.client.facebook_page\" data-href=\"https://www.facebook.com/{{::$ctrl.client.facebook_page}}/\" data-tabs=\"timeline\" data-width=\"900px\" data-small-header=\"false\" data-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"true\"><div class=\"fb-xfbml-parse-ignore\"><blockquote cite=\"https://www.facebook.com/{{::$ctrl.client.facebook_page}}/\"><a href=\"https://www.facebook.com/{{::$ctrl.client.facebook_page}}/\">{{::$ctrl.client.facebook_page}}</a></blockquote></div></div></div></div><!-- /Facebook --><br><br><!-- Twitter --><div><h1 class=\"md-title\">Twitter</h1><br><div><div class=\"o-info c-clients-row__info\"><md-input-container class=\"md-block\"><label>Twitter Username</label><input name=\"facebook_page\" ng-model=\"$ctrl.client.twitter_username\" type=\"text\"></md-input-container></div><twitter-timeline ng-if=\"$ctrl.client.twitter_username\"><a class=\"twitter-timeline\" href=\"https://twitter.com/{{::$ctrl.client.twitter_username}}\" data-screen-name=\"{{::$ctrl.client.twitter_username}}\" data-widget-id=\"700089897353261056\">Tweets by @{{::$ctrl.client.twitter_username}}</a><twitter-timeline></twitter-timeline></twitter-timeline></div></div><!-- /Twitter --></form>");
$templateCache.put("app/client-social-media-notes/client-social-media-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/client-website/client-website.html","<p class=\"md-body-1\">Are you missing a website for your business? Perhaps you have a website and you\'re not satisfied with it. Zoek proudly offers Exclusive Websites - designed by you and built for you. You\'ll work with a website designer to let them know everything you\'re looking for and we\'ll build a website that\'s perfect for your business. Interested?</p><br><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.createWebsiteTicket()\" ladda=\"$ctrl.loading\">Request a Discovery Call today</md-button>");
$templateCache.put("app/client-website-notes/client-website-notes.html","<md-content layout-padding><notes-list notes=\"$ctrl.notes\" on-add-note=\"$ctrl.addNote($event)\"></notes-list></md-content>");
$templateCache.put("app/clients/clients.html","<div layout-margin layout=\"column\" layout-gt-md=\"row\"><clients-list clients=\"$ctrl.clients\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></clients-list></div>");
$templateCache.put("app/error/error.html","<md-content layout=\"column\" layout-align=\"center center\" style=\"min-height: 100%\"><h1><i class=\"fa fa-5x fa-exclamation-triangle\" aria-hidden=\"true\"></i></h1><h2>There was a problem!</h2></md-content>");
$templateCache.put("app/forgot-password/forgot-password.html","<form name=\"forgotPasswordForm\" ng-submit=\"forgotPasswordForm.$valid && $ctrl.requestReset()\" accessible-form novalidate><h1 class=\"md-title\">Forgot Password</h1><md-input-container class=\"md-block\"><label>Email</label><input name=\"email\" ng-model=\"$ctrl.email\" type=\"email\" required><div ng-messages=\"forgotPasswordForm.email.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div layout=\"column\"><button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Send Email</button> <a class=\"md-body-1\" ui-sref=\"root-login.login\" style=\"text-align: center; margin-top: 8px\">Back</a></div></form>");
$templateCache.put("app/leads/leads.html","<div class=\"u-padding--right u-padding--bottom\" layout=\"column\" flex ui-view></div>");
$templateCache.put("app/leads-list/leads-list.html","<div class=\"u-margin--top u-margin--left\"><leads-list leads=\"$ctrl.leads\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></leads-list></div>");
$templateCache.put("app/leads-show/leads-show.html","<form class=\"u-margin--top u-margin--left\" name=\"editLeadForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\"><div flex><p>{{$ctrl.lead.name}}</p></div><md-button ng-click=\"$ctrl.save()\" ladda=\"$ctrl.loading\">Save</md-button><md-button ng-click=\"$ctrl.saveAndConvert()\" ladda=\"$ctrl.loading\">Save & Convert</md-button><md-button ng-click=\"$ctrl.convertPrepay()\" ladda=\"$ctrl.loading\">Convert Prepay</md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content><div layout=\"column\" layout-gt-sm=\"row\" layout-margin layout-wrap><div><!--<i class=\"fa fa-2x fa-lock\" aria-hidden=\"true\"></i>--> <i class=\"fa fa-2x fa-unlock\" aria-hidden=\"true\"></i></div><div><h4 class=\"md-subheader\">Lead ID</h4><p class=\"md-body-1\">{{::$ctrl.lead.lead_no}}</p></div><div><h4 class=\"md-subheader\">Disposition</h4><p class=\"md-body-1\">{{$ctrl.lead.disposition}}</p></div><div><edit-staff-rep title=\"Sales Representative\" reps=\"$ctrl.salesReps.data\" rep=\"$ctrl.lead.closer\" on-change=\"$ctrl.changeSalesRep($event)\" editing=\"$ctrl.editingSalesRep\"></edit-staff-rep></div><div><h4 class=\"md-subheader\">Created</h4><p class=\"md-body-1\">{{$ctrl.lead.created | date : \'MMM dd, yyyy h:mm a\'}}</p></div><div><h4 class=\"md-subheader\">Last Modified Time</h4><p class=\"md-body-1\">{{$ctrl.lead.updated | date : \'MMM dd, yyyy h:mm a\'}}</p></div></div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Contact\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><div flex=\"50\"><md-input-container class=\"md-block\"><label>First name</label><input ng-model=\"$ctrl.lead.first_name\" name=\"first_name\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Last Name</label><input ng-model=\"$ctrl.lead.last_name\" name=\"last_name\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Email</label><input ng-model=\"$ctrl.lead.email\" name=\"email\" type=\"email\"><div ng-messages=\"editLeadForm.email.$error\"><div ng-message=\"email\">Invalid email</div></div></md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block\"><label>Alt Email</label><input ng-model=\"$ctrl.lead.alt_email\" name=\"alt_email\" type=\"email\"><div ng-messages=\"editLeadForm.alt_email.$error\"><div ng-message=\"email\">Invalid email</div></div></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.lead.do_not_send_emails\" ng-true-value=\"true\" ng-false-value=\"false\">Don\'t trigger emails</md-checkbox></md-input-container></div><div flex=\"50\" layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>Phone</label><input ng-model=\"$ctrl.lead.phone\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"phone\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.lead.phone_is_mobile\" ng-true-value=\"true\" ng-false-value=\"false\">Is Mobile</md-checkbox></md-input-container></div></div><div flex=\"50\" layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>Alt Phone</label><input ng-model=\"$ctrl.lead.alt_phone\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"alt_phone\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.lead.alt_phone_is_mobile\" ng-true-value=\"true\" ng-false-value=\"false\">Is Mobile</md-checkbox></md-input-container></div></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Fax</label><input ng-model=\"$ctrl.lead.fax\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"fax\"></md-input-container></div><div flex=\"50\"><select-lead-type name=\"lead_type\" label=\"Lead Type\" ng-model=\"$ctrl.lead.lead_type\" ng-messages=\"editLeadForm.lead_type.$error\"></select-lead-type></div></div></md-content></md-tab><md-tab label=\"Business\"><md-content layout-padding><h1 class=\"md-subheader md-primary\">Business</h1><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><div flex=\"33\"><md-input-container class=\"md-block\"><label>Business</label><input ng-model=\"$ctrl.lead.business\" name=\"business\" type=\"text\"></md-input-container></div><div flex=\"33\"><md-input-container class=\"md-block\"><label>Business Email</label><input ng-model=\"$ctrl.lead.business_email\" type=\"email\" name=\"business_email\"><div ng-messages=\"editLeadForm.business_email.$error\"><div ng-message=\"email\">Invalid email</div></div></md-input-container></div><div flex=\"33\"><md-input-container class=\"md-block\"><label>Business Phone</label><input ng-model=\"$ctrl.lead.business_phone\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"business_phone\"></md-input-container></div><div flex=\"25\"><select-industry name=\"industry\" label=\"Industry\" ng-model=\"$ctrl.lead.industry\" ng-messages=\"editLeadForm.industry.$error\"></select-industry></div><div flex=\"25\"><md-input-container class=\"md-block\"><label>Sub-Industry</label><input name=\"subindustry\" ng-model=\"$ctrl.lead.subindustry\" type=\"text\"></md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block\"><label>Website</label><input ng-model=\"$ctrl.lead.website\" name=\"website\" http-prefix type=\"url\"></md-input-container></div><div flex=\"25\"><select-business-type name=\"business_type\" label=\"Business Type\" ng-model=\"$ctrl.lead.business_type\"></select-business-type></div></div></md-content><md-content layout-padding><h1 class=\"md-subheader md-primary\">Address</h1><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><div flex=\"50\"><md-input-container class=\"md-block\"><label>Address 1</label><input ng-model=\"$ctrl.lead.address.line1\" name=\"address1\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Address 2</label><input ng-model=\"$ctrl.lead.address.line2\" name=\"address2\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>City</label><input ng-model=\"$ctrl.lead.address.city\" name=\"city\" type=\"text\"></md-input-container></div><div flex=\"50\"><select-state name=\"state\" label=\"State\" ng-model=\"$ctrl.lead.address.state\" ng-messages=\"editLeadForm.state.$error\"></select-state></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Postal Code</label><input ng-model=\"$ctrl.lead.address.postal\" name=\"postal\" type=\"text\"></md-input-container></div><div flex=\"50\"><select-country name=\"country\" label=\"Country\" ng-model=\"$ctrl.lead.address.country\" ng-messages=\"editLeadForm.country.$error\"></select-country></div></div></md-content></md-tab><md-tab label=\"Subscription\"><md-content class=\"md-padding\"><zoek-packages selected-package-id=\"$ctrl.lead.getSubscription().getPackage().id\" on-click=\"$ctrl.handleOnClickPackage($event)\"></zoek-packages></md-content></md-tab><md-tab label=\"Package Details\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><div flex=\"50\"><md-input-container class=\"md-block\"><label>1. Primary Account Holder First Name</label><input name=\"first_name\" ng-model=\"$ctrl.lead.first_name\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>2. Primary Account Holder Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.lead.last_name\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>3. Business Name</label><input name=\"business\" ng-model=\"$ctrl.lead.business\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>4. Authorized Users on the Account</label><input name=\"authorized_users\" ng-model=\"$ctrl.lead.authorized_users\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>5. Email for receipts and account information from Zoek</label><input name=\"email\" ng-model=\"$ctrl.lead.email\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>6. Email for \"Contact Us\" Section on C.A.P. Site</label><input name=\"email_for_contact\" ng-model=\"$ctrl.lead.email_for_contact\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>7. Listing address line 1</label><input name=\"address1\" ng-model=\"$ctrl.lead.address.line1\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>8. Listing address line 2</label><input name=\"address2\" ng-model=\"$ctrl.lead.address.line2\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>9. Listing city</label><input name=\"city\" ng-model=\"$ctrl.lead.address.city\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>10. Listing state</label><md-select name=\"state\" ng-model=\"$ctrl.lead.address.state\"><md-option ng-repeat=\"state in $ctrl.states track by $index\" ng-value=\"state.abbreviation\">{{::state.name}}</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>11. Listing postal</label><input name=\"postal\" ng-model=\"$ctrl.lead.address.postal\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>12. Listing country</label><md-select name=\"country\" ng-model=\"$ctrl.lead.address.country\"><md-option ng-repeat=\"country in lead.countries track by $index\" ng-value=\"::country[\'alpha-2\']\">{{::country.name}}</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>13. Address Type</label><md-select name=\"address_type\" ng-model=\"$ctrl.lead.address.type\"><md-option>Residential</md-option><md-option>Storefront</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>14. How Many Locations?</label><md-select name=\"number_of_locations\" ng-model=\"$ctrl.lead.number_of_locations\"><md-option>1</md-option><md-option>2</md-option><md-option>3</md-option><md-option>4+</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>15. Phone number for Zoek to contact you</label><input name=\"phone\" ng-model=\"$ctrl.lead.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>16. Fax Number</label><input name=\"fax\" ng-model=\"$ctrl.lead.fax\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>17. Desired URL</label><input name=\"desired_url\" ng-model=\"$ctrl.lead.desired_url\" type=\"text\" http-prefix> <a href=\"https://www.godaddy.com/\" target=\"_blank\"><md-button class=\"md-primary md-button\">Check Availability</md-button></a></md-input-container></div><div flex=\"50\"><div class=\"md-block\"><payment-methods label=\"18. Payments Accepted\" name=\"payment_methods\" ng-model=\"$ctrl.lead.payments_accepted\"></payment-methods></div></div><div flex=\"100\"><business-hours hours=\"$ctrl.lead.business_hours\"></business-hours></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>20. License No.</label><input name=\"license_no\" ng-model=\"$ctrl.lead.license_no\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>21. Awards and Accolades</label><input name=\"awards_and_accolades\" ng-model=\"lead.lead.awards_and_accolades\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>22. Certifications</label><input name=\"certifications\" ng-model=\"$ctrl.lead.certifications\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>23. Year Established</label><input name=\"years_in_business\" ng-model=\"$ctrl.lead.years_in_business\" type=\"text\" ui-mask=\"9999\" ui-mask-placeholder-char=\"space\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>24. Number of Employees</label><input name=\"number_of_employees\" ng-model=\"$ctrl.lead.number_of_employees\" type=\"text\"></md-input-container></div><div flex=\"50\"><languages-spoken label=\"25. Languages Spoken\" name=\"languages_spoken\" ng-model=\"$ctrl.lead.languages_spoken\"></languages-spoken></div><div flex=\"50\"><parking-available label=\"26. Parking Available\" name=\"parking_available\" ng-model=\"$ctrl.lead.parking_available\"></parking-available></div><div flex=\"50\"><div class=\"md-block\"><label>27. Run Special Promotions (e.g. Happy Hour, Half Off, $10 Off First Service, Referalls, etc)</label><div layout-margin><md-radio-group layout=\"row\" class=\"u-margin--top\" ng-model=\"$ctrl.lead.run_special_promotions\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group><br><md-input-container class=\"md-block\" flex ng-show=\"$ctrl.lead.run_special_promotions\"><label>Special Promotions</label><input name=\"special_promotion\" ng-model=\"$ctrl.lead.special_promotion\" type=\"text\" md-maxlength=\"40\"></md-input-container></div></div></div></div></md-content></md-tab><md-tab label=\"Payment\"><md-content layout-padding><h1 class=\"md-subheader md-primary\">Billing Address</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex=\"50\"><label>Billing Address 1</label><input name=\"address1\" type=\"text\" ng-model=\"$ctrl.billing.line1\"></md-input-container><md-input-container flex=\"50\"><label>Address 2</label><input name=\"address2\" type=\"text\" ng-model=\"$ctrl.billing.line2\"></md-input-container><md-input-container flex=\"25\"><label>City</label><input name=\"city\" type=\"text\" ng-model=\"$ctrl.billing.city\"></md-input-container><div flex=\"25\"><select-state name=\"state\" label=\"State\" ng-model=\"$ctrl.billing.state\" ng-messages=\"editLeadForm.state.$error\"></select-state></div><md-input-container flex=\"25\"><label>Postal</label><input name=\"postal\" type=\"text\" ng-model=\"$ctrl.billing.postal\" postal-lookup address=\"$ctrl.billing\"></md-input-container><div flex=\"25\"><select-country name=\"country\" label=\"Country\" ng-model=\"$ctrl.billing.country\" ng-messages=\"editLeadForm.country.$error\"></select-country></div></div><h1 class=\"md-subheader md-primary\">Credit Card</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex><label>Name on card</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.card.name\"></md-input-container><md-input-container flex><label>Card Number</label><input name=\"card_number\" type=\"text\" ng-model=\"$ctrl.card.number\" ui-mask=\"9999 9999 9999 999?9\" ui-mask-placeholder-char=\"space\" credit-card><div ng-messages=\"editLeadForm.card_number.$error\"><div ng-message=\"creditCard\">Invalid credit card</div></div></md-input-container><md-input-container flex><label>Exp Date</label><input name=\"exp_date\" type=\"text\" ng-model=\"$ctrl.card.exp_date\" placeholder=\"MM / YY\" ui-mask=\"99 / 99\" credit-card-exp><div ng-messages=\"editLeadForm.exp_date.$error\"><div ng-message=\"creditCardExp\">Expired</div></div></md-input-container><md-input-container flex><label>CVC</label><input name=\"cvc\" type=\"text\" ng-model=\"$ctrl.card.cvc\" ui-mask=\"999?9\" ui-mask-placeholder-char=\"space\"></md-input-container></div><h1 class=\"md-subheader md-primary\">Check</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex><label>Bank</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.check.bank\"></md-input-container><md-input-container flex><label>Routing Number</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.check.routing\"></md-input-container><md-input-container flex><label>Account Number</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.check.account\"></md-input-container></div></md-content></md-tab></md-tabs></md-content></form><div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\"><md-button class=\"md-fab md-primary\" aria-label=\"Delete Lead\" permission permission-only=\"[\'deleteLead\']\" ng-click=\"$ctrl.deleteLead($event)\"><md-tooltip>Delete Lead</md-tooltip><md-icon md-svg-src=\"/assets/cross_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Notes\" ng-click=\"$ctrl.openNotesModal($event)\"><md-tooltip>Notes</md-tooltip><md-icon md-svg-src=\"/assets/notes_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Hot Button\" ng-click=\"$ctrl.openHotButtonModal($event)\"><md-tooltip>Hot Button</md-tooltip><md-icon md-svg-src=\"/assets/fire_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Disposition\" ng-click=\"$ctrl.openDispositionModal($event)\"><md-tooltip>Disposition</md-tooltip><md-icon md-svg-src=\"/assets/pencil_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Send Proposal\" ng-click=\"$ctrl.openProposalModal($event)\"><md-tooltip>Send Proposal</md-tooltip><md-icon md-svg-src=\"/assets/mail_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/login/login.html","<login on-submit=\"$ctrl.login(credentials)\" is-loading=\"$ctrl.loading\"></login>");
$templateCache.put("app/not-found/not-found.html","<md-content layout=\"column\" layout-align=\"center center\" style=\"min-height: 100%\"><h1><i class=\"fa fa-5x fa-exclamation-triangle\" aria-hidden=\"true\"></i></h1><h2>404 Not Found!</h2></md-content>");
$templateCache.put("app/provisioner-clients/provisioner-clients.html","<div class=\"u-margin--top u-margin--left\"><clients-list filtering=\"$ctrl.filtering\" clients=\"$ctrl.clients\" sales-reps=\"$ctrl.salesReps\" title=\"{{$ctrl.pinner.name + \' - \' + $ctrl.status}}\" get-clients=\"$ctrl.getClients($event)\"></clients-list></div>");
$templateCache.put("app/provisioning/provisioning.html","<div class=\"u-padding--right u-padding--bottom\" ui-view layout=\"column\" flex></div>");
$templateCache.put("app/provisioning-client/provisioning-client.html","<div flex><div class=\"u-margin--top u-margin--left\"><progressbar class=\"u-margin--top\" steps=\"14\" current=\"$ctrl.client.progress\"></progressbar></div><div ui-view></div></div><div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\"><md-button class=\"md-fab md-primary\" aria-label=\"Change Status\" ng-click=\"$ctrl.openChangeStatusModal($event)\"><md-tooltip>Change Status</md-tooltip><md-icon md-svg-src=\"/assets/close_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"View Lead\" ng-click=\"$ctrl.openViewClientModal($event)\"><md-tooltip>View Lead</md-tooltip><md-icon md-svg-src=\"/assets/view_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Edit Subscription\" ng-click=\"$ctrl.openEditSubscriptionModal($event)\"><md-tooltip>Edit Subscription</md-tooltip><md-icon md-svg-src=\"/assets/pencil_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Notes\" ng-click=\"$ctrl.openNotesModal($event)\"><md-tooltip>Notes</md-tooltip><md-icon md-svg-src=\"/assets/notes_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Hot Button\" ng-click=\"$ctrl.openHotButtonsModal($event)\"><md-tooltip>Hot Button</md-tooltip><md-icon md-svg-src=\"/assets/fire_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/provisioning-client-step1/provisioning-client-step1.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 1</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content layout-padding><div class=\"md-body-1\" layout-padding>Welcome to Zoek, my name is <strong>{{::$ctrl.profile.name}}</strong> and I am going to be guiding you through our onboarding process to get all of the information that we’ll need to start working on your account. This should only take a couple of minutes and will be the first step toward success with your <strong>{{::$ctrl.client.subscription.package.name}}</strong>.<div layout=\"column\" layout-gt-sm=\"row\"><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Client</h4><ul><li>CID: {{::$ctrl.client.client_no}}</li><li>Name: {{::$ctrl.client.name}}</li><li>Business: {{::$ctrl.client.business}}</li><li>Industry: {{::$ctrl.client.industry}}</li><li>Sub-Industry: {{::$ctrl.client.subindustry}}</li></ul></div></div><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Subscription</h4><ul><li>Package Type: {{$ctrl.client.subscription.package.name}} {{$ctrl.client.getPlan().name}}</li><li>Monthly Fee: {{$ctrl.client.subscription.monthly_fee | currency}}</li><li>Setup Fee: {{$ctrl.client.subscription.setup_fee | currency}}</li><li>Term: {{$ctrl.client.getPlan().payment_term}} Months</li></ul></div><div><h4 class=\"md-subheader md-primary\">Add Ons:</h4><ul><li ng-show=\"!$ctrl.client.subscription.add_on_ids.length\">None</li><li ng-repeat=\"addOn in $ctrl.client.subscription.add_ons.data\">{{addOn.name}}</li></ul></div></div><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Sales Rep</h4><p>{{::$ctrl.client.closer.name}}</p></div></div></div></div><div><button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.next()\">Next</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step10/provisioning-client-step10.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 10</p></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\"><p>In the next few minutes, I am going to quickly go over the rest of the services that we will be providing to you for your package. Each of these is important for your Internet marketing campaign so I want to make sure that you don’t have any questions about them and that you understand what we are going to be doing for you. You’re already aware of the keywords and cities that we will be targeting and we’ve got your Google My Business page set up so the first step is all taken care of. Next, our team of content writers will create unique content for your business so if there is any information that you’d like to have included in your content, feel free to email content@gozoek.com to make them aware. You’ll have 48 hours from now before they get started on writing your content so be sure to send it as soon as possible.</p><br><br><p>*You can also let the client know that they’ll receive an email including all of the phone numbers and email addresses that they’ll need.*</p><br><br><md-input-container class=\"md-block\"><label>Any specific information client wants in their content</label><textarea name=\"content_request\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.client.content_request\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>Content written as</label><md-select name=\"content_request_written_as\" ng-model=\"$ctrl.client.content_request_written_as\"><md-option value=\"\"></md-option><md-option value=\"first_person\">First Person</md-option><md-option value=\"second_person\">Second Person</md-option><md-option value=\"third_person\">Third Person</md-option></md-select></md-input-container></div><div><button class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step9\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.next()\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step11/provisioning-client-step11.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 11</p></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\" ng-show=\"$ctrl.client.website\">After your content is completed, we will start building your Client Acquisition Page that will act as a direct link between you and your customers. This page will be connected to a URL and hosts a proprietary software that we’ve developed to give you accurate reporting on how your business is doing online. This is the page that we will get on page 1 of Search Engines which is great news to you because it contains direct links to your existing website which will generate a flow of traffic to your site and provide potential customers with even more information about you on the Internet.</div><div class=\"md-body-1\" ng-hide=\"$ctrl.client.website\">After your content is completed, we will start building your Client Acquisition Page that will act as a direct link between you and your customers. This page will be connected to a URL and hosts a proprietary software that we’ve developed to give you accurate reporting on how your business is doing online. This is the page that we will get on page 1 of Search Engines which is great news to you because it will generate a flow of traffic to your potential customers and give them even more information about your business on the Internet.</div><div><button class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step10\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.next()\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step12/provisioning-client-step12.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 12</p></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\">When you CAP is created, we will start to build out all of your other online directory listings. Remember, you’ll be able to see where all of your directories are listed by filling out the PowerListings scan tool available on our website or in your MyZoek dashboard. Keep in mind that this process may take some time since we’re adding information to so many directories.</div><div><button class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step11\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.next()\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step13/provisioning-client-step13.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 13</p></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\">Your account should now be all set up and ready to go. Remember, you MyZoek dashboard has all of the information that you’ll need to see for your account. As your campaign progresses, more information will be available to you online and we’ll be reaching out with information via email so please keep an eye out for those. You’ll start receiving monthly reports with information about how things are going but you can log into your dashboard at any time. If you have any questions, feel free to submit a support ticket or utilize our live chat that is available on our website. Our technical support team is also available by phone Monday through Friday from 6:00 am to 5:00 pm Pacific Standard Time at (888)737-9635. You should be receiving your welcome email shortly and that will include the login information for your MyZoek dashboard. Just remember that it takes about 4 weeks or so for all of the parts of your marketing campaign to be completed so if you’re noticing some areas that are missing information, don’t be alarmed. Your Zoek Promise will set in as soon as we receive the signed contract back from you so be sure to get that completed as soon as possible. You account will now be sent over to our Account Success Experts and they’ll get to work. Is there anything else I can help you with today?</div><div><button class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step12\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.next()\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step14/provisioning-client-step14.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 14 Completed</p></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\"><p>Ok great, thank you so much for your time and assistance with this. One last thing I need to get form you is a satisfaction level with our services so far. I know it’s all new but we really focus on structuring everything based on the satisfaction of our clients and welcome constructive criticism. On a scale of 1 – 10, how satisfied are you with the account set up process?</p><br><br><div layout=\"row\" layout-margin layout-align=\"center center\"><span>Not Satisfied</span><md-radio-group ng-model=\"$ctrl.client.rating\" layout=\"row\"><md-radio-button ng-value=\"n\" class=\"md-primary\" ng-repeat=\"n in [1,2,3,4,5,6,7,8,9,10]\">{{::n}}</md-radio-button></md-radio-group><span>Very Satisfied</span></div><br><br><p>If they give you a good rating number, tell them that you’ll be emailing them some information about places that they can leave a review and let them know that you’d really appreciate hearing back from them.</p></div><div><button class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step13\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.finish()\" ladda=\"$ctrl.loading\">Finish</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step2/provisioning-client-step2.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 2</p></div></md-toolbar><md-content layout-padding><p class=\"md-body-1\">To get started, I want to verify that we have the correct email address on file <strong>( {{$ctrl.client.email}} )</strong> by making sure that you’ve received our welcome email as well as a receipt for the purchase of your <strong>{{$ctrl.client.subscription.package.name}}</strong>. Did you receive those already?</p><div><a class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step1\">Go Back</a> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.next()\" ladda=\"$ctrl.loading\">Yes</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.openUpdateEmailModal($event)\">No</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.openUpdateEmailModal($event)\">N/A</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step3/provisioning-client-step3.html","<form name=\"pinnerKeywordsForm\" ng-submit=\"pinnerKeywordsForm.$valid && $ctrl.updateKeywords()\" accessible-form novalidate><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 3 Keywords</p><span flex></span> <a class=\"md-button\" href=\"http://keywordtool.io\" target=\"_blank\">Keyword Research</a></div></md-toolbar><md-content layout-padding><p class=\"md-body-1\">As you know, the goal of our Internet marketing campaign is to provide you with the services necessary to get your business on page one of search engines. In order to set up your account for success, we will be selecting 10 keywords together that we will use while building our your campaign. These keywords will be selected based on your business industry and location – we want to pick keywords that your potential customers might search for so keep that in mind.</p><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" layout-margin ng-repeat=\"keyword in [] | range:$ctrl.client.subscription.number_of_keywords track by $index\"><label>Keyword {{$index + 1}}</label><input type=\"text\" name=\"$index\" ng-model=\"$ctrl.keywords[$index]\" ng-required=\"$index < 10\"><div ng-messages=\"pinnerKeywordsForm.$index.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><div><a class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step2\">Go Back</a> <button class=\"md-button md-primary md-raised\" type=\"button\" ng-click=\"$ctrl.selectKeywordsLater($event)\">Select Later</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div></form>");
$templateCache.put("app/provisioning-client-step4/provisioning-client-step4.html","<form name=\"pinnerCitiesForm\" ng-submit=\"pinnerCitiesForm.$valid && $ctrl.updateCities()\" accessible-form novalidate><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 4 Cities</p><span flex></span> <a class=\"md-button\" href=\"http://www.searchbug.com/tools/zip-radius.aspx\" target=\"_blank\">Cities Research</a></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\">We will also be working on expanding the reach of your business from your city to other surrounding cities. Since you’ve purchased the <strong>{{$ctrl.package_name}}</strong>, we will be targeting the nearest <strong>{{$ctrl.number_of_cities}}</strong> cities for you. We want to take a look at the best city options for your business and make sure they’re in a reasonable service area so we’re not reaching out to customers that are too far away. Let me see what options we have available for you:</div><br><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" layout-margin ng-repeat=\"city in [] | range:$ctrl.number_of_cities track by $index\"><label>City {{$index + 1}}</label><input type=\"text\" name=\"$index\" ng-model=\"$ctrl.cities[$index]\"><div ng-messages=\"pinnerCitiesForm.$index.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><div><a class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step3\">Go Back</a> <button class=\"md-button md-primary md-raised\" type=\"button\" ng-click=\"$ctrl.selectCitiesLater($event)\">Select Later</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div></form>");
$templateCache.put("app/provisioning-client-step5/provisioning-client-step5.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 5 Call Tracking</p></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\"><span ng-show=\"$ctrl.client.hasCallTracking()\">Ok, I see here that you have elected to incorporate call tracking into your package? That’s great. </span>Call tracking is one of the best ways to track your conversion through our internet marketing campaign. The phone number that we select for you will be displayed on all of the online business listings that we create for you so when your potential customers start finding your business online, they’ll call that number and you’ll receive the call on your regular phone line. You’ll also receive an email that shows you the phone number and includes a recording of the phone call for your convenience.</div><div><a class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step4\">Go Back</a> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.optOut()\" ng-disabled=\"!$ctrl.client.hasCallTracking()\" ladda=\"$ctrl.opttingout\">OPT OUT</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.optIn()\" ng-disabled=\"$ctrl.client.hasCallTracking()\" ladda=\"$ctrl.opttingin\">OPT IN</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.next()\" ladda=\"$ctrl.loading\">Continue</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step6/provisioning-client-step6.html","<form name=\"pinnerGmailForm\" ng-submit=\"pinnerGmailForm.$valid && $ctrl.next()\" novalidate><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 6 Google My Business</p><span flex></span> <a class=\"md-button\" href=\"https://accounts.google.com/SignUp\" target=\"_blank\">Create</a></div></md-toolbar><md-content layout-padding><div class=\"md-body-1\" layout-padding>Now that we’ve identified your 10 keywords and cities, we can get to work on your account. The first thing that we need to do to ensure success of your Internet marketing campaign is secure your Google My Business Online Profile. I’m going to do a quick search to see if there is one that’s already been created. Do you mind giving me just a moment to get this figured out?</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Email</label><input name=\"email\" type=\"email\" ng-model=\"$ctrl.client.gmail_address\" autocomplete=\"off\" required><div ng-messages=\"pinnerGmailForm.email.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"email\">Invalid Email</div></div></md-input-container><md-input-container flex><label>Password</label><input name=\"password\" type=\"text\" ng-model=\"$ctrl.client.gmail_password\" autocomplete=\"off\" required><div ng-messages=\"pinnerGmailForm.password.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><div><a class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step5\">Go Back</a> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Next</button></div></md-content></div></form>");
$templateCache.put("app/provisioning-client-step7/provisioning-client-step7.html","<div class=\"u-margin--top u-margin--left\" ng-init=\"$ctrl.step = \'step1\'\" ng-show=\"$ctrl.step === \'step1\'\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 7 Does client have existing listing?</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content layout-padding><div><button class=\"md-button md-raised\" ui-sref=\"root.provisioning.client.step6\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.step = \'step2a\'\">Yes</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.step = \'step2b\'\">No</button></div></md-content></div><div class=\"u-margin--top u-margin--left\" ng-show=\"$ctrl.step === \'step2a\'\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 7 Does client have login info?</p></div></md-toolbar><md-content layout-padding><div><button class=\"md-button md-raised\" ng-click=\"$ctrl.step = \'step1\'\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.step = \'step3\'\">Yes</button> <button class=\"md-primary md-raised\" ui-sref=\"root.provisioning.client.step9\">No</button></div></md-content></div><div class=\"u-margin--top u-margin--left\" ng-show=\"$ctrl.step === \'step3\'\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 7</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content layout-padding><div><button class=\"md-button md-raised\" ng-click=\"$ctrl.step = \'step2a\'\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.addManagement()\">Add Management</button> <button class=\"md-primary md-raised\" ui-sref=\"root.provisioning.client.step9\">Next</button></div></md-content></div><div class=\"u-margin--top u-margin--left\" ng-show=\"$ctrl.step === \'step2b\'\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 7</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content layout-padding><div><button class=\"md-button md-raised\" ng-click=\"$ctrl.step = \'step1\'\" type=\"button\">Go Back</button> <a class=\"md-button md-primary md-raised\" href=\"https://www.google.com/business/\" target=\"_blank\">Setup Google My Business</a> <button class=\"md-button md-primary md-raised\" ui-sref=\"root.provisioning.client.step8\">Next</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step8/provisioning-client-step8.html","<div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 8</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content layout-padding><div><button class=\"md-button md-raised\" ui-sref=\"root.pinner.client.step7\">Go Back</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.sentPostcard = true\">Send Postcard</button> <button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.listingLive()\" ladda=\"$ctrl.loading\">Listing is live</button></div></md-content><md-content ng-show=\"$ctrl.sentPostcard\" layout-padding><div class=\"md-body-1\" layout-padding>Now that we have created your listing, we will need to verify it through Google. They will be sending you a postcard and you should receive it at this address <strong style=\"white-space: nowrap\">{{::$ctrl.client.address.formatted}}</strong> within 5 business days. Please be sure to contact us as soon as you receive it. You will receive a reminder email in about 3 days. As a courtesy, I’d like to schedule a time to call you back in 5 days so we can get that information from you.</div><div><button class=\"md-button md-primary md-raised\" ng-click=\"$ctrl.callbackPostCard()\" ladda=\"$ctrl.loading\" type=\"button\">Schedule Callback</button></div></md-content></div>");
$templateCache.put("app/provisioning-client-step9/provisioning-client-step9.html","<form class=\"pinner-step-9\" layout=\"column\" layout-gt-sm=\"row\" name=\"pinnerSubscriptionDetailForm\" ng-submit=\"pinnerSubscriptionDetailForm.$valid && $ctrl.next()\" accessible-form novalidate><div class=\"u-margin--top u-margin--left\" flex><md-toolbar><div class=\"md-toolbar-tools\"><p>Step 9 Package Details</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-content layout-padding><p class=\"md-body-1\">Ok, now that we’ve got the beginning pieces of your campaign ready, I’d like to verify some information with you to make sure that we are able to provide you with all necessary reporting and information.</p><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>1. Primary Account Holder First Name</label><input name=\"first_name\" ng-model=\"$ctrl.client.first_name\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>2. Primary Account Holder Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.client.last_name\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>3. Business Name</label><input name=\"business_name\" ng-model=\"$ctrl.client.business\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.business.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>4. Authorized Users on the Account</label><input name=\"authorized_users\" ng-model=\"$ctrl.client.authorized_users\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.authorized_users.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>5. Email for receipts and account information from Zoek</label><input name=\"email_for_receipts\" ng-model=\"$ctrl.client.email\" type=\"text\" autocomplete=\"off\" required><div ng-messages=\"openerSubscriptionDetailForm.email_for_receipts.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>6. Email for \"Contact Us\" Section on C.A.P. Site</label><input name=\"email_for_contact\" ng-model=\"$ctrl.client.email_for_contact\" type=\"text\" autocomplete=\"off\" required><div ng-messages=\"openerSubscriptionDetailForm.email_for_contact.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><md-checkbox ng-model=\"$ctrl.client.hide_address\" ng-false-value=\"false\" ng-true-value=\"true\">Hide Address</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>7. Listing address line 1</label><input name=\"address1\" ng-model=\"$ctrl.client.address.line1\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.address1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>8. Listing address line 2</label><input name=\"address2\" ng-model=\"$ctrl.client.address.line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>8. Listing city</label><input name=\"city\" ng-model=\"$ctrl.client.address.city\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><select-state name=\"state\" label=\"9. Listing state\" ng-model=\"$ctrl.client.address.state\" ng-messages=\"openerSubscriptionDetailForm.state.$error\" ng-required=\"true\"></select-state></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>10. Listing postal</label><input name=\"postal\" ng-model=\"$ctrl.client.address.postal\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-country name=\"country\" ng-model=\"$ctrl.client.address.country\" ng-required=\"true\"></select-country></div><md-input-container class=\"md-block\" flex=\"50\"><label>12. Address Type</label><md-select name=\"address_type\" ng-model=\"$ctrl.client.address.type\"><md-option>Residential</md-option><md-option>Storefront</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>13. How Many Locations?</label><md-select name=\"address_type\" ng-model=\"$ctrl.client.number_of_locations\"><md-option>1</md-option><md-option>2</md-option><md-option>3</md-option><md-option>4+</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>14. Phone number for Zoek to contact you</label><input name=\"phone\" ng-model=\"$ctrl.client.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" autocomplete=\"off\" required><div ng-messages=\"openerSubscriptionDetailForm.phone.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>15. Fax Number</label><input name=\"fax\" ng-model=\"$ctrl.client.fax\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>16. Desired URL</label><input name=\"desired_url\" ng-model=\"$ctrl.client.desired_url\" type=\"text\" http-prefix> <a href=\"https://www.godaddy.com/\" target=\"_blank\"><md-button class=\"md-primary md-button\">Check Availability</md-button></a></md-input-container><div class=\"md-block\" flex=\"50\"><payment-methods ng-model=\"$ctrl.client.payments_accepted\"></payment-methods></div><business-hours hours=\"$ctrl.client.business_hours\"></business-hours><md-input-container class=\"md-block\" flex=\"50\"><label>19. License No.</label><input name=\"license_no\" ng-model=\"$ctrl.client.license_no\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>21. Awards and Accolades</label><input name=\"awards_and_accolades\" ng-model=\"$ctrl.client.awards_and_accolades\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>21. Certifications</label><input name=\"certifications\" ng-model=\"$ctrl.client.certifications\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>22. Years Established</label><input name=\"years_in_business\" ng-model=\"$ctrl.client.years_in_business\" type=\"text\" ui-mask=\"9999\" ui-mask-placeholder-char=\"space\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>23. Number of Employees</label><input name=\"number_of_employees\" ng-model=\"$ctrl.client.number_of_employees\" type=\"text\"></md-input-container><div class=\"md-block\" flex=\"50\"><languages-spoken ng-model=\"$ctrl.client.languages_spoken\"></languages-spoken></div><div class=\"md-block\" flex=\"50\"><parking-available ng-model=\"$ctrl.client.parking_available\"></parking-available></div><div class=\"md-block\" flex=\"50\"><label>26. Run Special Promotions (e.g. Happy Hour, Half Off, $10 Off First Service, Referalls, etc)</label><md-radio-group layout=\"row\" class=\"u-margin--top\" ng-model=\"$ctrl.client.run_special_promotions\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group><md-input-container class=\"md-block\" flex ng-show=\"$ctrl.client.run_special_promotions\"><label>Special Methods</label><input name=\"special_promotion\" ng-model=\"$ctrl.client.special_promotion\" type=\"text\" md-maxlength=\"40\"></md-input-container></div><div class=\"md-block\" flex=\"50\"><md-input-container class=\"md-block\" flex><label>76. Website</label><input name=\"website\" ng-model=\"$ctrl.client.website\" type=\"text\" http-prefix></md-input-container></div></div><div><button class=\"md-button md-raised\" ui-sref=\"root.pinner.client.step8\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Continue</button></div></md-content></div></form>");
$templateCache.put("app/provisioning-clients/provisioning-clients.html","<div class=\"u-margin--top u-margin--left\"><clients-list clients=\"$ctrl.clients\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></clients-list></div><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Provisioners</p></div></md-toolbar><md-content layout-padding><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Name</span></th><th md-column><span>Active</span></th><th md-column><span>Provisioning</span></th><th md-column><span>Claimed</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr\" md-row ng-repeat=\"provisioner in $ctrl.provisioners.data\"><td md-cell>{{::provisioner.name}}</td><td md-cell ng-click=\"$ctrl.viewCompletedClients(provisioner)\"><a ui-sref=\"root.provisioner.clients({provisioner_id: provisioner.id, status: \'active\'})\">{{::provisioner.completed || 0}}</a></td><td md-cell><a ui-sref=\"root.provisioner.clients({provisioner_id: provisioner.id, status: \'provisioning\'})\">{{::provisioner.in_progress || 0}}</a></td><td md-cell><a ui-sref=\"root.provisioner.clients({provisioner_id: provisioner.id})\">{{::provisioner.claimed || 0}}</a></td></tr></tbody></table></md-table-container></md-content></div>");
$templateCache.put("app/provisioning-listing-sync/provisioning-listing-sync.html","<div class=\"u-margin--left u-margin--top\"><package-details client=\"$ctrl.client\" on-submit=\"$ctrl.handleSubmit($event)\" on-go-back=\"$ctrl.handleGoBack($event)\" loading=\"$ctrl.loading\"></package-details></div>");
$templateCache.put("app/provisioning-mobile-app/provisioning-mobile-app.html","<div class=\"u-margin--left u-margin--top\"><mobile-app-questionnaire on-submit=\"$ctrl.handleSubmit($event)\" on-go-back=\"$ctrl.handleGoBack()\" loading=\"$ctrl.loading\" questionnaire=\"$ctrl.client.mobile_app_questionnaire\"></mobile-app-questionnaire></div>");
$templateCache.put("app/qualifiers/qualifiers.html","<div class=\"u-padding--right u-padding--bottom\" ui-view></div>");
$templateCache.put("app/qualifiers-lead/qualifiers-lead.html","<div ui-view></div><div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\"><md-button class=\"md-fab md-primary\" aria-label=\"View Lead\" ng-click=\"$ctrl.openViewLeadModal($event)\"><md-tooltip>View Lead</md-tooltip><md-icon md-svg-src=\"/assets/view_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Notes\" ng-click=\"$ctrl.openNotesModal($event)\"><md-tooltip>Notes</md-tooltip><md-icon md-svg-src=\"/assets/notes_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Hot Button\" ng-click=\"$ctrl.openHotButtonsModal($event)\"><md-tooltip>Hot Button</md-tooltip><md-icon md-svg-src=\"/assets/fire_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Save / Exit\" ng-click=\"$ctrl.openSaveModal($event)\"><md-tooltip>Save / Exit</md-tooltip><md-icon md-svg-src=\"/assets/exit_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/qualifiers-leads/qualifiers-leads.html","<div class=\"u-margin--top u-margin--left\"><leads-list leads=\"$ctrl.leads\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></leads-list></div><div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\"><md-button class=\"md-fab md-primary\" aria-label=\"Add New Lead\" ui-sref=\"root.leads.add\"><md-tooltip>Add New Lead</md-tooltip><md-icon md-svg-src=\"/assets/plus_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/qualifiers-package/qualifiers-package.html","<div class=\"u-margin--top u-margin--left\"><progressbar steps=\"5\" current=\"$ctrl.lead.progress\"></progressbar></div><div class=\"u-margin--top u-margin--left\"><qualifier-steps current=\"1\" progress=\"$ctrl.lead.progress\"></qualifier-steps></div><div layout=\"column\" layout-gt-sm=\"row\" flex><div class=\"u-margin--top u-margin--left\"><md-toolbar><div class=\"md-toolbar-tools\"><p class=\"md-title\">Included in every package</p></div></md-toolbar><md-content><md-list class=\"md-dense\"><md-list-item class=\"md-1-line\" ng-repeat=\"include in $ctrl.packageIncludes track by $index\"><div class=\"md-list-item-text\"><p class=\"md-body-1\">{{::include}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div><div class=\"u-margin--top u-margin--left\" layout=\"column\" flex><md-toolbar><div class=\"md-toolbar-tools\"><p class=\"md-title\">Select a package</p></div></md-toolbar><md-content flex><div layout=\"column\" layout-gt-sm=\"row\" layout-margin><zoek-package class=\"zoek-package\" ng-repeat=\"package in $ctrl.packages.data\" is-active=\"$ctrl.lead.getSubscription().getPackage().id == package.id\" on-click=\"$ctrl.handleOnClickPackage($event)\" package=\"package\"></zoek-package></div></md-content></div></div>");
$templateCache.put("app/qualifiers-package-details/qualifiers-package-details.html","<div class=\"u-margin--top u-margin--left\"><progressbar steps=\"2\" current=\"$ctrl.lead.progress\"></progressbar></div><div class=\"u-margin--top u-margin--left\"><qualifier-steps current=\"2\" progress=\"$ctrl.lead.progress\"></qualifier-steps></div><div class=\"u-margin--top u-margin--left\" flex><form name=\"openerSubscriptionDetailForm\" ng-submit=\"openerSubscriptionDetailForm.$valid && $ctrl.saveSubscription()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Package Details</p></div></md-toolbar><md-content layout-padding><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>1. Primary Account Holder First Name</label><input name=\"first_name\" ng-model=\"$ctrl.lead.first_name\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>2. Primary Account Holder Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.lead.last_name\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>3. Business Name</label><input name=\"business\" ng-model=\"$ctrl.lead.business\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.business.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>4. Authorized Users on the Account</label><input name=\"authorized_users\" ng-model=\"$ctrl.lead.authorized_users\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.authorized_users.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>5. Email for receipts and account information from Zoek</label><input name=\"email\" ng-model=\"$ctrl.lead.email\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.email.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>6. Email for \"Contact Us\" Section on C.A.P. Site</label><input name=\"email_for_contact\" ng-model=\"$ctrl.lead.email_for_contact\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.email_for_contact.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>7. Listing address line 1</label><input name=\"address1\" ng-model=\"$ctrl.lead.address.line1\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.address1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>8. Listing address line 2</label><input name=\"address2\" ng-model=\"$ctrl.lead.address.line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>9. Listing city</label><input name=\"city\" ng-model=\"$ctrl.lead.address.city\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-state name=\"state\" label=\"10. Listing state\" ng-messages=\"openerSubscriptionDetailForm.state.$error\" ng-model=\"$ctrl.lead.address.state\" ng-required=\"true\"></select-state></div><md-input-container class=\"md-block\" flex=\"50\"><label>11. Listing postal</label><input name=\"postal\" ng-model=\"$ctrl.lead.address.postal\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-country name=\"country\" label=\"12. Listing country\" ng-messages=\"openerSubscriptionDetailForm.country.$error\" ng-model=\"$ctrl.lead.address.country\" ng-required=\"true\"></select-country></div><md-input-container class=\"md-block\" flex=\"50\"><label>13. Address Type</label><md-select name=\"address_type\" ng-model=\"$ctrl.lead.address.type\"><md-option ng-value=\"\'residential\'\">Residential</md-option><md-option ng-value=\"\'storefront\'\">Storefront</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>14. How Many Locations?</label><md-select name=\"number_of_locations\" ng-model=\"$ctrl.lead.number_of_locations\"><md-option ng-value=\"\'1\'\">1</md-option><md-option ng-value=\"\'2\'\">2</md-option><md-option ng-value=\"\'3\'\">3</md-option><md-option ng-value=\"\'4+\'\">4+</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>15. Phone number for Zoek to contact you</label><input name=\"phone\" ng-model=\"$ctrl.lead.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>16. Fax Number</label><input name=\"fax\" ng-model=\"$ctrl.lead.fax\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>17. Desired URL</label><input name=\"desired_url\" ng-model=\"$ctrl.lead.desired_url\" type=\"text\" http-prefix> <a href=\"https://www.godaddy.com/\" target=\"_blank\"><md-button class=\"md-primary md-button\">Check Availability</md-button></a></md-input-container><div flex=\"50\"><payment-methods label=\"17. Payments Accepted\" ng-model=\"$ctrl.lead.payments_accepted\"></payment-methods></div><div flex=\"100\"><business-hours hours=\"$ctrl.lead.business_hours\"></business-hours></div><md-input-container class=\"md-block\" flex=\"50\"><label>20. License No.</label><input name=\"license_no\" ng-model=\"$ctrl.lead.license_no\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>21. Awards and Accolades</label><input name=\"awards_and_accolades\" ng-model=\"$ctrl.lead.awards_and_accolades\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>22. Certifications</label><input name=\"certifications\" ng-model=\"$ctrl.lead.certifications\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>23. Year Established</label><input name=\"years_in_business\" ng-model=\"$ctrl.lead.years_in_business\" type=\"text\" ui-mask=\"9999\" ui-mask-placeholder-char=\"space\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>24. Number of Employees</label><input name=\"number_of_employees\" ng-model=\"$ctrl.lead.number_of_employees\" type=\"text\"></md-input-container><div flex=\"50\"><languages-spoken label=\"24. Languages Spoken\" ng-model=\"$ctrl.lead.languages_spoken\"></languages-spoken></div><div flex=\"50\"><parking-available label=\"26. Parking Available\" ng-model=\"$ctrl.lead.parking_available\"></parking-available></div><div class=\"md-block\" flex=\"50\"><label>27. Run Special Promotions (e.g. Happy Hour, Half Off, $10 Off First Service, Referalls, etc)</label><div layout-margin><md-radio-group layout=\"row\" class=\"u-margin--top\" ng-model=\"$ctrl.lead.run_special_promotions\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group><br><md-input-container class=\"md-block\" flex ng-show=\"$ctrl.lead.run_special_promotions\"><label>Special Promotions</label><input name=\"special_promotion\" ng-model=\"$ctrl.lead.special_promotion\" type=\"text\" ng-required=\"$ctrl.lead.run_special_promotions\" md-maxlength=\"40\"><div ng-messages=\"openerSubscriptionDetailForm.special_promotion.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div><div layout=\"column\"><div>28. Cities <a href=\"http://www.searchbug.com/tools/zip-radius.aspx\" target=\"_blank\"><md-button class=\"md-primary\">Search Cities</md-button></a></div><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" ng-repeat=\"n in [] | range:$ctrl.lead.subscription.number_of_cities track by $index\"><label>City {{$index + 1}}</label><input type=\"text\" ng-model=\"$ctrl.lead.subscription.cities[$index]\"></md-input-container></div></div><div layout=\"column\"><div>29. Keywords <a href=\"http://keywordtool.io\" target=\"_blank\"><md-button class=\"md-primary\">Search Keywords</md-button></a></div><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" ng-repeat=\"n in [] | range:$ctrl.lead.subscription.number_of_keywords track by $index\"><label>Keyword {{$index + 1}}</label><input type=\"text\" ng-model=\"$ctrl.lead.subscription.keywords[$index]\"></md-input-container></div></div></div><div><button class=\"md-button md-raised\" ui-sref=\"root.closer.lead.packages\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Continue</button></div></md-content></form></div>");
$templateCache.put("app/qualifiers-payment/qualifiers-payment.html","<div class=\"u-margin--top u-margin--left\"><progressbar steps=\"5\" current=\"$ctrl.lead.progress\"></progressbar></div><div class=\"u-margin--top u-margin--left\"><qualifier-steps current=\"3\" progress=\"$ctrl.lead.progress\"></qualifier-steps></div><div class=\"u-margin--top u-margin--left\"><payment-details loading=\"$ctrl.loading\" billing=\"$ctrl.billing\" card=\"$ctrl.card\" on-submit=\"$ctrl.submit($event)\" on-go-back=\"$ctrl.goBack($event)\"></payment-details></div>");
$templateCache.put("app/quick-add/quick-add.html","<form class=\"u-margin\" name=\"editLeadForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\"><span flex></span><md-button ng-click=\"$ctrl.save()\" ladda=\"$ctrl.loading\">Save</md-button><md-button ng-click=\"$ctrl.saveAndConvert()\" ladda=\"$ctrl.loading\">Save & Convert</md-button></div></md-toolbar><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Contact\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><div flex=\"50\"><md-input-container class=\"md-block\"><label>First name</label><input ng-model=\"$ctrl.lead.first_name\" name=\"first_name\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Last Name</label><input ng-model=\"$ctrl.lead.last_name\" name=\"last_name\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Email</label><input ng-model=\"$ctrl.lead.email\" name=\"email\" type=\"email\"><div ng-messages=\"editLeadForm.email.$error\"><div ng-message=\"email\">Invalid email</div></div></md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block\"><label>Alt Email</label><input ng-model=\"$ctrl.lead.alt_email\" name=\"alt_email\" type=\"email\"><div ng-messages=\"editLeadForm.alt_email.$error\"><div ng-message=\"email\">Invalid email</div></div></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.lead.do_not_send_emails\" ng-true-value=\"true\" ng-false-value=\"false\">Don\'t trigger emails</md-checkbox></md-input-container></div><div flex=\"50\" layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>Phone</label><input ng-model=\"$ctrl.lead.phone\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"phone\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.lead.phone_is_mobile\" ng-true-value=\"true\" ng-false-value=\"false\">Is Mobile</md-checkbox></md-input-container></div></div><div flex=\"50\" layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>Alt Phone</label><input ng-model=\"$ctrl.lead.alt_phone\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"alt_phone\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><md-checkbox class=\"md-body-1\" ng-model=\"$ctrl.lead.alt_phone_is_mobile\" ng-true-value=\"true\" ng-false-value=\"false\">Is Mobile</md-checkbox></md-input-container></div></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Fax</label><input ng-model=\"$ctrl.lead.fax\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"fax\"></md-input-container></div><div flex=\"50\"><select-lead-type name=\"lead_type\" label=\"Lead Type\" ng-model=\"$ctrl.lead.lead_type\" ng-messages=\"editLeadForm.lead_type.$error\"></select-lead-type></div></div></md-content></md-tab><md-tab label=\"Business\"><md-content layout-padding><h1 class=\"md-subheader md-primary\">Business</h1><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><div flex=\"33\"><md-input-container class=\"md-block\"><label>Business</label><input ng-model=\"$ctrl.lead.business\" name=\"business\" type=\"text\"></md-input-container></div><div flex=\"33\"><md-input-container class=\"md-block\"><label>Business Email</label><input ng-model=\"$ctrl.lead.business_email\" type=\"email\" name=\"business_email\"><div ng-messages=\"editLeadForm.business_email.$error\"><div ng-message=\"email\">Invalid email</div></div></md-input-container></div><div flex=\"33\"><md-input-container class=\"md-block\"><label>Business Phone</label><input ng-model=\"$ctrl.lead.business_phone\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" type=\"tel\" name=\"business_phone\"></md-input-container></div><div flex=\"25\"><select-industry name=\"industry\" label=\"Industry\" ng-model=\"$ctrl.lead.industry\" ng-messages=\"editLeadForm.industry.$error\"></select-industry></div><div flex=\"25\"><md-input-container class=\"md-block\"><label>Sub-Industry</label><input name=\"subindustry\" ng-model=\"$ctrl.lead.subindustry\" type=\"text\"></md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block\"><label>Website</label><input ng-model=\"$ctrl.lead.website\" name=\"website\" http-prefix type=\"url\"></md-input-container></div><div flex=\"25\"><select-business-type name=\"business_type\" label=\"Business Type\" ng-model=\"$ctrl.lead.business_type\"></select-business-type></div></div></md-content><md-content layout-padding><h1 class=\"md-subheader md-primary\">Address</h1><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><div flex=\"50\"><md-input-container class=\"md-block\"><label>Address 1</label><input ng-model=\"$ctrl.lead.address.line1\" name=\"address1\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Address 2</label><input ng-model=\"$ctrl.lead.address.line2\" name=\"address2\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>City</label><input ng-model=\"$ctrl.lead.address.city\" name=\"city\" type=\"text\"></md-input-container></div><div flex=\"50\"><select-state name=\"state\" label=\"State\" ng-model=\"$ctrl.lead.address.state\" ng-messages=\"editLeadForm.state.$error\"></select-state></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Postal Code</label><input ng-model=\"$ctrl.lead.address.postal\" name=\"postal\" type=\"text\"></md-input-container></div><div flex=\"50\"><select-country name=\"country\" label=\"Country\" ng-model=\"$ctrl.lead.address.country\" ng-messages=\"editLeadForm.country.$error\"></select-country></div></div></md-content></md-tab><md-tab label=\"Subscription\"><md-content class=\"md-padding\"><zoek-packages selected-package-id=\"$ctrl.lead.getSubscription().getPackage().id\" on-click=\"$ctrl.handleOnClickPackage($event)\"></zoek-packages></md-content></md-tab><md-tab label=\"Package Details\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><div flex=\"50\"><md-input-container class=\"md-block\"><label>1. Primary Account Holder First Name</label><input name=\"first_name\" ng-model=\"$ctrl.lead.first_name\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>2. Primary Account Holder Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.lead.last_name\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>3. Business Name</label><input name=\"business\" ng-model=\"$ctrl.lead.business\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>4. Authorized Users on the Account</label><input name=\"authorized_users\" ng-model=\"$ctrl.lead.authorized_users\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>5. Email for receipts and account information from Zoek</label><input name=\"email\" ng-model=\"$ctrl.lead.email\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>6. Email for \"Contact Us\" Section on C.A.P. Site</label><input name=\"email_for_contact\" ng-model=\"$ctrl.lead.email_for_contact\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>7. Listing address line 1</label><input name=\"address1\" ng-model=\"$ctrl.lead.address.line1\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>8. Listing address line 2</label><input name=\"address2\" ng-model=\"$ctrl.lead.address.line2\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>9. Listing city</label><input name=\"city\" ng-model=\"$ctrl.lead.address.city\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>10. Listing state</label><md-select name=\"state\" ng-model=\"$ctrl.lead.address.state\"><md-option ng-repeat=\"state in $ctrl.states track by $index\" ng-value=\"::state.abbreviation\">{{::state.name}}</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>11. Listing postal</label><input name=\"postal\" ng-model=\"$ctrl.lead.address.postal\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>12. Listing country</label><md-select name=\"country\" ng-model=\"$ctrl.lead.address.country\"><md-option ng-repeat=\"country in lead.countries track by $index\" ng-value=\"::country[\'alpha-2\']\">{{::country.name}}</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>13. Address Type</label><md-select name=\"address_type\" ng-model=\"$ctrl.lead.address.type\"><md-option>Residential</md-option><md-option>Storefront</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>14. How Many Locations?</label><md-select name=\"number_of_locations\" ng-model=\"$ctrl.lead.number_of_locations\"><md-option>1</md-option><md-option>2</md-option><md-option>3</md-option><md-option>4+</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>15. Phone number for Zoek to contact you</label><input name=\"phone\" ng-model=\"$ctrl.lead.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>16. Fax Number</label><input name=\"fax\" ng-model=\"$ctrl.lead.fax\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>17. Desired URL</label><input name=\"desired_url\" ng-model=\"$ctrl.lead.desired_url\" type=\"text\" http-prefix> <a href=\"https://www.godaddy.com/\" target=\"_blank\"><md-button class=\"md-primary md-button\">Check Availability</md-button></a></md-input-container></div><div flex=\"50\"><div class=\"md-block\"><payment-methods label=\"18. Payments Accepted\" name=\"payment_methods\" ng-model=\"$ctrl.lead.payments_accepted\"></payment-methods></div></div><div flex=\"100\"><business-hours hours=\"$ctrl.lead.business_hours\"></business-hours></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>20. License No.</label><input name=\"license_no\" ng-model=\"$ctrl.lead.license_no\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>21. Awards and Accolades</label><input name=\"awards_and_accolades\" ng-model=\"lead.lead.awards_and_accolades\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>22. Certifications</label><input name=\"certifications\" ng-model=\"$ctrl.lead.certifications\" type=\"text\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>23. Year Established</label><input name=\"years_in_business\" ng-model=\"$ctrl.lead.years_in_business\" type=\"text\" ui-mask=\"9999\" ui-mask-placeholder-char=\"space\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>24. Number of Employees</label><input name=\"number_of_employees\" ng-model=\"$ctrl.lead.number_of_employees\" type=\"text\"></md-input-container></div><div flex=\"50\"><languages-spoken label=\"25. Languages Spoken\" name=\"languages_spoken\" ng-model=\"$ctrl.lead.languages_spoken\"></languages-spoken></div><div flex=\"50\"><parking-available label=\"26. Parking Available\" name=\"parking_available\" ng-model=\"$ctrl.lead.parking_available\"></parking-available></div><div flex=\"50\"><div class=\"md-block\"><label>27. Run Special Promotions (e.g. Happy Hour, Half Off, $10 Off First Service, Referalls, etc)</label><div layout-margin><md-radio-group layout=\"row\" class=\"u-margin--top\" ng-model=\"$ctrl.lead.run_special_promotions\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group><br><md-input-container class=\"md-block\" flex ng-show=\"$ctrl.lead.run_special_promotions\"><label>Special Promotions</label><input name=\"special_promotion\" ng-model=\"$ctrl.lead.special_promotion\" type=\"text\" md-maxlength=\"40\"></md-input-container></div></div></div></div></md-content></md-tab><md-tab label=\"Payment\"><md-content layout-padding><h1 class=\"md-subheader md-primary\">Billing Address</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex=\"50\"><label>Billing Address 1</label><input name=\"address1\" type=\"text\" ng-model=\"$ctrl.billing.line1\"></md-input-container><md-input-container flex=\"50\"><label>Address 2</label><input name=\"address2\" type=\"text\" ng-model=\"$ctrl.billing.line2\"></md-input-container><md-input-container flex=\"25\"><label>City</label><input name=\"city\" type=\"text\" ng-model=\"$ctrl.billing.city\"></md-input-container><div flex=\"25\"><select-state name=\"state\" label=\"State\" ng-model=\"$ctrl.billing.state\" ng-messages=\"editLeadForm.state.$error\"></select-state></div><md-input-container flex=\"25\"><label>Postal</label><input name=\"postal\" type=\"text\" ng-model=\"$ctrl.billing.postal\" postal-lookup address=\"$ctrl.billing\"></md-input-container><div flex=\"25\"><select-country name=\"country\" label=\"Country\" ng-model=\"$ctrl.billing.country\" ng-messages=\"editLeadForm.country.$error\"></select-country></div></div><h1 class=\"md-subheader md-primary\">Credit Card</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex><label>Name on card</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.card.name\"></md-input-container><md-input-container flex><label>Card Number</label><input name=\"card_number\" type=\"text\" ng-model=\"$ctrl.card.number\" ui-mask=\"9999 9999 9999 999?9\" ui-mask-placeholder-char=\"space\" credit-card><div ng-messages=\"editLeadForm.card_number.$error\"><div ng-message=\"creditCard\">Invalid credit card</div></div></md-input-container><md-input-container flex><label>Exp Date</label><input name=\"exp_date\" type=\"text\" ng-model=\"$ctrl.card.exp_date\" placeholder=\"MM / YY\" ui-mask=\"99 / 99\" credit-card-exp><div ng-messages=\"editLeadForm.exp_date.$error\"><div ng-message=\"creditCardExp\">Expired</div></div></md-input-container><md-input-container flex><label>CVC</label><input name=\"cvc\" type=\"text\" ng-model=\"$ctrl.card.cvc\" ui-mask=\"999?9\" ui-mask-placeholder-char=\"space\"></md-input-container></div></md-content></md-tab></md-tabs></md-content></form><div style=\"position:fixed; top: 50px; right: 2%; z-index: 9\" ng-show=\"!!$ctrl.lead.id\"><md-button class=\"md-fab md-primary\" aria-label=\"Notes\" ng-click=\"$ctrl.openNotesModal($event)\"><md-tooltip>Notes</md-tooltip><md-icon md-svg-src=\"/assets/notes_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Hot Button\" ng-click=\"$ctrl.openHotButtonModal($event)\"><md-tooltip>Hot Button</md-tooltip><md-icon md-svg-src=\"/assets/fire_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Disposition\" ng-click=\"$ctrl.openDispositionModal($event)\"><md-tooltip>Disposition</md-tooltip><md-icon md-svg-src=\"/assets/pencil_icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-primary\" aria-label=\"Send Proposal\" ng-click=\"$ctrl.openProposalModal($event)\"><md-tooltip>Send Proposal</md-tooltip><md-icon md-svg-src=\"/assets/mail_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/reset-password/reset-password.html","<form name=\"resetPasswordForm\" ng-submit=\"resetPasswordForm.$valid && resetPassword.resetPassword()\" accessible-form novalidate><h1 class=\"md-title\">Reset Password</h1><md-input-container class=\"md-block\"><label>Password</label><input name=\"password\" ng-model=\"resetPassword.newPassword\" type=\"password\" minlength=\"6\" maxlength=\"20\" required><div ng-messages=\"resetPasswordForm.password.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"minlength\">Minimum of 6 characters</div><div ng-message=\"maxlength\">Maximum of 20 characters</div></div></md-input-container><md-input-container class=\"md-block\"><label>Confirm Password</label><input name=\"confirmPassword\" ng-model=\"resetPassword.confirmPassword\" type=\"password\" match=\"{{resetPassword.newPassword}}\" required><div ng-messages=\"resetPasswordForm.confirmPassword.$error\"><div ng-message=\"required\">Required.</div><div ng-message=\"match\">Password does not match</div></div></md-input-container><div layout=\"column\"><button class=\"md-button md-raised md-primary\" ladda=\"resetPassword.loading\" type=\"submit\">Reset</button> <a class=\"md-body-1\" ui-sref=\"root_login.login\" style=\"text-align: center; margin-top: 8px\">Back</a></div></form>");
$templateCache.put("app/root/root.html","<md-progress-linear ng-show=\"$ctrl.navigation.transitioning\" md-mode=\"indeterminate\" style=\"position: fixed; z-index: 9\"></md-progress-linear><md-toolbar class=\"md-medium-tall c-root__header\"><div class=\"md-toolbar-tools\"><img class=\"c-root__logo\" src=\"../assets/logo.png\" layout-align=\"start\"> <span flex></span> <a class=\"md-button\" href=\"https://www.join.me/\" target=\"_blank\" style=\"color: #ffffff\">Join.Me</a> <button class=\"md-button\" ng-click=\"$ctrl.logout()\" style=\"color: #ffffff\">Logout</button></div></md-toolbar><div class=\"authenticated\" layout=\"row\"><sidebar class=\"authenticated__sidebar\"></sidebar><div flex ui-view></div></div>");
$templateCache.put("app/root-login/root-login.html","<md-progress-linear ng-show=\"stateChangeStart\" md-mode=\"indeterminate\" style=\"position: fixed\"></md-progress-linear><div class=\"c-root-login\" flex layout=\"column\" layout-align=\"center center\"><img layout-margin src=\"../assets/logo.png\"><md-content class=\"c-root-login__body md-whiteframe-20dp\" layout-padding layout=\"column\" ui-view></md-content></div>");
$templateCache.put("app/sae-pipeline/sae-pipeline.html","<div class=\"u-margin\"><sae-pipeline-list title=\"SAE Pipeline\" clients=\"$ctrl.clients\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></sae-pipeline-list></div>");
$templateCache.put("app/unauthorized/unauthorized.html","<md-content layout=\"column\" layout-align=\"center center\" style=\"min-height: 100%\"><h1><i class=\"fa fa-5x fa-exclamation-triangle\" aria-hidden=\"true\"></i></h1><h2>Unauthorized Access!</h2></md-content>");
$templateCache.put("app/web-leads/web-leads.html","<div class=\"u-margin\"><leads-list title=\"Web Leads\" leads=\"$ctrl.leads\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></leads-list></div>");
$templateCache.put("app/xfer/xfer.html","<div class=\"u-margin\"><xfer-list title=\"Xfer\" leads=\"$ctrl.leads\" query=\"$ctrl.$stateParams\" on-select=\"$ctrl.handleSelect($event)\" on-filter=\"$ctrl.handleFilter($event)\" on-export=\"$ctrl.handleExport($event)\"></xfer-list></div>");
$templateCache.put("app/components/add_new_staff_modal/add_new_staff_modal.html","<md-dialog><form name=\"staffForm\" ng-submit=\"staffForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Add New Staff</p></div></md-toolbar><md-dialog-content><div layout-margin><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>First Name</label><input name=\"first_name\" type=\"text\" ng-model=\"$ctrl.staff.first_name\" required><div ng-messages=\"staffForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Last Name</label><input name=\"last_name\" type=\"text\" ng-model=\"$ctrl.staff.last_name\" required><div ng-messages=\"staffForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Email</label><input name=\"email\" type=\"email\" ng-model=\"$ctrl.staff.email\" required><div ng-messages=\"staffForm.email.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"email\">Invalid email</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Password</label><input name=\"password\" type=\"text\" ng-model=\"$ctrl.staff.password\" ng-minlength=\"6\" ng-maxlength=\"20\" required><div ng-messages=\"staffForm.password.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"minlength\">Minimum of 6 characters</div><div ng-message=\"maxlength\">Maximum of 20 characters</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Roles</label><md-select ng-model=\"$ctrl.staff.role_id\" required><md-option ng-repeat=\"role in $ctrl.roles track by $index\" ng-value=\"role.id\">{{::role.name | capitalize}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Team</label><md-select ng-model=\"$ctrl.staff.team\"><md-option ng-repeat=\"team in $ctrl.teams track by $index\" ng-value=\"team\">{{::team}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Add Staff</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/app_a_la_carte_disclosure_modal/app_a_la_carte_disclosure_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Finish & Charge</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-dialog-content><md-content layout-padding><h4 class=\"md-subheader\">Terms and Conditions of Service</h4><p class=\"md-body-1\">Thank you <strong>{{::$ctrl.user.name}}</strong> for deciding to take the next step in making your business mobile friendly with Zoek Marketing.</p><p class=\"md-body-1\">Before we get your account activated and begin development on your app we need to go over a few disclosures and terms of your new service for your protection. The following will be recorded for quality assurance and training purposes, is this acceptable with you?</p><p class=\"md-body-1\">This part is very important: The charge on your account will appear as Zoek or Web Group and will be for <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> today and <strong>{{$ctrl.user.getSubscription().monthly_fee | currency}}</strong> per month after that. Is this understood?</p><p class=\"md-body-1\">Great, next we need to verify that you are the legal signatory on (checking account/card number) ending in <strong>{{$ctrl.paymentInfo.card.number.substr(-4, 4)}}</strong>, is this correct? Please state your full name as it appears on the account.</p><p class=\"md-body-1\">Thank you for verifying your identity with me. The next step only takes a few minutes, this portion is to better educate you about our services to make sure that you understand the specifics of our service so you know what to expect and how to gauge the effectiveness of your new campaign.</p><p class=\"md-body-1\">Does this make sense so far?</p><p class=\"md-body-1\">Great - you should see a proof of your app within 5 days after speaking to your design coordinator. Once this proof is approved by you the app will become live on the Google and on the Apple App Store within two business weeks following approval. If we do not hear back from you within a few days after submitting the proof for your approval we will assume you approve and push it through to the app and play store.</p><p class=\"md-body-1\">Do you have any questions so far?</p><p class=\"md-body-1\">Great – we are almost done!</p><p class=\"md-body-1\">For your convenience every account at Zoek is kept on auto-pay via the account of your choosing and will be billed the <strong>{{$ctrl.moment().format(\'Do\')}}</strong> of every month. Your package is <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> today to register your account and then you will pay <strong>{{$ctrl.user.getSubscription().monthly_fee | currency}}</strong> per month after that every month. The agreement is month to month with no cancellation fees and only a minimum 7 days’ notice of cancellation is required.</p><p class=\"md-body-1\">Is this understood?</p><p class=\"md-body-1\">Lastly, I just want to double check and make sure you have all of our information, should you need to contact us in the future. Our toll-free number is 888-737-9635 and you may follow the voice prompts for whatever questions you may have on your account. You may also email apps@gozoek.com with any general questions you may have. When you call or email - please keep in mind that our hours of operation are from 7:00am to 4:30pm Pacific.</p><p class=\"md-body-1\">When I transfer you please make sure to ask the agent about our referral and partner programs, you can get free service, upgrades, and more by taking advantage of it.</p><p class=\"md-body-1\">Do you have any more questions for me before I transfer you over to get your account going? Thanks again for choosing Zoek, and welcome to the family. <span style=\"font-style: italic\">Transfer Client</span></p></md-content></md-dialog-content><md-dialog-actions><md-checkbox ng-model=\"$ctrl.readPrompt\" ng-true-value=\"true\" ng-false-value=\"false\" style=\"margin-bottom: 0\">Read Prompt</md-checkbox><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" ng-disabled=\"$ctrl.loading\">Cancel</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.confirm()\" ng-disabled=\"!$ctrl.readPrompt\" ladda=\"$ctrl.loading\">Charge Card</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/apply_hours_modal/apply_hours_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Apply Hours</p></div></md-toolbar><md-dialog-content><md-content layout=\"column\" layout-gt-sm=\"row\" layout-padding><md-checkbox ng-model=\"$ctrl.hours[0]\" ng-true-value=\"true\" ng-false-value=\"false\">Sunday</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[1]\" ng-true-value=\"true\" ng-false-value=\"false\">Monday</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[2]\" ng-true-value=\"true\" ng-false-value=\"false\">Tuesday</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[3]\" ng-true-value=\"true\" ng-false-value=\"false\">Wednesday</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[4]\" ng-true-value=\"true\" ng-false-value=\"false\">Thursday</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[5]\" ng-true-value=\"true\" ng-false-value=\"false\">Friday</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[6]\" ng-true-value=\"true\" ng-false-value=\"false\">Saturday</md-checkbox></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.apply()\">Apply</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/billing_address_modal/billing_address_modal.html","<md-dialog flex-gt-sm=\"50\"><form name=\"billingForm\" ng-submit=\"billingForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Billing Address</p></div></md-toolbar><md-dialog-content><div layout-margin><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>Address Line 1</label><input name=\"line1\" ng-model=\"$ctrl.user.getBilling().line1\" type=\"text\" required><div ng-messages=\"billingForm.line1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Line 2</label><input name=\"address2\" ng-model=\"$ctrl.user.getBilling().line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label>City</label><input name=\"city\" ng-model=\"$ctrl.user.getBilling().city\" type=\"text\" required><div ng-messages=\"billingForm.city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"25\"><select-state name=\"state\" label=\"State\" ng-model=\"$ctrl.user.getBilling().state\" ng-messages=\"billingForm.state.$error\" ng-required=\"true\"></select-state></div><md-input-container class=\"md-block\" flex=\"25\"><label>Postal</label><input name=\"postal\" ng-model=\"$ctrl.user.getBilling().postal\" type=\"text\" postal-lookup address=\"$ctrl.user.getBilling()\" required><div ng-messages=\"billingForm.postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"25\"><select-country name=\"country\" label=\"Country\" ng-model=\"$ctrl.user.getBilling().country\" ng-messages=\"billingForm.country.$error\" ng-required=\"true\"></select-country></div></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Okay</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/business_hours/business_hours.html","<div layout=\"column\">Hours<div layout-padding><p class=\"md-caption\">Sunday</p><md-checkbox ng-model=\"$ctrl.hours[0].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[0].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[0].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[0].opens\"></md-input-container><md-input-container><label>Closes</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[0].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[0])\">Apply Hours</md-button></div></div></div><div layout-padding><p class=\"md-caption\">Monday</p><md-checkbox ng-model=\"$ctrl.hours[1].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[1].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[1].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[1].opens\"></md-input-container><md-input-container><label>Closes</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[1].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[1])\">Apply Hours</md-button></div></div></div><div layout-padding><p class=\"md-caption\">Tuesday</p><md-checkbox ng-model=\"$ctrl.hours[2].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[2].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[2].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[2].opens\"></md-input-container><md-input-container><label>Closes</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[2].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[2])\">Apply Hours</md-button></div></div></div><div layout-padding><p class=\"md-caption\">Wednesday</p><md-checkbox ng-model=\"$ctrl.hours[3].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[3].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[3].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[3].opens\"></md-input-container><md-input-container><label>Close</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[3].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[3])\">Apply Hours</md-button></div></div></div><div layout-padding><p class=\"md-caption\">Thursday</p><md-checkbox ng-model=\"$ctrl.hours[4].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[4].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[4].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[4].opens\"></md-input-container><md-input-container><label>Close</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[4].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[4])\">Apply Hours</md-button></div></div></div><div layout-padding><p class=\"md-caption\">Friday</p><md-checkbox ng-model=\"$ctrl.hours[5].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[5].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[5].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[5].opens\"></md-input-container><md-input-container><label>Closes</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[5].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[5])\">Apply Hours</md-button></div></div></div><div layout-padding><p class=\"md-caption\">Saturday</p><md-checkbox ng-model=\"$ctrl.hours[6].closed\">Closed</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[6].is_24_hours\">24 Hours</md-checkbox><md-checkbox ng-model=\"$ctrl.hours[6].by_appointment\">By Appointment</md-checkbox><div layout=\"row\"><md-input-container><label>Opens</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[6].opens\"></md-input-container><md-input-container><label>Close</label><input ui-timepicker type=\"text\" ng-model=\"$ctrl.hours[6].closes\"></md-input-container><div><md-button class=\"md-raised\" ng-click=\"$ctrl.applyAllHours($event, $ctrl.hours[6])\">Apply Hours</md-button></div></div></div></div>");
$templateCache.put("app/components/cancel_modal/cancel_modal.html","<md-dialog><form name=\"cancelForm\" ng-submit=\"cancelForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Cancel</p></div></md-toolbar><md-dialog-content><div layout-margin><div layout=\"column\"><md-input-container class=\"md-block\"><label>Reason for cancel</label><input name=\"reason\" type=\"text\" ng-model=\"$ctrl.reason\" required><div ng-messages=\"cancelForm.reason.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Okay</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/change_password_modal/change_password_modal.html","<md-dialog flex=\"45\"><form name=\"changePasswordForm\" ng-submit=\"changePasswordForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Change Password</p></div></md-toolbar><md-dialog-content><md-content layout-padding><md-input-container class=\"md-block\"><label>Password</label><input name=\"password\" ng-model=\"$ctrl.password\" type=\"password\" minlength=\"6\" maxlength=\"20\" required><div ng-messages=\"changePasswordForm.password.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"minlength\">Minimum of 6 characters</div><div ng-message=\"maxlength\">Maximum of 20 characters</div></div></md-input-container><md-input-container class=\"md-block\"><label>Confirm Password</label><input name=\"confirmPassword\" ng-model=\"$ctrl.password_confirmation\" type=\"password\" match=\"{{$ctrl.password}}\" required><div ng-messages=\"changePasswordForm.confirmPassword.$error\"><div ng-message=\"required\">Required.</div><div ng-message=\"match\">Password does not match</div></div></md-input-container></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"$ctrl.loading\">Change</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/change_status_modal/change_status_modal.html","<md-dialog flex=\"25\"><form name=\"statusForm\" ng-submit=\"statusForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Change Client Status</p></div></md-toolbar><md-dialog-content><br><div layout-margin><select-status name=\"status\" label=\"Select Status\" ng-model=\"$ctrl.status\" ng-required=\"true\"></select-status><br><md-input-container class=\"md-block\" ng-show=\"$ctrl.status === \'failed_compliance\' || $ctrl.status === \'cancelled\'\"><label>Reason</label><input name=\"reason\" type=\"text\" ng-model=\"$ctrl.reason\" ng-required=\"$ctrl.status === \'failed_compliance\' || $ctrl.status === \'cancelled\'\"><div ng-messages=\"statusForm.reason.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Change</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/check_modal/check_modal.html","<md-dialog flex-gt-sm=\"50\"><form name=\"checkForm\" ng-submit=\"checkForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Checking</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-dialog-content><div layout-margin><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex><label>Bank</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.user.getChecking().bank\" required><div ng-messages=\"checkForm.bank.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex><label>Account Number</label><input name=\"account_number\" type=\"text\" ng-model=\"$ctrl.user.getChecking().account\" required><div ng-messages=\"checkForm.account_number.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex><label>Routing Number</label><input name=\"routing_number\" type=\"text\" ng-model=\"$ctrl.user.getChecking().routing\" required><div ng-messages=\"checkForm.routing_number.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Okay</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/clients_list/clients_list.html","<md-toolbar><div class=\"md-toolbar-tools\"><p flex>{{$ctrl.title || \'Clients\'}}</p></div></md-toolbar><md-content layout-padding><form name=\"filterForm\" ng-submit=\"filterForm.$valid && $ctrl.handleFilter()\"><h1 class=\"md-subheader md-primary\">Filters</h1><div><md-input-container><label>Client ID</label><input name=\"client_no\" ng-model=\"$ctrl.query.client_no\" type=\"text\"></md-input-container><md-input-container><label>First Name</label><input name=\"first_name\" ng-model=\"$ctrl.query.first_name\" type=\"text\"></md-input-container><md-input-container><label>Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.query.last_name\" type=\"text\"></md-input-container><md-input-container><label>Email</label><input name=\"email\" ng-model=\"$ctrl.query.email\" type=\"text\"></md-input-container><md-input-container><label>Phone</label><input name=\"phone\" ng-model=\"$ctrl.query.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container><label>Business</label><input name=\"business\" ng-model=\"$ctrl.query.business\" type=\"text\"></md-input-container><md-input-container><label>Address Street</label><input name=\"address\" ng-model=\"$ctrl.query.address_line1\" type=\"text\"></md-input-container><md-datepicker name=\"created_from\" ng-model=\"$ctrl.query.created_from\" md-max-date=\"$ctrl.query.created_to\" md-placeholder=\"Created from\"></md-datepicker><md-datepicker name=\"created_to\" ng-model=\"$ctrl.query.created_to\" md-placeholder=\"Create to\" md-min-date=\"$ctrl.query.created_from\"></md-datepicker><md-input-container><label>Progress</label><md-select name=\"progress\" ng-model=\"$ctrl.query.progress\"><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"num in [0,1,2,3,4,5,6,7,8,9,10,11,12,13]\" ng-value=\"num\">{{num}}</md-option></md-select></md-input-container><select-provisioner name=\"provisioner\" label=\"Provisioner\" ng-model=\"$ctrl.query.pinner_id\"></select-provisioner><select-sales-rep name=\"sales_representative\" label=\"Sales Representative\" ng-model=\"$ctrl.query.closer_id\"></select-sales-rep><select-status name=\"state\" label=\"Status\" ng-model=\"$ctrl.query.status\"></select-status><select-lead-type name=\"lead_type\" label=\"Lead Type\" ng-model=\"$ctrl.query.lead_type\"></select-lead-type><select-business-type name=\"business_type\" label=\"Business Type\" ng-model=\"$ctrl.query.business_type\"></select-business-type><select-package name=\"package\" label=\"Package Type\" ng-model=\"$ctrl.query.package_id\"></select-package></div><md-button class=\"md-raised\" type=\"submit\">Filter</md-button><md-button class=\"md-raised\" type=\"button\" ng-click=\"$ctrl.handleExport()\">Export</md-button></form><md-table-container><table md-table md-progress=\"$ctrl.filtering\"><thead md-head md-order=\"$ctrl.query.order\" md-on-reorder=\"$ctrl.onReorder\"><tr md-row><th md-column md-numeric md-order-by=\"client_no\"><span>ID</span></th><th md-column md-order-by=\"first_name\"><span>Name</span></th><th md-column md-order-by=\"business\"><span>Business</span></th><th md-column><span>Close Type</span></th><th md-column><span>Package Type</span></th><th md-column><span>Monthly</span></th><th md-column md-order-by=\"pinner_id\"><span>Provisioner</span></th><th md-column md-order-by=\"progress\"><span>Progress</span></th><th md-column md-order-by=\"status\"><span>Status</span></th><th md-column md-order-by=\"updated_at\"><span>Last Updated</span></th><th md-column md-order-by=\"created_at\"><span>Created</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr u-cursor--pointer\" md-row ng-click=\"$ctrl.handleSelect(client)\" ng-repeat=\"client in $ctrl.clients.data\"><td md-cell>{{::client.client_no}}</td><td md-cell>{{::client.name}}</td><td md-cell>{{::client.business}}</td><td md-cell>{{::client.close_type}}</td><td md-cell>{{::client.subscription.package.name}} {{::client.subscription.getPlan().name}}</td><td md-cell><span ng-style=\"!!client.subscription.custom_price && {\'text-decoration\':\'line-through\'}\">{{::client.subscription.monthly_fee | currency}} </span><span>{{::client.subscription.custom_price | currency}}</span></td><td md-cell>{{::client.pinner.name}}</td><td md-cell>{{::client.progress || 0}}</td><td md-cell><span class=\"status--{{::client.status}}\">{{::client.status | capitalize}}</span></td><td md-cell>{{::client.updated | date : \'MMM dd, yyyy h:mm a\'}}</td><td md-cell>{{::client.created | date : \'MMM dd, yyyy h:mm a\'}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.clients.meta.pagination.per_page\" md-page=\"$ctrl.clients.meta.pagination.current_page\" md-total=\"{{$ctrl.clients.meta.pagination.total}}\" md-options=\"[5, 10, 15, 50, 100, 200]\" md-on-paginate=\"$ctrl.onPaginate\" md-page-select></md-table-pagination></md-content>");
$templateCache.put("app/components/closer_agreement_modal/closer_agreement_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Finish & Charge</p></div></md-toolbar><md-dialog-content><md-content layout-padding><h4 class=\"md-subheader\">Terms and Conditions of Service</h4><p class=\"md-body-1\">Before I transfer you over I just need to go over a couple points of service to make sure we are all on the same page. This will only take a couple minutes and will review and inform you about our services as to make sure you understand and know what to expect allowing you to see the effectiveness your new digital marketing plan.</p><p class=\"md-body-1\">First, I need to verify for your protection that you are the legal signatory on card ending in <strong>{{::$ctrl.paymentInfo.card.number.substr(-4, 4)}}</strong>, is this correct? Please say your name as it is listed on your account. Thank you!</p><p class=\"md-body-1\">To recap: Zoek is a digital marketing firm - we are not Google, not Yahoo, or Bing. We have no business relationship with any of the search engines mentioned. To ensure we are clear, the charge on you statement will appear as Zoek. Is this understood? Great.</p><p class=\"md-body-1\">The marketing package you have enrolled with today is our <strong>{{::$ctrl.user.getSubscription().getPackage().name}}</strong>. Your package includes customized search engine optimization for the local, organic, and mobile levels of Google, Yahoo, and Bing. We also include up to 35+ various online directories such as yellow pages, white pages, and manta – just to name a few. We will optimize your business for <strong>{{::$ctrl.user.getSubscription().number_of_cities}}</strong> cities and up to ten unique keywords.</p><p class=\"md-body-1\">Is this understood? Great!</p><p class=\"md-body-1\">The Zoek marketing experts will begin a labor-intensive process of programming and coding exclusively for your custom C.A.P site! The C.A.P. site is designed and programmed for optimization so it can be found on page one. At your direction, we may link your existing website to the your new C.A.P. via hyperlinks and call-to-action headers. Our optimization experts will be servicing and monitoring your account so that you may experience the most optimal results possible.</p><p class=\"md-body-1\">Your package today includes our Zoek Promise which states that <strong>{{::$ctrl.user.business}}</strong> will be found on the front page of the major Search Engines; Google, Yahoo, Bing for a minimum of two keywords within 55 days of the date of your contracted service agreement is signed and returned. You agree to contact Zoek if you think your business is not ranking on the front page at which point a representative will help you find your front page placement. If upon review it is confirmed that your business is not ranking you will be provided with the next month of service at no charge. You agree to give Zoek 48 hours to achieve your front- page rankings.</p><ul style=\"list-style-type: upper-alpha; margin-left: 50px\" layout-margin><li><p class=\"md-body-1\">Monthly Contracts: Your package today is <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> ({{$ctrl.user.getSubscription().monthly_fee | currency}} plus {{$ctrl.user.getSubscription().setup_fee | currency}} setup fee) = <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> total. You will then pay <strong>{{$ctrl.user.getSubscription().monthly_fee | currency}}</strong> automatically every 30 days, until <strong>{{$ctrl.user.getSubscription().getBillEndDate()}}</strong>. If you wish to cancel at the conclusion of the agreed {{$ctrl.user.getSubscription().getPlan().payment_term}} month contracted term, you may do so at any time without penalty. A short notice of seven days prior to the end of the term is required. In order to cancel this contractual agreement with Zoek you agree and understand you will be held responsible for paying half of the remaining balance due to Zoek for your account. You agree to sign and send back an electronic signature verifying your acknowledgment of any type cancellation.</p></li></ul><p class=\"md-body-1\">Before we wrap up I’d like to give you all of our contact info. Our toll-free number is 888- 737-9635 and you may follow the voice prompts for whatever questions you may have on your account. You may also email us for any general questions you may have to help@gozoek.com. Do you have any further questions for me before I transfer you over to finish getting your account set-up?</p><p class=\"md-body-1\">Thank you so much and welcome to Zoek! Hold on one second while I transfer you over.</p></md-content></md-dialog-content><md-dialog-actions><md-checkbox ng-model=\"$ctrl.readPrompt\" ng-true-value=\"true\" ng-false-value=\"false\" style=\"margin-bottom: 0\">Read Prompt</md-checkbox><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" ng-disabled=\"$ctrl.loading\">Cancel</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.confirm()\" ng-disabled=\"!$ctrl.readPrompt\" ladda=\"$ctrl.loading\">Charge Card</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/credit_card/credit_card.html","<form name=\"creditCardForm\"><div layout=\"row\"><md-subheader class=\"md-primary\">Credit Card</md-subheader><md-button ng-click=\"$ctrl.updating = true\" ng-hide=\"$ctrl.updating\">Update</md-button></div><div class=\"md-body-1\" layout-margin ng-hide=\"$ctrl.updating\"><p>{{$ctrl.card.name}}</p><p>{{$ctrl.card.type | capitalize}} ending in {{$ctrl.card.last4digits}}</p><p>{{$ctrl.card.exp_month}}/{{$ctrl.card.exp_year}}</p></div><div layout-margin ng-show=\"$ctrl.updating\"><credit-card-form card=\"$ctrl.card\" form=\"creditCardForm\"></credit-card-form></div></form>");
$templateCache.put("app/components/credit_card_modal/credit_card_modal.html","<md-dialog flex-gt-sm=\"50\"><form name=\"creditCardForm\" ng-submit=\"creditCardForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Credit Card</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-dialog-content><div layout-margin><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex><label>Name on card</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.user.getCreditCard().name\" required><div ng-messages=\"creditCardForm.name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex><label>Card Number</label><input name=\"card_number\" type=\"text\" ng-model=\"$ctrl.user.getCreditCard().number\" ui-mask=\"9999 9999 9999 999?9\" ui-mask-placeholder-char=\"space\" credit-card required><div ng-messages=\"creditCardForm.card_number.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"creditCard\">Invalid credit card</div></div></md-input-container><md-input-container flex><label>Exp Date</label><input name=\"exp_date\" type=\"text\" ng-model=\"$ctrl.user.getCreditCard().exp_date\" placeholder=\"MM / YY\" ui-mask=\"99 / 99\" credit-card-exp required><div ng-messages=\"creditCardForm.exp_date.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"creditCardExp\">Expired</div></div></md-input-container><md-input-container flex><label>CVC</label><input name=\"cvc\" type=\"text\" ng-model=\"$ctrl.user.getCreditCard().cvc\" ui-mask=\"999?9\" ui-mask-placeholder-char=\"space\" required><div ng-messages=\"creditCardForm.cvc.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Okay</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crm/crm.html","<md-toolbar><div class=\"md-toolbar-tools\"><p flex>CRM</p></div></md-toolbar><md-content layout-padding><div><p><span>Flash Sale Status:</span> {{$ctrl.flashSaleStatus ? \'active\' : \'inactive\' | capitalize}}</p><button class=\"md-button md-raised\" ng-click=\"$ctrl.toggleFlashSaleStatus()\" ladda=\"$ctrl.updatingFlashStatus\">{{$ctrl.flashSaleStatus ? \'Deactivate\' : \'Activate\'}}</button></div></md-content>");
$templateCache.put("app/components/disposition_modal/disposition_modal.html","<md-dialog flex=\"25\"><form name=\"dispositionForm\" ng-submit=\"dispositionForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Set Disposition</p></div></md-toolbar><md-dialog-content><br><div layout-margin><md-input-container class=\"md-block\"><label>Select Disposition</label><md-select ng-model=\"$ctrl.disposition\" required><md-option ng-repeat=\"disposition in $ctrl.dispositions\" ng-value=\"disposition\">{{::disposition}}</md-option></md-select><div ng-messages=\"dispositionForm.disposition.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" ladda=\"$ctrl.loading\" type=\"submit\">Set</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/edit_staff_rep/edit_staff_rep.html","<h4 class=\"md-subheader\">{{$ctrl.title}}</h4><p ng-hide=\"$ctrl.editing\"><a class=\"md-body-1 md-primary\" href=\"\" ng-click=\"$ctrl.overrideToAllowChangeRep($event)\">{{$ctrl.rep.name || \'N/A\'}}</a></p><div layout=\"row\" ng-show=\"$ctrl.editing\"><md-select name=\"salesRep\" ng-model=\"$ctrl.rep\"><md-option ng-value=\"rep\" ng-repeat=\"rep in ::$ctrl.reps track by rep.id\">{{::rep.name | capitalize}}</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"$ctrl.editing = false\"><md-icon md-svg-icon=\"/assets/cross_icon.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"$ctrl.changeRep($ctrl.rep)\"><md-icon md-svg-icon=\"/assets/check_icon.svg\"></md-icon></md-button></div>");
$templateCache.put("app/components/edit_subscription_modal/edit_subscription_modal.html","<md-dialog><form name=\"editSubscriptionForm\" ng-submit=\"$ctrl.updateSubscription()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-title\">Edit Subscription</h2></div></md-toolbar><md-dialog-content><div layout-padding><h4 class=\"md-subheader\">Add Ons</h4><div ng-repeat=\"addOn in $ctrl.addOns.data\n        | remove2499listingSyncAddOn\n        | remove2999ListingSyncAddOnForSomePackages : $ctrl.subscription.package_id\n        | removeFreeCallTrackingAddOnForSomePackages : $ctrl.subscription.package_id\n        | removeMobileAppAddOnsForMobilePackage : $ctrl.subscription.package_id\n        | removeSetupFeeAddOns\n        | freeMobileApp: $ctrl.subscription.package_id\n        | freeZocialMedia: $ctrl.subscription.package_id\n        | professionalMobileApp: $ctrl.subscription.package_id\n        | removeMonitorAppOnly: $ctrl.subscription.package_id\"><md-checkbox ng-disabled=\"!$ctrl.canAddAddOn(addOn.id)\" ng-checked=\"$ctrl.subscriptionHasAddOn(addOn.id)\" ng-click=\"$ctrl.toggle(addOn.id)\">{{::addOn.name}}</md-checkbox></div><md-input-container class=\"md-block\"><label>Select Package</label><md-select ng-model=\"$ctrl.subscription.package_id\" ng-change=\"$ctrl.onChangePackage()\" required><md-option ng-repeat=\"package in $ctrl.packages.data\" ng-value=\"package.id\"><span class=\"md-body-1\">{{::package.name}}</span></md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>Select Type</label><md-select ng-model=\"$ctrl.subscription.plan_id\" ng-change=\"$ctrl.handleSelectPackageType()\" required><md-option ng-repeat=\"plan in $ctrl.plans\n              | remove2499listingSyncPlan\n              | flashSaleEditSubscription\n              | removeInactivePlans\" ng-value=\"plan.id\"><span class=\"md-body-1\">{{\'Package \' + plan.name}}</span> <span class=\"md-body-1\" ng-show=\"plan.payment_term\">{{\': \' + plan.payment_term + \' Months\'}}</span></md-option></md-select></md-input-container><div class=\"c-customize-package-modal__cost\"><span class=\"c-customize-package-modal__total\">Total: </span><span class=\"c-customize-package-modal__price\">{{$ctrl.subscription.monthly_fee || 0 | currency}}/month + {{$ctrl.subscription.deposit_fee || 0 | currency}} Deposit + {{$ctrl.subscription.setup_fee || 0 | currency}} Setup</span></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Save</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/export_modal/export_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p class=\"md-title\">Export</p></div></md-toolbar><md-dialog-content><md-content layout-padding><p class=\"md-body-1\" ng-show=\"!$ctrl.progress.error && $ctrl.progress.started && !$ctrl.progress.finished\">Exporting...</p><p class=\"md-body-1\" ng-show=\"!$ctrl.progress.error && $ctrl.progress.finished\">Finished...</p><p class=\"md-body-1\" ng-show=\"$ctrl.progress.error\">Error...</p><md-progress-linear md-mode=\"determinate\" value=\"{{($ctrl.progress.completed / $ctrl.progress.total) * 100}}\"></md-progress-linear><p class=\"md-caption\">Exported {{$ctrl.progress.completed}} / {{$ctrl.progress.total}}</p><p class=\"md-body-1\" ng-show=\"$ctrl.progress.error\">{{$ctrl.progress.error}}</p></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\">Close</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/hot_buttons_modal/hot_buttons_modal.html","<md-dialog><form name=\"hotButtonsForm\" ng-submit=\"$ctrl.save()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Hot Buttons</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-dialog-content><md-content layout-padding><div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"25\" ng-repeat=\"hot_button in $ctrl.hot_buttons track by $index\"><md-checkbox ng-checked=\"$ctrl.exists(hot_button, $ctrl.user_hot_buttons)\" ng-click=\"$ctrl.toggle(hot_button, $ctrl.user_hot_buttons)\">{{::hot_button}}</md-checkbox></div></div></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"$ctrl.loading\">Save</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/input_cities/input_cities.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" ng-repeat=\"n in [] | range:$ctrl.number track by $index\"><label>City {{$index + 1}}</label><input type=\"text\" ng-model=\"$ctrl.ngModel[$index]\" ng-required=\"$ctrl.ngRequired\"><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container></div>");
$templateCache.put("app/components/input_keywords/input_keywords.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" ng-repeat=\"n in [] | range:$ctrl.number track by $index\"><label>Keyword {{$index + 1}}</label><input type=\"text\" ng-model=\"$ctrl.ngModel[$index]\" ng-required=\"$ctrl.ngRequired\"><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container></div>");
$templateCache.put("app/components/languages_spoken/languages_spoken.html","<label>{{$ctrl.label}}</label><div class=\"u-margin--top-small\" layout=\"row\" layout-wrap><div flex=\"50\" flex-gt-sm=\"33\" ng-repeat=\"language in $ctrl.languages track by $index\"><md-checkbox ng-checked=\"$ctrl.exists(language, $ctrl.ngModel)\" ng-click=\"$ctrl.toggle(language, $ctrl.ngModel)\">{{::language | capitalize}}</md-checkbox></div></div>");
$templateCache.put("app/components/leads_created_per_day/leads_created_per_day.html","<div ng-show=\"!$ctrl.loading && $ctrl.labels.length\"><md-datepicker name=\"created_from\" ng-model=\"$ctrl.query.created_from\" md-max-date=\"$ctrl.query.created_to\" md-placeholder=\"Created from\" ng-change=\"$ctrl.getData($ctrl.query)\"></md-datepicker><md-datepicker name=\"created_to\" ng-model=\"$ctrl.query.created_to\" md-placeholder=\"Create to\" md-min-date=\"$ctrl.query.created_from\" ng-change=\"$ctrl.getData($ctrl.query)\"></md-datepicker></div><canvas class=\"chart chart-bar\" chart-data=\"$ctrl.data\" chart-labels=\"$ctrl.labels\" chart-series=\"$ctrl.series\"></canvas><div layout=\"row\" layout-align=\"center center\" ng-show=\"$ctrl.loading\"><i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"!$ctrl.loading && !$ctrl.labels.length\"><h1 class=\"md-title\">No Data</h1></div>");
$templateCache.put("app/components/leads_list/leads_list.html","<md-toolbar><div class=\"md-toolbar-tools\"><p flex>{{$ctrl.title || \'Leads\'}}</p></div></md-toolbar><md-content layout-padding><form name=\"filterForm\" ng-submit=\"filterForm.$valid && $ctrl.handleFilter()\"><h1 class=\"md-subheader md-primary\">Filters</h1><div><md-input-container><label>Lead ID</label><input name=\"lead_no\" ng-model=\"$ctrl.query.lead_no\" type=\"text\"></md-input-container><md-input-container><label>First Name</label><input name=\"first_name\" ng-model=\"$ctrl.query.first_name\" type=\"text\"></md-input-container><md-input-container><label>Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.query.last_name\" type=\"text\"></md-input-container><md-input-container><label>Email</label><input name=\"email\" ng-model=\"$ctrl.query.email\" type=\"text\"></md-input-container><md-input-container><label>Phone</label><input name=\"phone\" ng-model=\"$ctrl.query.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container><label>Business</label><input name=\"business\" ng-model=\"$ctrl.query.business\" type=\"text\"></md-input-container><md-input-container><label>Address Street</label><input name=\"address\" ng-model=\"$ctrl.query.address_line1\" type=\"text\"></md-input-container><md-datepicker name=\"created_from\" ng-model=\"$ctrl.query.created_from\" md-max-date=\"$ctrl.query.created_to\" md-placeholder=\"Created from\"></md-datepicker><md-datepicker name=\"created_to\" ng-model=\"$ctrl.query.created_to\" md-placeholder=\"Create to\" md-min-date=\"$ctrl.query.created_from\"></md-datepicker><md-input-container><label>Progress</label><md-select name=\"progress\" ng-model=\"$ctrl.query.progress\"><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"num in [0,1,2,3,4]\" ng-value=\"num\">{{num}}</md-option></md-select></md-input-container><select-sales-rep name=\"sales_representative\" label=\"Sales Representative\" ng-model=\"$ctrl.query.closer_id\"></select-sales-rep><select-lead-type name=\"lead_type\" label=\"Lead Type\" ng-model=\"$ctrl.query.lead_type\"></select-lead-type><select-business-type name=\"business_type\" label=\"Business Type\" ng-model=\"$ctrl.query.business_type\"></select-business-type><select-disposition name=\"disposition\" label=\"Disposition\" ng-model=\"$ctrl.query.disposition\"></select-disposition><select-package name=\"package\" label=\"Package Type\" ng-model=\"$ctrl.query.package_id\"></select-package></div><button class=\"md-button md-raised\" type=\"submit\">Filter</button> <button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.handleExport()\">Export</button></form><md-table-container><table md-table md-progress=\"$ctrl.filtering\"><thead md-head md-order=\"$ctrl.query.order\" md-on-reorder=\"$ctrl.onReorder\"><tr md-row><th md-column md-numeric md-order-by=\"lead_no\"><span>Lead ID</span></th><th md-column md-order-by=\"first_name\"><span>Name</span></th><th md-column md-order-by=\"business\"><span>Business</span></th><th md-column md-order-by=\"business\"><span>Phone</span></th><th md-column md-order-by=\"business\"><span>State</span></th><th md-column md-order-by=\"closer_id\"><span>Opener</span></th><th md-column md-order-by=\"progress\"><span>Closer</span></th><th md-column md-order-by=\"created_at\"><span>Created</span></th><th md-column md-order-by=\"updated_at\"><span>Modified</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr u-cursor--pointer\" md-row ng-click=\"$ctrl.handleSelect(lead)\" ng-repeat=\"lead in $ctrl.leads.data\"><td md-cell>{{::lead.lead_no}}</td><td md-cell>{{::lead.name}}</td><td md-cell>{{::lead.business}}</td><td md-cell>{{::lead.phone}}</td><td md-cell>{{::lead.address.state}}</td><td md-cell>{{::lead.opener.name}}</td><td md-cell>{{::lead.closer.name}}</td><td md-cell>{{::lead.created | date : \'MMM dd, yyyy h:mm a\'}}</td><td md-cell>{{::lead.updated | date : \'MMM dd, yyyy h:mm a\'}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.leads.meta.pagination.per_page\" md-page=\"$ctrl.leads.meta.pagination.current_page\" md-total=\"{{$ctrl.leads.meta.pagination.total}}\" md-options=\"[5, 10, 15, 50, 100, 200]\" md-on-paginate=\"$ctrl.onPaginate\" md-page-select></md-table-pagination></md-content>");
$templateCache.put("app/components/listing_sync_disclosure_modal/listing_sync_disclosure_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Finish & Charge</p></div></md-toolbar><md-dialog-content><md-content layout-padding><h4 class=\"md-subheader\">Terms and Conditions of Service</h4><p class=\"md-body-1\">So before I send you over to activate your account I just need to go over a couple points of service to make sure we are all on the same page. This will only take a couple minutes and will review and inform you about our services as to make sure you understand and know what to expect.</p><p class=\"md-body-1\">First, I need to verify for your protection that you are the legal signatory on card ending in <strong>{{::$ctrl.paymentInfo.card.number.substr(-4, 4)}}</strong>, is this correct? Please say your name as it is listed on your account. Thank you!</p><p class=\"md-body-1\">To recap: Zoek is a digital marketing firm - we are not Google, not Yahoo, or Bing. We have no business relationship with any of the search engines mentioned. To ensure sure we are clear, the charge on you statement will appear as Zoek, or Web Placement. Is this understood? Great.</p><p class=\"md-body-1\">The package you have enrolled with today is called “Listings Sync.” To recap this service will distribute, correct, and claim your online business profiles amongst all directories in Zoek’s network of service. In addition to the previously mentioned services Zoek will also actively suppress all duplicate listings that your business may have within the network.</p><p class=\"md-body-1\">Is this understood? Great!</p><ul style=\"list-style-type: upper-alpha; margin-left: 50px\" layout-margin><li><p class=\"md-body-1\">Monthly Contracts: Your package today is <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> ({{$ctrl.user.getSubscription().monthly_fee | currency}} first month charge plus {{$ctrl.user.getSubscription().setup_fee | currency}} setup fee) = <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> total. You will then pay <strong>{{$ctrl.user.getSubscription().monthly_fee | currency}}</strong> automatically every month until cancelled. If you wish to cancel you may do so at any time without penalty. A short notice of seven days prior to the end of the term is required. You agree to sign and send back an electronic signature verifying your acknowledgment of any type cancellation.</p></li><li><p class=\"md-body-1\">Please keep in mind that now that you are enrolled in the Listing Sync platform you will be eligible for SEO services to help you achieve front page placement on Google, Yahoo, and Bing in your local area. If you decide to upgrade to a higher package please email or call us at anytime. You may visit gozoek.com and click to schedule a demo to learn more about our SEO services.</p></li></ul><p class=\"md-body-1\">Before we wrap up I’d like to give you all of our contact info. Our toll-free number is 888-737-9635 and you may follow the voice prompts for whatever questions you may have on your account. You may also email us for any general questions you may have to help@gozoek.com. Do you have any further questions for me before I transfer you over to finish getting your account set-up?</p><p class=\"md-body-1\">Thank you so much and welcome to Zoek! Hold on one second while I transfer you over.</p></md-content></md-dialog-content><md-dialog-actions><md-checkbox ng-model=\"$ctrl.readPrompt\" ng-true-value=\"true\" ng-false-value=\"false\" style=\"margin-bottom: 0\">Read Prompt</md-checkbox><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" ng-disabled=\"$ctrl.loading\">Cancel</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.confirm()\" ng-disabled=\"!$ctrl.readPrompt\" ladda=\"$ctrl.loading\">Charge Card</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/log_modal/log_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Log</p></div></md-toolbar><md-dialog-content><md-content layout-padding>Log</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/components/login/login.html","<form name=\"loginForm\" ng-submit=\"loginForm.$valid && $ctrl.login()\" accessible-form novalidate><md-input-container class=\"md-block\"><label>Email</label><md-icon md-svg-src=\"/assets/email_icon.svg\"></md-icon><input name=\"email\" ng-model=\"$ctrl.credentials.email\" type=\"email\" required><div ng-messages=\"loginForm.email.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"email\">Invalid email</div></div></md-input-container><md-input-container class=\"md-block\"><label>Password</label><md-icon md-svg-src=\"/assets/lock_icon.svg\"></md-icon><input name=\"password\" ng-model=\"$ctrl.credentials.password\" type=\"password\" required><div ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div layout=\"column\"><button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Login</button> <a class=\"md-body-1\" ui-sref=\"root-login.forgot-password\" href=\"\" ng-hide=\"$ctrl.hideForgotPassword\" style=\"text-align: center; margin-top: 8px\">Forgot Password?</a></div></form>");
$templateCache.put("app/components/login_modal/login_modal.html","<md-dialog flex-gt-xs=\"25\"><form name=\"loginForm\" ng-submit=\"$ctrl.login()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Manager Override</p></div></md-toolbar><md-dialog-content><md-content layout-padding><md-input-container class=\"md-block\"><label>Email</label><md-icon md-svg-src=\"/assets/email_icon.svg\"></md-icon><input name=\"email\" ng-model=\"$ctrl.credentials.email\" type=\"email\" required><div ng-messages=\"loginForm.email.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"email\">Invalid email</div></div></md-input-container><md-input-container class=\"md-block\"><label>Password</label><md-icon md-svg-src=\"/assets/lock_icon.svg\"></md-icon><input name=\"password\" ng-model=\"$ctrl.credentials.password\" type=\"password\" required><div ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" type=\"button\">Cancel</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Login</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/mobile_app_questionnaire/mobile_app_questionnaire.html","<form name=\"questionnaireForm\" ng-submit=\"questionnaireForm.$valid && $ctrl.handleSubmit()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Mobile App Questionnaire</p></div></md-toolbar><md-content layout-padding><div layout=\"column\"><!-- App Name --><md-input-container class=\"md-block\"><label>Desired App Name</label><input name=\"app_name\" ng-model=\"$ctrl.questionnaire.app_name\" type=\"text\" md-maxlength=\"12\" required><div class=\"md-body-1\">Your app name can not be longer than 12 characters including spaces. This name will appear under your app icon.</div><div ng-messages=\"questionnaireForm.app_name.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"ngMaxlength\">Your app name can not be longer than 12 characters including spaces.</div></div></md-input-container><!-- /App Name --><!-- Website --><md-input-container class=\"md-block\"><label>Website</label><input name=\"website\" ng-model=\"$ctrl.questionnaire.website\" type=\"url\" http-prefix required><div class=\"md-body-1\">Do you have a website? If so, we can pull photos, content, etc. directly from your website.</div><div ng-messages=\"questionnaireForm.website.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"url\">Incorrect format</div></div></md-input-container><!-- /Website --><!-- Desired Logo --><div><h4 class=\"md-body-2\">Desired Logo?</h4><p class=\"md-body-1\">This logo will appear on your apps homepage.</p><br><md-radio-group ng-model=\"$ctrl.questionnaire.desired_logo\" required><md-radio-button class=\"md-body-1\" value=\"Yes - if yes.\">Yes - if yes. (REP. email to apps@gozoek.com)</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No - a generic logo is fine.\">No - a generic logo is fine.</md-radio-button></md-radio-group></div><!-- /Desired Logo --><!-- Desired Icon --><div><h4 class=\"md-body-2\">Desired Icon?</h4><p class=\"md-body-1\">This icon will appear as the app icon - you\'ll see this first thing when finding your app in the app store.</p><br><md-radio-group ng-model=\"$ctrl.questionnaire.desired_icon\" required><md-radio-button class=\"md-body-1\" value=\"Yes - same as my logo.\">Yes - same as my logo</md-radio-button><md-radio-button class=\"md-body-1\" value=\"Yes - different than my logo.\">Yes - different than my logo. (REP. email to apps@gozoek.com)</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No - a generic icon is fine.\">No - a generic icon is fine.</md-radio-button></md-radio-group></div><!-- /Desired Icon --><!-- Loading Images --><div><h4 class=\"md-body-2\">Loading Images</h4><p class=\"md-body-1\">These images will be displayed on the screen while the app is loading. You can submit up to 4 images.</p><br><md-radio-group ng-model=\"$ctrl.questionnaire.loading_images\" required><md-radio-button class=\"md-body-1\" value=\"Yes - I have my own photos.\">Yes - I have my own photos. (REP. email to apps@gozoek.com)</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No - generic images are fine.\">No - generic images are fine.</md-radio-button></md-radio-group></div><!-- /Loading Images --><!-- Additional Images --><md-input-container><h4 class=\"md-body-2\">Additional Images</h4><p class=\"md-body-1\">These are additional photos can be displayed in a gallery on your app.</p><br><md-radio-group name=\"additional_images\" ng-model=\"$ctrl.questionnaire.additional_images\" required><md-radio-button class=\"md-body-1\" value=\"Yes - I have my own photos.\">Yes - I have my own photos. (REP. email to apps@gozoek.com)</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No - generic photos are fine.\">No - generic photos are fine.</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No - I don\'t want a gallery on my app.\">No - I don\'t want a gallery on my app.</md-radio-button></md-radio-group><div ng-messages=\"questionnaireForm.additional_images.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><!-- /Additional Images --><!-- Widgets --><md-input-container class=\"md-block\"><label>Please list the widgets that you would like to use for your app.</label><textarea name=\"widgets\" rows=\"5\" md-no-autogrow ng-model=\"$ctrl.questionnaire.widgets\" required></textarea><div ng-messages=\"questionnaireForm.widgets.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><!-- /Widgets --><!-- Push Notifications --><div><h4 class=\"md-body-2\">Push Notifications</h4><p class=\"md-body-1\">You can have push notifications set up on your app to reach out to your customers if you\'d like.</p><br><md-radio-group ng-model=\"$ctrl.questionnaire.push_notifications\" required><md-radio-button class=\"md-body-1\" value=\"Yes - I want push notifications.\">Yes - I want push notifications, (REP. email title, a message and the time and date for push notifications to app@gozoek.com)</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No - I don\'t want push notifications.\">No - I don\'t want push notifications.</md-radio-button></md-radio-group></div><!-- /Push Notifications --><!-- For Your Information --><div><h4 class=\"md-body-2\">For Your Information...</h4><p class=\"md-body-1\">Changing the App Icon Name, App Icon or Loading Screens will require republishing and going through another 2 - 2 1/2 week process with app publishers for them to re-verify information. If you would like for your app to be found in the Google Play Store, you will need to set up a Google Developer account. We will send you instructions on how to complete this simple process. If you do not want your app in the Google Play Store, you do not need to set this up and your app will be found on the Apple App Store only.</p><br><md-radio-group ng-model=\"$ctrl.questionnaire.for_your_information\" required><md-radio-button class=\"md-body-1\" value=\"Yes, rep has read this to the client and they understand.\">Yes, rep has read this to the client and they understand.</md-radio-button><md-radio-button class=\"md-body-1\" value=\"No, rep has read this to the client and they understand.\n            Client does NOT want their app in Google Play Store.\">No, rep has read this to the client and they understand. Client does NOT want their app in Google Play Store.</md-radio-button></md-radio-group></div><!-- /For Your Information --></div><div><button class=\"md-button md-raised\" ng-click=\"$ctrl.onGoBack()\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Finish</button></div></md-content></form>");
$templateCache.put("app/components/notes_list/notes_list.html","<h1 class=\"md-title\">Notes</h1><form name=\"$ctrl.notesForm\" ng-submit=\"$ctrl.notesForm.$valid && $ctrl.addNote($ctrl.note)\" novalidate><md-input-container class=\"md-block\" flex><label>Note</label><textarea name=\"notes\" id=\"\" cols=\"30\" rows=\"10\" ng-model=\"$ctrl.note\" required></textarea><div ng-messages=\"$ctrl.notesForm.notes.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised\" ladda=\"$ctrl.loading\">Add</md-button></form><ul><li ng-repeat=\"note in $ctrl.notes.data\"><div layout-padding><p class=\"md-body-1\">{{note.note}}</p><p class=\"md-body-2\"><span>{{note.created_at}} by {{note.createdBy.name}}</span> <span class=\"md-caption\">({{note.type | capitalize}})</span></p><md-divider></md-divider></div></li></ul>");
$templateCache.put("app/components/notes_modal/notes_modal.html","<md-dialog flex-gt-xs=\"50\"><form name=\"$ctrl.notesForm\" ng-submit=\"$ctrl.notesForm.$valid && $ctrl.confirm()\" accessible-form novalidate><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><p>Notes</p></div></md-toolbar><md-dialog-content layout-padding style=\"max-height: 500px\"><ul><li ng-repeat=\"note in $ctrl.notes.data\"><div layout-padding><p class=\"md-body-1\">{{note.note}}</p><p class=\"md-body-2\"><span>{{note.created_at}} by {{note.createdBy.name}}</span> <span class=\"md-caption\">({{note.type | capitalize}})</span></p><md-divider></md-divider></div></li></ul></md-dialog-content><md-dialog-actions class=\"md-whiteframe-14dp\" style=\"height: 100px\"><md-input-container class=\"md-block\" flex><label>Add Note</label><input name=\"note\" ng-model=\"$ctrl.note\" required><div ng-messages=\"$ctrl.notesForm.note.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"$ctrl.loading\">Add</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/opener_steps/opener_steps.html","<ul class=\"steps\"><li class=\"steps__item\" ng-class=\"$ctrl.getClass(1)\" ng-click=\"$ctrl.handleClick(1)\"><step-item text=\"Contact Information\" number=\"1\" is-completed=\"$ctrl.isComplete(1)\" is-current=\"$ctrl.isCurrent(1)\"></step-item></li><li class=\"steps__arrow\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li class=\"steps__item\" ng-class=\"$ctrl.getClass(2)\" ng-click=\"$ctrl.handleClick(2)\"><step-item text=\"Qualifiers\" number=\"2\" is-completed=\"$ctrl.isComplete(2)\" is-current=\"$ctrl.isCurrent(2)\"></step-item></li></ul>");
$templateCache.put("app/components/package_customize_modal/package_customize_modal.html","<md-dialog><form name=\"customizePackageModalForm\" ng-submit=\"$ctrl.submitSubscription()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-title\">Customize Package</h2></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear><md-dialog-content><div layout-padding><h1 class=\"md-body-2\">Package: {{::$ctrl.pkg.name}} {{::$ctrl.pkg.description}}</h1><h4 class=\"md-subheader\">Add Ons</h4><div ng-repeat=\"addOn in $ctrl.addOns.data\n      | remove2499listingSyncAddOn\n      | remove2999ListingSyncAddOnForSomePackages: $ctrl.subscription.package_id\n      | removeFreeCallTrackingAddOnForSomePackages: $ctrl.subscription.package_id\n      | removeMobileAppAddOnsForMobilePackage: $ctrl.subscription.package_id\n      | freeMobileApp: $ctrl.subscription.package_id\n      | freeZocialMedia: $ctrl.subscription.package_id\n      | professionalMobileApp: $ctrl.subscription.package_id\n      | removeMonitorAppOnly: $ctrl.subscription.package_id\n      track by $index\"><md-checkbox ng-disabled=\"$ctrl.subscription.canAddAddOn(addOn)\" ng-checked=\"$ctrl.subscription.hasAddOn(addOn)\" ng-click=\"$ctrl.toggle(addOn)\"><span class=\"md-body-1\">{{::addOn.name}}</span></md-checkbox></div><md-input-container class=\"md-block\"><md-select name=\"plan\" ng-model=\"$ctrl.subscription.plan_id\" ng-change=\"$ctrl.subscription.updateTotal()\" required><md-option ng-value=\"\"><span class=\"md-body-1\">Select Type</span></md-option><md-option ng-repeat=\"plan in $ctrl.pkg.plans\n              | remove2499listingSyncPlan\n              | flashSalePlan : $ctrl.lead\n              | removeSavePlans\n              | removeInactivePlans\" ng-value=\"plan.id\"><span class=\"md-body-1\">{{\'Package \' + plan.name}}</span> <span class=\"md-body-1\" ng-show=\"plan.payment_term\">{{\': \' + plan.payment_term + \' Months\'}}</span></md-option></md-select><div ng-messages=\"customizePackageModalForm.plan.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div class=\"c-customize-package-modal__cost md-body-2\"><span class=\"c-customize-package-modal__total\">Total: </span><span class=\"c-customize-package-modal__price\">{{$ctrl.subscription.monthly_fee || 0 | currency}}/month + {{$ctrl.subscription.deposit_fee || 0 | currency}} Deposit + {{$ctrl.subscription.setup_fee || 0 | currency}} Setup</span></div></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Continue</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/package_details/package_details.html","<form name=\"pinnerSubscriptionDetailForm\" ng-submit=\"pinnerSubscriptionDetailForm.$valid && $ctrl.handleSubmit()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Package Details</p></div></md-toolbar><md-content layout-padding><p class=\"md-body-1\">Ok, now that we’ve got the beginning pieces of your campaign ready, I’d like to verify some information with you to make sure that we are able to provide you with all necessary reporting and information.</p><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\"><label>1. Primary Account Holder First Name</label><input name=\"first_name\" ng-model=\"$ctrl.client.first_name\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.first_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>2. Primary Account Holder Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.client.last_name\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.last_name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>3. Business Name</label><input name=\"business_name\" ng-model=\"$ctrl.client.business\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.business.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>4. Authorized Users on the Account</label><input name=\"authorized_users\" ng-model=\"$ctrl.client.authorized_users\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.authorized_users.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>5. Email for receipts and account information from Zoek</label><input name=\"email_for_receipts\" ng-model=\"$ctrl.client.email\" type=\"text\" autocomplete=\"off\" required><div ng-messages=\"openerSubscriptionDetailForm.email_for_receipts.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>6. Email for \"Contact Us\" Section on C.A.P. Site</label><input name=\"email_for_contact\" ng-model=\"$ctrl.client.email_for_contact\" type=\"text\" autocomplete=\"off\" required><div ng-messages=\"openerSubscriptionDetailForm.email_for_contact.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><md-checkbox ng-model=\"$ctrl.client.hide_address\" ng-false-value=\"false\" ng-true-value=\"true\">Hide Address</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>7. Listing address line 1</label><input name=\"address1\" ng-model=\"$ctrl.client.address.line1\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.address1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>8. Listing address line 2</label><input name=\"address2\" ng-model=\"$ctrl.client.address.line2\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>8. Listing city</label><input name=\"city\" ng-model=\"$ctrl.client.address.city\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-state name=\"state\" label=\"9. Listing state\" ng-model=\"$ctrl.client.address.state\" ng-messages=\"openerSubscriptionDetailForm.state.$error\" ng-required=\"true\"></select-state></div><md-input-container class=\"md-block\" flex=\"50\"><label>10. Listing postal</label><input name=\"postal\" ng-model=\"$ctrl.client.address.postal\" type=\"text\" required><div ng-messages=\"openerSubscriptionDetailForm.postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"50\"><select-country name=\"country\" label=\"11. Listing country\" ng-model=\"$ctrl.client.address.country\" ng-messages=\"openerSubscriptionDetailForm.country.$error\" ng-required=\"true\"></select-country></div><md-input-container class=\"md-block\" flex=\"50\"><label>12. Address Type</label><md-select name=\"address_type\" ng-model=\"$ctrl.client.address.type\"><md-option>Residential</md-option><md-option>Storefront</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>13. How Many Locations?</label><md-select name=\"address_type\" ng-model=\"$ctrl.client.number_of_locations\"><md-option>1</md-option><md-option>2</md-option><md-option>3</md-option><md-option>4+</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>14. Phone number for Zoek to contact you</label><input name=\"phone\" ng-model=\"$ctrl.client.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" autocomplete=\"off\" required><div ng-messages=\"openerSubscriptionDetailForm.phone.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>15. Fax Number</label><input name=\"fax\" ng-model=\"$ctrl.client.fax\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>16. Desired URL</label><input name=\"desired_url\" ng-model=\"$ctrl.client.desired_url\" type=\"text\" http-prefix> <a href=\"https://www.godaddy.com/\" target=\"_blank\"><md-button class=\"md-primary md-button\">Check Availability</md-button></a></md-input-container><div flex=\"50\"><payment-methods name=\"payment_methods\" label=\"17. Payments Accepted\" ng-model=\"$ctrl.client.payments_accepted\"></payment-methods></div><business-hours hours=\"$ctrl.client.business_hours\"></business-hours><md-input-container class=\"md-block\" flex=\"50\"><label>19. License No.</label><input name=\"license_no\" ng-model=\"$ctrl.client.license_no\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>21. Awards and Accolades</label><input name=\"awards_and_accolades\" ng-model=\"$ctrl.client.awards_and_accolades\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>21. Certifications</label><input name=\"certifications\" ng-model=\"$ctrl.client.certifications\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>22. Years Established</label><input name=\"years_in_business\" ng-model=\"$ctrl.client.years_in_business\" type=\"text\" ui-mask=\"9999\" ui-mask-placeholder-char=\"space\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>23. Number of Employees</label><input name=\"number_of_employees\" ng-model=\"$ctrl.client.number_of_employees\" type=\"text\"></md-input-container><div class=\"md-block\" flex=\"50\"><languages-spoken name=\"languages_spoken\" label=\"24. Languages Spoken\" ng-model=\"$ctrl.client.languages_spoken\"></languages-spoken></div><div class=\"md-block\" flex=\"50\"><parking-available name=\"parking_available\" label=\"25. Parking Available\" ng-model=\"$ctrl.client.parking_available\"></parking-available></div><div class=\"md-block\" flex=\"50\"><label>26. Run Special Promotions (e.g. Happy Hour, Half Off, $10 Off First Service, Referalls, etc)</label><md-radio-group layout=\"row\" class=\"u-margin--top\" ng-model=\"$ctrl.client.run_special_promotions\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group><md-input-container class=\"md-block\" flex ng-show=\"$ctrl.client.run_special_promotions\"><label>Special Methods</label><input name=\"special_promotion\" ng-model=\"$ctrl.client.special_promotion\" type=\"text\" md-maxlength=\"40\"></md-input-container></div><div class=\"md-block\" flex=\"50\"><md-input-container class=\"md-block\" flex><label>27. Website</label><input name=\"website\" ng-model=\"$ctrl.client.website\" type=\"text\" http-prefix></md-input-container></div></div><div><button class=\"md-button md-raised\" ng-click=\"$ctrl.handleGoBack()\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Finish</button></div></md-content></form>");
$templateCache.put("app/components/package_recommend_modal/package_recommend_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-title\">Package Recommendation</h2></div></md-toolbar><md-dialog-content><div layout-margin><p class=\"md-title\">{{::$ctrl.recommendedPackage.name}}</p><br><p class=\"md-subtitle\"><strong>Monthly Fee:</strong></p><p class=\"md-body-2\">{{::$ctrl.recommendedPackage.plans[0].monthly_fee | currency}}</p><br><p class=\"md-subtitle\"><strong>Included in package:</strong></p><ul><li ng-repeat=\"include in $ctrl.package_includes track by $index\"><p class=\"md-body-1\" style=\"margin-bottom: 8px\">{{::include}}</p></li><li ng-repeat=\"include in $ctrl.recommendedPackage.includes track by $index\"><p class=\"md-body-1\" style=\"margin-bottom: 8px\">{{::include}}</p></li></ul></div></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\">Select Another Package</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.confirm()\">Select Package</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/parking_available/parking_available.html","<label>{{$ctrl.label}}</label><div class=\"u-margin--top-small\" layout=\"row\" layout-wrap><div flex=\"50\" flex-gt-sm=\"33\" ng-repeat=\"parking in $ctrl.parkingAvailable track by $index\"><md-checkbox ng-checked=\"$ctrl.exists(parking, $ctrl.ngModel)\" ng-click=\"$ctrl.toggle(parking, $ctrl.ngModel)\">{{::parking | capitalize}}</md-checkbox></div></div>");
$templateCache.put("app/components/payment_details/payment_details.html","<form name=\"closerPaymentForm\" ng-submit=\"closerPaymentForm.$valid && $ctrl.submit()\" accessible-form novalidate><md-toolbar><div class=\"md-toolbar-tools\"><div>Payment Details</div></div></md-toolbar><md-content layout-padding><h1 class=\"md-subheader md-primary\">Billing Address</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex=\"50\"><label>Billing Address 1</label><input name=\"address1\" type=\"text\" ng-model=\"$ctrl.billing.line1\" required><div ng-messages=\"closerPaymentForm.address1.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex=\"50\"><label>Address 2</label><input name=\"address2\" type=\"text\" ng-model=\"$ctrl.billing.line2\"></md-input-container><md-input-container flex=\"25\"><label>City</label><input name=\"city\" type=\"text\" ng-model=\"$ctrl.billing.city\" required><div ng-messages=\"closerPaymentForm.city.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"25\"><select-state name=\"state\" label=\"State\" ng-model=\"$ctrl.billing.state\" ng-messages=\"closerPaymentForm.state.$error\" ng-required=\"true\"></select-state></div><md-input-container flex=\"25\"><label>Postal</label><input name=\"postal\" type=\"text\" ng-model=\"$ctrl.billing.postal\" postal-lookup address=\"$ctrl.billing\" required><div ng-messages=\"closerPaymentForm.postal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><div flex=\"25\"><select-country name=\"country\" label=\"Country\" ng-model=\"$ctrl.billing.country\" ng-messages=\"closerPaymentForm.country.$error\" ng-required=\"true\"></select-country></div></div><h1 class=\"md-subheader md-primary\">Credit Card</h1><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-input-container flex><label>Name on card</label><input name=\"name\" type=\"text\" ng-model=\"$ctrl.card.name\" required><div ng-messages=\"closerPaymentForm.name.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container flex><label>Card Number</label><input name=\"card_number\" type=\"text\" ng-model=\"$ctrl.card.number\" ui-mask=\"9999 9999 9999 999?9\" ui-mask-placeholder-char=\"space\" credit-card required><div ng-messages=\"closerPaymentForm.card_number.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"creditCard\">Invalid credit card</div></div></md-input-container><md-input-container flex><label>Exp Date</label><input name=\"exp_date\" type=\"text\" ng-model=\"$ctrl.card.exp_date\" placeholder=\"MM / YY\" ui-mask=\"99 / 99\" credit-card-exp required><div ng-messages=\"closerPaymentForm.exp_date.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"creditCardExp\">Expired</div></div></md-input-container><md-input-container flex><label>CVC</label><input name=\"cvc\" type=\"text\" ng-model=\"$ctrl.card.cvc\" ui-mask=\"999?9\" ui-mask-placeholder-char=\"space\" required><div ng-messages=\"closerPaymentForm.cvc.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div><div><button class=\"md-button md-raised\" ng-click=\"$ctrl.goBack()\" type=\"button\">Go Back</button> <button class=\"md-button md-primary md-raised\" type=\"submit\" ladda=\"$ctrl.loading\">Continue</button></div></md-content></form>");
$templateCache.put("app/components/payment_methods/payment_methods.html","<label>{{$ctrl.label}}</label><div class=\"u-margin--top-small\" layout=\"row\" layout-wrap><div flex=\"50\" flex-gt-sm=\"33\" ng-repeat=\"payment in $ctrl.paymentMethods track by $index\"><md-checkbox ng-checked=\"$ctrl.exists(payment, $ctrl.ngModel)\" ng-click=\"$ctrl.toggle(payment, $ctrl.ngModel)\">{{::payment | capitalize}}</md-checkbox></div></div>");
$templateCache.put("app/components/payment_successful_modal/payment_successful_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Congratulations Payment Successful!</p></div></md-toolbar><md-dialog-content><md-content layout-padding><p class=\"md-body-2\">Payment in the {{($ctrl.user.getSubscription().monthly_fee + $ctrl.user.getSubscription().setup_fee) | currency}} for Client ID Number {{::$ctrl.user.client_no}}. Confirmation emailed to {{::$ctrl.user.email}}. Next payment will be {{::$ctrl.user.getSubscription().monthly_fee | currency}} on {{::$ctrl.nextDate}}.</p></md-content></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.confirm()\">Confirm</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/prepay_disclosure_modal/prepay_disclosure_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Finish & Charge</p></div></md-toolbar><md-dialog-content><md-content layout-padding><h4 class=\"md-subheader\">Terms and Conditions of Service</h4><p class=\"md-body-1\">Before I transfer you over I just need to go over a couple points of service to make sure we are all on the same page. This will only take a couple minutes and will review and inform you about our services as to make sure you understand and know what to expect allowing you to see the effectiveness your new digital marketing plan.</p><p class=\"md-body-1\">First, I need to verify for your protection that you are the legal signatory on card ending in <strong>{{::$ctrl.paymentInfo.card.number.substr(-4, 4)}}</strong>, is this correct? Please say your name as it is listed on your account. Thank you!</p><p class=\"md-body-1\">To recap: Zoek is a digital marketing firm - we are not Google, not Yahoo, or Bing. We have no business relationship with any of the search engines mentioned. To ensure we are clear, the charge on you statement will appear as Zoek. Is this understood? Great.</p><p class=\"md-body-1\">The marketing package you have enrolled with today is our <strong>{{::$ctrl.user.getSubscription().getPackage().name}}</strong>. Your package includes customized search engine optimization for the local, organic, and mobile levels of Google, Yahoo, and Bing. We also include up to 50 various online directories such as yellow pages, white pages, and manta – just to name a few. We will optimize your business for <strong>{{::$ctrl.user.getSubscription().number_of_cities}}</strong> cities and up to ten unique keywords.</p><p class=\"md-body-1\">Is this understood? Great!</p><p class=\"md-body-1\">The Zoek marketing experts will begin a labor-intensive process of programming and coding exclusively for your custom C.A.P site! The C.A.P. site is designed and programmed for optimization so it can be found on page one. At your direction, we may link your existing website to the your new C.A.P. via hyperlinks and call-to-action headers. Our optimization experts will be servicing and monitoring your account so that you may experience the most optimal results possible.</p><p class=\"md-body-1\">Your package today includes our Zoek Promise which states that <strong>{{::$ctrl.user.business}}</strong> will be found on the front page of the major Search Engines; Google, Yahoo, Bing for a minimum of two keywords within 55 days of the date of your contracted service agreement is signed and returned. You agree to contact Zoek if you think your business is not ranking on the front page at which point a representative will help you find your front page placement. If upon review it is confirmed that your business is not ranking you will be provided with the next month of service at no charge. You agree to give Zoek 48 hours to achieve your front- page rankings.</p><ul style=\"list-style-type: upper-alpha; margin-left: 50px\" layout-margin><li><p class=\"md-body-1\">Monthly Contracts: Your package today is <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> ({{$ctrl.user.getSubscription().monthly_fee | currency}} plus {{$ctrl.user.getSubscription().setup_fee | currency}} setup fee) = <strong>{{$ctrl.user.getSubscription().getTotal() | currency}}</strong> total. You will then pay <strong>{{$ctrl.user.getSubscription().monthly_fee | currency}}</strong> automatically every 30 days, until <strong>{{$ctrl.user.getSubscription().getBillEndDate()}}</strong>. If you wish to cancel at the conclusion of the agreed {{$ctrl.user.getSubscription().getPlan().payment_term}} month contracted term, you may do so at any time without penalty. A short notice of seven days prior to the end of the term is required. In order to cancel this contractual agreement with Zoek you agree and understand you will be held responsible for paying half of the remaining balance due to Zoek for your account. You agree to sign and send back an electronic signature verifying your acknowledgment of any type cancellation.</p></li></ul><p class=\"md-body-1\">Before we wrap up I’d like to give you all of our contact info. Our toll-free number is 888- 737-9635 and you may follow the voice prompts for whatever questions you may have on your account. You may also email us for any general questions you may have to help@gozoek.com. Do you have any further questions for me before I transfer you over to finish getting your account set-up?</p><p class=\"md-body-1\">Thank you so much and welcome to Zoek! Hold on one second while I transfer you over.</p></md-content></md-dialog-content><md-dialog-actions><md-checkbox ng-model=\"$ctrl.readPrompt\" ng-true-value=\"true\" ng-false-value=\"false\" style=\"margin-bottom: 0\">Read Prompt</md-checkbox><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\" ng-disabled=\"$ctrl.loading\">Cancel</button> <button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.confirm()\" ng-disabled=\"!$ctrl.readPrompt\" ladda=\"$ctrl.loading\">Charge Card</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/progressbar/progressbar.html","<div class=\"o-progressbar\"><div class=\"o-progressbar__top\"><span class=\"o-progressbar__steps\">{{progressbar.current || 0}} out of {{progressbar.steps || 0}} steps completed </span><span class=\"o-progressbar__percentage\">{{(progressbar.current / progressbar.steps) * 100 | number : 0}}%</span></div><progress class=\"o-progressbar__bar\" max=\"100\" value=\"{{progressbar.current / progressbar.steps * 100}}\"></progress></div>");
$templateCache.put("app/components/proposal_modal/proposal_modal.html","<md-dialog><form name=\"proposalForm\" ng-submit=\"proposalForm.$valid && $ctrl.sendProposal()\"><md-toolbar><div class=\"md-toolbar-tools\"><p>Send Proposal</p></div></md-toolbar><md-dialog-content><md-content layout-padding><md-input-container class=\"md-block\"><label>Select Proposal</label><md-select name=\"proposal\" ng-model=\"$ctrl.proposal\" ng-required=\"true\"><md-option></md-option><md-option ng-repeat=\"proposal in $ctrl.proposals\" ng-value=\"proposal\">{{proposal.name}}</md-option></md-select><div ng-messages=\"proposalForm.proposal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised\" ng-click=\"$ctrl.cancel()\">Cancel</button> <button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"$ctrl.loading\">Send Proposal</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/qualifier_steps/qualifier_steps.html","<ul class=\"steps\"><li class=\"steps__item\" ng-class=\"$ctrl.getClass(1)\" ng-click=\"$ctrl.handleClick(1)\"><step-item text=\"Select Package\" number=\"1\" is-completed=\"$ctrl.isComplete(1)\" is-current=\"$ctrl.isCurrent(1)\"></step-item></li><li class=\"steps__arrow\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li class=\"steps__item\" ng-class=\"$ctrl.getClass(2)\" ng-click=\"$ctrl.handleClick(2)\"><step-item text=\"Package Details\" number=\"2\" is-completed=\"$ctrl.isComplete(2)\" is-current=\"$ctrl.isCurrent(2)\"></step-item></li><li class=\"steps__arrow\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li class=\"steps__item\" ng-class=\"$ctrl.getClass(3)\" ng-click=\"$ctrl.handleClick(3)\"><step-item text=\"Payment\" number=\"3\" is-completed=\"$ctrl.isComplete(3)\" is-current=\"$ctrl.isCurrent(3)\"></step-item></li></ul>");
$templateCache.put("app/components/refund_modal/refund_modal.html","<md-dialog><form name=\"refundForm\" ng-submit=\"refundForm.$valid && refundModal.confirm()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Refund</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"refundModal.loading\"></md-progress-linear><md-dialog-content><div layout-margin><div layout=\"column\"><md-input-container class=\"md-block\"><label>Reason for refund</label><input name=\"reason\" type=\"text\" ng-model=\"refundModal.reason\" required><div ng-messages=\"refundForm.reason.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><md-input-container class=\"md-block\"><label>Amount</label><input name=\"amount\" type=\"number\" ng-model=\"refundModal.amount\" required><div ng-messages=\"refundForm.amount.$error\"><div ng-message=\"required\">Required</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised\" ng-click=\"refundModal.cancel()\">Cancel</md-button><md-button class=\"md-raised md-primary\" ladda=\"refundModal.loading\" ng-disabled=\"refundForm.$invalid\" type=\"submit\">Okay</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/sae_pipeline_list/sae_pipeline_list.html","<md-toolbar><div class=\"md-toolbar-tools\"><p flex>{{$ctrl.title || \'SAE Pipeline\'}}</p></div></md-toolbar><md-content layout-padding><form name=\"filterForm\" ng-submit=\"filterForm.$valid && $ctrl.handleFilter()\"><h1 class=\"md-subheader md-primary\">Filters</h1><div><md-input-container><label>Client ID</label><input name=\"client_no\" ng-model=\"$ctrl.query.client_no\" type=\"text\"></md-input-container><md-input-container><label>First Name</label><input name=\"first_name\" ng-model=\"$ctrl.query.first_name\" type=\"text\"></md-input-container><md-input-container><label>Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.query.last_name\" type=\"text\"></md-input-container><md-input-container><label>Email</label><input name=\"email\" ng-model=\"$ctrl.query.email\" type=\"text\"></md-input-container><md-input-container><label>Phone</label><input name=\"phone\" ng-model=\"$ctrl.query.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container><label>Business</label><input name=\"business\" ng-model=\"$ctrl.query.business\" type=\"text\"></md-input-container><md-input-container><label>Address Street</label><input name=\"address\" ng-model=\"$ctrl.query.address_line1\" type=\"text\"></md-input-container><md-datepicker name=\"created_from\" ng-model=\"$ctrl.query.created_from\" md-max-date=\"$ctrl.query.created_to\" md-placeholder=\"Created from\"></md-datepicker><md-datepicker name=\"created_to\" ng-model=\"$ctrl.query.created_to\" md-placeholder=\"Create to\" md-min-date=\"$ctrl.query.created_from\"></md-datepicker><md-input-container><label>Progress</label><md-select name=\"progress\" ng-model=\"$ctrl.query.progress\"><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"num in [0,1,2,3,4,5,6,7,8,9,10,11,12,13]\" ng-value=\"num\">{{num}}</md-option></md-select></md-input-container></div><md-button class=\"md-raised\" type=\"submit\">Filter</md-button><md-button class=\"md-raised\" type=\"button\" ng-click=\"$ctrl.handleExport()\">Export</md-button></form><md-table-container><table md-table md-progress=\"$ctrl.filtering\"><thead md-head md-order=\"$ctrl.query.order\" md-on-reorder=\"$ctrl.onReorder\"><tr md-row><th md-column md-numeric md-order-by=\"client_no\"><span>ID</span></th><th md-column md-order-by=\"first_name\"><span>Name</span></th><th md-column md-order-by=\"business\"><span>Business</span></th><th md-column><span>Package Type</span></th><th md-column><span>Monthly</span></th><th md-column md-order-by=\"pinner_id\"><span>Provisioner</span></th><th md-column md-order-by=\"progress\"><span>Progress</span></th><th md-column md-order-by=\"status\"><span>Status</span></th><th md-column md-order-by=\"updated_at\"><span>Last Updated</span></th><th md-column md-order-by=\"created_at\"><span>Created</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr u-cursor--pointer\" md-row ng-click=\"$ctrl.handleSelect(client)\" ng-repeat=\"client in $ctrl.clients.data\"><td md-cell>{{::client.client_no}}</td><td md-cell>{{::client.name}}</td><td md-cell>{{::client.business}}</td><td md-cell>{{::client.subscription.package.name}} {{::client.subscription.getPlan().name}}</td><td md-cell>{{::client.subscription.monthly_fee | currency}}</td><td md-cell>{{::client.pinner.name}}</td><td md-cell>{{::client.progress || 0}}</td><td md-cell><span class=\"status--{{::client.status}}\">{{::client.status | capitalize}}</span></td><td md-cell>{{::client.updated | date : \'MMM dd, yyyy h:mm a\'}}</td><td md-cell>{{::client.created | date : \'MMM dd, yyyy h:mm a\'}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.clients.meta.pagination.per_page\" md-page=\"$ctrl.clients.meta.pagination.current_page\" md-total=\"{{$ctrl.clients.meta.pagination.total}}\" md-options=\"[5, 10, 15, 50, 100, 200]\" md-on-paginate=\"$ctrl.onPaginate\" md-page-select></md-table-pagination></md-content>");
$templateCache.put("app/components/save_modal/save_modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><p>Save / Exit</p></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-show=\"saveModal.loading\"></md-progress-linear><md-dialog-content><md-content layout-padding><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"saveModal.view = \'callback\'\">Setup Callback Time</md-button><md-button class=\"md-raised\" ng-click=\"saveModal.view = \'proposal\'\">Send Proposal</md-button><md-button class=\"md-raised\" ng-click=\"saveModal.view = \'disposition\'\">Set Disposition</md-button><md-button class=\"md-raised\" ng-click=\"saveModal.exit()\">Exit</md-button></div><div><form name=\"proposalForm\" ng-submit=\"proposalForm.$valid && saveModal.sendProposal()\" ng-show=\"saveModal.view === \'proposal\'\"><md-input-container class=\"md-block\"><label>Select Proposal</label><md-select name=\"proposal\" ng-model=\"saveModal.proposal\" ng-required=\"true\"><md-option></md-option><md-option ng-repeat=\"proposal in saveModal.proposals\" ng-value=\"proposal\">{{proposal.name}}</md-option></md-select><div ng-messages=\"proposalForm.proposal.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"saveModal.loading\">Send Proposal</button></form><form name=\"dispositionForm\" ng-show=\"saveModal.view === \'disposition\'\" ng-submit=\"dispositionForm.$valid && saveModal.setDisposition()\"><select-disposition name=\"disposition\" label=\"Select Disposition\" ng-messages=\"dispositionForm.disposition.$error\" ng-model=\"saveModal.disposition\" ng-required=\"true\"></select-disposition><button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"saveModal.loading\">Set Disposition</button></form><form name=\"callbackForm\" ng-show=\"saveModal.view === \'callback\'\" ng-submit=\"callbackForm.$valid && saveModal.setCallback(saveModal.callback)\"><div layout=\"row\"><div flex style=\"margin-top: 15px\"><md-datepicker ng-model=\"saveModal.callback.date\" md-placeholder=\"Enter date\" required></md-datepicker></div><md-input-container flex><label>Time</label><input ui-timepicker type=\"text\" ng-model=\"saveModal.callback.time\" required></md-input-container></div><button class=\"md-button md-raised md-primary\" type=\"submit\" ladda=\"saveModal.loading\">Set Callback Time</button></form></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/components/select_business_type/select_business_type.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option value=\"{{::businessType}}\" ng-repeat=\"businessType in $ctrl.businessTypes track by $index\">{{::businessType}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_country/select_country.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option ng-repeat=\"country in $ctrl.countries track by $index\" ng-value=\"::country[\'alpha-2\']\">{{::country.name}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_disposition/select_disposition.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option ng-repeat=\"disposition in $ctrl.dispositions\" ng-value=\"disposition\">{{::disposition}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_industry/select_industry.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option value=\"{{::industry}}\" ng-repeat=\"industry in $ctrl.industries track by $index\">{{::industry}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_lead_type/select_lead_type.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option value=\"{{::leadType}}\" ng-repeat=\"leadType in $ctrl.leadTypes track by $index\">{{::leadType}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_marketing_methods/select_marketing_methods.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\" multiple=\"multiple\"><md-option ng-value=\"marketingMethod\" ng-repeat=\"marketingMethod in $ctrl.marketingMethods\">{{::marketingMethod}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_package/select_package.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.loading\" ng-change=\"$ctrl.handleChange()\" aria-label=\"Select Package\"><md-option></md-option><md-option ng-repeat=\"pkg in ::$ctrl.packages track by $index\" ng-value=\"pkg.id\">{{::pkg.name | capitalize}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_proposal/select_proposal.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option ng-repeat=\"proposal in $ctrl.proposals\" ng-value=\"proposal\">{{::proposal.name}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_provisioner/select_provisioner.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.loading\"><md-option></md-option><md-option ng-repeat=\"provisioner in ::$ctrl.provisioners track by $index\" ng-value=\"provisioner.id\">{{::provisioner.name | capitalize}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_role/select_role.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option ng-repeat=\"role in $ctrl.roles track by $index\" ng-value=\"role.id\">{{::role.name | capitalize}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_sales_rep/select_sales_rep.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.loading\"><md-option></md-option><md-option ng-repeat=\"salesRep in ::$ctrl.salesReps track by $index\" ng-value=\"salesRep.id\">{{::salesRep.name | capitalize}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_state/select_state.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option ng-repeat=\"state in $ctrl.states track by $index\" ng-value=\"::state.abbreviation\">{{::state.name}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/select_status/select_status.html","<md-input-container class=\"md-block\"><label>{{$ctrl.label}}</label><md-select name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.ngRequired\"><md-option></md-option><md-option ng-repeat=\"status in $ctrl.statuses track by $index\" ng-value=\"status\">{{::status | capitalize}}</md-option></md-select><div ng-messages=\"$ctrl.ngMessages\"><div ng-message=\"required\">Required</div></div></md-input-container>");
$templateCache.put("app/components/sidebar/sidebar.html","<nav class=\"sidebar\" layout=\"column\"><a class=\"sidebar__item\" permission permission-only=\"[\'viewAdd\']\" ui-sref=\"root.add\" ui-sref-active-if=\"\'root.add\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-user-follow\"></p>Add </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewQuickAdd\']\" ui-sref=\"root.quick-add\" ui-sref-active-if=\"\'root.quick-add\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-user-follow\"></p>Quick Add </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewQualifiers\']\" ui-sref=\"root.qualifiers.leads\" ui-sref-active-if=\"\'root.qualifiers\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-user-following\"></p>X-Log </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewProvisioning\']\" ui-sref=\"root.provisioning.clients\" ui-sref-active-if=\"\'root.provisioning\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-eye\"></p>Provisioning </a><a class=\"sidebar__item\" ui-sref=\"root.sae-pipeline\" ui-sref-active-if=\"\'root.sae-pipeline\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-grid\"></p>SAE Pipeline </a><!--<a class=\"sidebar__item\"--><!--ui-sref=\"root.xfer\"--><!--ui-sref-active-if=\"\'root.xfer\'\"--><!--ui-sref-active-class=\"sidebar__item&#45;&#45;active\">--><!--<p class=\"sidebar__icon icon-action-redo\"></p>--><!--Xfer--><!--</a>--> <a class=\"sidebar__item\" ui-sref=\"root.web-leads\" ui-sref-active-if=\"\'root.web-leads\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-screen-desktop\"></p>Web Leads </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewLeads\']\" ui-sref=\"root.leads.list\" ui-sref-active-if=\"\'root.leads\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-flag\"></p>Leads </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewClients\']\" ui-sref=\"root.clients\" ui-sref-active-if=\"[\'root.clients\', \'root.client\']\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-star\"></p>Clients </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewTickets\']\" href=\"https://gozoek.zendesk.com/agent/filters/77996428\" target=\"_blank\"><p class=\"sidebar__icon icon-tag\"></p>Tickets </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewStaff\']\" ui-sref=\"root.agents\" ui-sref-active-if=\"[\'root.agents\', \'root.agent\']\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-people\"></p>Agents </a><a class=\"sidebar__item\" permission permission-only=\"[\'viewActivity\']\" ui-sref=\"root.activity\" ui-sref-active-if=\"\'root.activity\'\" ui-sref-active-class=\"sidebar__item--active\"><p class=\"sidebar__icon icon-layers\"></p>Logs</a></nav>");
$templateCache.put("app/components/staff_list/staff_list.html","<md-toolbar><div class=\"md-toolbar-tools\"><p flex>Agents</p></div></md-toolbar><md-content layout-padding><form name=\"filterForm\" ng-submit=\"filterForm.$valid && $ctrl.handleFilter()\"><h1 class=\"md-subheader md-primary\">Filters</h1><div><md-input-container><label>Agent ID</label><input name=\"lead_no\" ng-model=\"$ctrl.query.staff_no\" type=\"text\"></md-input-container><md-input-container><label>First Name</label><input name=\"first_name\" ng-model=\"$ctrl.query.first_name\" type=\"text\"></md-input-container><md-input-container><label>Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.query.last_name\" type=\"text\"></md-input-container><md-input-container><label>Email</label><input name=\"email\" ng-model=\"$ctrl.query.email\" type=\"text\"></md-input-container><select-role name=\"role_id\" label=\"Role\" ng-model=\"$ctrl.query.role_id\"></select-role><md-input-container class=\"md-block\"><label>Status</label><md-select name=\"status\" ng-model=\"$ctrl.query.status\"><md-option></md-option><md-option value=\"active\">Active</md-option><md-option value=\"inactive\">Inactive</md-option></md-select></md-input-container></div><button class=\"md-button md-raised\" type=\"submit\">Filter</button> <button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.handleLoginActivityExport()\">Export Login Activity</button></form><md-table-container><table md-table md-progress=\"$ctrl.filtering\"><thead md-head md-order=\"$ctrl.query.order\" md-on-reorder=\"$ctrl.onReorder\"><tr md-row><th md-column md-numeric md-order-by=\"staff_no\"><span>Agent ID</span></th><th md-column md-order-by=\"first_name\"><span>Name</span></th><th md-column md-order-by=\"role_id\"><span>Role</span></th><th md-column md-order-by=\"status\"><span>Status</span></th><th md-column md-order-by=\"updated_at\"><span>Last Updated</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr u-cursor--pointer\" md-row ng-click=\"$ctrl.handleSelect(staff)\" ng-repeat=\"staff in $ctrl.staff.data\"><td md-cell>{{::staff.staff_no}}</td><td md-cell>{{::staff.name}}</td><td md-cell>{{::staff.role.name | capitalize}}</td><td md-cell>{{::staff.status | capitalize}}</td><td md-cell>{{::staff.updated | date : \'MMM dd, yyyy h:mm a\'}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.staff.meta.pagination.per_page\" md-page=\"$ctrl.staff.meta.pagination.current_page\" md-total=\"{{$ctrl.staff.meta.pagination.total}}\" md-options=\"[5, 10, 15, 50, 100, 200]\" md-on-paginate=\"$ctrl.onPaginate\" md-page-select></md-table-pagination></md-content>");
$templateCache.put("app/components/step_item/step_item.html","<div class=\"step-item\"><span class=\"step-item__circle\" ng-class=\"{\'step-item__circle--complete\': $ctrl.isCompleted, \'step-item__circle--current\': $ctrl.isCurrent}\"><i ng-show=\"$ctrl.isCompleted\" class=\"fa fa-check\"></i> <span ng-show=\"!$ctrl.isCompleted\">{{::$ctrl.number}}</span> </span><span class=\"step-item__text\" ng-class=\"{\'step-item__text--complete\': $ctrl.isCompleted, \'step-item__text--current\': $ctrl.isCurrent}\">{{::$ctrl.text}}</span></div>");
$templateCache.put("app/components/steps/steps.html","<nav class=\"o-steps\"><div class=\"o-steps__item o-steps__item--completed\" ng-click=\"$ctrl.onClickItem(0, \'root.closer.leads\')\"><span class=\"o-steps__circle\"><i class=\"fa fa-check\"></i> </span><span>Select Lead</span></div><div class=\"o-steps__item\" ng-class=\"{\'o-steps__item--active\': $ctrl.current === 2, \'o-steps__item--completed\': $ctrl.progress >= 1}\" ng-click=\"$ctrl.onClickItem(1, \'root.closer.lead.questionnaires\')\"><span class=\"o-steps__circle\"><i ng-show=\"$ctrl.progress > 1\" class=\"fa fa-check\"></i> <span ng-hide=\"$ctrl.progress > 1\">2</span> </span><span>Questionnaires</span></div><div class=\"o-steps__item\" ng-class=\"{\'o-steps__item--active\': $ctrl.current === 3, \'o-steps__item--completed\': $ctrl.progress >= 2}\" ng-click=\"$ctrl.onClickItem(2, \'root.closer.lead.packages\')\"><span class=\"o-steps__circle\"><i ng-show=\"$ctrl.progress > 2\" class=\"fa fa-check\"></i> <span ng-hide=\"$ctrl.progress > 2\">3</span> </span><span>Select A Package</span></div><div class=\"o-steps__item\" ng-class=\"{\'o-steps__item--active\': $ctrl.current === 4, \'o-steps__item--completed\': $ctrl.progress >= 3}\" ng-click=\"$ctrl.onClickItem(3, \'root.closer.lead.details\')\"><span class=\"o-steps__circle\"><i ng-show=\"$ctrl.progress > 3\" class=\"fa fa-check\"></i> <span ng-hide=\"$ctrl.progress > 3\">4</span> </span><span>Package Details</span></div><div class=\"o-steps__item\" ng-class=\"{\'o-steps__item--active\': $ctrl.current === 5, \'o-steps__item--completed\': $ctrl.progress >= 4}\" ng-click=\"$ctrl.onClickItem(4, \'root.closer.lead.payment\')\"><span class=\"o-steps__circle\"><i ng-show=\"$ctrl.progress > 4\" class=\"fa fa-check\"></i> <span ng-hide=\"$ctrl.progress > 4\">5</span> </span><span>Payment</span></div></nav>");
$templateCache.put("app/components/update_email_modal/update_email_modal.html","<md-dialog flex-gt-xs=\"25\"><form name=\"updateEmailForm\" ng-submit=\"updateEmailForm.$valid && $ctrl.updateEmail()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><p>Update Email</p></div></md-toolbar><md-dialog-content><md-content layout-padding><md-input-container class=\"md-block\"><label>Email</label><input name=\"email\" type=\"email\" ng-model=\"$ctrl.email\" required><div ng-messages=\"updateEmailForm.email.$error\"><div ng-message=\"required\">Required</div><div ng-message=\"email\">Invalid email</div></div></md-input-container></md-content></md-dialog-content><md-dialog-actions><button class=\"md-button md-raised md-primary\" ng-click=\"$ctrl.updateEmail()\" type=\"submit\">Update</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/view_client_modal/view_client_modal.html","<md-dialog flex-gt-sm=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Client</h2></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Lead</h4></div><div><h4 class=\"md-subheader\">Name</h4><p class=\"md-body-1\">{{::$ctrl.user.name}}</p></div><div><h4 class=\"md-subheader\">Address</h4><p class=\"md-body-1\">{{::$ctrl.user.address.line1}} {{::$ctrl.user.address.line2}} {{::$ctrl.user.address.city}}, {{::$ctrl.user.address.state}} {{::$ctrl.user.address.postal}} {{::$ctrl.user.address.country}}</p></div><div><h4 class=\"md-subheader\">Email</h4><p class=\"md-body-1\">{{::$ctrl.user.email}}</p></div><div><h4 class=\"md-subheader\">Alt. Email</h4><p class=\"md-body-1\">{{::$ctrl.user.alt_email || \'N/A\'}}</p></div><div><h4 class=\"md-subheader\">Phone</h4><p class=\"md-body-1\">{{::$ctrl.user.phone}}</p></div><div><h4 class=\"md-subheader\">Alt. Phone</h4><p class=\"md-body-1\">{{::$ctrl.user.alt_phone || \'N/A\'}}</p></div><div><h4 class=\"md-subheader\">Business</h4><p class=\"md-body-1\">{{::$ctrl.user.business}}</p></div><div><h4 class=\"md-subheader\">Industry</h4><p class=\"md-body-1\">{{::$ctrl.user.industry}}</p></div><div><h4 class=\"md-subheader\">Sub-Industry</h4><p class=\"md-body-1\">{{::$ctrl.user.subindustry}}</p></div><div><h4 class=\"md-subheader\">Website</h4><p class=\"md-body-1\">{{::$ctrl.user.website || \'N/A\'}}</p></div></div><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Subscription</h4></div><div><h4 class=\"md-subheader\">Package</h4><p class=\"md-body-1\">{{::$ctrl.user.subscription.package.name}} {{::$ctrl.user.getPlan().name}}</p></div><div><h4 class=\"md-subheader\">Payment Term</h4><p class=\"md-body-1\">{{::$ctrl.user.getPlan().payment_term}} Months</p></div><div><h4 class=\"md-subheader\">Add Ons</h4><p class=\"md-body-1\" ng-show=\"!$ctrl.user.subscription.add_on_ids.length\">No Add Ons</p><p class=\"md-body-1\" ng-repeat=\"add_on in $ctrl.user.subscription.add_ons.data\">{{::add_on.name}}</p></div><div><h4 class=\"md-subheader\">Monthly Fee</h4><p class=\"md-body-1\">{{::$ctrl.user.subscription.monthly_fee | currency}}</p></div><div><h4 class=\"md-subheader\">Setup Fee</h4><p class=\"md-body-1\">{{::$ctrl.user.subscription.setup_fee | currency}}</p></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/view_lead_modal/view_lead_modal.html","<md-dialog flex-gt-sm=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Current Lead</h2></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Lead</h4></div><div><h4 class=\"md-subheader\">Name</h4><p class=\"md-body-1\">{{::$ctrl.user.name}}</p></div><div><h4 class=\"md-subheader\">Address</h4><p class=\"md-body-1\">{{::$ctrl.user.address.line1}} {{::$ctrl.user.address.line2}} {{::$ctrl.user.address.city}}, {{::$ctrl.user.address.state}} {{::$ctrl.user.address.postal}} {{::$ctrl.user.address.country}}</p></div><div><h4 class=\"md-subheader\">Email</h4><p class=\"md-body-1\">{{::$ctrl.user.email}}</p></div><div><h4 class=\"md-subheader\">Alt. Email</h4><p class=\"md-body-1\">{{::$ctrl.user.alt_email || \'N/A\'}}</p></div><div><h4 class=\"md-subheader\">Phone</h4><p class=\"md-body-1\">{{::$ctrl.user.phone}}</p></div><div><h4 class=\"md-subheader\">Alt. Phone</h4><p class=\"md-body-1\">{{::$ctrl.user.alt_phone || \'N/A\'}}</p></div><div><h4 class=\"md-subheader\">Business</h4><p class=\"md-body-1\">{{::$ctrl.user.business}}</p></div><div><h4 class=\"md-subheader\">Industry</h4><p class=\"md-body-1\">{{::$ctrl.user.industry}}</p></div><div><h4 class=\"md-subheader\">Sub-Industry</h4><p class=\"md-body-1\">{{::$ctrl.user.subindustry}}</p></div><div><h4 class=\"md-subheader\">Website</h4><p class=\"md-body-1\">{{::$ctrl.user.website || \'N/A\'}}</p></div></div><div flex layout-margin><div><h4 class=\"md-subheader md-primary\">Subscription</h4></div><div ng-show=\"$ctrl.user.subscription\"><h4 class=\"md-subheader\">Package</h4><p class=\"md-body-1\">{{::$ctrl.user.subscription.package.name}} {{::$ctrl.user.getPlan().name}}</p></div><div ng-show=\"$ctrl.user.subscription\"><h4 class=\"md-subheader\">Payment Term</h4><p class=\"md-body-1\">{{::$ctrl.user.getPlan().payment_term}} Months</p></div><div ng-show=\"$ctrl.user.subscription\"><h4 class=\"md-subheader\">Add Ons</h4><p class=\"md-body-1\" ng-show=\"!$ctrl.user.subscription.add_on_ids.length\">No Add Ons</p><p class=\"md-body-1\" ng-repeat=\"add_on in $ctrl.user.subscription.add_ons.data\">{{::add_on.name}}</p></div><div ng-show=\"$ctrl.user.subscription\"><h4 class=\"md-subheader\">Monthly Fee</h4><p class=\"md-body-1\">{{::$ctrl.user.subscription.monthly_fee | currency}}</p></div><div ng-show=\"$ctrl.user.subscription\"><h4 class=\"md-subheader\">Setup Fee</h4><p class=\"md-body-1\">{{::$ctrl.user.subscription.setup_fee | currency}}</p></div><br><div><h4 class=\"md-subheader md-primary\">Title Qualifier Notes</h4><p class=\"md-body-1\">{{::$ctrl.user.questionnaires.title_qualifier_notes}}</p></div><br><div><h4 class=\"md-subheader md-primary\">Local content is the most relevant to search engines like GYB. Are looking for local or national exposure for your company?</h4><p class=\"md-body-1\">{{::$ctrl.user.questionnaires.question4 | capitalize}}</p></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/xfer-list/xfer-list.html","<md-toolbar><div class=\"md-toolbar-tools\"><p flex>{{$ctrl.title || \'Leads\'}}</p></div></md-toolbar><md-content layout-padding><form name=\"filterForm\" ng-submit=\"filterForm.$valid && $ctrl.handleFilter()\"><h1 class=\"md-subheader md-primary\">Filters</h1><div><md-input-container><label>Lead ID</label><input name=\"lead_no\" ng-model=\"$ctrl.query.lead_no\" type=\"text\"></md-input-container><md-input-container><label>First Name</label><input name=\"first_name\" ng-model=\"$ctrl.query.first_name\" type=\"text\"></md-input-container><md-input-container><label>Last Name</label><input name=\"last_name\" ng-model=\"$ctrl.query.last_name\" type=\"text\"></md-input-container><md-input-container><label>Email</label><input name=\"email\" ng-model=\"$ctrl.query.email\" type=\"text\"></md-input-container><md-input-container><label>Phone</label><input name=\"phone\" ng-model=\"$ctrl.query.phone\" type=\"tel\" ui-mask=\"(999) 999 - 9999\" placeholder=\"(xxx) xxx - xxxx\"></md-input-container><md-input-container><label>Business</label><input name=\"business\" ng-model=\"$ctrl.query.business\" type=\"text\"></md-input-container><md-input-container><label>Address Street</label><input name=\"address\" ng-model=\"$ctrl.query.address_line1\" type=\"text\"></md-input-container><md-datepicker name=\"created_from\" ng-model=\"$ctrl.query.created_from\" md-max-date=\"$ctrl.query.created_to\" md-placeholder=\"Created from\"></md-datepicker><md-datepicker name=\"created_to\" ng-model=\"$ctrl.query.created_to\" md-placeholder=\"Create to\" md-min-date=\"$ctrl.query.created_from\"></md-datepicker><md-input-container><label>Progress</label><md-select name=\"progress\" ng-model=\"$ctrl.query.progress\"><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"num in [0,1,2,3,4]\" ng-value=\"num\">{{num}}</md-option></md-select></md-input-container><select-business-type name=\"business_type\" label=\"Business Type\" ng-model=\"$ctrl.query.business_type\"></select-business-type><select-disposition name=\"disposition\" label=\"Disposition\" ng-model=\"$ctrl.query.disposition\"></select-disposition><select-package name=\"package\" label=\"Package Type\" ng-model=\"$ctrl.query.package_id\"></select-package></div><button class=\"md-button md-raised\" type=\"submit\">Filter</button> <button class=\"md-button md-raised\" type=\"button\" ng-click=\"$ctrl.handleExport()\">Export</button></form><md-table-container><table md-table md-progress=\"$ctrl.filtering\"><thead md-head md-order=\"$ctrl.query.order\" md-on-reorder=\"$ctrl.onReorder\"><tr md-row><!--<th md-column><span>Locked</span></th>--><th md-column md-numeric md-order-by=\"lead_no\"><span>Lead ID</span></th><th md-column md-order-by=\"first_name\"><span>Name</span></th><th md-column md-order-by=\"lead_type\"><span>Type</span></th><th md-column md-order-by=\"business\"><span>Business</span></th><th md-column md-order-by=\"disposition\"><span>Disposition</span></th><th md-column md-order-by=\"closer_id\"><span>Sales Rep</span></th><th md-column md-order-by=\"progress\"><span>Progress</span></th><th md-column md-order-by=\"updated_at\"><span>Last Updated</span></th><th md-column md-order-by=\"created_at\"><span>Created</span></th></tr></thead><tbody md-body><tr class=\"c-leads__tr u-cursor--pointer\" md-row ng-click=\"$ctrl.handleSelect(lead)\" ng-repeat=\"lead in $ctrl.leads.data\"><!--<td md-cell><i class=\"fa fa-2x fa-unlock\" aria-hidden=\"true\"></i></td>--><td md-cell>{{::lead.lead_no}}</td><td md-cell>{{::lead.name}}</td><td md-cell>{{::lead.lead_type}}</td><td md-cell>{{::lead.business}}</td><td md-cell>{{::lead.disposition}}</td><td md-cell>{{::lead.closer.name}}</td><td md-cell>{{::lead.progress || 0}}</td><td md-cell>{{::lead.updated | date : \'MMM dd, yyyy h:mm a\'}}</td><td md-cell>{{::lead.created | date : \'MMM dd, yyyy h:mm a\'}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.leads.meta.pagination.per_page\" md-page=\"$ctrl.leads.meta.pagination.current_page\" md-total=\"{{$ctrl.leads.meta.pagination.total}}\" md-options=\"[5, 10, 15, 50, 100, 200]\" md-on-paginate=\"$ctrl.onPaginate\" md-page-select></md-table-pagination></md-content>");
$templateCache.put("app/components/zoek_package/zoek_package.html","<div class=\"c-package\" ng-class=\"$ctrl.getClass()\" ng-click=\"$ctrl.handleClick($event)\"><div class=\"c-package__top\"><p class=\"c-package__price\">{{::$ctrl.package.plans[0].monthly_fee | currency}}</p><p class=\"c-package__setup\">+ Setup</p><p class=\"c-package__name\">{{::$ctrl.package.name}}</p><p class=\"c-package__subtitle\">{{::$ctrl.package.description}}</p></div><ul class=\"c-package__includes\"><li ng-repeat=\"include in $ctrl.package.includes track by $index\"><p class=\"md-body-1\">{{::include}}</p></li></ul></div>");
$templateCache.put("app/components/zoek_packages/zoek_packages.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-margin><zoek-package class=\"zoek-package\" ng-repeat=\"package in $ctrl.packages\" is-active=\"$ctrl.selectedPackageId == package.id\" on-click=\"$ctrl.handleOnClick($event)\" package=\"package\"></zoek-package></div>");}]);